export type Maybe<T> = T;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
};

export type AccountRecognitionList = {
  __typename?: 'AccountRecognitionList';
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<Recognition>>>;
  to?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type AccountTrophy = {
  __typename?: 'AccountTrophy';
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  poll?: Maybe<Poll>;
  pollId?: Maybe<Scalars['String']>;
  quote?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity AccountTrophy. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type AccountTrophyList = {
  __typename?: 'AccountTrophyList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<AccountTrophy>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type AccountVote = {
  __typename?: 'AccountVote';
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  /** @deprecated Use 'authorId' now. */
  createdById?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  moderated?: Maybe<Scalars['Boolean']>;
  poll?: Maybe<Poll>;
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type AccountVoteList = {
  __typename?: 'AccountVoteList';
  count?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<AccountVote>>>;
  to?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type ActiveOrderDetails = {
  __typename?: 'ActiveOrderDetails';
  /** @deprecated This field is no longer used and will be removed in a future release. */
  count?: Maybe<Scalars['Int']>;
  /** @deprecated This field is no longer used and will be removed in a future release. */
  countForSchemeType?: Maybe<Scalars['Int']>;
  /** @deprecated This field is no longer used and will be removed in a future release. */
  value?: Maybe<Scalars['Float']>;
  /** @deprecated This field is no longer used and will be removed in a future release. */
  valueForSchemeType?: Maybe<Scalars['Float']>;
};

export type AddBasketItemInput = {
  brochureGroupId: Scalars['Int'];
  organisationId?: InputMaybe<Scalars['ID']>;
  productTemplateId: Scalars['Int'];
  schemeType: Scalars['ID'];
  selectedSize: Scalars['String'];
};

export type AddBasketItemPayload = {
  __typename?: 'AddBasketItemPayload';
  addBasketItem?: Maybe<BasketItemPayload>;
};

export type AddBusinessToGroupInput = {
  businessGroupId?: InputMaybe<Scalars['ID']>;
  businessId: Scalars['ID'];
};

export type AddCompanyInput = {
  companyDetails: CompanyDetailsInput;
  uuid: Scalars['String'];
};

export type AddIndividualInput = {
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
};

export type AddIndividualResponse = {
  __typename?: 'AddIndividualResponse';
  link?: Maybe<VerificationLink>;
  signUp?: Maybe<SignUp>;
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lineFive?: Maybe<Scalars['String']>;
  lineFour?: Maybe<Scalars['String']>;
  lineSix?: Maybe<Scalars['String']>;
  lineThree?: Maybe<Scalars['String']>;
  nameOrNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lineFive?: InputMaybe<Scalars['String']>;
  lineFour?: InputMaybe<Scalars['String']>;
  lineSix?: InputMaybe<Scalars['String']>;
  lineThree?: InputMaybe<Scalars['String']>;
  nameOrNumber?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
};

/** Input for creating a single advanced budget assignment */
export type AdjustAdvancedBudgetInput = {
  amount: Scalars['Int'];
  budget: Scalars['String'];
};

export type AdjustAdvancedBudgetResponse = {
  __typename?: 'AdjustAdvancedBudgetResponse';
  success: Scalars['Boolean'];
};

/** Response from creating advanced budget assignments */
export type AdjustAdvancedBudgetsResponse = {
  __typename?: 'AdjustAdvancedBudgetsResponse';
  success: Scalars['Boolean'];
  totalProcessed: Scalars['Int'];
};

/** Input for updating the distribution of points between two categories */
export type AdjustBudgetInput = {
  amount: Scalars['Int'];
  fromBudget: Scalars['String'];
  toBudget: Scalars['String'];
};

export type AdsAdvertiser = {
  __typename?: 'AdsAdvertiser';
  metadata?: Maybe<Metadata>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  remoteId?: Maybe<Scalars['ID']>;
  source?: Maybe<AdsAdvertiserSource>;
  status?: Maybe<AdsAdvertiserStatus>;
  uuid: Scalars['ID'];
};

/**
 * Paginated List for entity AdsAdvertiser. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type AdsAdvertiserList = {
  __typename?: 'AdsAdvertiserList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<AdsAdvertiser>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const AdsAdvertiserSource = {
  Everflow: 'EVERFLOW',
  SourceUnknown: 'SOURCE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type AdsAdvertiserSource = typeof AdsAdvertiserSource[keyof typeof AdsAdvertiserSource];
export const AdsAdvertiserStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  StatusUnknown: 'STATUS_UNKNOWN',
  Suspended: 'SUSPENDED',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type AdsAdvertiserStatus = typeof AdsAdvertiserStatus[keyof typeof AdsAdvertiserStatus];
export type AdsClick = {
  __typename?: 'AdsClick';
  tid?: Maybe<Scalars['ID']>;
};

export type AdsConverClickEverflowInput = {
  tid?: InputMaybe<Scalars['ID']>;
};

export type AdsConverClickInput = {
  everflow?: InputMaybe<AdsConverClickEverflowInput>;
};

export type AdsOffer = {
  __typename?: 'AdsOffer';
  advertiser?: Maybe<AdsAdvertiser>;
  channels: Array<AdsOfferChannel>;
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['ID']>;
  destinationUrl?: Maybe<Scalars['String']>;
  errorMsg?: Maybe<Scalars['String']>;
  kind?: Maybe<AdsOfferKind>;
  metadata?: Maybe<Metadata>;
  name?: Maybe<Scalars['String']>;
  notRegionIds: Array<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  regionIds: Array<Scalars['ID']>;
  remoteAdvertiserId?: Maybe<Scalars['ID']>;
  remoteId?: Maybe<Scalars['ID']>;
  source?: Maybe<AdsOfferSource>;
  status?: Maybe<AdsOfferStatus>;
  termsAndConditions?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export const AdsOfferChannel = {
  Android: 'ANDROID',
  ChannelUnknown: 'CHANNEL_UNKNOWN',
  Ios: 'IOS',
  Unrecognized: 'UNRECOGNIZED',
  Web: 'WEB'
} as const;

export type AdsOfferChannel = typeof AdsOfferChannel[keyof typeof AdsOfferChannel];
export const AdsOfferKind = {
  CategoryBoost: 'CATEGORY_BOOST',
  EmailHero: 'EMAIL_HERO',
  HomepageHero: 'HOMEPAGE_HERO',
  KindUnknown: 'KIND_UNKNOWN',
  PerkboxPicksLane: 'PERKBOX_PICKS_LANE',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type AdsOfferKind = typeof AdsOfferKind[keyof typeof AdsOfferKind];
/**
 * Paginated List for entity AdsOffer. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type AdsOfferList = {
  __typename?: 'AdsOfferList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<AdsOffer>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const AdsOfferSource = {
  Everflow: 'EVERFLOW',
  SourceUnknown: 'SOURCE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type AdsOfferSource = typeof AdsOfferSource[keyof typeof AdsOfferSource];
export const AdsOfferStatus = {
  Active: 'ACTIVE',
  Deleted: 'DELETED',
  Error: 'ERROR',
  Paused: 'PAUSED',
  Pending: 'PENDING',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type AdsOfferStatus = typeof AdsOfferStatus[keyof typeof AdsOfferStatus];
/** Represents a budget category with its balance and optional role information */
export type AdvancedBudget = {
  __typename?: 'AdvancedBudget';
  balance: Scalars['Int'];
  budgetRole?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  uuid: Scalars['String'];
};

/**
 * Paginated List for entity BudgetSum. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use offset based pagination
 */
export type AdvancedBudgetsList = {
  __typename?: 'AdvancedBudgetsList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<BudgetSum>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

/** Namespace for all advancedBudgets mutations */
export type AdvancedBudgetsMutations = {
  __typename?: 'AdvancedBudgetsMutations';
  /** Update the points distributed between two categories. */
  adjustAdvancedBudget: AdjustAdvancedBudgetResponse;
  /**
   * Create advanced budget assignments from CSV upload. This mutation handles
   * batching internally for large uploads.
   */
  adjustAdvancedBudgets: AdjustAdvancedBudgetsResponse;
  /**
   * Migrate a business to Advanced Budgets. This is currently a one way
   * journey, and the business in question MUST be aware that during this
   * migration the reward wallets system as a whole will be unavailable. Changes
   * to rewards wallets during this time may be lost or lead to errors
   */
  migrate: MigrateBudgetsResponse;
  /** Transfer budget between managers and budgets */
  transferAdvancedBudgets: TransferAdvancedBudgetsResponse;
};


/** Namespace for all advancedBudgets mutations */
export type AdvancedBudgetsMutationsAdjustAdvancedBudgetArgs = {
  input: AdjustBudgetInput;
};


/** Namespace for all advancedBudgets mutations */
export type AdvancedBudgetsMutationsAdjustAdvancedBudgetsArgs = {
  assignments: Array<AdjustAdvancedBudgetInput>;
};


/** Namespace for all advancedBudgets mutations */
export type AdvancedBudgetsMutationsMigrateArgs = {
  businessId: Scalars['ID'];
};


/** Namespace for all advancedBudgets mutations */
export type AdvancedBudgetsMutationsTransferAdvancedBudgetsArgs = {
  input: TransferAdvancedBudgetInput;
};

/** Namespace for all advancedBudgets queries */
export type AdvancedBudgetsQueries = {
  __typename?: 'AdvancedBudgetsQueries';
  /** Get detailed information about a specific budget */
  getBudgetDetails?: Maybe<BudgetDetails>;
  /** Get managers for a specific budget */
  getBudgetManagers?: Maybe<ManagerAllocationsList>;
  /** Get total balance and unassigned balance for the current business */
  getBudgetTotals: BudgetTotals;
  /** Get total balance and unassigned balance for a user's reward wallet */
  getWalletTotals?: Maybe<WalletTotals>;
  /** Get total balance across all reward wallets for the current business */
  getWalletTotalsSummary: WalletTotalsSummary;
  /** List budgets for the current business with pagination and search support */
  listBudgets: AdvancedBudgetsList;
  /** List all reward wallets for the current business with pagination and search support */
  listWallets: WalletSumsList;
  /** Get budgets for a user's reward wallet. If userId is provided, fetches that user's wallet. Otherwise, fetches the current user's wallet. */
  rewardWalletWithBudgets?: Maybe<RewardWalletWithBudgets>;
};


/** Namespace for all advancedBudgets queries */
export type AdvancedBudgetsQueriesGetBudgetDetailsArgs = {
  id: Scalars['ID'];
};


/** Namespace for all advancedBudgets queries */
export type AdvancedBudgetsQueriesGetBudgetManagersArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
};


/** Namespace for all advancedBudgets queries */
export type AdvancedBudgetsQueriesGetWalletTotalsArgs = {
  userId: Scalars['ID'];
};


/** Namespace for all advancedBudgets queries */
export type AdvancedBudgetsQueriesListBudgetsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
};


/** Namespace for all advancedBudgets queries */
export type AdvancedBudgetsQueriesListWalletsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
};


/** Namespace for all advancedBudgets queries */
export type AdvancedBudgetsQueriesRewardWalletWithBudgetsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type AdyenAdditionalDetails = {
  __typename?: 'AdyenAdditionalDetails';
  additionalData?: Maybe<ProcessedPaymentAdditionalData>;
  merchantReference?: Maybe<Scalars['String']>;
  pspReference?: Maybe<Scalars['String']>;
  refusalReason?: Maybe<Scalars['String']>;
  resultCode?: Maybe<Scalars['String']>;
};

export type AdyenProcessedPayment = {
  __typename?: 'AdyenProcessedPayment';
  action?: Maybe<Scalars['String']>;
  additionalData?: Maybe<ProcessedPaymentAdditionalData>;
  merchantReference?: Maybe<Scalars['String']>;
  pspReference?: Maybe<Scalars['String']>;
  resultCode?: Maybe<Scalars['String']>;
};

export type AlgoliaDealBrand = {
  __typename?: 'AlgoliaDealBrand';
  bannerUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type AmountAndCurrency = {
  __typename?: 'AmountAndCurrency';
  amount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
};

export type AndroidPaymentSettings = {
  __typename?: 'AndroidPaymentSettings';
  googlePayId?: Maybe<Scalars['String']>;
};

export type AnnualLeaveConfig = {
  __typename?: 'AnnualLeaveConfig';
  annualLeave?: Maybe<Scalars['String']>;
  annualLeaveCap?: Maybe<Scalars['String']>;
  maxRequest?: Maybe<Scalars['String']>;
  maxRequestCap?: Maybe<Scalars['String']>;
  minAllowance?: Maybe<Scalars['String']>;
  minAnnualLeave?: Maybe<Scalars['String']>;
  minimumValuesCap?: Maybe<Scalars['String']>;
  model?: Maybe<AnnualLeaveModel>;
  paymentFrequency?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export const AnnualLeaveModel = {
  Days: 'Days',
  Hours: 'Hours'
} as const;

export type AnnualLeaveModel = typeof AnnualLeaveModel[keyof typeof AnnualLeaveModel];
export type AnnualLeavePurchaseOrder = {
  __typename?: 'AnnualLeavePurchaseOrder';
  id: Scalars['ID'];
};

export type AnnualLeavePurchaseOrderData = {
  __typename?: 'AnnualLeavePurchaseOrderData';
  errors?: Maybe<Array<AnnualLeavePurchaseOrderError>>;
  order?: Maybe<AnnualLeavePurchaseOrder>;
};

export type AnnualLeavePurchaseOrderError = {
  __typename?: 'AnnualLeavePurchaseOrderError';
  fieldName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type AnnualLeavePurchaseOrderInput = {
  annualLeaveAmount: Scalars['Float'];
  contractStatus: Scalars['String'];
  dateOfBirth: Scalars['String'];
  deliveryAddress1: Scalars['String'];
  deliveryAddress2: Scalars['String'];
  deliveryCounty: Scalars['String'];
  deliveryPostcode: Scalars['String'];
  deliveryTown: Scalars['String'];
  department: Scalars['String'];
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  email: Scalars['String'];
  employeeNumber: Scalars['String'];
  firstName: Scalars['String'];
  knowAnnualSalary: Scalars['String'];
  lastName: Scalars['String'];
  leaveAllowance: Scalars['Int'];
  leaveRequest: Scalars['Int'];
  lineManagerApproval?: InputMaybe<Scalars['Boolean']>;
  lineManagerEmail: Scalars['String'];
  lineManagerName: Scalars['String'];
  mobileNumber: Scalars['String'];
  niNumber: Scalars['String'];
  organisationId?: InputMaybe<Scalars['ID']>;
  payBeforeTax: Scalars['String'];
  paymentFrequency?: InputMaybe<Scalars['String']>;
  placeOfWork: Scalars['String'];
  purchaseModel: Scalars['String'];
  relativeUrl: Scalars['String'];
  telephoneNumber: Scalars['String'];
  termsAcknowledged: Scalars['Boolean'];
  timeInAWorkingWeek: Scalars['Int'];
  title: Scalars['String'];
};

export type AnnualLeavePurchaseOrderPayload = {
  __typename?: 'AnnualLeavePurchaseOrderPayload';
  createAnnualLeavePurchaseOrder?: Maybe<AnnualLeavePurchaseOrderData>;
};

export type Answer = {
  __typename?: 'Answer';
  response: Scalars['String'];
  scoreMarks: Scalars['Int'];
};

export type AnswerInput = {
  response: Scalars['String'];
  scoreMarks: Scalars['Int'];
};

export type Assertion = {
  __typename?: 'Assertion';
  acs?: Maybe<Scalars['String']>;
  postParams?: Maybe<Array<AssertionPostParams>>;
  response?: Maybe<Scalars['String']>;
};

/**
 * Map of key,value pairs to apply as the body of a post message. Graphql has
 * no concept of a Map, so iterate client side
 */
export type AssertionPostParams = {
  __typename?: 'AssertionPostParams';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** The kind of wellbeing assessment */
export const AssessmentKind = {
  /** Burnout assessment */
  AssessmentTypeBurnout: 'ASSESSMENT_TYPE_BURNOUT',
  /** Social wellbeing assessment */
  AssessmentTypeSocialWellbeing: 'ASSESSMENT_TYPE_SOCIAL_WELLBEING',
  /** Unknown assessment kind */
  AssessmentTypeUnknown: 'ASSESSMENT_TYPE_UNKNOWN',
  /** Wellbeing index assessment */
  AssessmentTypeWellbeingIndex: 'ASSESSMENT_TYPE_WELLBEING_INDEX'
} as const;

export type AssessmentKind = typeof AssessmentKind[keyof typeof AssessmentKind];
export type AssignFfRewardPointsInput = {
  amount: Scalars['Int'];
  destinationUserIds: Array<Scalars['ID']>;
  message: Scalars['String'];
  sourceId: Scalars['ID'];
};

export const AuditEventType = {
  EventAutomationActivated: 'EVENT_AUTOMATION_ACTIVATED',
  EventAutomationCreated: 'EVENT_AUTOMATION_CREATED',
  EventAutomationDeactivated: 'EVENT_AUTOMATION_DEACTIVATED',
  EventAutomationEdited: 'EVENT_AUTOMATION_EDITED',
  EventBusinessChanged: 'EVENT_BUSINESS_CHANGED',
  EventBusinessCreated: 'EVENT_BUSINESS_CREATED',
  EventBusinessGdprCleanupChanged: 'EVENT_BUSINESS_GDPR_CLEANUP_CHANGED',
  EventBusinessGdprCleanupCreated: 'EVENT_BUSINESS_GDPR_CLEANUP_CREATED',
  EventBusinessGdprCleanupDeleted: 'EVENT_BUSINESS_GDPR_CLEANUP_DELETED',
  EventBusinessNameChanged: 'EVENT_BUSINESS_NAME_CHANGED',
  EventBusinessOnboardingCompleted: 'EVENT_BUSINESS_ONBOARDING_COMPLETED',
  EventBusinessOnboardingCreated: 'EVENT_BUSINESS_ONBOARDING_CREATED',
  EventBusinessOnboardingDisabled: 'EVENT_BUSINESS_ONBOARDING_DISABLED',
  EventBusinessOnboardingEnabled: 'EVENT_BUSINESS_ONBOARDING_ENABLED',
  EventBusinessOnboardingLaunchManagerAssigned: 'EVENT_BUSINESS_ONBOARDING_LAUNCH_MANAGER_ASSIGNED',
  EventBusinessOnboardingStepModified: 'EVENT_BUSINESS_ONBOARDING_STEP_MODIFIED',
  EventBusinessSubdomainChanged: 'EVENT_BUSINESS_SUBDOMAIN_CHANGED',
  EventBusinessWorkosChanged: 'EVENT_BUSINESS_WORKOS_CHANGED',
  EventBusinessWorkosCreated: 'EVENT_BUSINESS_WORKOS_CREATED',
  EventBusinessWorkosDirectoryConfigChanged: 'EVENT_BUSINESS_WORKOS_DIRECTORY_CONFIG_CHANGED',
  EventBusinessWorkosDirectoryConfigCreated: 'EVENT_BUSINESS_WORKOS_DIRECTORY_CONFIG_CREATED',
  EventBusinessWorkosDirectoryConfigDeleted: 'EVENT_BUSINESS_WORKOS_DIRECTORY_CONFIG_DELETED',
  EventCultureHubCardChanged: 'EVENT_CULTURE_HUB_CARD_CHANGED',
  EventCultureHubCardCreated: 'EVENT_CULTURE_HUB_CARD_CREATED',
  EventCultureHubCardDeleted: 'EVENT_CULTURE_HUB_CARD_DELETED',
  EventDealChanged: 'EVENT_DEAL_CHANGED',
  EventDealCreated: 'EVENT_DEAL_CREATED',
  EventDealProductConfigChanged: 'EVENT_DEAL_PRODUCT_CONFIG_CHANGED',
  EventDealProductConfigCreated: 'EVENT_DEAL_PRODUCT_CONFIG_CREATED',
  EventIadminAccessChanged: 'EVENT_IADMIN_ACCESS_CHANGED',
  EventIadminCreated: 'EVENT_IADMIN_CREATED',
  EventIadminDetailsChanged: 'EVENT_IADMIN_DETAILS_CHANGED',
  EventIadminDisabled: 'EVENT_IADMIN_DISABLED',
  EventIadminEnabled: 'EVENT_IADMIN_ENABLED',
  EventIadminLoggedIn: 'EVENT_IADMIN_LOGGED_IN',
  EventIadminStartedGhostSession: 'EVENT_IADMIN_STARTED_GHOST_SESSION',
  EventPerksHomepageChanged: 'EVENT_PERKS_HOMEPAGE_CHANGED',
  EventPerksHomepageCreated: 'EVENT_PERKS_HOMEPAGE_CREATED',
  EventRegionChanged: 'EVENT_REGION_CHANGED',
  EventRegionCreated: 'EVENT_REGION_CREATED',
  EventRoleCreated: 'EVENT_ROLE_CREATED',
  EventRoleFeaturesChanged: 'EVENT_ROLE_FEATURES_CHANGED',
  EventRoleNameChanged: 'EVENT_ROLE_NAME_CHANGED',
  EventServiceFeesTierChangedGlobal: 'EVENT_SERVICE_FEES_TIER_CHANGED_GLOBAL',
  EventServiceFeesTierChangedTenant: 'EVENT_SERVICE_FEES_TIER_CHANGED_TENANT',
  EventServiceFeesTierCreatedGlobal: 'EVENT_SERVICE_FEES_TIER_CREATED_GLOBAL',
  EventServiceFeesTierCreatedTenant: 'EVENT_SERVICE_FEES_TIER_CREATED_TENANT',
  EventServiceFeesTierDeletedGlobal: 'EVENT_SERVICE_FEES_TIER_DELETED_GLOBAL',
  EventServiceFeesTierDeletedTenant: 'EVENT_SERVICE_FEES_TIER_DELETED_TENANT',
  EventTeamBrandingChanged: 'EVENT_TEAM_BRANDING_CHANGED',
  EventTeamChanged: 'EVENT_TEAM_CHANGED',
  EventTeamCreated: 'EVENT_TEAM_CREATED',
  EventTeamDeleted: 'EVENT_TEAM_DELETED',
  EventTeamFeaturesChanged: 'EVENT_TEAM_FEATURES_CHANGED',
  EventTeamNameChanged: 'EVENT_TEAM_NAME_CHANGED',
  EventTeamProductCycleToWorkSettingsChanged: 'EVENT_TEAM_PRODUCT_CYCLE_TO_WORK_SETTINGS_CHANGED',
  EventTeamProductEapSettingsChanged: 'EVENT_TEAM_PRODUCT_EAP_SETTINGS_CHANGED',
  EventTeamProductMedicalChanged: 'EVENT_TEAM_PRODUCT_MEDICAL_CHANGED',
  EventTeamProductPerksChanged: 'EVENT_TEAM_PRODUCT_PERKS_CHANGED',
  EventTeamProductRnrChanged: 'EVENT_TEAM_PRODUCT_RNR_CHANGED',
  EventTeamProductWalletSettingsChanged: 'EVENT_TEAM_PRODUCT_WALLET_SETTINGS_CHANGED',
  EventUnknown: 'EVENT_UNKNOWN',
  EventUserActivated: 'EVENT_USER_ACTIVATED',
  EventUserChanged: 'EVENT_USER_CHANGED',
  EventUserChangedPassword: 'EVENT_USER_CHANGED_PASSWORD',
  EventUserCreated: 'EVENT_USER_CREATED',
  EventUserDisabled: 'EVENT_USER_DISABLED',
  EventUserDobChanged: 'EVENT_USER_DOB_CHANGED',
  EventUserEmailChanged: 'EVENT_USER_EMAIL_CHANGED',
  EventUserEnabled: 'EVENT_USER_ENABLED',
  EventUserGhosted: 'EVENT_USER_GHOSTED',
  EventUserJoinedRole: 'EVENT_USER_JOINED_ROLE',
  EventUserJoinedTeam: 'EVENT_USER_JOINED_TEAM',
  EventUserLeftRole: 'EVENT_USER_LEFT_ROLE',
  EventUserLeftTeam: 'EVENT_USER_LEFT_TEAM',
  EventUserLegacyRoleChanged: 'EVENT_USER_LEGACY_ROLE_CHANGED',
  EventUserLoggedIn: 'EVENT_USER_LOGGED_IN',
  EventUserMarketingProfileChanged: 'EVENT_USER_MARKETING_PROFILE_CHANGED',
  EventUserMarketingSignatureChanged: 'EVENT_USER_MARKETING_SIGNATURE_CHANGED',
  EventUserMfaSetupAdded: 'EVENT_USER_MFA_SETUP_ADDED',
  EventUserMfaSetupChanged: 'EVENT_USER_MFA_SETUP_CHANGED',
  EventUserMfaSetupConfirmed: 'EVENT_USER_MFA_SETUP_CONFIRMED',
  EventUserMfaSetupRemoved: 'EVENT_USER_MFA_SETUP_REMOVED',
  EventUserNameChanged: 'EVENT_USER_NAME_CHANGED',
  EventUserOnboardingStepCompleted: 'EVENT_USER_ONBOARDING_STEP_COMPLETED',
  EventUserPhoneNumberChanged: 'EVENT_USER_PHONE_NUMBER_CHANGED',
  EventUserPhoneNumberCreated: 'EVENT_USER_PHONE_NUMBER_CREATED',
  EventUserPhoneNumberDeleted: 'EVENT_USER_PHONE_NUMBER_DELETED',
  EventUserTeamAssignmentChanged: 'EVENT_USER_TEAM_ASSIGNMENT_CHANGED',
  EventUserWorkosDirectoryChanged: 'EVENT_USER_WORKOS_DIRECTORY_CHANGED',
  EventUserWorkosDirectoryCreated: 'EVENT_USER_WORKOS_DIRECTORY_CREATED',
  EventUserWorkosDirectoryDeleted: 'EVENT_USER_WORKOS_DIRECTORY_DELETED',
  EventUserWorkosSsoChanged: 'EVENT_USER_WORKOS_SSO_CHANGED',
  EventUserWorkosSsoCreated: 'EVENT_USER_WORKOS_SSO_CREATED',
  EventUserWorkosSsoDeleted: 'EVENT_USER_WORKOS_SSO_DELETED',
  EventZuoraMappingChanged: 'EVENT_ZUORA_MAPPING_CHANGED',
  EventZuoraMappingCreated: 'EVENT_ZUORA_MAPPING_CREATED',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type AuditEventType = typeof AuditEventType[keyof typeof AuditEventType];
export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  auditUser?: Maybe<AuditUser>;
  eventType?: Maybe<AuditEventType>;
  initiatingUser?: Maybe<Scalars['ID']>;
  misc?: Maybe<Array<AuditLogMiscEntry>>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceType?: Maybe<AuditResourceType>;
  timestamp?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

/**
 * Paginated List for entity AuditLogEntry. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type AuditLogEntryList = {
  __typename?: 'AuditLogEntryList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<AuditLogEntry>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type AuditLogMiscEntry = {
  __typename?: 'AuditLogMiscEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export const AuditResourceType = {
  ResourceAutomation: 'RESOURCE_AUTOMATION',
  ResourceBusiness: 'RESOURCE_BUSINESS',
  ResourceCultureHubCard: 'RESOURCE_CULTURE_HUB_CARD',
  ResourceDeal: 'RESOURCE_DEAL',
  ResourceDealProductConfig: 'RESOURCE_DEAL_PRODUCT_CONFIG',
  ResourceIadmin: 'RESOURCE_IADMIN',
  ResourcePerksHomepage: 'RESOURCE_PERKS_HOMEPAGE',
  ResourceRegion: 'RESOURCE_REGION',
  ResourceRole: 'RESOURCE_ROLE',
  ResourceServiceFeesTier: 'RESOURCE_SERVICE_FEES_TIER',
  ResourceTeam: 'RESOURCE_TEAM',
  ResourceUnknown: 'RESOURCE_UNKNOWN',
  ResourceUser: 'RESOURCE_USER',
  ResourceZuoraMapping: 'RESOURCE_ZUORA_MAPPING',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type AuditResourceType = typeof AuditResourceType[keyof typeof AuditResourceType];
export type AuditSearchResponse = {
  __typename?: 'AuditSearchResponse';
  debugSearch?: Maybe<Scalars['String']>;
  nextSearchAfter?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type AuditUser = {
  __typename?: 'AuditUser';
  isInternalAdmin?: Maybe<Scalars['Boolean']>;
  isService?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

export const AuthProvider = {
  Google: 'GOOGLE',
  Microsoft: 'MICROSOFT',
  ProviderUnknown: 'PROVIDER_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type AuthProvider = typeof AuthProvider[keyof typeof AuthProvider];
export type AuthUrlState = {
  url?: InputMaybe<Scalars['String']>;
};

/** One row for the auto-approvals CSV template (camelCase in the API; CSV column titles are applied on the client). */
export type AutoApproveCsvTemplateRow = {
  __typename?: 'AutoApproveCsvTemplateRow';
  budgetCategoryName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type AutoApproveCsvValidationError = {
  __typename?: 'AutoApproveCsvValidationError';
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  row?: Maybe<Scalars['Int']>;
};

export type AutoApproveCsvValidationResult = {
  __typename?: 'AutoApproveCsvValidationResult';
  dataRowCount?: Maybe<Scalars['Int']>;
  errors: Array<AutoApproveCsvValidationError>;
  valid: Scalars['Boolean'];
};

export type AutoApprovedUserBudget = {
  __typename?: 'AutoApprovedUserBudget';
  approvedAt?: Maybe<Scalars['Int']>;
  approvedBy?: Maybe<Scalars['String']>;
  approver?: Maybe<User>;
  budget: Budget;
  budgetCategoryId?: Maybe<Scalars['String']>;
  isAutoApprovalEnabled?: Maybe<Scalars['Boolean']>;
  user: User;
  userId?: Maybe<Scalars['String']>;
  userMaxPoints?: Maybe<Scalars['Int']>;
};

/**
 * Paginated List for entity AutoApprovedUserBudget. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type AutoApprovedUserBudgetList = {
  __typename?: 'AutoApprovedUserBudgetList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<AutoApprovedUserBudget>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const AutoApprovedUserBudgetsFilter = {
  FilterAll: 'FILTER_ALL',
  FilterAutoApproved: 'FILTER_AUTO_APPROVED',
  FilterNotAutoApproved: 'FILTER_NOT_AUTO_APPROVED',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type AutoApprovedUserBudgetsFilter = typeof AutoApprovedUserBudgetsFilter[keyof typeof AutoApprovedUserBudgetsFilter];
export const AutomationRewardType = {
  Custom: 'CUSTOM',
  Fixed: 'FIXED',
  FixedCustom: 'FIXED_CUSTOM',
  None: 'NONE'
} as const;

export type AutomationRewardType = typeof AutomationRewardType[keyof typeof AutomationRewardType];
export const AutomationType = {
  AutomationTypeUnknown: 'AUTOMATION_TYPE_UNKNOWN',
  Birthday: 'BIRTHDAY',
  Unrecognized: 'UNRECOGNIZED',
  WorkAnniversary: 'WORK_ANNIVERSARY'
} as const;

export type AutomationType = typeof AutomationType[keyof typeof AutomationType];
export type AutomationUiSettings = {
  __typename?: 'AutomationUISettings';
  rewardType?: Maybe<AutomationRewardType>;
};

export type Basket = {
  __typename?: 'Basket';
  cashback?: Maybe<BasketTotal>;
  items?: Maybe<Array<BasketItem>>;
  metadata?: Maybe<Metadata>;
  shippingAddress?: Maybe<Address>;
  total?: Maybe<BasketTotal>;
  userId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

export const BasketDiscountType = {
  Cashback: 'CASHBACK',
  Standard: 'STANDARD'
} as const;

export type BasketDiscountType = typeof BasketDiscountType[keyof typeof BasketDiscountType];
export type BasketInput = {
  isRewards?: InputMaybe<Scalars['Boolean']>;
  items: Array<BasketInputItem>;
  paymentDetails?: InputMaybe<BasketPaymentDetailsInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  userId: Scalars['ID'];
};

export type BasketInputItem = {
  amount?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  entityId: Scalars['ID'];
  entityType: BasketItemType;
  faceValue?: InputMaybe<Scalars['Int']>;
  noProduct?: InputMaybe<Scalars['Boolean']>;
  openValue?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['ID']>;
  targetUserId?: InputMaybe<Scalars['ID']>;
};

export type BasketItem = {
  __typename?: 'BasketItem';
  amount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  deal?: Maybe<Deal>;
  entityId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<BasketItemType>;
  faceValue?: Maybe<Scalars['Int']>;
  isRewards?: Maybe<Scalars['Boolean']>;
  openValue?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']>;
  targetUserId?: Maybe<Scalars['ID']>;
  total?: Maybe<BasketTotal>;
};

export type BasketItemPayload = {
  __typename?: 'BasketItemPayload';
  basket?: Maybe<PayrollPayBasketData>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export const BasketItemType = {
  Deal: 'DEAL',
  EntityTypeUnknown: 'ENTITY_TYPE_UNKNOWN',
  FlexiReward: 'FLEXI_REWARD',
  Merchandise: 'MERCHANDISE',
  Reward: 'REWARD',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BasketItemType = typeof BasketItemType[keyof typeof BasketItemType];
export type BasketPaymentDetailsInput = {
  discountType?: InputMaybe<BasketDiscountType>;
  provider?: InputMaybe<PaymentProvider>;
};

export type BasketTotal = {
  __typename?: 'BasketTotal';
  amount?: Maybe<Scalars['Int']>;
  currency?: Maybe<PaymentCurrencyType>;
  discountPercentage?: Maybe<Scalars['Float']>;
  discountPercentageAfterServiceCharge?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Int']>;
  serviceCharge?: Maybe<Scalars['Int']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BasketTotalWithBreakDown = {
  __typename?: 'BasketTotalWithBreakDown';
  cashback?: Maybe<BasketTotal>;
  items?: Maybe<Array<BasketTotalWithBreakDownItems>>;
  total?: Maybe<BasketTotal>;
};

export type BasketTotalWithBreakDownItems = {
  __typename?: 'BasketTotalWithBreakDownItems';
  item?: Maybe<BasketItem>;
  total?: Maybe<BasketTotal>;
};

export type BenchmarkReport = {
  __typename?: 'BenchmarkReport';
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  points?: Maybe<Array<Maybe<DatePoint>>>;
  topic?: Maybe<Scalars['String']>;
};

export type BenchmarkReports = {
  __typename?: 'BenchmarkReports';
  reports?: Maybe<Array<Maybe<BenchmarkReport>>>;
};

export type Benefit = {
  __typename?: 'Benefit';
  description: Scalars['String'];
  name: Scalars['String'];
  provider?: Maybe<BenefitProvider>;
  providerId: Scalars['String'];
  uuid: Scalars['ID'];
};

export type BenefitContactInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  telephone: Scalars['String'];
};

export type BenefitContent = {
  __typename?: 'BenefitContent';
  bannerImage?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  faq?: Maybe<BenefitContentFaq>;
  howItWorks?: Maybe<BenefitContentHowItWorks>;
  smallCopy?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
  why?: Maybe<BenefitContentWhy>;
};

export type BenefitContentFaq = {
  __typename?: 'BenefitContentFAQ';
  content?: Maybe<Array<BenefitContentFaqContent>>;
  title?: Maybe<Scalars['String']>;
  viewMoreCopy?: Maybe<Scalars['String']>;
  viewMoreUrl?: Maybe<Scalars['String']>;
};

export type BenefitContentFaqContent = {
  __typename?: 'BenefitContentFAQContent';
  a?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};

export type BenefitContentHowItWorks = {
  __typename?: 'BenefitContentHowItWorks';
  content?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export const BenefitContentType = {
  Alp: 'alp',
  Ctw: 'ctw',
  He: 'he'
} as const;

export type BenefitContentType = typeof BenefitContentType[keyof typeof BenefitContentType];
export type BenefitContentWhy = {
  __typename?: 'BenefitContentWhy';
  content?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type BenefitEnquiryInput = {
  benefitId: Scalars['ID'];
  contact: BenefitContactInput;
  customerMessage?: InputMaybe<Scalars['String']>;
  employees: Scalars['Int'];
};

/**
 * Paginated List for entity Benefit. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type BenefitList = {
  __typename?: 'BenefitList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Benefit>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type BenefitProvider = {
  __typename?: 'BenefitProvider';
  email: Scalars['String'];
  name: Scalars['String'];
  uuid: Scalars['ID'];
};

export type Bike = {
  bikeType: Scalars['String'];
  brand?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type BikeShopBreadcrumb = {
  __typename?: 'BikeShopBreadcrumb';
  forceLink?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  link: Scalars['String'];
};

export type BikeShopData = {
  __typename?: 'BikeShopData';
  scheme?: Maybe<BikeShopScheme>;
};

export type BikeShopScheme = {
  __typename?: 'BikeShopScheme';
  bikeDepartmentId: Scalars['ID'];
  bikeShopsListBreadcrumbs?: Maybe<Array<Maybe<BikeShopBreadcrumb>>>;
  findBikeShopBreadcrumbs?: Maybe<Array<Maybe<BikeShopBreadcrumb>>>;
  schemeSuppliers?: Maybe<Array<Maybe<BikeShopSchemeSupplier>>>;
  suppliers?: Maybe<Array<Maybe<BikeShopSupplier>>>;
};

export type BikeShopSchemeSupplier = {
  __typename?: 'BikeShopSchemeSupplier';
  bikeShopQuoteInformation?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  formattedAddressString?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isOnline?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  supplierWebsite?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
};

export type BikeShopSupplier = {
  __typename?: 'BikeShopSupplier';
  county?: Maybe<Scalars['String']>;
  formattedAddressString?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isOnline?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  supplierWebsite?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
};

export const BillingCtaScreen = {
  CtaRenewal: 'CTA_RENEWAL',
  CtaUnknown: 'CTA_UNKNOWN',
  CtaUpsell: 'CTA_UPSELL',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BillingCtaScreen = typeof BillingCtaScreen[keyof typeof BillingCtaScreen];
export type BillingMapping = {
  __typename?: 'BillingMapping';
  businessFeatureFlags?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  featureFlags?: Maybe<Array<Scalars['String']>>;
  metadata?: Maybe<Metadata>;
  productSettings: ProductSettings;
  regionId: Scalars['ID'];
  rootFeatureFlags?: Maybe<Array<Scalars['String']>>;
  rootProductSettings: ProductSettings;
  uuid: Scalars['ID'];
  zuoraProductId: Scalars['ID'];
};

export type BillingMappingInput = {
  businessFeatureFlags?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  newProductSettings?: InputMaybe<ProductSettingsInput>;
  newRootProductSettings?: InputMaybe<ProductSettingsInput>;
  productSettings?: InputMaybe<PerksSettingsInput>;
  regionId?: InputMaybe<Scalars['ID']>;
  rootFeatureFlags?: InputMaybe<Array<Scalars['String']>>;
  rootProductSettings?: InputMaybe<PerksSettingsInput>;
  zuoraProductId: Scalars['ID'];
};

/**
 * Paginated List for entity BillingMapping. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type BillingMappingList = {
  __typename?: 'BillingMappingList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<BillingMapping>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type BillingMappingUpdateInput = {
  businessFeatureFlags?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<MetadataInput>;
  newProductSettings?: InputMaybe<ProductSettingsInput>;
  newRootProductSettings?: InputMaybe<ProductSettingsInput>;
  productSettings?: InputMaybe<PerksSettingsInput>;
  regionId?: InputMaybe<Scalars['ID']>;
  rootFeatureFlags?: InputMaybe<Array<Scalars['String']>>;
  rootProductSettings?: InputMaybe<PerksSettingsInput>;
  uuid: Scalars['ID'];
  zuoraProductId: Scalars['ID'];
};

export type BillingMigrationResult = {
  __typename?: 'BillingMigrationResult';
  businessId: Scalars['ID'];
  createdBUId?: Maybe<Scalars['ID']>;
  errorMsg?: Maybe<Scalars['String']>;
  status: BillingMigrationStatus;
};

export const BillingMigrationStatus = {
  Complete: 'COMPLETE',
  Failed: 'FAILED',
  Skipped: 'SKIPPED'
} as const;

export type BillingMigrationStatus = typeof BillingMigrationStatus[keyof typeof BillingMigrationStatus];
export const BillingPeriod = {
  Annual: 'Annual',
  Month: 'Month',
  Quarter: 'Quarter',
  Unrecognized: 'UNRECOGNIZED',
  Unspecified: 'Unspecified'
} as const;

export type BillingPeriod = typeof BillingPeriod[keyof typeof BillingPeriod];
export type BillingProductsForTeam = {
  __typename?: 'BillingProductsForTeam';
  businessFeatureFlags: Array<Scalars['String']>;
  featureFlags: Array<Scalars['String']>;
  productSettings?: Maybe<ProductSettings>;
  rootFeatureFlags: Array<Scalars['String']>;
  rootProductSettings?: Maybe<ProductSettings>;
};

export const BillingRegion = {
  All: 'ALL',
  Unknown: 'UNKNOWN',
  Au: 'au',
  En: 'en',
  Fr: 'fr',
  Ire: 'ire',
  Nz: 'nz',
  Row: 'row'
} as const;

export type BillingRegion = typeof BillingRegion[keyof typeof BillingRegion];
export type BillingUpdatePlanFlags = {
  __typename?: 'BillingUpdatePlanFlags';
  current: Array<Scalars['ID']>;
  diff?: Maybe<BillingUpdatePlanFlagsDiff>;
  next: Array<Scalars['ID']>;
};

export type BillingUpdatePlanFlagsDiff = {
  __typename?: 'BillingUpdatePlanFlagsDiff';
  toAdd: Array<Scalars['ID']>;
  toRemove: Array<Scalars['ID']>;
};

export type BillingUpdatePlanForTeam = {
  __typename?: 'BillingUpdatePlanForTeam';
  featureFlags: BillingUpdatePlanFlags;
  productSettings: BillingUpdatePlanProductSettings;
  regionId?: Maybe<Scalars['ID']>;
  teamId: Scalars['ID'];
};

export type BillingUpdatePlanProductSettings = {
  __typename?: 'BillingUpdatePlanProductSettings';
  current: ProductSettingsPerks;
  diff?: Maybe<ProductSettingsPerks>;
  next: ProductSettingsPerks;
};

export type BirthdayBoxMetadata = {
  __typename?: 'BirthdayBoxMetadata';
  /** @deprecated birthday box is no more */
  brandName?: Maybe<Scalars['String']>;
  /** @deprecated birthday box is no more */
  desc?: Maybe<Scalars['String']>;
  /** @deprecated birthday box is no more */
  image?: Maybe<Scalars['String']>;
  /** @deprecated birthday box is no more */
  linkProduct?: Maybe<Scalars['ID']>;
  /** @deprecated birthday box is no more */
  productId?: Maybe<Scalars['ID']>;
  /** @deprecated birthday box is no more */
  title?: Maybe<Scalars['String']>;
};

export const BirthdayPreferences = {
  BirthdayPreferenceUnknown: 'BIRTHDAY_PREFERENCE_UNKNOWN',
  Celebrate: 'CELEBRATE',
  DoNotCelebrate: 'DO_NOT_CELEBRATE',
  Private: 'PRIVATE',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BirthdayPreferences = typeof BirthdayPreferences[keyof typeof BirthdayPreferences];
export type BoostedSavingInput = {
  oldSavings?: InputMaybe<UserSavingsInput>;
};

export type BoostedSavings = {
  __typename?: 'BoostedSavings';
  oldSavings?: Maybe<UserSavings>;
};

export const BotLinkType = {
  LinkTypeUnknown: 'LINK_TYPE_UNKNOWN',
  MicrosoftTeams: 'MICROSOFT_TEAMS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BotLinkType = typeof BotLinkType[keyof typeof BotLinkType];
export type BotLinkedBusiness = {
  __typename?: 'BotLinkedBusiness';
  businessId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  remoteId?: Maybe<Scalars['String']>;
  type?: Maybe<BotLinkType>;
};

export type BotLinkedUser = {
  __typename?: 'BotLinkedUser';
  businessId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  remoteId?: Maybe<Scalars['String']>;
  type?: Maybe<BotLinkType>;
  userId?: Maybe<Scalars['String']>;
};

export type Branding = {
  __typename?: 'Branding';
  businessId: Scalars['ID'];
  businessLogoUrl: Scalars['String'];
  businessSquareLogoUrl?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  primaryColour: Scalars['String'];
  teamId: Scalars['ID'];
  textColour: Scalars['String'];
  uuid: Scalars['ID'];
  welcomeEmail?: Maybe<Scalars['String']>;
};

export type Budget = {
  __typename?: 'Budget';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  metadata: CategoryMetadata;
  name: Scalars['String'];
  percentage: Scalars['Float'];
  tag: BudgetGroupTag;
  uuid: Scalars['ID'];
  walletId: Scalars['ID'];
};

export type BudgetCategories = {
  __typename?: 'BudgetCategories';
  categories: Array<Budget>;
  unassigned: BudgetUnassigned;
};

export type BudgetCategory = {
  __typename?: 'BudgetCategory';
  categoryId?: Maybe<Scalars['ID']>;
  useUnassigned?: Maybe<Scalars['Boolean']>;
};

export type BudgetCategoryRequest = {
  categoryId: Scalars['ID'];
  useUnassigned: Scalars['Boolean'];
};

/** Detailed information about a budget category, including manager allocations */
export type BudgetDetails = {
  __typename?: 'BudgetDetails';
  /** The budget category information */
  budget: AdvancedBudget;
  /** Total balance across all wallets in this budget category */
  totalBalance: Scalars['Int'];
};

/** This references a finite list of predefined tags associated to a category in a 1-1 relationship to aid reporting */
export type BudgetGroupTag = {
  __typename?: 'BudgetGroupTag';
  name: Scalars['String'];
  uuid: Scalars['String'];
};

/** Role of a user within a budget category */
export const BudgetRole = {
  /** Manager with elevated permissions for the budget */
  Manager: 'MANAGER',
  /** Regular user with budget allocation */
  User: 'USER'
} as const;

export type BudgetRole = typeof BudgetRole[keyof typeof BudgetRole];
/** Represents a budget sum for a business - aggregated balance per category */
export type BudgetSum = {
  __typename?: 'BudgetSum';
  name: Scalars['String'];
  sum: Scalars['Int'];
  uuid: Scalars['String'];
};

/** Total balance information for a business */
export type BudgetTotals = {
  __typename?: 'BudgetTotals';
  /** Total balance across all budgets in the business */
  totalBalance: Scalars['Int'];
  /** Total unassigned balance for the business */
  totalUnassignedBalance: Scalars['Int'];
};

/**
 * All uncategorised budget falls into the 'unassigned' category, it doesn't exist as an entity in the wallet at this time
 * and as a result does not have a 'real' uuid, but we give it one for apollo cache
 */
export type BudgetUnassigned = {
  __typename?: 'BudgetUnassigned';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  metadata: CategoryMetadata;
  name: Scalars['String'];
  percentage: Scalars['Float'];
  uuid: Scalars['ID'];
  walletId: Scalars['ID'];
};

export type BulkBudgetAssignmentAssignment = {
  budget: Scalars['String'];
  users: Array<BulkBudgetAssignmentUserInput>;
};

export const BulkBudgetAssignmentErrorType = {
  InsufficientFunds: 'INSUFFICIENT_FUNDS',
  InvalidBudget: 'INVALID_BUDGET',
  InvalidUser: 'INVALID_USER',
  NotAdminManager: 'NOT_ADMIN_MANAGER',
  NotManager: 'NOT_MANAGER'
} as const;

export type BulkBudgetAssignmentErrorType = typeof BulkBudgetAssignmentErrorType[keyof typeof BulkBudgetAssignmentErrorType];
export type BulkBudgetAssignmentUserInput = {
  amount: Scalars['Int'];
  uuid: Scalars['ID'];
};

export type BulkChangeEmail = {
  businessId: Scalars['ID'];
  changes: Array<InputMaybe<EmailChange>>;
};

export type BulkRewardFailedEmails = {
  __typename?: 'BulkRewardFailedEmails';
  email?: Maybe<Scalars['String']>;
  status?: Maybe<BulkRewardFailedEmailsStatus>;
};

export const BulkRewardFailedEmailsStatus = {
  Error: 'ERROR',
  NotFound: 'NOT_FOUND',
  Unknown: 'UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BulkRewardFailedEmailsStatus = typeof BulkRewardFailedEmailsStatus[keyof typeof BulkRewardFailedEmailsStatus];
export type BulkRewardResponse = {
  __typename?: 'BulkRewardResponse';
  status: BulkRewardStatus;
  uuid: Scalars['ID'];
};

export const BulkRewardStatus = {
  Abandoned: 'ABANDONED',
  AwaitingApproval: 'AWAITING_APPROVAL',
  Complete: 'COMPLETE',
  Error: 'ERROR',
  Pending: 'PENDING',
  Unrecognized: 'UNRECOGNIZED',
  Validating: 'VALIDATING'
} as const;

export type BulkRewardStatus = typeof BulkRewardStatus[keyof typeof BulkRewardStatus];
export type BulkRewardStatusResponse = {
  __typename?: 'BulkRewardStatusResponse';
  status: BulkRewardStatus;
};

export type BulkRewardTransferOutcome = {
  __typename?: 'BulkRewardTransferOutcome';
  bulkRewardId?: Maybe<Scalars['ID']>;
  currency?: Maybe<Scalars['String']>;
  pointsPerUser?: Maybe<Scalars['Int']>;
  rewardedUsers?: Maybe<Array<Maybe<BulkTransferOutcomeUser>>>;
};

export const BulkRewardTransferOutcomeUserStatus = {
  Complete: 'COMPLETE',
  Failed: 'FAILED',
  Pending: 'PENDING',
  TransferStatusTypeUnknown: 'TRANSFER_STATUS_TYPE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BulkRewardTransferOutcomeUserStatus = typeof BulkRewardTransferOutcomeUserStatus[keyof typeof BulkRewardTransferOutcomeUserStatus];
export type BulkTransferOutcomeUser = {
  __typename?: 'BulkTransferOutcomeUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  status: BulkRewardTransferOutcomeUserStatus;
};

export type Business = {
  __typename?: 'Business';
  businessName: Scalars['String'];
  businessType?: Maybe<BusinessType>;
  contractStartDate?: Maybe<Scalars['String']>;
  creationMetadata?: Maybe<BusinessCreationMetadata>;
  /** @deprecated Use directoryId in WorkOSOrganisation instead. */
  directorySyncId?: Maybe<Scalars['ID']>;
  featureFlags: Array<Scalars['ID']>;
  globalAdminIds: Array<Scalars['ID']>;
  globalAdminRoleId: Scalars['ID'];
  globalAdmins: Array<User>;
  groupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isEnabled: Scalars['Boolean'];
  loginPageSsoButtonText?: Maybe<Scalars['String']>;
  metadata: Metadata;
  /** @deprecated This holds old tenant data, should not be used outside graph. */
  oldTenantData: Tenant;
  rootTeam: Team;
  rootTeamId: Scalars['ID'];
  salesforceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  selfRegistrations?: Maybe<Array<Maybe<BusinessSelfRegistrationType>>>;
  showPasswordLogin: Scalars['Boolean'];
  showSsoLogin: Scalars['Boolean'];
  /** @deprecated Use connectionId in WorkOSOrganisation instead. */
  ssoId?: Maybe<Scalars['ID']>;
  subdomain: Scalars['String'];
  teamManagers: Array<User>;
  uuid: Scalars['ID'];
};

export type BusinessCreationMetadata = {
  __typename?: 'BusinessCreationMetadata';
  business?: Maybe<Business>;
  businessId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<InternalUser>;
  createdById?: Maybe<Scalars['ID']>;
  details?: Maybe<Scalars['String']>;
  reasonForCreation?: Maybe<BusinessCreationReason>;
};

export const BusinessCreationReason = {
  Ch: 'CH',
  Customer: 'CUSTOMER',
  Demo: 'DEMO',
  Test: 'TEST',
  Unknown: 'UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BusinessCreationReason = typeof BusinessCreationReason[keyof typeof BusinessCreationReason];
export type BusinessGroup = {
  __typename?: 'BusinessGroup';
  groupName: Scalars['String'];
  uuid: Scalars['ID'];
};

/**
 * Paginated List for entity BusinessGroup. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type BusinessGroupList = {
  __typename?: 'BusinessGroupList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<BusinessGroup>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

/**
 * Paginated List for entity Business. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type BusinessList = {
  __typename?: 'BusinessList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Business>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type BusinessMetadata = {
  __typename?: 'BusinessMetadata';
  comments?: Maybe<Scalars['String']>;
  config?: Maybe<BusinessMetadataConfig>;
  homepage?: Maybe<BusinessMetadataHomePage>;
  uuid?: Maybe<Scalars['ID']>;
};

export type BusinessMetadataConfig = {
  __typename?: 'BusinessMetadataConfig';
  alternativeAppDownloadImage?: Maybe<Scalars['String']>;
};

export type BusinessMetadataHomePage = {
  __typename?: 'BusinessMetadataHomePage';
  isEnabled?: Maybe<Scalars['Boolean']>;
  widgets?: Maybe<Array<Maybe<BusinessMetadataHomePageWidget>>>;
};

export type BusinessMetadataHomePageLayout = {
  __typename?: 'BusinessMetadataHomePageLayout';
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  xOffset?: Maybe<Scalars['Int']>;
  yOffset?: Maybe<Scalars['Int']>;
};

export type BusinessMetadataHomePageWidget = {
  __typename?: 'BusinessMetadataHomePageWidget';
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<BusinessMetadataHomePageWidgetImage>;
  imageWithText?: Maybe<BusinessMetadataHomePageWidgetImageWithText>;
  layouts?: Maybe<BusinessMetadataHomePageWidgetLayouts>;
  type?: Maybe<BusinessMetadataHomePageWidgetTypes>;
  video?: Maybe<BusinessMetadataHomePageWidgetVideo>;
};

export type BusinessMetadataHomePageWidgetImage = {
  __typename?: 'BusinessMetadataHomePageWidgetImage';
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
};

export type BusinessMetadataHomePageWidgetImageWithText = {
  __typename?: 'BusinessMetadataHomePageWidgetImageWithText';
  body?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
};

export type BusinessMetadataHomePageWidgetLayouts = {
  __typename?: 'BusinessMetadataHomePageWidgetLayouts';
  desktop?: Maybe<BusinessMetadataHomePageLayout>;
  mobile?: Maybe<BusinessMetadataHomePageLayout>;
};

export const BusinessMetadataHomePageWidgetTypes = {
  Image: 'image',
  ImageWithText: 'imageWithText',
  Video: 'video'
} as const;

export type BusinessMetadataHomePageWidgetTypes = typeof BusinessMetadataHomePageWidgetTypes[keyof typeof BusinessMetadataHomePageWidgetTypes];
export type BusinessMetadataHomePageWidgetVideo = {
  __typename?: 'BusinessMetadataHomePageWidgetVideo';
  videoUrl?: Maybe<Scalars['String']>;
};

export const BusinessOverviewDuration = {
  BusinessOverviewLast_12Months: 'BUSINESS_OVERVIEW_LAST_12_MONTHS',
  BusinessOverviewLast_90Days: 'BUSINESS_OVERVIEW_LAST_90_DAYS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BusinessOverviewDuration = typeof BusinessOverviewDuration[keyof typeof BusinessOverviewDuration];
export type BusinessRedemptionReport = {
  __typename?: 'BusinessRedemptionReport';
  perks?: Maybe<Array<Maybe<PerkRedemptionsReport>>>;
  /** @deprecated Use 'perks' instead. */
  topTenPerks?: Maybe<Array<Maybe<PerkRedemptionsReport>>>;
  uuid?: Maybe<Scalars['ID']>;
};

export const BusinessRedemptionReportRedemptionType = {
  RedemptionTypeCompanyBenefit: 'REDEMPTION_TYPE_COMPANY_BENEFIT',
  RedemptionTypeFlexiPoints: 'REDEMPTION_TYPE_FLEXI_POINTS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BusinessRedemptionReportRedemptionType = typeof BusinessRedemptionReportRedemptionType[keyof typeof BusinessRedemptionReportRedemptionType];
export type BusinessRedemptionReportResponse = {
  __typename?: 'BusinessRedemptionReportResponse';
  availableDates?: Maybe<Array<Maybe<DateMonthYear>>>;
  report?: Maybe<BusinessRedemptionReport>;
};

export type BusinessRestrictions = {
  __typename?: 'BusinessRestrictions';
  currentNumberOfUsers?: Maybe<Scalars['Int']>;
  hasMaxUserLimit?: Maybe<Scalars['Boolean']>;
  maxUsersLimit?: Maybe<Scalars['Int']>;
};

export const BusinessSelfRegistrationType = {
  SelfRegistrationTypeAssignmentId: 'SELF_REGISTRATION_TYPE_ASSIGNMENT_ID',
  SelfRegistrationTypeEmployeeId: 'SELF_REGISTRATION_TYPE_EMPLOYEE_ID',
  SelfRegistrationTypeMembershipId: 'SELF_REGISTRATION_TYPE_MEMBERSHIP_ID',
  SelfRegistrationTypePayrollNumber: 'SELF_REGISTRATION_TYPE_PAYROLL_NUMBER',
  SelfRegistrationTypeUnknown: 'SELF_REGISTRATION_TYPE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BusinessSelfRegistrationType = typeof BusinessSelfRegistrationType[keyof typeof BusinessSelfRegistrationType];
export type BusinessSettings = {
  __typename?: 'BusinessSettings';
  companySize?: Maybe<OrganisationalSummaryCompanySize>;
  industry?: Maybe<Scalars['String']>;
  showUntil?: Maybe<Date>;
};

export type BusinessStory = {
  __typename?: 'BusinessStory';
  cards?: Maybe<Array<Maybe<StoryCards>>>;
  highlights?: Maybe<Array<Maybe<StoryHighlights>>>;
  persona?: Maybe<StoryPersona>;
};

export type BusinessSubdomainChange = {
  __typename?: 'BusinessSubdomainChange';
  setAt?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
};

export const BusinessType = {
  BusinessTypeCouncilLgps: 'BUSINESS_TYPE_COUNCIL_LGPS',
  BusinessTypeNhs: 'BUSINESS_TYPE_NHS',
  BusinessTypePrivate: 'BUSINESS_TYPE_PRIVATE',
  BusinessTypePublic: 'BUSINESS_TYPE_PUBLIC',
  BusinessTypeUnknown: 'BUSINESS_TYPE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type BusinessType = typeof BusinessType[keyof typeof BusinessType];
export type BusinessWalletTransfersCsv = {
  __typename?: 'BusinessWalletTransfersCSV';
  data: Scalars['String'];
  totalItemsCount?: Maybe<Scalars['Int']>;
};

export const CacheControlScope = {
  Private: 'PRIVATE',
  Public: 'PUBLIC'
} as const;

export type CacheControlScope = typeof CacheControlScope[keyof typeof CacheControlScope];
export type CalculatorBudget = {
  __typename?: 'CalculatorBudget';
  label: Scalars['String'];
  value: Scalars['String'];
};

export const CancellationReason = {
  BudgetCuts: 'BUDGET_CUTS',
  BusinessDownsizeOrClose: 'BUSINESS_DOWNSIZE_OR_CLOSE',
  CustomerServiceNotGreat: 'CUSTOMER_SERVICE_NOT_GREAT',
  EmployeesNotUsing: 'EMPLOYEES_NOT_USING',
  HighPrice: 'HIGH_PRICE',
  LimitedGlobalOfferings: 'LIMITED_GLOBAL_OFFERINGS',
  ManagementChanging: 'MANAGEMENT_CHANGING',
  MissingFeature: 'MISSING_FEATURE',
  OfferFromCompetitor: 'OFFER_FROM_COMPETITOR',
  Other: 'OTHER',
  TakingABreak: 'TAKING_A_BREAK',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CancellationReason = typeof CancellationReason[keyof typeof CancellationReason];
export type Card = {
  __typename?: 'Card';
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  fidelCardUuid?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
  syncToFidelError?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  userUuid?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity Card. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type CardList = {
  __typename?: 'CardList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Card>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type CashbackProduct = {
  __typename?: 'CashbackProduct';
  amount?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type CashbackTransaction = {
  __typename?: 'CashbackTransaction';
  addedOnWalletServiceAt?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  authTransactionImportedAt?: Maybe<Scalars['String']>;
  clearingTransactionImportedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  dateCashbackCompletedAt?: Maybe<Scalars['String']>;
  dateUnix?: Maybe<Scalars['Int']>;
  deal?: Maybe<Deal>;
  failedToAddOnWalletServiceReason?: Maybe<Scalars['String']>;
  fidelTransactionUuid?: Maybe<Scalars['ID']>;
  merchantLocationUuid?: Maybe<Scalars['ID']>;
  merchantUuid?: Maybe<Scalars['ID']>;
  metadata?: Maybe<Metadata>;
  notificationSentAt?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['String']>;
  status?: Maybe<CashbackTransactionStatus>;
  transactionAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
  userUuid?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
  walletTransferScheduleUuid?: Maybe<Scalars['ID']>;
};

export type CashbackTransactionListFilters = {
  status?: InputMaybe<CashbackTransactionStatus>;
  userId?: InputMaybe<Scalars['ID']>;
};

export const CashbackTransactionStatus = {
  StatusCancelled: 'STATUS_CANCELLED',
  StatusCompleted: 'STATUS_COMPLETED',
  StatusPending: 'STATUS_PENDING',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CashbackTransactionStatus = typeof CashbackTransactionStatus[keyof typeof CashbackTransactionStatus];
export type CashbackTransactionTotalAmount = {
  __typename?: 'CashbackTransactionTotalAmount';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
};

export type CashbackTransactionsListResponse = {
  __typename?: 'CashbackTransactionsListResponse';
  nextSearchAfter?: Maybe<Scalars['String']>;
  results?: Maybe<Array<CashbackTransaction>>;
  total?: Maybe<Scalars['Int']>;
};

export type CategoriesEmployeeOrganisation = {
  __typename?: 'CategoriesEmployeeOrganisation';
  employeeOrganisation?: Maybe<PayrollPayDepartmentCategoriesData>;
};

export type CategoryMetadata = {
  __typename?: 'CategoryMetadata';
  color: Scalars['String'];
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type Celebration = {
  __typename?: 'Celebration';
  celebrationId?: Maybe<Scalars['ID']>;
  icon?: Maybe<Trophy>;
  name?: Maybe<Scalars['String']>;
  usageCount?: Maybe<Scalars['Int']>;
};

export type CelebrationTag = {
  __typename?: 'CelebrationTag';
  archived?: Maybe<Scalars['Boolean']>;
  automationType?: Maybe<AutomationType>;
  banner?: Maybe<CelebrationTagAsset>;
  businessId?: Maybe<Scalars['String']>;
  cover?: Maybe<CelebrationTagAsset>;
  default?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<CelebrationTagAsset>;
  image?: Maybe<CelebrationTagAsset>;
  isComingSoon?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<AutomationUiSettings>;
  status?: Maybe<CelebrationTagStatus>;
  tag?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type CelebrationTagAsset = {
  __typename?: 'CelebrationTagAsset';
  alt?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
};

export const CelebrationTagKind = {
  Automation: 'AUTOMATION',
  CompanyCelebration: 'COMPANY_CELEBRATION',
  CompanyValue: 'COMPANY_VALUE',
  Greeting: 'GREETING',
  KindUnknown: 'KIND_UNKNOWN',
  ThemeTemplate: 'THEME_TEMPLATE',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CelebrationTagKind = typeof CelebrationTagKind[keyof typeof CelebrationTagKind];
export const CelebrationTagStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Closed: 'CLOSED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CelebrationTagStatus = typeof CelebrationTagStatus[keyof typeof CelebrationTagStatus];
export type CelebrationsRecognition = {
  __typename?: 'CelebrationsRecognition';
  recognitionId?: Maybe<Scalars['String']>;
  rpTransferred?: Maybe<Scalars['Int']>;
};

export type CelebrationsReport = {
  __typename?: 'CelebrationsReport';
  availableDates?: Maybe<Array<Maybe<DateMonthYear>>>;
  companyValuesAndCelebrations?: Maybe<ValuesAndCelebrationsReport>;
  polls?: Maybe<PollReport>;
  recognition?: Maybe<RecognitionReport>;
};

export const CelebrationsReportCategory = {
  CompanyValuesAndCelebrations: 'COMPANY_VALUES_AND_CELEBRATIONS',
  Polls: 'POLLS',
  RecognitionGiving: 'RECOGNITION_GIVING',
  RecognitionReceiving: 'RECOGNITION_RECEIVING',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CelebrationsReportCategory = typeof CelebrationsReportCategory[keyof typeof CelebrationsReportCategory];
export const CelebrationsReportDuration = {
  CelebrationsLast_6Months: 'CELEBRATIONS_LAST_6_MONTHS',
  CelebrationsLast_12Months: 'CELEBRATIONS_LAST_12_MONTHS',
  CelebrationsLast_30Days: 'CELEBRATIONS_LAST_30_DAYS',
  CelebrationsLast_90Days: 'CELEBRATIONS_LAST_90_DAYS',
  CelebrationsMonth: 'CELEBRATIONS_MONTH',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CelebrationsReportDuration = typeof CelebrationsReportDuration[keyof typeof CelebrationsReportDuration];
export type CelebrationsReportPoll = {
  __typename?: 'CelebrationsReportPoll';
  companyValueIds: Array<Scalars['String']>;
  companyValues?: Maybe<CompanyValueList>;
  createdAt?: Maybe<Date>;
  criteria?: Maybe<Scalars['String']>;
  poll?: Maybe<Poll>;
  pollId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  totalNominees?: Maybe<Scalars['Int']>;
  totalVotes?: Maybe<Scalars['Int']>;
  voteEndedAt?: Maybe<Date>;
};

export type CelebrationsReportPollWinner = {
  __typename?: 'CelebrationsReportPollWinner';
  pollIds: Array<Scalars['String']>;
  regionId?: Maybe<Scalars['ID']>;
  regionName?: Maybe<Scalars['String']>;
  totalVotesReceived?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export type CelebrationsReportTeam = {
  __typename?: 'CelebrationsReportTeam';
  companyValues: Array<CompanyValueReporting>;
  recognitionIds: Array<Scalars['ID']>;
  recognitions: Array<CelebrationsRecognition>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['ID']>;
  /** @deprecated uuid causing incorrect caching */
  uuid?: Maybe<Scalars['ID']>;
};

export type CelebrationsReportUser = {
  __typename?: 'CelebrationsReportUser';
  companyValues: Array<CompanyValueReporting>;
  /** @deprecated now using recognitions to bring through ids and rpTransferred */
  recognitionIds: Array<Scalars['ID']>;
  recognitions: Array<CelebrationsRecognition>;
  regionId?: Maybe<Scalars['ID']>;
  regionName?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  /** @deprecated uuid causing incorrect caching */
  uuid?: Maybe<Scalars['ID']>;
};

export type Checkout = {
  __typename?: 'Checkout';
  basket?: Maybe<Basket>;
  failureReason?: Maybe<Scalars['String']>;
  fullRedemptions: Array<CheckoutRedemption>;
  metadata?: Maybe<Metadata>;
  paymentOrder?: Maybe<PaymentOrder>;
  paymentOrderId?: Maybe<Scalars['ID']>;
  redemptions: Array<ItemRedemption>;
  status?: Maybe<CheckoutStatus>;
  userId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

export const CheckoutComDesignKind = {
  DesignKindComponent: 'DESIGN_KIND_COMPONENT',
  DesignKindContext: 'DESIGN_KIND_CONTEXT',
  DesignKindFrames: 'DESIGN_KIND_FRAMES',
  DesignKindHosted: 'DESIGN_KIND_HOSTED',
  DesignKindId: 'DESIGN_KIND_ID',
  DesignKindToken: 'DESIGN_KIND_TOKEN',
  DesignKindUnknown: 'DESIGN_KIND_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CheckoutComDesignKind = typeof CheckoutComDesignKind[keyof typeof CheckoutComDesignKind];
/**
 * Paginated List for entity Checkout. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type CheckoutList = {
  __typename?: 'CheckoutList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Checkout>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type CheckoutProductConfig = {
  __typename?: 'CheckoutProductConfig';
  limits?: Maybe<CheckoutProductConfigLimits>;
  products?: Maybe<Array<Maybe<CheckoutProductConfigProducts>>>;
  uuid?: Maybe<Scalars['ID']>;
};

export type CheckoutProductConfigAddInput = {
  limits?: InputMaybe<CheckoutProductConfigLimitsInput>;
  products?: InputMaybe<Array<InputMaybe<CheckoutProductConfigProductsInput>>>;
};

export type CheckoutProductConfigLimits = {
  __typename?: 'CheckoutProductConfigLimits';
  forOpenValue?: Maybe<CheckoutProductConfigLimitsOpenValue>;
  inWindow?: Maybe<CheckoutProductConfigLimitsInWindow>;
  overTime?: Maybe<CheckoutProductConfigLimitsOverTime>;
  perRedemption?: Maybe<CheckoutProductConfigLimitsPerRedemption>;
};

export type CheckoutProductConfigLimitsInWindow = {
  __typename?: 'CheckoutProductConfigLimitsInWindow';
  dateWindow?: Maybe<CheckoutProductConfigLimitsInWindowDate>;
  eventWindow?: Maybe<CheckoutProductConfigLimitsInWindowEvent>;
};

export type CheckoutProductConfigLimitsInWindowDate = {
  __typename?: 'CheckoutProductConfigLimitsInWindowDate';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type CheckoutProductConfigLimitsInWindowDateInput = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type CheckoutProductConfigLimitsInWindowEvent = {
  __typename?: 'CheckoutProductConfigLimitsInWindowEvent';
  daysAfter?: Maybe<Scalars['Int']>;
  daysBefore?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type CheckoutProductConfigLimitsInWindowEventInput = {
  daysAfter?: InputMaybe<Scalars['Int']>;
  daysBefore?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CheckoutProductConfigLimitsInWindowInput = {
  dateWindow?: InputMaybe<CheckoutProductConfigLimitsInWindowDateInput>;
  eventWindow?: InputMaybe<CheckoutProductConfigLimitsInWindowEventInput>;
};

export type CheckoutProductConfigLimitsInput = {
  forOpenValue?: InputMaybe<CheckoutProductConfigLimitsOpenValueInput>;
  inWindow?: InputMaybe<CheckoutProductConfigLimitsInWindowInput>;
  overTime?: InputMaybe<CheckoutProductConfigLimitsOverTimeInput>;
  perRedemption?: InputMaybe<CheckoutProductConfigLimitsPerRedemptionInput>;
};

export type CheckoutProductConfigLimitsOpenValue = {
  __typename?: 'CheckoutProductConfigLimitsOpenValue';
  maxValue?: Maybe<Scalars['Int']>;
  minValue?: Maybe<Scalars['Int']>;
};

export type CheckoutProductConfigLimitsOpenValueInput = {
  maxValue?: InputMaybe<Scalars['Int']>;
  minValue?: InputMaybe<Scalars['Int']>;
};

export type CheckoutProductConfigLimitsOverTime = {
  __typename?: 'CheckoutProductConfigLimitsOverTime';
  maxPrice?: Maybe<CheckoutProductConfigLimitsOverTimeMaxPrice>;
  numberOfItems?: Maybe<CheckoutProductConfigLimitsOverTimeNumberOfItems>;
};

export type CheckoutProductConfigLimitsOverTimeInput = {
  maxPrice?: InputMaybe<CheckoutProductConfigLimitsOverTimeMaxPriceInput>;
  numberOfItems?: InputMaybe<CheckoutProductConfigLimitsOverTimeNumberOfItemsInput>;
};

export type CheckoutProductConfigLimitsOverTimeMaxPrice = {
  __typename?: 'CheckoutProductConfigLimitsOverTimeMaxPrice';
  price?: Maybe<CheckoutProductConfigLimitsOverTimeMaxPricePrice>;
  timePeriod?: Maybe<Scalars['Int']>;
};

export type CheckoutProductConfigLimitsOverTimeMaxPriceInput = {
  price?: InputMaybe<CheckoutProductConfigLimitsOverTimeMaxPricePriceInput>;
  timePeriod?: InputMaybe<Scalars['Int']>;
};

export type CheckoutProductConfigLimitsOverTimeMaxPricePrice = {
  __typename?: 'CheckoutProductConfigLimitsOverTimeMaxPricePrice';
  currency?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type CheckoutProductConfigLimitsOverTimeMaxPricePriceInput = {
  currency?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type CheckoutProductConfigLimitsOverTimeNumberOfItems = {
  __typename?: 'CheckoutProductConfigLimitsOverTimeNumberOfItems';
  number?: Maybe<Scalars['Int']>;
  timePeriod?: Maybe<Scalars['Int']>;
};

export type CheckoutProductConfigLimitsOverTimeNumberOfItemsInput = {
  number?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<Scalars['Int']>;
};

export type CheckoutProductConfigLimitsPerRedemption = {
  __typename?: 'CheckoutProductConfigLimitsPerRedemption';
  maxPriceBeforeDiscounts?: Maybe<Scalars['Int']>;
  minPriceBeforeDiscounts?: Maybe<Scalars['Int']>;
  numberOfItems?: Maybe<Scalars['Int']>;
  numberOfProducts?: Maybe<Scalars['Int']>;
};

export type CheckoutProductConfigLimitsPerRedemptionInput = {
  maxPriceBeforeDiscounts?: InputMaybe<Scalars['Int']>;
  minPriceBeforeDiscounts?: InputMaybe<Scalars['Int']>;
  numberOfItems?: InputMaybe<Scalars['Int']>;
  numberOfProducts?: InputMaybe<Scalars['Int']>;
};

export type CheckoutProductConfigProducts = {
  __typename?: 'CheckoutProductConfigProducts';
  salePrice?: Maybe<CheckoutProductConfigProductsSalePrice>;
  uuid?: Maybe<Scalars['ID']>;
};

export type CheckoutProductConfigProductsInput = {
  salePrice?: InputMaybe<CheckoutProductConfigProductsSalePriceInput>;
  uuid?: InputMaybe<Scalars['ID']>;
};

export type CheckoutProductConfigProductsSalePrice = {
  __typename?: 'CheckoutProductConfigProductsSalePrice';
  currency?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

export type CheckoutProductConfigProductsSalePriceInput = {
  currency?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type CheckoutProductConfigUpdateInput = {
  limits?: InputMaybe<CheckoutProductConfigLimitsInput>;
  products?: InputMaybe<Array<InputMaybe<CheckoutProductConfigProductsInput>>>;
};

export type CheckoutRedemption = {
  __typename?: 'CheckoutRedemption';
  checkoutId?: Maybe<Scalars['ID']>;
  date?: Maybe<Date>;
  dateUnix?: Maybe<Scalars['Int']>;
  dealSnapshot?: Maybe<Deal>;
  dealUnavailable?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  isUsed?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Metadata>;
  order?: Maybe<CheckoutRedemptionOrder>;
  status?: Maybe<CheckoutRedemptionStatus>;
  type?: Maybe<CheckoutRedemptionType>;
  user?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

/**
 * Paginated List for entity CheckoutRedemption. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type CheckoutRedemptionList = {
  __typename?: 'CheckoutRedemptionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<CheckoutRedemption>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type CheckoutRedemptionOrder = {
  __typename?: 'CheckoutRedemptionOrder';
  basket?: Maybe<Basket>;
  paymentId?: Maybe<Scalars['ID']>;
  paymentOrder?: Maybe<PaymentOrder>;
  products?: Maybe<Array<CheckoutRedemptionOrderProduct>>;
  totals?: Maybe<CheckoutRedemptionOrderTotals>;
  uuid?: Maybe<Scalars['ID']>;
};

export type CheckoutRedemptionOrderProduct = {
  __typename?: 'CheckoutRedemptionOrderProduct';
  items?: Maybe<Array<Maybe<Stock>>>;
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['Int']>;
  salePrice?: Maybe<CheckoutRedemptionSalePrice>;
  supplier?: Maybe<Scalars['String']>;
  totals?: Maybe<CheckoutRedemptionOrderTotals>;
};

export type CheckoutRedemptionOrderTotals = {
  __typename?: 'CheckoutRedemptionOrderTotals';
  total?: Maybe<CheckoutRedemptionPrice>;
  totalBeforeDiscount?: Maybe<CheckoutRedemptionPrice>;
  totalSavings?: Maybe<CheckoutRedemptionPrice>;
  totalVAT?: Maybe<CheckoutRedemptionPrice>;
};

export type CheckoutRedemptionPrice = {
  __typename?: 'CheckoutRedemptionPrice';
  currency?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type CheckoutRedemptionSalePrice = {
  __typename?: 'CheckoutRedemptionSalePrice';
  currency?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export const CheckoutRedemptionStatus = {
  Archived: 'ARCHIVED',
  Complete: 'COMPLETE',
  Refund: 'REFUND',
  Started: 'STARTED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CheckoutRedemptionStatus = typeof CheckoutRedemptionStatus[keyof typeof CheckoutRedemptionStatus];
export const CheckoutRedemptionType = {
  FlexiReward: 'FLEXI_REWARD',
  Merchandise: 'MERCHANDISE',
  Perks: 'PERKS',
  Reward: 'REWARD',
  TypeUnknown: 'TYPE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CheckoutRedemptionType = typeof CheckoutRedemptionType[keyof typeof CheckoutRedemptionType];
export type CheckoutRedemptionUserLimits = {
  __typename?: 'CheckoutRedemptionUserLimits';
  amountLeftToRedeem?: Maybe<CheckoutRedemptionUserLimitsAmount>;
  dealProduct?: Maybe<CheckoutRedemptionUserLimitsDealProduct>;
  eventWindowLimit?: Maybe<CheckoutRedemptionUserLimitsEvent>;
  itemsLeftToRedeem?: Maybe<CheckoutRedemptionUserLimitsItems>;
  openValueLimit?: Maybe<CheckoutRedemptionUserLimitsOpenValue>;
};

export type CheckoutRedemptionUserLimitsAmount = {
  __typename?: 'CheckoutRedemptionUserLimitsAmount';
  amount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
};

export type CheckoutRedemptionUserLimitsDealProduct = {
  __typename?: 'CheckoutRedemptionUserLimitsDealProduct';
  deal?: Maybe<Deal>;
  dealId: Scalars['ID'];
  product?: Maybe<Product>;
  productId: Scalars['ID'];
};

export type CheckoutRedemptionUserLimitsEvent = {
  __typename?: 'CheckoutRedemptionUserLimitsEvent';
  fromDate?: Maybe<Scalars['String']>;
  redeemable?: Maybe<Scalars['Boolean']>;
  toDate?: Maybe<Scalars['String']>;
};

export type CheckoutRedemptionUserLimitsItems = {
  __typename?: 'CheckoutRedemptionUserLimitsItems';
  amount?: Maybe<Scalars['Int']>;
};

export type CheckoutRedemptionUserLimitsOpenValue = {
  __typename?: 'CheckoutRedemptionUserLimitsOpenValue';
  from?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
};

export type CheckoutRedemptionUserLimitsProductsInput = {
  dealId: Scalars['ID'];
  productId: Scalars['ID'];
};

export const CheckoutStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Redeeming: 'REDEEMING',
  Started: 'STARTED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CheckoutStatus = typeof CheckoutStatus[keyof typeof CheckoutStatus];
export type CommissionGroup = {
  __typename?: 'CommissionGroup';
  groupCode?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['Int']>;
  groupName?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type CommsMessage = {
  __typename?: 'CommsMessage';
  eventName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  properties?: Maybe<Scalars['String']>;
  purchaseProperties?: Maybe<Scalars['String']>;
  sentMetadata?: Maybe<Array<Maybe<CommsMessageSentMetadata>>>;
  source?: Maybe<Scalars['ID']>;
  status?: Maybe<CommsMessageStatus>;
  target?: Maybe<CommsMessageTarget>;
  type?: Maybe<CommsMessageType>;
  userId?: Maybe<Scalars['ID']>;
  uuid: Scalars['ID'];
};

/**
 * Paginated List for entity CommsMessage. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type CommsMessageList = {
  __typename?: 'CommsMessageList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<CommsMessage>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type CommsMessageSentMetadata = {
  __typename?: 'CommsMessageSentMetadata';
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['String']>;
  sentBy?: Maybe<InternalUser>;
  sentById?: Maybe<Scalars['String']>;
};

export const CommsMessageStatus = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  Resend: 'RESEND',
  Sent: 'SENT',
  UnknownStatus: 'UNKNOWN_STATUS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CommsMessageStatus = typeof CommsMessageStatus[keyof typeof CommsMessageStatus];
export const CommsMessageTarget = {
  Braze: 'BRAZE',
  Rudderstack: 'RUDDERSTACK',
  Segment: 'SEGMENT',
  UnknownTarget: 'UNKNOWN_TARGET',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CommsMessageTarget = typeof CommsMessageTarget[keyof typeof CommsMessageTarget];
export const CommsMessageType = {
  BroadcastEvent: 'BROADCAST_EVENT',
  PurchaseEvent: 'PURCHASE_EVENT',
  StandardEvent: 'STANDARD_EVENT',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CommsMessageType = typeof CommsMessageType[keyof typeof CommsMessageType];
export type CompanyBenefitInput = {
  bannerImage?: InputMaybe<Scalars['String']>;
  cardImage?: InputMaybe<Scalars['String']>;
  contactInfo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  importantInfo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locale?: InputMaybe<Scalars['String']>;
  redemptionInstructions?: InputMaybe<Scalars['String']>;
  savings?: InputMaybe<CompanyBenefitSavingsInput>;
  status?: InputMaybe<DealStatus>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DealsListType>;
};

export type CompanyBenefitSavingsBoostedSavingsInput = {
  oldSavings?: InputMaybe<CompanyBenefitSavingsUserSavingsInput>;
};

export type CompanyBenefitSavingsInput = {
  boostedSavings?: InputMaybe<CompanyBenefitSavingsBoostedSavingsInput>;
  userSavings?: InputMaybe<CompanyBenefitSavingsUserSavingsInput>;
};

export type CompanyBenefitSavingsUserSavingsInput = {
  header?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CompanyBenefitUpdateInput = {
  bannerImage?: InputMaybe<Scalars['String']>;
  cardImage?: InputMaybe<Scalars['String']>;
  contactInfo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  importantInfo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locale?: InputMaybe<Scalars['String']>;
  redemptionInstructions?: InputMaybe<Scalars['String']>;
  savings?: InputMaybe<CompanyBenefitSavingsInput>;
  status?: InputMaybe<DealStatus>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DealsListType>;
  urlSlug?: InputMaybe<Scalars['String']>;
};

export type CompanyCheck = {
  __typename?: 'CompanyCheck';
  outcome?: Maybe<SignUpOutcome>;
  uuid: Scalars['String'];
};

export type CompanyDetails = {
  __typename?: 'CompanyDetails';
  address: Address;
  country: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
  supplierId?: Maybe<Scalars['String']>;
};

export type CompanyDetailsInput = {
  address: AddressInput;
  country: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
  supplierId?: InputMaybe<Scalars['String']>;
};

export type CompanyNewsTile = {
  __typename?: 'CompanyNewsTile';
  config?: Maybe<CompanyNewsTileConfig>;
  uuid?: Maybe<Scalars['ID']>;
  xpos?: Maybe<Scalars['Int']>;
  ypos?: Maybe<Scalars['Int']>;
};

export type CompanyNewsTileConfig = {
  __typename?: 'CompanyNewsTileConfig';
  backgroundColor?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  templateIcon?: Maybe<Scalars['String']>;
  templateText?: Maybe<Scalars['String']>;
  type?: Maybe<CompanyNewsTileType>;
  url?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type CompanyNewsTileConfigInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  columnWidth: Scalars['Int'];
  fileId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  templateIcon?: InputMaybe<Scalars['String']>;
  templateText?: InputMaybe<Scalars['String']>;
  type: CompanyNewsTileType;
  url?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type CompanyNewsTileInput = {
  config: CompanyNewsTileConfigInput;
  uuid?: InputMaybe<Scalars['ID']>;
  xpos: Scalars['Int'];
  ypos: Scalars['Int'];
};

export const CompanyNewsTileType = {
  Empty: 'empty',
  File: 'file',
  Image: 'image',
  Template: 'template',
  Video: 'video'
} as const;

export type CompanyNewsTileType = typeof CompanyNewsTileType[keyof typeof CompanyNewsTileType];
export type CompanyValue = {
  __typename?: 'CompanyValue';
  archived?: Maybe<Scalars['Boolean']>;
  authorId?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  icon?: Maybe<Trophy>;
  name?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  usageCount?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['ID']>;
};

export type CompanyValueInput = {
  desc?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<TrophyInput>;
  name?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Paginated List for entity CompanyValue. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type CompanyValueList = {
  __typename?: 'CompanyValueList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<CompanyValue>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type CompanyValueReporting = {
  __typename?: 'CompanyValueReporting';
  count?: Maybe<Scalars['Int']>;
  icon?: Maybe<Trophy>;
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type ConfirmIdentifierInput = {
  code: Scalars['String'];
  identifier: Scalars['String'];
  uuid: Scalars['ID'];
};

export type CreateBulkBudgetAssignmentInput = {
  assignments: Array<BulkBudgetAssignmentAssignment>;
  message: Scalars['String'];
  sourceId: Scalars['ID'];
};

export type CreateBulkBudgetAssignmentResponse = {
  __typename?: 'CreateBulkBudgetAssignmentResponse';
  success: Scalars['Boolean'];
};

export type CreateBusinessGroupInput = {
  groupName: Scalars['String'];
};

export type CreateBusinessInput = {
  awsRegion?: InputMaybe<Scalars['String']>;
  businessName: Scalars['String'];
  creationMeta: CreateBusinessMetadataInput;
  groupId?: InputMaybe<Scalars['ID']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  loginPageSsoButtonText?: InputMaybe<Scalars['String']>;
  showPasswordLogin: Scalars['Boolean'];
  showSsoLogin: Scalars['Boolean'];
  subdomain: Scalars['String'];
};

export type CreateBusinessMetadataInput = {
  details?: InputMaybe<Scalars['String']>;
  reasonForCreation: BusinessCreationReason;
};

export type CreateConfirmIdentifierResponse = {
  __typename?: 'CreateConfirmIdentifierResponse';
  digits?: Maybe<Scalars['Int']>;
  expires?: Maybe<Date>;
  resend?: Maybe<Date>;
  uuid: Scalars['ID'];
};

export type CreateCycleToWorkQuoteAttributesInput = {
  accessoriesQuoteValue: Scalars['Float'];
  bikeQuoteAmount: Scalars['Float'];
  bikeQuoteDescription: Scalars['String'];
  bikeQuoteValue: Scalars['Float'];
  bikes?: InputMaybe<Array<Bike>>;
  dateOfBirth: Scalars['String'];
  deliveryAddress1: Scalars['String'];
  deliveryAddress2: Scalars['String'];
  deliveryCounty: Scalars['String'];
  deliveryPostcode: Scalars['String'];
  deliveryTown: Scalars['String'];
  documents: Array<Scalars['Upload']>;
  email: Scalars['String'];
  employeeNumber: Scalars['String'];
  firstName: Scalars['String'];
  helmetQuoteValue: Scalars['Float'];
  hireAgreementAcknowledged?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  mobileNumber: Scalars['String'];
  niNumber: Scalars['String'];
  placeOfWork: Scalars['String'];
  salarySacrificeArrangementAcknowledged?: InputMaybe<Scalars['Boolean']>;
  supplierId: Scalars['ID'];
  telephoneNumber: Scalars['String'];
  termsAcknowledged?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type CreateCycleToWorkQuoteInput = {
  brochureGroupId: Scalars['ID'];
  organisationId?: InputMaybe<Scalars['ID']>;
  quoteAttributes: CreateCycleToWorkQuoteAttributesInput;
  relativeUrl: Scalars['String'];
};

export type CreateCycleToWorkQuotePayload = {
  __typename?: 'CreateCycleToWorkQuotePayload';
  errors?: Maybe<Array<PayrollPayOrderError>>;
  faq?: Maybe<Scalars['String']>;
  order?: Maybe<PayrollPayOrder>;
  postUrl?: Maybe<Scalars['String']>;
  products?: Maybe<Array<PayrollPayOrderProduct>>;
  revenue?: Maybe<Scalars['String']>;
  ssoLink?: Maybe<Scalars['String']>;
  storeName?: Maybe<Scalars['String']>;
  supplier?: Maybe<Scalars['String']>;
};

export type CreateDealBrandInput = {
  bannerUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CreateDealInput = {
  bannerImage?: InputMaybe<Scalars['String']>;
  cardImage?: InputMaybe<Scalars['String']>;
  contactInfo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  emailRequired?: InputMaybe<Scalars['Boolean']>;
  header?: InputMaybe<Scalars['String']>;
  importantInfo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalIdentifier: Scalars['String'];
  redemptionInstructions?: InputMaybe<Scalars['String']>;
  savings?: InputMaybe<CompanyBenefitSavingsInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  type: DealType;
  urlSlug: Scalars['String'];
};

export type CreateDealPriceModifierInput = {
  businessId?: InputMaybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealKind: PriceModifierDealKind;
  discount: Scalars['Float'];
  status: PriceModifierDealStatus;
  tier?: InputMaybe<ProductSettingsPerksTiers>;
};

export type CreateFraudBlacklistedEmailInput = {
  email: Scalars['String'];
  state?: InputMaybe<FraudBlacklistedEmailState>;
};

export type CreateFraudThresholdInput = {
  enabled: Scalars['Boolean'];
  fraudDurationHours: Scalars['Int'];
  tenantId?: InputMaybe<Scalars['String']>;
  threshold: Scalars['Int'];
  type: FraudThresholdType;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateGroupCelebrationInput = {
  budget?: InputMaybe<BudgetCategoryRequest>;
  collaboratorIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customRewardId?: InputMaybe<Scalars['String']>;
  greetingId: Scalars['String'];
  originalTimezone: Scalars['String'];
  receiverId: Scalars['String'];
  rewardAmount: Scalars['Int'];
  scheduledAt: Scalars['String'];
  source?: InputMaybe<GroupCelebrationSource>;
};

export type CreateGymOrderInput = {
  dateOfBirth: Scalars['String'];
  deliveryAddress1: Scalars['String'];
  deliveryAddress2: Scalars['String'];
  deliveryCounty: Scalars['String'];
  deliveryPostcode: Scalars['String'];
  deliveryTown: Scalars['String'];
  email: Scalars['String'];
  employeeNumber: Scalars['String'];
  firstName: Scalars['String'];
  gymAmount: Scalars['Float'];
  gymName: Scalars['String'];
  gymTransactionReference: Scalars['String'];
  lastName: Scalars['String'];
  mobileNumber: Scalars['String'];
  niNumber: Scalars['String'];
  organisationId?: InputMaybe<Scalars['ID']>;
  placeOfWork: Scalars['String'];
  relativeUrl: Scalars['String'];
  telephoneNumber: Scalars['String'];
  termsAcknowledged: Scalars['Boolean'];
  title: Scalars['String'];
};

export type CreateGymOrderPayload = {
  __typename?: 'CreateGymOrderPayload';
  createGymOrder?: Maybe<GymBenefitOrderData>;
};

export type CreateIngestionJobInput = {
  fullRefresh?: InputMaybe<Scalars['Boolean']>;
  preventOverlap?: InputMaybe<Scalars['Boolean']>;
  provider?: InputMaybe<PendingDealProvider>;
};

export type CreateMagicLoginResponse = {
  __typename?: 'CreateMagicLoginResponse';
  digits?: Maybe<Scalars['Int']>;
  expires?: Maybe<Date>;
  resend?: Maybe<Date>;
  uuid: Scalars['ID'];
};

export type CreatePaymentContextInput = {
  amount: Scalars['Int'];
  currency: PaymentCurrencyType;
  paymentOrderId: Scalars['ID'];
  source: PaymentContextSource;
};

export type CreatePayrollGivingOrderInput = {
  dateOfBirth: Scalars['String'];
  deliveryAddress1: Scalars['String'];
  deliveryAddress2: Scalars['String'];
  deliveryCounty: Scalars['String'];
  deliveryPostcode: Scalars['String'];
  deliveryTown: Scalars['String'];
  donationValue: Scalars['Float'];
  email: Scalars['String'];
  employeeNumber: Scalars['String'];
  firstName: Scalars['String'];
  hireAgreementAcknowledged?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  mobileNumber: Scalars['String'];
  niNumber: Scalars['String'];
  organisationId?: InputMaybe<Scalars['ID']>;
  placeOfWork: Scalars['String'];
  recurringDonation: Scalars['Boolean'];
  relativeUrl: Scalars['String'];
  salarySacrificeArrangementAcknowledged?: InputMaybe<Scalars['Boolean']>;
  telephoneNumber: Scalars['String'];
  termsAcknowledged?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type CreatePayrollGivingOrderPayload = {
  __typename?: 'CreatePayrollGivingOrderPayload';
  createPayrollGivingQuote?: Maybe<PayrollGivingOrder>;
};

export type CreateQuestionnaireInput = {
  /** The kind of assessment this questionnaire belongs to */
  assessmentType?: InputMaybe<AssessmentKind>;
  calculationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  questions?: InputMaybe<Array<QuestionInput>>;
  status?: InputMaybe<QuestionnaireStatus>;
  type: QuestionnaireKind;
};

export type CreateRewardArgs = {
  companyValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  custom?: InputMaybe<Scalars['String']>;
  isCreditReward?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  occasionId?: InputMaybe<Scalars['String']>;
  poll_id?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  recipientUserIds: Array<InputMaybe<Scalars['String']>>;
  recognition_id?: InputMaybe<Scalars['String']>;
  rewardId?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenantId: Scalars['String'];
};

export type CreateScheduledRecognitionInput = {
  budget?: InputMaybe<BudgetCategoryRequest>;
  companyValueIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customRewardId?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  occasionId?: InputMaybe<Scalars['ID']>;
  originalTimezone: Scalars['String'];
  receiverIds: Array<Scalars['ID']>;
  rewardAmount?: InputMaybe<Scalars['Int']>;
  scheduledAt?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<ScheduledRecognitionSource>;
  visibility?: InputMaybe<RecognitionVisibility>;
};

export type CreateScoreInput = {
  answers?: InputMaybe<Array<Scalars['Int']>>;
  questionnaireId: Scalars['ID'];
  rawScore: Scalars['Int'];
  strategy?: InputMaybe<ScoreStrategy>;
  tenantId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type CreateStoreOrderInput = {
  dateOfBirth: Scalars['String'];
  deliveryAddress1: Scalars['String'];
  deliveryAddress2?: InputMaybe<Scalars['String']>;
  deliveryCounty?: InputMaybe<Scalars['String']>;
  deliveryPostcode: Scalars['String'];
  deliveryTown: Scalars['String'];
  email: Scalars['String'];
  employeeNumber: Scalars['String'];
  firstName: Scalars['String'];
  hireAgreementAcknowledged?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  mobileNumber: Scalars['String'];
  niNumber: Scalars['String'];
  organisationId?: InputMaybe<Scalars['ID']>;
  placeOfWork: Scalars['String'];
  salarySacrificeArrangementAcknowledged?: InputMaybe<Scalars['Boolean']>;
  schemeType: Scalars['ID'];
  telephoneNumber: Scalars['String'];
  termsAcknowledged?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type CreateStoreOrderPayload = {
  __typename?: 'CreateStoreOrderPayload';
  createStoreOrder?: Maybe<PayrollPayStoreOrder>;
};

export type CreateTenantWalletTransfersInput = {
  amount: Scalars['Int'];
  destinationOwnerId: Scalars['ID'];
  destinationWalletId: Scalars['ID'];
  reason: Scalars['String'];
  sourceOwnerId: Scalars['ID'];
  sourceWalletId: Scalars['ID'];
  type: Scalars['String'];
};

export type CreateTravelAndLeisureOrderInput = {
  dateOfBirth: Scalars['String'];
  deliveryAddress1: Scalars['String'];
  deliveryAddress2?: InputMaybe<Scalars['String']>;
  deliveryCounty?: InputMaybe<Scalars['String']>;
  deliveryPostcode: Scalars['String'];
  deliveryTown: Scalars['String'];
  email: Scalars['String'];
  employeeNumber: Scalars['String'];
  firstName: Scalars['String'];
  holidayAdultsNum: Scalars['Int'];
  holidayAmount: Scalars['Float'];
  holidayChildrenNum: Scalars['Int'];
  holidayType: Scalars['String'];
  lastName: Scalars['String'];
  mobileNumber: Scalars['String'];
  niNumber: Scalars['String'];
  organisationId?: InputMaybe<Scalars['ID']>;
  placeOfWork: Scalars['String'];
  relativeUrl: Scalars['String'];
  telephoneNumber: Scalars['String'];
  termsAcknowledged: Scalars['Boolean'];
  title: Scalars['String'];
};

export type CreatedFileHandlerResponse = {
  __typename?: 'CreatedFileHandlerResponse';
  uploadUrl: Scalars['String'];
  uuid: Scalars['ID'];
};

export const CultureHubTileType = {
  TypeEmpty: 'TYPE_EMPTY',
  TypeFile: 'TYPE_FILE',
  TypeImage: 'TYPE_IMAGE',
  TypeTemplate: 'TYPE_TEMPLATE',
  TypeUnknown: 'TYPE_UNKNOWN',
  TypeVideo: 'TYPE_VIDEO',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CultureHubTileType = typeof CultureHubTileType[keyof typeof CultureHubTileType];
export type CurrencyExchange = {
  __typename?: 'CurrencyExchange';
  currency: Scalars['String'];
  fpExchangeRate: Scalars['Float'];
  gbpExchangeRate: Scalars['Float'];
  metadata?: Maybe<Metadata>;
  rpExchangeRate: Scalars['Float'];
};

export type CustomReward = {
  __typename?: 'CustomReward';
  author: User;
  authorId: Scalars['String'];
  businessId?: Maybe<Scalars['String']>;
  locations: Array<Maybe<Scalars['String']>>;
  metadata: Metadata;
  policy: Scalars['String'];
  redemptionInstructions: Scalars['String'];
  regions?: Maybe<Array<Maybe<Team>>>;
  status: CustomRewardStatus;
  title: Scalars['String'];
  uuid: Scalars['String'];
};

export type CustomRewardInput = {
  locations: Array<Scalars['String']>;
  policy: Scalars['String'];
  redemptionInstructions: Scalars['String'];
  title: Scalars['String'];
};

export const CustomRewardStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Hidden: 'HIDDEN',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type CustomRewardStatus = typeof CustomRewardStatus[keyof typeof CustomRewardStatus];
export type CustomRewardTransaction = {
  __typename?: 'CustomRewardTransaction';
  adminId: Scalars['String'];
  author: User;
  businessId: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  customReward: CustomReward;
  customRewardId: Scalars['String'];
  dateUnix: Scalars['Int'];
  isUsed: Scalars['Boolean'];
  metadata: Metadata;
  receiver: User;
  receiverId: Scalars['String'];
  recognition: Recognition;
  recognitionId: Scalars['String'];
  uuid: Scalars['String'];
};

/**
 * Paginated List for entity CustomRewardTransaction. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type CustomRewardTransactionsList = {
  __typename?: 'CustomRewardTransactionsList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<CustomRewardTransaction>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type CustomRewardsFilter = {
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<CustomRewardStatus>;
};

export type CustomerFile = {
  __typename?: 'CustomerFile';
  status: FileStatus;
  uuid: Scalars['ID'];
};

export type CustomerFileResponse = {
  __typename?: 'CustomerFileResponse';
  downloadUrl: Scalars['String'];
  file: CustomerFile;
};

export type Date = {
  __typename?: 'Date';
  nanos?: Maybe<Scalars['Int']>;
  seconds?: Maybe<Scalars['String']>;
};

export type DateInput = {
  month?: InputMaybe<Scalars['Int']>;
  nanos?: InputMaybe<Scalars['Int']>;
  quarter?: InputMaybe<Scalars['Int']>;
  seconds?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type DateMonthYear = {
  __typename?: 'DateMonthYear';
  month?: Maybe<Scalars['Int']>;
  quarter?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type DatePoint = {
  __typename?: 'DatePoint';
  date?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Deal = {
  __typename?: 'Deal';
  algoliaQueryId?: Maybe<Scalars['ID']>;
  bannerImage?: Maybe<Scalars['String']>;
  /** @deprecated birthday box is no more */
  birthdayBoxMetaData?: Maybe<Array<Maybe<BirthdayBoxMetadata>>>;
  brand?: Maybe<AlgoliaDealBrand>;
  brandId?: Maybe<Scalars['ID']>;
  brandName?: Maybe<Scalars['String']>;
  brandTagIds?: Maybe<Array<Scalars['String']>>;
  cardImage?: Maybe<Scalars['String']>;
  cashbackETADays?: Maybe<Scalars['Int']>;
  contactInfo?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dateTurnedOn?: Maybe<Scalars['String']>;
  dateUnix?: Maybe<Scalars['Int']>;
  deliveryHighlight?: Maybe<Scalars['String']>;
  deliveryInfo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  earnPoints?: Maybe<Scalars['Boolean']>;
  emailRequired?: Maybe<Scalars['Boolean']>;
  endsAt?: Maybe<Scalars['Int']>;
  externalIdentifier?: Maybe<Scalars['String']>;
  externalLinks?: Maybe<DealExternalLinks>;
  externalLoginUrl?: Maybe<Scalars['String']>;
  frequentlyAskedQuestions?: Maybe<Array<Maybe<FrequentlyAskedQuestion>>>;
  hasLocation?: Maybe<Scalars['Boolean']>;
  header?: Maybe<Scalars['String']>;
  howItWorks?: Maybe<Array<Maybe<Scalars['String']>>>;
  importantInfo?: Maybe<Array<Maybe<Scalars['String']>>>;
  increasedPointsBackPercentageDelta?: Maybe<Scalars['Float']>;
  internalIdentifier?: Maybe<Scalars['String']>;
  /** @deprecated birthday box is no more */
  isBirthdayBox?: Maybe<Scalars['Boolean']>;
  /** @deprecated perks go is dead */
  isInStoreDeal?: Maybe<Scalars['Boolean']>;
  /** @deprecated perks go is dead */
  isPerksGoRetailDeal?: Maybe<Scalars['Boolean']>;
  isTTDeal?: Maybe<Scalars['Boolean']>;
  isValidFor24Hours?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<DealLocation>;
  /** @deprecated perks go is dead */
  merchantUuids?: Maybe<Array<Maybe<Scalars['String']>>>;
  offers: Array<AdsOffer>;
  paymentOptions?: Maybe<DealPaymentOptions>;
  popularity?: Maybe<Scalars['Int']>;
  productConfig?: Maybe<ProductConfig>;
  provider?: Maybe<Scalars['String']>;
  redemptionInstructions?: Maybe<Scalars['String']>;
  regionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  reviewState?: Maybe<DealReviewState>;
  savings?: Maybe<UserSaving>;
  status?: Maybe<DealStatus>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  teamIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  teams?: Maybe<Array<Maybe<Team>>>;
  template?: Maybe<Scalars['String']>;
  tenant?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  ttPrice?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  typeHighlight?: Maybe<Scalars['String']>;
  urlSlug?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type DealBrand = {
  __typename?: 'DealBrand';
  approved?: Maybe<Scalars['Boolean']>;
  bannerUrl?: Maybe<Scalars['String']>;
  dateUnix?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<DealBrand>;
  parentId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<DealBrandStatus>;
  tagIds: Array<Scalars['ID']>;
  tags: Array<Tag>;
  uuid?: Maybe<Scalars['ID']>;
  variants?: Maybe<Array<Maybe<DealBrand>>>;
};

/**
 * Paginated List for entity DealBrand. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type DealBrandList = {
  __typename?: 'DealBrandList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<DealBrand>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type DealBrandSearchResponse = {
  __typename?: 'DealBrandSearchResponse';
  brand?: Maybe<DealBrand>;
  count?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export const DealBrandStatus = {
  StatusOff: 'STATUS_OFF',
  StatusOn: 'STATUS_ON',
  UnknownStatus: 'UNKNOWN_STATUS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type DealBrandStatus = typeof DealBrandStatus[keyof typeof DealBrandStatus];
export type DealCategory = {
  __typename?: 'DealCategory';
  /** @deprecated No longer used */
  active?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use new 'Tag.kind = DealCategory' */
  dealCount?: Maybe<Scalars['Int']>;
  /** @deprecated Use new 'Tag.kind = DealCategory' */
  image?: Maybe<Scalars['String']>;
  /** @deprecated Use new 'Tag.kind = DealCategory' */
  isGeolocationRelated?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use new 'Tag.kind = DealCategory' */
  name?: Maybe<Scalars['String']>;
  /** @deprecated No longer used */
  onMenu?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use new 'Tag.kind = DealCategory' */
  rewardCount?: Maybe<Scalars['Int']>;
  /** @deprecated Use new 'Tag.kind = DealCategory' and 'tag.children' */
  tags?: Maybe<Array<Maybe<DealsTag>>>;
  /** @deprecated Use new 'Tag.kind = DealCategory' */
  type?: Maybe<DealCategoryType>;
  /** @deprecated Use new 'Tag.kind = DealCategory' */
  url?: Maybe<Scalars['String']>;
  /** @deprecated Use new 'Tag.kind = DealCategory' */
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity DealCategory. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type DealCategoryList = {
  __typename?: 'DealCategoryList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<DealCategory>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const DealCategoryType = {
  Earn: 'EARN',
  Free: 'FREE',
  Spend: 'SPEND',
  Tt: 'TT'
} as const;

export type DealCategoryType = typeof DealCategoryType[keyof typeof DealCategoryType];
export type DealExternalLinks = {
  __typename?: 'DealExternalLinks';
  android?: Maybe<Scalars['String']>;
  ios?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity Deal. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type DealList = {
  __typename?: 'DealList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Deal>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const DealListSort = {
  Date: 'date',
  FromPriceAsc: 'fromPrice_asc',
  FromPriceDesc: 'fromPrice_desc',
  New: 'new',
  Popularity: 'popularity',
  Search: 'search'
} as const;

export type DealListSort = typeof DealListSort[keyof typeof DealListSort];
export type DealLocation = {
  __typename?: 'DealLocation';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  dealUuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  merchantLocationUuid?: Maybe<Scalars['String']>;
  /** @deprecated Use 'postcode' now. */
  postCode?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  /** @deprecated Use 'id' now. */
  uuid?: Maybe<Scalars['String']>;
};

export type DealLocationFilterTags = {
  __typename?: 'DealLocationFilterTags';
  isNational?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type DealLocationFilterUpdateInput = {
  childrenIds: Array<Scalars['ID']>;
  filterable: Scalars['Boolean'];
  image: Scalars['String'];
  locale: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['ID'];
};

/**
 * Paginated List for entity DealLocation. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type DealLocationList = {
  __typename?: 'DealLocationList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<DealLocation>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type DealOrder = {
  __typename?: 'DealOrder';
  paymentId?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<DealOrderProduct>>>;
  total?: Maybe<DealOrderAmount>;
  totalBeforeDiscount?: Maybe<DealOrderAmount>;
  totalSavings?: Maybe<DealOrderAmount>;
  totalVAT?: Maybe<DealOrderAmount>;
  uuid?: Maybe<Scalars['ID']>;
};

export type DealOrderAmount = {
  __typename?: 'DealOrderAmount';
  currency?: Maybe<PaymentCurrencyType>;
  value?: Maybe<Scalars['Float']>;
};

export type DealOrderProduct = {
  __typename?: 'DealOrderProduct';
  items?: Maybe<Array<Maybe<DealOrderProductItem>>>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  /** @deprecated Use 'productId' or 'product.uuid' */
  uuid?: Maybe<Scalars['ID']>;
};

export type DealOrderProductItem = {
  __typename?: 'DealOrderProductItem';
  code?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  /** @deprecated Bad property name, use productId */
  product?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['String']>;
  /** @deprecated Bad data model, use productId */
  uuid?: Maybe<Scalars['ID']>;
};

export type DealPackageInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type DealPaymentOptions = {
  __typename?: 'DealPaymentOptions';
  zip?: Maybe<DealPaymentOptionsZip>;
};

export type DealPaymentOptionsZip = {
  __typename?: 'DealPaymentOptionsZip';
  enabled?: Maybe<Scalars['Boolean']>;
  rate?: Maybe<Scalars['String']>;
};

export type DealPriceModifier = {
  __typename?: 'DealPriceModifier';
  businessId: Scalars['String'];
  dealId: Scalars['String'];
  dealKind: PriceModifierDealKind;
  discount: Scalars['Float'];
  metadata?: Maybe<Metadata>;
  status: PriceModifierDealStatus;
  tier?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/**
 * Paginated List for entity DealPriceModifier. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type DealPriceModifiersList = {
  __typename?: 'DealPriceModifiersList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<DealPriceModifier>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type DealProductSnapshot = {
  __typename?: 'DealProductSnapshot';
  clippingPercentage?: Maybe<Scalars['Int']>;
  data?: Maybe<ProductData>;
  name?: Maybe<Scalars['String']>;
  salePrice?: Maybe<ProductSalePrice>;
  supplier?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
  vat?: Maybe<Scalars['Int']>;
};

export type DealRedemption = {
  __typename?: 'DealRedemption';
  Etag?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dateUnix?: Maybe<Scalars['Int']>;
  deal?: Maybe<Deal>;
  dealUnavailable?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  fullDeal?: Maybe<Deal>;
  isUsed?: Maybe<Scalars['Boolean']>;
  order?: Maybe<DealOrder>;
  pdf?: Maybe<Scalars['String']>;
  status?: Maybe<RedemptionStatus>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity DealRedemption. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type DealRedemptionList = {
  __typename?: 'DealRedemptionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<DealRedemption>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const DealReviewState = {
  Approved: 'APPROVED',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  UnknownReviewState: 'UNKNOWN_REVIEW_STATE',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type DealReviewState = typeof DealReviewState[keyof typeof DealReviewState];
export type DealSaga = {
  __typename?: 'DealSaga';
  basket?: Maybe<Basket>;
  currentStep?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
  errorData?: Maybe<DealSagaErrorData>;
  errorLog?: Maybe<Array<Maybe<Scalars['String']>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  nextStep?: Maybe<DealSagaStep>;
  paymentOrder?: Maybe<PaymentOrder>;
  paymentOrderId?: Maybe<Scalars['String']>;
  redemption?: Maybe<DealRedemption>;
  redemptionId?: Maybe<Scalars['String']>;
  status?: Maybe<DealSagaStep>;
  threeDS?: Maybe<DealSaga3ds>;
  totalSteps?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type DealSaga3ds = {
  __typename?: 'DealSaga3ds';
  issuerUrl?: Maybe<Scalars['String']>;
  md?: Maybe<Scalars['String']>;
  paRequest?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  termUrl?: Maybe<Scalars['String']>;
};

export type DealSagaErrorData = {
  __typename?: 'DealSagaErrorData';
  allowed?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['Int']>;
  hour?: Maybe<Scalars['Int']>;
  minute?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['Int']>;
  openValueFrom?: Maybe<Scalars['Int']>;
  openValueTo?: Maybe<Scalars['Int']>;
  period?: Maybe<Scalars['Int']>;
  second?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/**
 * Paginated List for entity DealSaga. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type DealSagaList = {
  __typename?: 'DealSagaList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<DealSaga>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const DealSagaStep = {
  Aborted: 'ABORTED',
  Complete: 'COMPLETE',
  Error: 'ERROR',
  Order: 'ORDER',
  Pay: 'PAY',
  Refund: 'REFUND',
  Started: 'STARTED',
  Update: 'UPDATE'
} as const;

export type DealSagaStep = typeof DealSagaStep[keyof typeof DealSagaStep];
export type DealSettings = {
  __typename?: 'DealSettings';
  companyBenefits: DealSettingsCompanyBenefits;
};

export type DealSettingsCompanyBenefits = {
  __typename?: 'DealSettingsCompanyBenefits';
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  topOfHomepage?: Maybe<Scalars['Boolean']>;
  whitelist: Array<DealSettingsCompanyBenefitsWhitelist>;
};

export type DealSettingsCompanyBenefitsInput = {
  logoUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  topOfHomepage?: InputMaybe<Scalars['Boolean']>;
  whitelist?: InputMaybe<Array<InputMaybe<DealSettingsCompanyBenefitsWhitelistInput>>>;
};

export type DealSettingsCompanyBenefitsWhitelist = {
  __typename?: 'DealSettingsCompanyBenefitsWhitelist';
  key: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type DealSettingsCompanyBenefitsWhitelistInput = {
  key: Scalars['ID'];
  value: Array<Scalars['ID']>;
};

export type DealSettingsInput = {
  companyBenefits?: InputMaybe<DealSettingsCompanyBenefitsInput>;
};

export const DealStatus = {
  Archived: 'ARCHIVED',
  Hidden: 'HIDDEN',
  Off: 'OFF',
  On: 'ON',
  Removed: 'REMOVED',
  Test: 'TEST',
  Unavailable: 'UNAVAILABLE',
  UnknownStatus: 'UNKNOWN_STATUS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type DealStatus = typeof DealStatus[keyof typeof DealStatus];
export type DealStockCount = {
  __typename?: 'DealStockCount';
  count: Scalars['Int'];
  id: Scalars['ID'];
};

export type DealStockCounts = {
  __typename?: 'DealStockCounts';
  allOutOfStock: Scalars['Boolean'];
  stockTotals: Array<Maybe<DealStockCount>>;
};

export const DealType = {
  Cashback: 'CASHBACK',
  Charity: 'CHARITY',
  Classic: 'CLASSIC',
  Company: 'COMPANY',
  Competition: 'COMPETITION',
  External: 'EXTERNAL',
  Merchandise: 'MERCHANDISE'
} as const;

export type DealType = typeof DealType[keyof typeof DealType];
export const DealsListType = {
  Company: 'COMPANY',
  Earn: 'EARN',
  NearMe: 'NEAR_ME',
  Spend: 'SPEND'
} as const;

export type DealsListType = typeof DealsListType[keyof typeof DealsListType];
export type DealsPackage = {
  __typename?: 'DealsPackage';
  addonIds: Array<Scalars['String']>;
  addons: Array<Tag>;
  /** @deprecated Not a thing anymore */
  homepage?: Maybe<DealsPackageHomepageTemp>;
  /** @deprecated Use region referenced in productsettings */
  homepageCategory?: Maybe<Tag>;
  /** @deprecated Use region referenced in productsettings */
  homepageCategoryId: Scalars['ID'];
  /** @deprecated Use region referenced in productsettings */
  homepageId: Scalars['ID'];
  /** @deprecated Not a thing anymore */
  locale?: Maybe<Scalars['String']>;
  /** @deprecated USe location filters directly */
  locationFilters?: Maybe<Tag>;
  /** @deprecated Should be retrieved from productsettings now. */
  maxTTAllowance?: Maybe<Scalars['Int']>;
  /** @deprecated Should be retrieved from productsettings now. */
  monthlyTTValue?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** @deprecated Use region referenced in productsettings */
  paymentCountryCode: PaymentCountryCode;
  /** @deprecated Use region referenced in productsettings */
  region: BillingRegion;
  /** @deprecated Use region referenced in productsettings */
  termsAndConditionsUrl: Scalars['String'];
  /** @deprecated Should be retrieved from productsettings now. */
  ttActivationDate?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type DealsPackageHomepageTemp = {
  __typename?: 'DealsPackageHomepageTemp';
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

/**
 * Paginated List for entity DealsPackage. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type DealsPackageList = {
  __typename?: 'DealsPackageList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<DealsPackage>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type DealsTag = {
  __typename?: 'DealsTag';
  dealCount: Scalars['Int'];
  filterable?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rewardCount: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type DealsTagInput = {
  filterable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Paginated List for entity DealsTag. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type DealsTagList = {
  __typename?: 'DealsTagList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<DealsTag>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type DetailGroup = {
  __typename?: 'DetailGroup';
  name?: Maybe<Scalars['String']>;
  paymentMethodData?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DetailItem = {
  __typename?: 'DetailItem';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DirectorySyncConfig = {
  __typename?: 'DirectorySyncConfig';
  launchAt?: Maybe<Date>;
  metadata?: Maybe<Metadata>;
  uuid: Scalars['ID'];
};

export type DiscountDiva = {
  __typename?: 'DiscountDiva';
  redemptions?: Maybe<Scalars['Int']>;
  totalSavingsAud?: Maybe<Scalars['Float']>;
  totalSavingsGbp?: Maybe<Scalars['Float']>;
  uniqueDeals?: Maybe<Scalars['Int']>;
};

export const DurationType = {
  Days: 'DAYS',
  DurationTypeUnknown: 'DURATION_TYPE_UNKNOWN',
  Hours: 'HOURS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type DurationType = typeof DurationType[keyof typeof DurationType];
/** An EAP phone number associated with a specific region. */
export type EapPhoneNumberEntry = {
  __typename?: 'EAPPhoneNumberEntry';
  /** The phone number to display for the region. */
  phoneNumber: Scalars['String'];
  /** ISO region code (e.g. GB, IE). */
  region: Scalars['String'];
};

/** Container for a list of EAP phone number entries. */
export type EapPhoneNumbers = {
  __typename?: 'EAPPhoneNumbers';
  /** List of EAP phone numbers with their associated regions. */
  phoneNumbers: Array<EapPhoneNumberEntry>;
};

export const EapTier = {
  Basic: 'BASIC',
  Enhanced: 'ENHANCED',
  Standard: 'STANDARD'
} as const;

export type EapTier = typeof EapTier[keyof typeof EapTier];
export type EmailChange = {
  newEmail?: InputMaybe<Scalars['String']>;
  oldEmail?: InputMaybe<Scalars['String']>;
};

export type Emoji = {
  __typename?: 'Emoji';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type EmployeeOrganisationData = {
  __typename?: 'EmployeeOrganisationData';
  id: Scalars['ID'];
  scheme?: Maybe<StoreScheme>;
  schemeWindow?: Maybe<Scalars['String']>;
};

export type EmploymentDetails = {
  __typename?: 'EmploymentDetails';
  annual_gross_salary?: Maybe<Scalars['String']>;
  employee_number?: Maybe<Scalars['String']>;
  hours_per_week?: Maybe<Scalars['String']>;
  job_grade?: Maybe<Scalars['String']>;
  ni_number?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<Scalars['String']>;
  probation_end_date?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  termination_date?: Maybe<Scalars['String']>;
};

export type EngagementGuru = {
  __typename?: 'EngagementGuru';
  engagementRate?: Maybe<Scalars['Float']>;
};

export type Enquiry = {
  __typename?: 'Enquiry';
  companyName: Scalars['String'];
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  leadId: Scalars['String'];
  licences: Scalars['Int'];
  middleName?: Maybe<Scalars['String']>;
  option?: Maybe<SignUpQuoteOption>;
};

export type EnquiryInput = {
  companyName: Scalars['String'];
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  leadId: Scalars['String'];
  licences: Scalars['Int'];
  middleName?: InputMaybe<Scalars['String']>;
  option?: InputMaybe<EnquiryInputOption>;
};

export type EnquiryInputOption = {
  billingPeriod: SignUpBillingPeriod;
  lengthOfContractInMonths: Scalars['Int'];
  pointsPerYear: Scalars['Int'];
  pricePerMonth: Scalars['Int'];
  provisioningPeriod: SignUpProvisioningPeriod;
  quoteId?: InputMaybe<Scalars['String']>;
};

export type ExpiryDetails = {
  __typename?: 'ExpiryDetails';
  amount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
};

export type ExpoVersionMapping = {
  __typename?: 'ExpoVersionMapping';
  appVersion: Scalars['String'];
  expoRequiredUpdate?: Maybe<Scalars['String']>;
};

export type ExternalDeal = {
  __typename?: 'ExternalDeal';
  approvalStatus?: Maybe<Scalars['String']>;
  bannerImage?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  cardImage?: Maybe<Scalars['String']>;
  deliveryHighlight?: Maybe<Scalars['String']>;
  deliveryInfo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['String']>;
  fullLocationTags?: Maybe<Array<Maybe<DealsTag>>>;
  fullTags?: Maybe<Array<Maybe<DealsTag>>>;
  header?: Maybe<Scalars['String']>;
  howItWorks?: Maybe<Array<Maybe<Scalars['String']>>>;
  importantInfo?: Maybe<Array<Maybe<Scalars['String']>>>;
  inactive?: Maybe<Scalars['Boolean']>;
  internalIdentifier?: Maybe<Scalars['String']>;
  invalid?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  locale?: Maybe<Scalars['String']>;
  nativeId?: Maybe<Scalars['String']>;
  redemptionInstructions?: Maybe<Scalars['String']>;
  savedBannerImage?: Maybe<Scalars['String']>;
  savedBrandName?: Maybe<Scalars['String']>;
  savedCardImage?: Maybe<Scalars['String']>;
  savedDeliveryInfo?: Maybe<Scalars['String']>;
  savedDescription?: Maybe<Scalars['String']>;
  savedFullLocationTags?: Maybe<Array<Maybe<DealsTag>>>;
  savedFullTags?: Maybe<Array<Maybe<DealsTag>>>;
  savedHeader?: Maybe<Scalars['String']>;
  savedHowItWorks?: Maybe<Array<Maybe<Scalars['String']>>>;
  savedImportantInfo?: Maybe<Array<Maybe<Scalars['String']>>>;
  savedInternalIdentifier?: Maybe<Scalars['String']>;
  savedKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  savedRedemptionInstructions?: Maybe<Scalars['String']>;
  savedSavings?: Maybe<UserSaving>;
  savedThumbnailImage?: Maybe<Scalars['String']>;
  savedURLSlug?: Maybe<Scalars['String']>;
  savings?: Maybe<UserSaving>;
  tags?: Maybe<Array<Scalars['ID']>>;
  thumbnailImage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  typeHighlight?: Maybe<Scalars['String']>;
  urlSlug?: Maybe<Scalars['String']>;
};

export type ExternalDealCounts = {
  __typename?: 'ExternalDealCounts';
  approved?: Maybe<Scalars['Int']>;
  inactiveOrRejected?: Maybe<Scalars['Int']>;
  invalidOrPending?: Maybe<Scalars['Int']>;
  modified?: Maybe<Scalars['Int']>;
  new?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Scalars['Int']>;
  unapprovedActiveAndValid?: Maybe<Scalars['Int']>;
};

export type ExternalDealInput = {
  apiCode: Scalars['String'];
  approvalStatus?: InputMaybe<Scalars['String']>;
  nativeId: Scalars['String'];
  savedBannerImage?: InputMaybe<Scalars['String']>;
  savedBrandName?: InputMaybe<Scalars['String']>;
  savedCardImage?: InputMaybe<Scalars['String']>;
  savedDeliveryInfo?: InputMaybe<Scalars['String']>;
  savedDescription?: InputMaybe<Scalars['String']>;
  savedFullLocationTags?: InputMaybe<Array<InputMaybe<DealsTagInput>>>;
  savedFullTags?: InputMaybe<Array<InputMaybe<DealsTagInput>>>;
  savedHeader?: InputMaybe<Scalars['String']>;
  savedHowItWorks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  savedImportantInfo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  savedInternalIdentifier?: InputMaybe<Scalars['String']>;
  savedKeywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  savedRedemptionInstructions?: InputMaybe<Scalars['String']>;
  savedSavings?: InputMaybe<UserSavingInput>;
  savedThumbnailImage?: InputMaybe<Scalars['String']>;
  savedURLSlug?: InputMaybe<Scalars['String']>;
};

/**
 * Paginated List for entity ExternalDeal. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type ExternalDealList = {
  __typename?: 'ExternalDealList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<ExternalDeal>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type FakeRedemption = {
  __typename?: 'FakeRedemption';
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['ID']>;
  fullDeal?: Maybe<Deal>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type FakeSaga = {
  __typename?: 'FakeSaga';
  basket?: Maybe<Basket>;
  checkoutId?: Maybe<Scalars['ID']>;
  currentStep?: Maybe<Scalars['Int']>;
  dealId?: Maybe<Scalars['ID']>;
  errorCode?: Maybe<Scalars['String']>;
  errorData?: Maybe<DealSagaErrorData>;
  errors?: Maybe<Array<Scalars['String']>>;
  nextStep?: Maybe<DealSagaStep>;
  paymentOrderId?: Maybe<Scalars['ID']>;
  redemption?: Maybe<FakeRedemption>;
  status?: Maybe<DealSagaStep>;
  totalSteps?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['ID']>;
};

export const FeatureFlagEntityType = {
  EntityBusiness: 'EntityBusiness',
  EntityRole: 'EntityRole',
  EntityTeam: 'EntityTeam'
} as const;

export type FeatureFlagEntityType = typeof FeatureFlagEntityType[keyof typeof FeatureFlagEntityType];
export const FeedEntityType = {
  Comment: 'comment',
  GroupCelebration: 'groupCelebration',
  Poll: 'poll',
  Recognition: 'recognition'
} as const;

export type FeedEntityType = typeof FeedEntityType[keyof typeof FeedEntityType];
export type FidelTransaction = {
  __typename?: 'FidelTransaction';
  authRequest?: Maybe<FidelTransactionRequest>;
  authTransactionImportedAt?: Maybe<Scalars['String']>;
  cashbackTransaction?: Maybe<CashbackTransaction>;
  clearingRequest?: Maybe<FidelTransactionRequest>;
  clearingTransactionImportedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  fidelTransactionUuid?: Maybe<Scalars['ID']>;
  merchantLocationUuid?: Maybe<Scalars['ID']>;
  merchantName?: Maybe<Scalars['String']>;
  merchantUuid?: Maybe<Scalars['ID']>;
  refundRequest?: Maybe<FidelTransactionRequest>;
  refundedAt?: Maybe<Scalars['String']>;
  transactionAmount?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['String']>;
  userCardUuid?: Maybe<Scalars['ID']>;
  uuid: Scalars['ID'];
};

export type FidelTransactionList = {
  __typename?: 'FidelTransactionList';
  count?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<FidelTransaction>>>;
  page?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type FidelTransactionRequest = {
  __typename?: 'FidelTransactionRequest';
  address?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  brandId: Scalars['ID'];
  city?: Maybe<Scalars['String']>;
  cleared?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastNumbers?: Maybe<Scalars['String']>;
};

export const FileStatus = {
  StatusDeleted: 'STATUS_DELETED',
  StatusFailed: 'STATUS_FAILED',
  StatusInfected: 'STATUS_INFECTED',
  StatusReady: 'STATUS_READY',
  StatusScanning: 'STATUS_SCANNING',
  StatusUnknown: 'STATUS_UNKNOWN',
  StatusValid: 'STATUS_VALID',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type FileStatus = typeof FileStatus[keyof typeof FileStatus];
export type FilterArgument = {
  bg?: InputMaybe<Scalars['Int']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hideLocked?: InputMaybe<Scalars['Boolean']>;
  maxPrice?: InputMaybe<Scalars['Float']>;
  minPrice?: InputMaybe<Scalars['Float']>;
  promo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  subcategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export const FlexiListScheduledSortEnum = {
  /** Events scheduled sooner appear at the beginning of the list and get older */
  ScheduledAtAsc: 'SCHEDULED_AT_ASC',
  /** Latest scheduled event first */
  ScheduledAtDsc: 'SCHEDULED_AT_DSC'
} as const;

export type FlexiListScheduledSortEnum = typeof FlexiListScheduledSortEnum[keyof typeof FlexiListScheduledSortEnum];
export type FlexiPointTransfer = {
  __typename?: 'FlexiPointTransfer';
  amount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  destinationIds: Array<Scalars['ID']>;
  details?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['ID']>;
  status?: Maybe<FlexiPointsTransferStatus>;
  uuid?: Maybe<Scalars['ID']>;
};

export type FlexiPointsAssignCredit = {
  __typename?: 'FlexiPointsAssignCredit';
  message?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  transferIds: Array<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type FlexiPointsExpiry = {
  __typename?: 'FlexiPointsExpiry';
  breakdown?: Maybe<Array<Maybe<ExpiryDetails>>>;
  cursor?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type FlexiPointsReward = {
  __typename?: 'FlexiPointsReward';
  message?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  transferIds: Array<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

export const FlexiPointsTransferStatus = {
  Complete: 'COMPLETE',
  Failed: 'FAILED',
  Pending: 'PENDING',
  TransferStatusTypeUnknown: 'TRANSFER_STATUS_TYPE_UNKNOWN'
} as const;

export type FlexiPointsTransferStatus = typeof FlexiPointsTransferStatus[keyof typeof FlexiPointsTransferStatus];
export type FlexiRewardScheduleInput = {
  originalTimezone: Scalars['String'];
  when: Scalars['String'];
};

export type FooterLinks = {
  __typename?: 'FooterLinks';
  customFooterLinks?: Maybe<Array<PayrollPayCustomFooterLink>>;
  showAccessibility?: Maybe<Scalars['Boolean']>;
  showContactUs?: Maybe<Scalars['Boolean']>;
  showCookiePolicy?: Maybe<Scalars['Boolean']>;
  showManageCookies?: Maybe<Scalars['Boolean']>;
  showOrganisationPrivacyNotice?: Maybe<Scalars['Boolean']>;
  showPrivacyPolicy?: Maybe<Scalars['Boolean']>;
  showPromotionalTermsAndConditions?: Maybe<Scalars['Boolean']>;
  showTermsAndConditions?: Maybe<Scalars['Boolean']>;
  showVivupPrivacyNotice?: Maybe<Scalars['Boolean']>;
};

export type FraudBlacklistedEmail = {
  __typename?: 'FraudBlacklistedEmail';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  state?: Maybe<FraudBlacklistedEmailState>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export const FraudBlacklistedEmailState = {
  Active: 'ACTIVE',
  BlacklistedEmailStateUnknown: 'BLACKLISTED_EMAIL_STATE_UNKNOWN',
  Inactive: 'INACTIVE'
} as const;

export type FraudBlacklistedEmailState = typeof FraudBlacklistedEmailState[keyof typeof FraudBlacklistedEmailState];
/**
 * Paginated List for entity FraudBlacklistedEmail. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type FraudBlacklistedEmailsList = {
  __typename?: 'FraudBlacklistedEmailsList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<FraudBlacklistedEmail>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type FraudThreshold = {
  __typename?: 'FraudThreshold';
  business?: Maybe<Business>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  enabled?: Maybe<Scalars['Boolean']>;
  fraudDurationHours?: Maybe<Scalars['Int']>;
  revisionId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['ID']>;
  threshold?: Maybe<Scalars['Int']>;
  type?: Maybe<FraudThresholdType>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

/**
 * Paginated List for entity FraudThreshold. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type FraudThresholdList = {
  __typename?: 'FraudThresholdList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<FraudThreshold>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const FraudThresholdType = {
  BusinessOrderAmount: 'BUSINESS_ORDER_AMOUNT',
  UserOrderCount: 'USER_ORDER_COUNT'
} as const;

export type FraudThresholdType = typeof FraudThresholdType[keyof typeof FraudThresholdType];
export type FrequentlyAskedQuestion = {
  __typename?: 'FrequentlyAskedQuestion';
  answer?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type GdprRemoveUsersResponse = {
  __typename?: 'GDPRRemoveUsersResponse';
  email?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GenerateAssertionMetadata = {
  vivup?: InputMaybe<VivupMetadata>;
};

export const GenerateAssertionProvider = {
  ServiceProviderGymflex: 'SERVICE_PROVIDER_GYMFLEX',
  ServiceProviderHealthhero: 'SERVICE_PROVIDER_HEALTHHERO',
  ServiceProviderLoveElectric: 'SERVICE_PROVIDER_LOVE_ELECTRIC',
  ServiceProviderMyMoneyMatters: 'SERVICE_PROVIDER_MY_MONEY_MATTERS',
  ServiceProviderTusker: 'SERVICE_PROVIDER_TUSKER',
  ServiceProviderUnknown: 'SERVICE_PROVIDER_UNKNOWN',
  ServiceProviderVivup: 'SERVICE_PROVIDER_VIVUP',
  ServiceProviderVivupCtw: 'SERVICE_PROVIDER_VIVUP_CTW',
  ServiceProviderVivupEap: 'SERVICE_PROVIDER_VIVUP_EAP',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type GenerateAssertionProvider = typeof GenerateAssertionProvider[keyof typeof GenerateAssertionProvider];
export const GetAuthUrlRequestClientType = {
  Android: 'ANDROID',
  Ios: 'IOS',
  Unrecognized: 'UNRECOGNIZED',
  Web: 'WEB'
} as const;

export type GetAuthUrlRequestClientType = typeof GetAuthUrlRequestClientType[keyof typeof GetAuthUrlRequestClientType];
export type GetAuthUrlResponse = {
  __typename?: 'GetAuthURLResponse';
  url?: Maybe<Scalars['String']>;
};

export type GetAutoApprovedUserBudgetInput = {
  budgetCategoryId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type GetHolidayQuoteValues = {
  __typename?: 'GetHolidayQuoteValues';
  employeeOrganisation?: Maybe<HolidayQuoteSchemeData>;
};

export type GetMarketingProfileInput = {
  optSettingsToCreate?: InputMaybe<MarketingProfileSettingsInput>;
  userId: Scalars['ID'];
};

export type GetOAuthSettingsResponse = {
  __typename?: 'GetOAuthSettingsResponse';
  businessId?: Maybe<Scalars['String']>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  metadata?: Maybe<Metadata>;
  provider?: Maybe<OAuthProvider>;
  uuid?: Maybe<Scalars['String']>;
};

export type GetQuoteBrochureGroup = {
  __typename?: 'GetQuoteBrochureGroup';
  id: Scalars['ID'];
  term?: Maybe<Scalars['String']>;
};

export type GetQuoteEmployeeOrganisation = {
  __typename?: 'GetQuoteEmployeeOrganisation';
  id: Scalars['ID'];
  scheme?: Maybe<GetQuoteScheme>;
};

export type GetQuotePageData = {
  __typename?: 'GetQuotePageData';
  employeeOrganisation?: Maybe<GetQuoteEmployeeOrganisation>;
};

export type GetQuoteScheme = {
  __typename?: 'GetQuoteScheme';
  bikeTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  brochureGroups?: Maybe<Array<Maybe<GetQuoteBrochureGroup>>>;
  faq?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  recurringDonationExists?: Maybe<Scalars['Boolean']>;
  salaryBracketCategory?: Maybe<Scalars['String']>;
};

export type GetUploadUrlResponse = {
  __typename?: 'GetUploadUrlResponse';
  uploadId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type GlobalTenant = {
  __typename?: 'GlobalTenant';
  businessId?: Maybe<Scalars['ID']>;
  region?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  /** @deprecated Use 'businessId' instead. */
  tenantId?: Maybe<Scalars['String']>;
};

export type GroupCelebration = {
  __typename?: 'GroupCelebration';
  author: User;
  budget?: Maybe<BudgetCategory>;
  businessId: Scalars['ID'];
  collaborators?: Maybe<Array<Maybe<User>>>;
  comments?: Maybe<RecognitionFeedCommentList>;
  customRewardId?: Maybe<Scalars['String']>;
  greeting: CelebrationTag;
  messages?: Maybe<Array<Maybe<GroupCelebrationMessage>>>;
  moderated?: Maybe<Scalars['Boolean']>;
  originalTimezone: Scalars['String'];
  reactions?: Maybe<RecognitionFeedReactionList>;
  receiver: User;
  rewardAmount: Scalars['Int'];
  scheduledAt: Scalars['Int'];
  scheduledEventId: Scalars['ID'];
  source: ScheduledRecognitionSource;
  status: GroupCelebrationStatus;
  uuid: Scalars['ID'];
  visibility: GroupCelebrationVisibility;
  walletTransferIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  when: Scalars['String'];
};

/**
 * Paginated List for entity GroupCelebration. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type GroupCelebrationList = {
  __typename?: 'GroupCelebrationList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<GroupCelebration>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type GroupCelebrationMessage = {
  __typename?: 'GroupCelebrationMessage';
  authorId?: Maybe<Scalars['ID']>;
  createdBy?: Maybe<User>;
  message?: Maybe<Scalars['String']>;
  moderated?: Maybe<Scalars['Boolean']>;
  parentId?: Maybe<Scalars['ID']>;
  status?: Maybe<GroupCelebrationStatus>;
  uuid?: Maybe<Scalars['ID']>;
};

export const GroupCelebrationSource = {
  Perkbox: 'PERKBOX',
  SourceUnknown: 'SOURCE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type GroupCelebrationSource = typeof GroupCelebrationSource[keyof typeof GroupCelebrationSource];
export const GroupCelebrationStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Closed: 'CLOSED',
  PublishFailure: 'PUBLISH_FAILURE',
  Scheduled: 'SCHEDULED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type GroupCelebrationStatus = typeof GroupCelebrationStatus[keyof typeof GroupCelebrationStatus];
export const GroupCelebrationVisibility = {
  Everyone: 'EVERYONE',
  Private: 'PRIVATE',
  Teams: 'TEAMS',
  Unrecognized: 'UNRECOGNIZED',
  VisibilityUnknown: 'VISIBILITY_UNKNOWN'
} as const;

export type GroupCelebrationVisibility = typeof GroupCelebrationVisibility[keyof typeof GroupCelebrationVisibility];
export type GymBenefitOrder = {
  __typename?: 'GymBenefitOrder';
  id: Scalars['ID'];
};

export type GymBenefitOrderData = {
  __typename?: 'GymBenefitOrderData';
  errors?: Maybe<Array<GymBenefitOrderError>>;
  order?: Maybe<GymBenefitOrder>;
};

export type GymBenefitOrderError = {
  __typename?: 'GymBenefitOrderError';
  fieldName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type HelixOrder = {
  __typename?: 'HelixOrder';
  action?: Maybe<Scalars['String']>;
  data?: Maybe<HelixOrderData>;
  dateUnix?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Metadata>;
  orderId?: Maybe<Scalars['ID']>;
  rawData?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type HelixOrderData = HelixOrderProductCanceled | HelixOrderProductShipped;

/**
 * Paginated List for entity HelixOrder. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type HelixOrderList = {
  __typename?: 'HelixOrderList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<HelixOrder>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type HelixOrderProductCanceled = {
  __typename?: 'HelixOrderProductCanceled';
  orderId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type HelixOrderProductShipped = {
  __typename?: 'HelixOrderProductShipped';
  orderId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  shippingDate?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingProvider?: Maybe<Scalars['ID']>;
  trackingProviderName?: Maybe<Scalars['String']>;
};

export type HolidayQuoteScheme = {
  __typename?: 'HolidayQuoteScheme';
  quoteSavings?: Maybe<QuoteSavings>;
};


export type HolidayQuoteSchemeQuoteSavingsArgs = {
  quotePrice: Scalars['String'];
};

export type HolidayQuoteSchemeData = {
  __typename?: 'HolidayQuoteSchemeData';
  scheme?: Maybe<HolidayQuoteScheme>;
};


export type HolidayQuoteSchemeDataSchemeArgs = {
  schemeTypeRelativeUrl: Scalars['ID'];
};

export type HomePage = {
  __typename?: 'HomePage';
  isEnabled?: Maybe<Scalars['Boolean']>;
  widgets?: Maybe<Array<Maybe<HomePageWidget>>>;
};

export type HomePageLaneQuery = {
  __typename?: 'HomePageLaneQuery';
  favouritesOnly?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  tag?: Maybe<DealsTag>;
  type?: Maybe<Scalars['String']>;
};

export type HomePageLayout = {
  __typename?: 'HomePageLayout';
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  xOffset?: Maybe<Scalars['Int']>;
  yOffset?: Maybe<Scalars['Int']>;
};

export type HomePageWidget = {
  __typename?: 'HomePageWidget';
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<HomePageWidgetImage>;
  imageWithText?: Maybe<HomePageWidgetImageWithText>;
  layouts?: Maybe<HomePageWidgetLayouts>;
  type?: Maybe<HomePageWidgetTypes>;
  video?: Maybe<HomePageWidgetVideo>;
};

export type HomePageWidgetImage = {
  __typename?: 'HomePageWidgetImage';
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
};

export type HomePageWidgetImageWithText = {
  __typename?: 'HomePageWidgetImageWithText';
  body?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
};

export type HomePageWidgetLayouts = {
  __typename?: 'HomePageWidgetLayouts';
  desktop?: Maybe<HomePageLayout>;
  mobile?: Maybe<HomePageLayout>;
};

export const HomePageWidgetTypes = {
  Image: 'image',
  ImageWithText: 'imageWithText',
  Video: 'video'
} as const;

export type HomePageWidgetTypes = typeof HomePageWidgetTypes[keyof typeof HomePageWidgetTypes];
export type HomePageWidgetVideo = {
  __typename?: 'HomePageWidgetVideo';
  videoUrl?: Maybe<Scalars['String']>;
};

export type Homepage = {
  __typename?: 'Homepage';
  banner?: Maybe<Deal>;
  bannerTagId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  kind?: Maybe<HomepageKind>;
  lanes: Array<HomepageLane>;
  metadata?: Maybe<Metadata>;
  name: Scalars['String'];
  state?: Maybe<HomepageState>;
  topCategoriesId?: Maybe<Scalars['ID']>;
  uuid: Scalars['ID'];
};

export type HomepageInput = {
  bannerTagId?: InputMaybe<Scalars['ID']>;
  description: Scalars['String'];
  kind?: InputMaybe<HomepageKind>;
  lanes?: InputMaybe<Array<InputMaybe<HomepageLanesInput>>>;
  name: Scalars['String'];
  state?: InputMaybe<HomepageState>;
  topCategoriesId?: InputMaybe<Scalars['ID']>;
};

export const HomepageKind = {
  KindPerks: 'KIND_PERKS',
  KindPlatform: 'KIND_PLATFORM',
  KindPlatformV2: 'KIND_PLATFORM_V2',
  KindUnknown: 'KIND_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type HomepageKind = typeof HomepageKind[keyof typeof HomepageKind];
export type HomepageLane = {
  __typename?: 'HomepageLane';
  bodyText?: Maybe<Scalars['String']>;
  data?: Maybe<DealList>;
  deals?: Maybe<Array<Maybe<Deal>>>;
  fallbackQuery?: Maybe<HomepageLaneQuery>;
  headerText?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  /** @deprecated Use 'seeMoreUrl' now. */
  linkedEntityUrl?: Maybe<Scalars['String']>;
  query?: Maybe<HomepageLaneQuery>;
  seeMoreUrl?: Maybe<Scalars['String']>;
  tag?: Maybe<DealsTag>;
  type?: Maybe<HomepageLaneType>;
};

/**
 * Paginated List for entity HomepageLane. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type HomepageLaneList = {
  __typename?: 'HomepageLaneList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<HomepageLane>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type HomepageLaneQuery = {
  __typename?: 'HomepageLaneQuery';
  /** @deprecated No longer used. */
  distinct?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer used. */
  geo?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer used. */
  hideEB?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer used. */
  hidePerksGo?: Maybe<Scalars['Boolean']>;
  isRewards?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Scalars['String']>>;
  tag?: Maybe<DealsTag>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  ttOnly?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type HomepageLaneQueryInput = {
  distinct?: InputMaybe<Scalars['Boolean']>;
  geo?: InputMaybe<Scalars['Boolean']>;
  hideEB?: InputMaybe<Scalars['Boolean']>;
  hidePerksGo?: InputMaybe<Scalars['Boolean']>;
  isRewards?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
  ttOnly?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export const HomepageLaneType = {
  AdsPerkboxPicks: 'ADS_PERKBOX_PICKS',
  Company: 'COMPANY',
  ContentCardBanner: 'CONTENT_CARD_BANNER',
  Earn: 'EARN',
  Explore: 'EXPLORE',
  GroceriesBanner: 'GROCERIES_BANNER',
  HeroBanner: 'HERO_BANNER',
  HomepageLaneTypeUnknown: 'HomepageLaneType_UNKNOWN',
  MyFavourites: 'MY_FAVOURITES',
  MyInterests: 'MY_INTERESTS',
  NearMe: 'NEAR_ME',
  New: 'NEW',
  Other: 'OTHER',
  Recognition: 'RECOGNITION',
  SearchPerks: 'SEARCH_PERKS',
  Spend: 'SPEND',
  Tag: 'TAG',
  Trending: 'TRENDING',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type HomepageLaneType = typeof HomepageLaneType[keyof typeof HomepageLaneType];
export type HomepageLanesInput = {
  bodyText?: InputMaybe<Scalars['String']>;
  fallbackQuery?: InputMaybe<HomepageLaneQueryInput>;
  headerText?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  linkedEntityUrl?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<HomepageLaneQueryInput>;
  type?: InputMaybe<HomepageLaneType>;
};

/**
 * Paginated List for entity Homepage. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type HomepageList = {
  __typename?: 'HomepageList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Homepage>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const HomepageState = {
  Active: 'ACTIVE',
  HomepageStateUnknown: 'HOMEPAGE_STATE_UNKNOWN',
  Inactive: 'INACTIVE',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type HomepageState = typeof HomepageState[keyof typeof HomepageState];
export type HomepageUpdateInput = {
  bannerTagId?: InputMaybe<Scalars['ID']>;
  description: Scalars['String'];
  kind?: InputMaybe<HomepageKind>;
  lanes?: InputMaybe<Array<InputMaybe<HomepageLanesInput>>>;
  name: Scalars['String'];
  state?: InputMaybe<HomepageState>;
  topCategoriesId?: InputMaybe<Scalars['ID']>;
  uuid: Scalars['ID'];
};

export type Incident = {
  __typename?: 'Incident';
  dateUnix?: Maybe<Scalars['Int']>;
  deal?: Maybe<Deal>;
  dealId?: Maybe<Scalars['ID']>;
  details?: Maybe<Scalars['String']>;
  driver?: Maybe<IncidentDriver>;
  externalId?: Maybe<Scalars['ID']>;
  externalUrl?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  productExternalId?: Maybe<Scalars['ID']>;
  provider?: Maybe<ProductProvider>;
  providerProductExternalId?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<IncidentStatus>;
  timeout?: Maybe<Scalars['Int']>;
  ttl?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['ID']>;
};

export const IncidentDriver = {
  DriverManual: 'DRIVER_MANUAL',
  DriverStatusPage: 'DRIVER_STATUS_PAGE',
  DriverStockFailure: 'DRIVER_STOCK_FAILURE',
  DriverUnknown: 'DRIVER_UNKNOWN',
  DriverWebhook: 'DRIVER_WEBHOOK',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type IncidentDriver = typeof IncidentDriver[keyof typeof IncidentDriver];
export const IncidentStatus = {
  StatusMonitoring: 'STATUS_MONITORING',
  StatusNew: 'STATUS_NEW',
  StatusResolved: 'STATUS_RESOLVED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type IncidentStatus = typeof IncidentStatus[keyof typeof IncidentStatus];
/**
 * Paginated List for entity Incident. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type IncidentsList = {
  __typename?: 'IncidentsList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Incident>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type IndividualCheck = {
  __typename?: 'IndividualCheck';
  ignored: Scalars['Boolean'];
  link?: Maybe<VerificationLink>;
  outcome?: Maybe<SignUpOutcome>;
  uuid: Scalars['String'];
};

export type IngestionJob = {
  __typename?: 'IngestionJob';
  dateUnix?: Maybe<Scalars['Int']>;
  extractSummary?: Maybe<IngestionJobExtractSummary>;
  fullRefresh?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  provider?: Maybe<PendingDealProvider>;
  status?: Maybe<IngestionJobStatus>;
  uuid: Scalars['ID'];
};

export type IngestionJobExtractSummary = {
  __typename?: 'IngestionJobExtractSummary';
  deletesCount?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  insertsCount?: Maybe<Scalars['Int']>;
  updatesCount?: Maybe<Scalars['Int']>;
};

/**
 * Paginated List for entity IngestionJob. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type IngestionJobList = {
  __typename?: 'IngestionJobList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<IngestionJob>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const IngestionJobStatus = {
  StatusCompleted: 'STATUS_COMPLETED',
  StatusExtracting: 'STATUS_EXTRACTING',
  StatusFailed: 'STATUS_FAILED',
  StatusNew: 'STATUS_NEW',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type IngestionJobStatus = typeof IngestionJobStatus[keyof typeof IngestionJobStatus];
export type InputBillingNotifyCtaScreenSeen = {
  ctaScreen?: InputMaybe<BillingCtaScreen>;
};

export type InputDetail = {
  __typename?: 'InputDetail';
  details?: Maybe<Array<Maybe<SubInputDetail>>>;
  itemSearchUrl?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<DetailItem>>>;
  key?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type InputRenewalContact = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

export type InputRenewalDiscount = {
  duration?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Float']>;
  recurringChargeId?: InputMaybe<Scalars['String']>;
};

export type InputRenewalOption = {
  annualCost?: InputMaybe<Scalars['Float']>;
  annualSaving?: InputMaybe<Scalars['Int']>;
  costPerSeatMonth?: InputMaybe<Scalars['Int']>;
  costPerSeatMonth4Dp?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<Scalars['Float']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  termLength?: InputMaybe<Scalars['Float']>;
};

export type InputRenewalProduct = {
  costPerSeatMonth?: InputMaybe<Scalars['Int']>;
  costPerSeatMonth4Dp?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<InputRenewalDiscount>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  recurringChargeId?: InputMaybe<Scalars['String']>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seats?: InputMaybe<Scalars['Int']>;
  uncounted?: InputMaybe<Scalars['Boolean']>;
  usageChargeId?: InputMaybe<Scalars['String']>;
};

export type InputRenewalUpsellContact = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  soldToIsBillTo?: InputMaybe<Scalars['Boolean']>;
  telephone?: InputMaybe<Scalars['String']>;
};

export type Inspiration = {
  __typename?: 'Inspiration';
  desc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCompanyValue?: Maybe<Scalars['Boolean']>;
  suggestion?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  trophy?: Maybe<Trophy>;
};

/**
 * Paginated List for entity Inspiration. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type InspirationList = {
  __typename?: 'InspirationList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Inspiration>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const InternalFeatureFlags = {
  AuthGhost: 'AuthGhost',
  AuthIAdminCanGdprUsers: 'AuthIAdminCanGDPRUsers',
  AuthIAdminEngineering: 'AuthIAdminEngineering',
  AuthIAdminReadOnly: 'AuthIAdminReadOnly',
  AuthMfaManage: 'AuthMFAManage',
  AuthManageSessionsAndDevices: 'AuthManageSessionsAndDevices',
  ChannelPartnerFullAccess: 'ChannelPartnerFullAccess',
  CoreBusinessFullAccess: 'CoreBusinessFullAccess',
  CoreGroupsFullAccess: 'CoreGroupsFullAccess',
  CoreUsersFullAccess: 'CoreUsersFullAccess',
  DealDiscountsFullAccess: 'DealDiscountsFullAccess',
  FlexiRewardsFullAccess: 'FlexiRewardsFullAccess',
  GodModeFlag: 'GodModeFlag',
  InsightsFullAccess: 'InsightsFullAccess',
  ManagePaymentsChAccess: 'ManagePaymentsCHAccess',
  ManagePaymentsFullAccess: 'ManagePaymentsFullAccess',
  ManageStockFullAccess: 'ManageStockFullAccess',
  ManageStockReadOnly: 'ManageStockReadOnly',
  MedicalFullAccess: 'MedicalFullAccess',
  OnboardingBusinessFullAccess: 'OnboardingBusinessFullAccess',
  OnboardingUserFullAccess: 'OnboardingUserFullAccess',
  OpenApiFullAccess: 'OpenApiFullAccess',
  PerksFullAccess: 'PerksFullAccess',
  RegionsFullAccess: 'RegionsFullAccess',
  ReportingFullAccess: 'ReportingFullAccess',
  RnRFullAccess: 'RnRFullAccess',
  TenantWalletFullAccess: 'TenantWalletFullAccess',
  V4RedemptionFullAccess: 'V4RedemptionFullAccess',
  WorkOsFullAccess: 'WorkOSFullAccess',
  ZuoraProductMappingsFullAccess: 'ZuoraProductMappingsFullAccess'
} as const;

export type InternalFeatureFlags = typeof InternalFeatureFlags[keyof typeof InternalFeatureFlags];
export type InternalUser = {
  __typename?: 'InternalUser';
  email?: Maybe<Scalars['String']>;
  featureFlags?: Maybe<Array<Maybe<InternalFeatureFlags>>>;
  fullName?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  locationDescription?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  profileImageUrl?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

/**
 * Paginated List for entity InternalUser. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type InternalUserList = {
  __typename?: 'InternalUserList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<InternalUser>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type InviteFamilyFriendUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type InviteFamilyFriendUserResponse = {
  __typename?: 'InviteFamilyFriendUserResponse';
  invitedUser: User;
  user: User;
};

export type InvitedUser = {
  __typename?: 'InvitedUser';
  status?: Maybe<InvitedUserStatus>;
  userId?: Maybe<Scalars['ID']>;
};

export const InvitedUserStatus = {
  Accepted: 'Accepted',
  Pending: 'Pending',
  Rejected: 'Rejected',
  Unrecognized: 'UNRECOGNIZED',
  Unknown: 'Unknown'
} as const;

export type InvitedUserStatus = typeof InvitedUserStatus[keyof typeof InvitedUserStatus];
export type Invoice = {
  __typename?: 'Invoice';
  amount?: Maybe<Scalars['Int']>;
  balance?: Maybe<Scalars['Int']>;
  businessID?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type IosPaymentSettings = {
  __typename?: 'IosPaymentSettings';
  applePayId?: Maybe<Scalars['String']>;
  iosReturnUrl?: Maybe<Scalars['String']>;
};

export type ItemRedemption = {
  __typename?: 'ItemRedemption';
  error?: Maybe<ItemRedemptionError>;
  item?: Maybe<BasketItem>;
  redemptionId?: Maybe<Scalars['ID']>;
  status?: Maybe<ItemRedemptionStatus>;
};

export type ItemRedemptionError = {
  __typename?: 'ItemRedemptionError';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export const ItemRedemptionStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Pending: 'PENDING',
  Refunded: 'REFUNDED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ItemRedemptionStatus = typeof ItemRedemptionStatus[keyof typeof ItemRedemptionStatus];
export type Lane = {
  __typename?: 'Lane';
  bodyText?: Maybe<Scalars['String']>;
  deals?: Maybe<Array<Maybe<Deal>>>;
  headerText?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  linkedEntityUrl?: Maybe<Scalars['String']>;
  query?: Maybe<HomePageLaneQuery>;
  tag?: Maybe<DealsTag>;
  type?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity Lane. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type LaneList = {
  __typename?: 'LaneList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Lane>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type LayoutScheme = {
  __typename?: 'LayoutScheme';
  banners?: Maybe<Array<PayrollPayBanner>>;
  basket?: Maybe<PayrollPayBasketTotals>;
  eligibilityAndLimitationsFeatureFlag?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isNewNet?: Maybe<Scalars['Boolean']>;
  quoteType?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  store?: Maybe<LayoutStore>;
  supplierDesktopBanner?: Maybe<Scalars['String']>;
  supplierMobileBanner?: Maybe<Scalars['String']>;
  supportLinks?: Maybe<Array<PayrollPaySupportLink>>;
  userOrganisationDetail?: Maybe<UserOrganisationDetail>;
  weeksPerYear?: Maybe<Scalars['Int']>;
  windowEndDate?: Maybe<Scalars['String']>;
  windowStartDate?: Maybe<Scalars['String']>;
};

export type LayoutStore = {
  __typename?: 'LayoutStore';
  algoliaFilters?: Maybe<PrpAlgoliaFilters>;
  algoliaSuggestions?: Maybe<PrpAlgoliaSuggestions>;
  departments?: Maybe<Array<StoreDepartment>>;
  localBikeShopEnabled?: Maybe<Scalars['Boolean']>;
};

export type LayoutWidgetConfig = {
  __typename?: 'LayoutWidgetConfig';
  content?: Maybe<LayoutWidgetConfigContent>;
  xpos?: Maybe<Scalars['Int']>;
  ypos?: Maybe<Scalars['Int']>;
};

export type LayoutWidgetConfigContent = {
  __typename?: 'LayoutWidgetConfigContent';
  height?: Maybe<Scalars['Int']>;
  type?: Maybe<LayoutWidgetType>;
  width?: Maybe<Scalars['Int']>;
};

export type LayoutWidgetConfigContentInput = {
  height: Scalars['Int'];
  type: LayoutWidgetType;
  width: Scalars['Int'];
};

export type LayoutWidgetConfigInput = {
  content: LayoutWidgetConfigContentInput;
  xpos: Scalars['Int'];
  ypos: Scalars['Int'];
};

export const LayoutWidgetType = {
  CompanyNews: 'companyNews',
  Perks: 'perks',
  Products: 'products'
} as const;

export type LayoutWidgetType = typeof LayoutWidgetType[keyof typeof LayoutWidgetType];
export type LayoutWidgets = {
  __typename?: 'LayoutWidgets';
  config?: Maybe<Array<Maybe<LayoutWidgetConfig>>>;
};

export type LayoutWidgetsInput = {
  config: Array<InputMaybe<LayoutWidgetConfigInput>>;
};

export type LimitExceededDetails = {
  __typename?: 'LimitExceededDetails';
  /** @deprecated This field is no longer used and will be removed in a future release. */
  benefitActiveOrdersExceeded?: Maybe<Scalars['Boolean']>;
  /** @deprecated This field is no longer used and will be removed in a future release. */
  totalBenefitOrderLimitExceeded?: Maybe<Scalars['Boolean']>;
};

export type LimitationMessage = {
  __typename?: 'LimitationMessage';
  translation?: Maybe<Scalars['String']>;
  values?: Maybe<LimitationMessageValues>;
};

export type LimitationMessageValues = {
  __typename?: 'LimitationMessageValues';
  allowLimit?: Maybe<Scalars['Float']>;
  availableAmountPerFrequency?: Maybe<Scalars['Float']>;
  countLimit?: Maybe<Scalars['Int']>;
  countLimitRemaining?: Maybe<Scalars['Int']>;
  valueLimitRemaining?: Maybe<Scalars['Float']>;
};

export type ListAutoApprovedUserBudgetsInput = {
  filter?: InputMaybe<AutoApprovedUserBudgetsFilter>;
  searchAfter?: InputMaybe<Scalars['String']>;
};

export type ListCompanies = {
  __typename?: 'ListCompanies';
  companyToken?: Maybe<Scalars['String']>;
  filter: ListCompaniesFilter;
  pageSize?: Maybe<Scalars['Int']>;
  uuid: Scalars['String'];
};

export type ListCompaniesFilter = {
  __typename?: 'ListCompaniesFilter';
  country: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
};

export type ListCompaniesFilterInput = {
  country: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
};

export type ListCustomRewardsTransactionsFilter = {
  authorId?: InputMaybe<Scalars['ID']>;
  isUsed?: InputMaybe<Scalars['Boolean']>;
  receiverId?: InputMaybe<Scalars['ID']>;
};

export type ListDealBrandFiltersInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  isParent?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['ID']>;
  searchString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DealBrandStatus>;
};

export type ListDealBrandsInput = {
  filters?: InputMaybe<ListDealBrandFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  searchAfter?: InputMaybe<Scalars['String']>;
};

export type ListIncidentsFiltersInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  dealId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<IncidentStatus>;
};

export type ListIncidentsInput = {
  filters?: InputMaybe<ListIncidentsFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  searchAfter?: InputMaybe<Scalars['String']>;
};

export const ListMediaRentalsExpiryStatus = {
  Active: 'ACTIVE',
  Any: 'ANY',
  Expired: 'EXPIRED',
  ExpiryStatusUnknown: 'EXPIRY_STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ListMediaRentalsExpiryStatus = typeof ListMediaRentalsExpiryStatus[keyof typeof ListMediaRentalsExpiryStatus];
export type ListMyCustomRewardsTransactionsFilter = {
  isUsed?: InputMaybe<Scalars['Boolean']>;
};

export type ListPointsRequestsInput = {
  idType?: InputMaybe<PointsRequestFilterType>;
  searchAfter?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PointsRequestStatus>;
  uuid?: InputMaybe<Scalars['ID']>;
};

export type ListRolesResponse = {
  __typename?: 'ListRolesResponse';
  results?: Maybe<Array<Maybe<Role>>>;
};

export type ListScheduledRewards = {
  __typename?: 'ListScheduledRewards';
  amount: Scalars['Int'];
  businessId: Scalars['ID'];
  currency: Scalars['String'];
  destinationIds: Array<Scalars['ID']>;
  message: Scalars['String'];
  occasionId?: Maybe<Scalars['ID']>;
  recipientCount: Scalars['Int'];
  scheduledFor: ScheduledTime;
  sourceId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type ListScheduledRewardsInput = {
  businessId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<FlexiListScheduledSortEnum>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type ListSelfRegistrationCodesResponse = {
  __typename?: 'ListSelfRegistrationCodesResponse';
  codes?: Maybe<Array<Maybe<SelfRegistrationCode>>>;
  nextPageToken?: Maybe<Scalars['String']>;
};

export type LockedProductRecommendation = {
  __typename?: 'LockedProductRecommendation';
  availableSizes?: Maybe<Array<Maybe<Scalars['String']>>>;
  brand?: Maybe<Scalars['String']>;
  brochureGroupId?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['ID']>;
  productTagImage?: Maybe<Scalars['String']>;
  productTagName?: Maybe<Scalars['String']>;
  productTags?: Maybe<Array<LockedProductTag>>;
  sku?: Maybe<Scalars['String']>;
  supplierName?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type LockedProductRecommendations = {
  __typename?: 'LockedProductRecommendations';
  employeeOrganisation?: Maybe<LockedProductRecommendationsData>;
};

export type LockedProductRecommendationsData = {
  __typename?: 'LockedProductRecommendationsData';
  id: Scalars['ID'];
  scheme?: Maybe<LockedProductRecommendationsScheme>;
};

export type LockedProductRecommendationsProduct = {
  __typename?: 'LockedProductRecommendationsProduct';
  id: Scalars['ID'];
  lockedRecommendationsSimilarProducts?: Maybe<Array<LockedProductRecommendation>>;
};


export type LockedProductRecommendationsProductLockedRecommendationsSimilarProductsArgs = {
  spendCap?: InputMaybe<Scalars['Float']>;
};

export type LockedProductRecommendationsScheme = {
  __typename?: 'LockedProductRecommendationsScheme';
  id: Scalars['ID'];
  product?: Maybe<LockedProductRecommendationsProduct>;
};

export type LockedProductTag = {
  __typename?: 'LockedProductTag';
  default?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['String']>;
  everGreen?: Maybe<Scalars['Boolean']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tagType?: Maybe<Scalars['String']>;
};

export type Login = {
  __typename?: 'Login';
  accessToken?: Maybe<Scalars['String']>;
  branding?: Maybe<Branding>;
  business?: Maybe<Business>;
  legacyToken?: Maybe<Scalars['String']>;
  productPermissions?: Maybe<ProductPermissions>;
  session?: Maybe<Session>;
  upsellRegion?: Maybe<UpsellRegion>;
  user?: Maybe<User>;
  userOnboarding?: Maybe<UserOnboarding>;
};

export type LoginActiveSession = {
  __typename?: 'LoginActiveSession';
  createdAt?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  refreshExpiresAt?: Maybe<Scalars['String']>;
  refreshedAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type LoginGhost = {
  __typename?: 'LoginGhost';
  branding?: Maybe<Branding>;
  business?: Maybe<Business>;
  productPermissions?: Maybe<ProductPermissions>;
  user?: Maybe<User>;
};

export type LoginPasswordless = {
  __typename?: 'LoginPasswordless';
  accessToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export type LoginRefresh = {
  __typename?: 'LoginRefresh';
  accessToken: Scalars['String'];
};

export type Mfa = {
  __typename?: 'MFA';
  phoneNumberLastDigits?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MfaSetup = {
  __typename?: 'MFASetup';
  /** @deprecated Use 'metadata' instead. */
  createdAt: Scalars['String'];
  isConfirmed: Scalars['Boolean'];
  metadata?: Maybe<Metadata>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberLastDigits: Scalars['String'];
  userId?: Maybe<Scalars['ID']>;
};

export type MfaTotpSetup = {
  __typename?: 'MFATotpSetup';
  code: Scalars['String'];
};

export type MfaTotpUser = {
  __typename?: 'MFATotpUser';
  isConfirmed: Scalars['Boolean'];
  metadata?: Maybe<Metadata>;
  userId: Scalars['ID'];
};

export type MfaValidate = {
  __typename?: 'MFAValidate';
  accessToken: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MagicLogin = {
  __typename?: 'MagicLogin';
  auth?: Maybe<Login>;
  branding?: Maybe<Branding>;
  business?: Maybe<Business>;
  status?: Maybe<MagicLoginStatus>;
};

export type MagicLoginResponse = {
  __typename?: 'MagicLoginResponse';
  logins: Array<MagicLogin>;
};

export const MagicLoginStatus = {
  MagicLoginStatusAdminPhoneLoginDisabled: 'MAGIC_LOGIN_STATUS_ADMIN_PHONE_LOGIN_DISABLED',
  MagicLoginStatusBusinessDisabled: 'MAGIC_LOGIN_STATUS_BUSINESS_DISABLED',
  MagicLoginStatusPasswordLoginDisabled: 'MAGIC_LOGIN_STATUS_PASSWORD_LOGIN_DISABLED',
  MagicLoginStatusSuccess: 'MAGIC_LOGIN_STATUS_SUCCESS',
  MagicLoginStatusUnknown: 'MAGIC_LOGIN_STATUS_UNKNOWN',
  MagicLoginStatusUserDisabled: 'MAGIC_LOGIN_STATUS_USER_DISABLED',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type MagicLoginStatus = typeof MagicLoginStatus[keyof typeof MagicLoginStatus];
/** Allocation of budget points to a specific manager or user */
export type ManagerAllocation = {
  __typename?: 'ManagerAllocation';
  /** Amount allocated to this user */
  allocation: Scalars['Int'];
  /** The role of the user in this budget */
  budgetRole: BudgetRole;
  /** The user ID of the wallet owner */
  userId: Scalars['ID'];
  /** Full name of the user */
  userName: Scalars['String'];
  /** The wallet ID for this allocation */
  walletId: Scalars['ID'];
};

/**
 * Paginated List for entity ManagerAllocation. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use offset based pagination
 */
export type ManagerAllocationsList = {
  __typename?: 'ManagerAllocationsList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<ManagerAllocation>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type ManualCreditStatementItemTransfer = {
  __typename?: 'ManualCreditStatementItemTransfer';
  currency?: Maybe<Scalars['String']>;
  transactionAmount?: Maybe<Scalars['Float']>;
};

export type MarketingBusinessProfile = {
  __typename?: 'MarketingBusinessProfile';
  businessId: Scalars['ID'];
  settings: MarketingBusinessProfileSettings;
};

export type MarketingBusinessProfileSettings = {
  __typename?: 'MarketingBusinessProfileSettings';
  unsubscribedEmail: Array<Scalars['String']>;
  unsubscribedPush: Array<Scalars['String']>;
};

export type MarketingBusinessProfileSettingsInput = {
  businessId: Scalars['ID'];
  unsubscribedEmail?: InputMaybe<Array<Scalars['String']>>;
  unsubscribedPush?: InputMaybe<Array<Scalars['String']>>;
};

export type MarketingProfile = {
  __typename?: 'MarketingProfile';
  metadata?: Maybe<Metadata>;
  settings?: Maybe<MarketingProfileSettings>;
  signature: Scalars['String'];
  uuid: Scalars['ID'];
};

export type MarketingProfileSettings = {
  __typename?: 'MarketingProfileSettings';
  emailSubscribed: MarketingSubscriptionState;
  pushSubscribed?: Maybe<MarketingSubscriptionState>;
  unsubscribedEmail?: Maybe<Array<Maybe<Scalars['String']>>>;
  unsubscribedPush?: Maybe<Array<Maybe<Scalars['String']>>>;
  wellnessLiveNotifications?: Maybe<Array<Maybe<WellnessLiveNotification>>>;
};

export type MarketingProfileSettingsInput = {
  emailSubscribed: MarketingSubscriptionState;
  pushSubscribed?: InputMaybe<MarketingSubscriptionState>;
  unsubscribedEmail?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unsubscribedPush?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wellnessLiveNotifications?: InputMaybe<Array<InputMaybe<WellnessLiveNotificationInput>>>;
};

export const MarketingSubscriptionState = {
  Unrecognized: 'UNRECOGNIZED',
  OptedIn: 'opted_in',
  Subscribed: 'subscribed',
  Unsubscribed: 'unsubscribed'
} as const;

export type MarketingSubscriptionState = typeof MarketingSubscriptionState[keyof typeof MarketingSubscriptionState];
export type MediaRental = {
  __typename?: 'MediaRental';
  expiresAt?: Maybe<Scalars['String']>;
  media?: Maybe<WellnessMedia>;
  mediaId?: Maybe<Scalars['ID']>;
  mediaType?: Maybe<MediaRentalType>;
  paymentOrder?: Maybe<PaymentOrder>;
  paymentOrderId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

/**
 * Paginated List for entity MediaRental. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type MediaRentalList = {
  __typename?: 'MediaRentalList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<MediaRental>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const MediaRentalType = {
  Live: 'LIVE',
  MediaTypeUnknown: 'MEDIA_TYPE_UNKNOWN',
  Static: 'STATIC',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type MediaRentalType = typeof MediaRentalType[keyof typeof MediaRentalType];
export type Merchant = {
  __typename?: 'Merchant';
  billableEntityUuid?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentDetailsEnteredAt?: Maybe<Scalars['String']>;
  preferredPaymentMethod?: Maybe<Scalars['String']>;
  refundPeriod?: Maybe<Scalars['Int']>;
  status?: Maybe<MerchantStatusEnum>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type MerchantBaseOffer = {
  __typename?: 'MerchantBaseOffer';
  createdAt: Scalars['String'];
  merchantSavingPercent: Scalars['Float'];
  merchantUuid: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type MerchantDayOffer = {
  __typename?: 'MerchantDayOffer';
  createdAt: Scalars['String'];
  merchantLocationSavingPercent: Scalars['Float'];
  merchantLocationUuid: Scalars['String'];
  offerDay?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type MerchantDayOfferInput = {
  offerDay: Scalars['String'];
  offerPercent: Scalars['Float'];
};

export type MerchantEmployee = {
  __typename?: 'MerchantEmployee';
  createdAt: Scalars['String'];
  employeeEmail: Scalars['String'];
  employeeFirstName: Scalars['String'];
  employeeLastName: Scalars['String'];
  employeePosition: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/**
 * Paginated List for entity MerchantEmployee. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type MerchantEmployeeList = {
  __typename?: 'MerchantEmployeeList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<MerchantEmployee>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type MerchantEmployeeOnboardingLink = {
  __typename?: 'MerchantEmployeeOnboardingLink';
  url: Scalars['String'];
};

/**
 * Paginated List for entity Merchant. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type MerchantList = {
  __typename?: 'MerchantList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Merchant>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type MerchantLocation = {
  __typename?: 'MerchantLocation';
  address: Scalars['String'];
  city: Scalars['String'];
  countryCode: Scalars['String'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  dayOffers?: Maybe<Array<Maybe<MerchantDayOffer>>>;
  merchantUuid: Scalars['String'];
  postcode: Scalars['String'];
  status: Scalars['String'];
  transactionsTotal: Scalars['Int'];
  updatedAt?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type MerchantLocationInput = {
  address1: Scalars['String'];
  city: Scalars['String'];
  dayOffers?: InputMaybe<Array<InputMaybe<MerchantDayOfferInput>>>;
  postcode: Scalars['String'];
};

/**
 * Paginated List for entity MerchantLocation. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type MerchantLocationList = {
  __typename?: 'MerchantLocationList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<MerchantLocation>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type MerchantLogin = {
  __typename?: 'MerchantLogin';
  accessToken?: Maybe<Scalars['String']>;
  merchantEmployeeEmail?: Maybe<Scalars['String']>;
  merchantEmployeeFirstName?: Maybe<Scalars['String']>;
  merchantEmployeeId?: Maybe<Scalars['String']>;
  merchantEmployeeLastName?: Maybe<Scalars['String']>;
};

export type MerchantPaymentMethod = {
  __typename?: 'MerchantPaymentMethod';
  paymentGatewayToken?: Maybe<Scalars['String']>;
  paymentGatewayUrl?: Maybe<Scalars['String']>;
  paymentSecretToken?: Maybe<Scalars['String']>;
};

export const MerchantStatusEnum = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Pending: 'PENDING',
  Suspended: 'SUSPENDED'
} as const;

export type MerchantStatusEnum = typeof MerchantStatusEnum[keyof typeof MerchantStatusEnum];
export type MerchantTransaction = {
  __typename?: 'MerchantTransaction';
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  lastFour?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  merchantLocationUuid?: Maybe<Scalars['String']>;
  savingCalculated?: Maybe<MerchantTransactionSaving>;
  transactionAmount: Scalars['Float'];
  updatedAt?: Maybe<Scalars['String']>;
  userUuid: Scalars['String'];
  uuid: Scalars['String'];
};

/**
 * Paginated List for entity MerchantTransaction. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type MerchantTransactionList = {
  __typename?: 'MerchantTransactionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<MerchantTransaction>;
  savingAmountTotals?: Maybe<Array<Maybe<MerchantTransactionTotal>>>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
  transactionAmountTotals?: Maybe<Array<Maybe<MerchantTransactionTotal>>>;
};

export type MerchantTransactionSaving = {
  __typename?: 'MerchantTransactionSaving';
  currency: Scalars['String'];
  offerPercentage: Scalars['Float'];
  transactionAmount: Scalars['Float'];
};

export type MerchantTransactionTotal = {
  __typename?: 'MerchantTransactionTotal';
  currency: Scalars['String'];
  total: Scalars['Float'];
};

export type MerchantUpdateMerchantInput = {
  name?: InputMaybe<Scalars['String']>;
  preferredPaymentMethod?: InputMaybe<Scalars['String']>;
  refundPeriod?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type MetadataInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type MigrateBudgetsResponse = {
  __typename?: 'MigrateBudgetsResponse';
  success: Scalars['Boolean'];
};

export type ModifyBulkRewardInput = {
  amount?: InputMaybe<Scalars['Int']>;
  budget?: InputMaybe<BudgetCategoryRequest>;
  message?: InputMaybe<Scalars['String']>;
  occasionId?: InputMaybe<Scalars['ID']>;
  schedule?: InputMaybe<FlexiRewardScheduleInput>;
  title?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type MultiCurrencyDetailsInput = {
  /** the equivalent amount in the payment order currency */
  equivalentAmount: Scalars['Int'];
  /** the exchange rate of currency to orderCurrency at the time of ordering */
  exchangeRate: Scalars['Float'];
  /** the currency of the parent payment order */
  orderCurrency: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptRenewalQuote?: Maybe<Scalars['Boolean']>;
  acceptRenewalUpsell?: Maybe<Scalars['Boolean']>;
  acceptTermsAndConditions?: Maybe<Scalars['Boolean']>;
  activateUser?: Maybe<User>;
  addBasketItem?: Maybe<AddBasketItemPayload>;
  addBusinessToGroup?: Maybe<Scalars['Boolean']>;
  addCheckoutProductConfig?: Maybe<CheckoutProductConfig>;
  addCompany?: Maybe<SignUp>;
  addFavouriteMedia?: Maybe<WellnessProfile>;
  addFeatureFlags?: Maybe<Scalars['Boolean']>;
  addGlobalAdminRole?: Maybe<Scalars['Boolean']>;
  addIndividual?: Maybe<AddIndividualResponse>;
  addPayrollOrderComment?: Maybe<Scalars['Boolean']>;
  addReaction?: Maybe<RecognitionFeedReaction>;
  addRoleToUser?: Maybe<Scalars['Boolean']>;
  addUserToTeam?: Maybe<Scalars['Boolean']>;
  adsConvertClick?: Maybe<Scalars['Boolean']>;
  /** Namespace for all advancedBudgets mutations */
  advancedBudgets: AdvancedBudgetsMutations;
  adyenAdditionalDetails?: Maybe<AdyenAdditionalDetails>;
  adyenProcessPayment?: Maybe<AdyenProcessedPayment>;
  archiveCheckoutRedemption?: Maybe<CheckoutRedemption>;
  archiveCompanyBenefit?: Maybe<Scalars['Boolean']>;
  archiveCompanyValue?: Maybe<CompanyValue>;
  archiveDealRedemption?: Maybe<Scalars['Boolean']>;
  archiveRecognition?: Maybe<Scalars['Boolean']>;
  assignCredit?: Maybe<FlexiPointsAssignCredit>;
  assignFFRewardPoints?: Maybe<FlexiPointsReward>;
  benefitsCreateEnquiry?: Maybe<Scalars['Boolean']>;
  billingFindOrCreateUnitForRegionId: TeamRegionMap;
  billingUnitsUpdate?: Maybe<Scalars['Boolean']>;
  botUnlinkBusiness?: Maybe<Scalars['Boolean']>;
  botUnlinkUser?: Maybe<Scalars['Boolean']>;
  botUseState?: Maybe<Scalars['Boolean']>;
  bulkChangeEmail?: Maybe<Scalars['Boolean']>;
  cancelRenewalQuote?: Maybe<Scalars['Boolean']>;
  changeBudgetCategories: BudgetCategories;
  changeBusinessSubdomain?: Maybe<Scalars['Boolean']>;
  clearBasket?: Maybe<Basket>;
  clearFidelTransaction?: Maybe<Scalars['Boolean']>;
  clearNotificationCount?: Maybe<Scalars['Boolean']>;
  clearProductSettingsRewards?: Maybe<ProductSettings>;
  commsResend?: Maybe<CommsMessage>;
  completeCheckout?: Maybe<Checkout>;
  /** @deprecated no longer used */
  completeMediaRental?: Maybe<MediaRental>;
  completeTopUp?: Maybe<Topup>;
  completeUserOnboardingStep?: Maybe<UserOnboarding>;
  confirmBulkReward?: Maybe<BulkRewardResponse>;
  confirmRewardPaymentOrder?: Maybe<Scalars['Boolean']>;
  confirmSignUpPayment?: Maybe<Scalars['Boolean']>;
  createAnnualLeavePurchaseOrder?: Maybe<AnnualLeavePurchaseOrderPayload>;
  createBillingMapping?: Maybe<BillingMapping>;
  createBulkBudgetAssignment?: Maybe<CreateBulkBudgetAssignmentResponse>;
  createBulkReward?: Maybe<BulkRewardResponse>;
  createBusiness?: Maybe<Business>;
  createBusinessGroup?: Maybe<BusinessGroup>;
  createBusinessOnboarding?: Maybe<TenantOnboarding>;
  createComment?: Maybe<RecognitionFeedComment>;
  createCompanyBenefit?: Maybe<Deal>;
  createCompanyNewsRow?: Maybe<Array<Maybe<CompanyNewsTile>>>;
  createCompanyValue?: Maybe<CompanyValue>;
  createConfirmIdentifier?: Maybe<CreateConfirmIdentifierResponse>;
  createCustomReward?: Maybe<CustomReward>;
  createCustomerFileHandler: CreatedFileHandlerResponse;
  createCycleToWorkQuote?: Maybe<CreateCycleToWorkQuotePayload>;
  createDeal?: Maybe<Deal>;
  createDealBrand?: Maybe<DealBrand>;
  createDealPackage?: Maybe<DealsPackage>;
  createDealPriceModifier?: Maybe<DealPriceModifier>;
  createFraudBlacklistedEmail?: Maybe<FraudBlacklistedEmail>;
  createFraudThreshold?: Maybe<FraudThreshold>;
  createGroupCelebration?: Maybe<GroupCelebration>;
  createGroupCelebrationMessage?: Maybe<GroupCelebration>;
  createGymOrder?: Maybe<CreateGymOrderPayload>;
  createHomepage: Homepage;
  createIngestionJob?: Maybe<IngestionJob>;
  createInternalAdminUser?: Maybe<InternalUser>;
  createMagicLogin?: Maybe<CreateMagicLoginResponse>;
  /** @deprecated no longer used */
  createMediaRental?: Maybe<MediaRental>;
  createOccasion?: Maybe<Occasion>;
  createPaymentContext?: Maybe<PaymentContext>;
  createPayrollGivingQuote?: Maybe<CreatePayrollGivingOrderPayload>;
  createPerksHomepage: PerksHomepage;
  createPoll?: Maybe<Poll>;
  createPollVote?: Maybe<PollVote>;
  createProduct?: Maybe<Product>;
  createQuestionnaire: Questionnaire;
  createRecognition?: Maybe<Recognition>;
  createRecognitionAutomation?: Maybe<RecognitionAutomation>;
  createRegion?: Maybe<Region>;
  createRegistrationCode?: Maybe<SelfRegistrationCodeResponse>;
  createReward?: Maybe<RewardAndPaymentOrders>;
  createSalsacBenefitLimitation?: Maybe<SalsacBenefitLimitation>;
  createSalsacBusinessBenefitLimitation?: Maybe<SalsacBusinessBenefitLimitation>;
  createSalsacBusinessIneligibilityCriteria?: Maybe<Scalars['Boolean']>;
  createSalsacBusinessIneligibilityRule?: Maybe<SalsacIneligibilityRuleSet>;
  createSalsacOrderEligibilityNotification?: Maybe<SalsacOrderEligibilityNotification>;
  createSalsacUserBusinessDetail?: Maybe<SalsacUserBusinessDetail>;
  /** @deprecated Now using the normal create recognition flow. Use 'createRecognition' instead. */
  createScheduledRecognition?: Maybe<SchedulerEvent>;
  createScore: Score;
  createStock?: Maybe<Scalars['Boolean']>;
  createStockBulkUpload?: Maybe<Scalars['Boolean']>;
  createStockJob?: Maybe<Scalars['Boolean']>;
  createStoreOrder?: Maybe<CreateStoreOrderPayload>;
  createTag?: Maybe<Tag>;
  createTeam?: Maybe<Team>;
  createTenantWalletTransfers?: Maybe<Scalars['Boolean']>;
  createTopUp?: Maybe<Topup>;
  createTravelAndLeisureOrder?: Maybe<TravelLeisureOrderPayload>;
  createUser?: Maybe<User>;
  createWorkOSOrganisation?: Maybe<WorkOsOrganisation>;
  deactivateUser?: Maybe<User>;
  dealAddFavourite?: Maybe<Scalars['Boolean']>;
  dealBrandDedup?: Maybe<Scalars['Boolean']>;
  dealRemoveFavourite?: Maybe<Scalars['Boolean']>;
  deleteBulkReward: Scalars['Boolean'];
  deleteCheckoutProductConfig?: Maybe<Scalars['Boolean']>;
  deleteComment?: Maybe<Scalars['Boolean']>;
  deleteCompanyNewsRow: Scalars['Boolean'];
  deleteCustomerFile: Scalars['Boolean'];
  deleteGroupCelebration?: Maybe<Scalars['Boolean']>;
  deletePoll?: Maybe<Scalars['Boolean']>;
  deleteReaction?: Maybe<Scalars['Boolean']>;
  deleteRegistrationCode?: Maybe<Scalars['Boolean']>;
  deleteSSOUser?: Maybe<Scalars['Boolean']>;
  deleteSavedCard?: Maybe<Scalars['Boolean']>;
  /** @deprecated Now using the normal archive recognition flow. Use 'archiveRecognition' instead. */
  deleteScheduledRecognition?: Maybe<Scalars['Boolean']>;
  deleteServiceFeesTiers?: Maybe<Scalars['Boolean']>;
  deleteTeam?: Maybe<Scalars['Boolean']>;
  deleteTiersByTenant?: Maybe<Scalars['Boolean']>;
  deleteUserPhoneNumber?: Maybe<Scalars['Boolean']>;
  editCompanyValue?: Maybe<CompanyValue>;
  gdprRemoveUsers?: Maybe<Array<Maybe<GdprRemoveUsersResponse>>>;
  generateBrazeJWT?: Maybe<Scalars['String']>;
  giftUserWalletCredit?: Maybe<Scalars['Boolean']>;
  ignoreIndividualCheck?: Maybe<Scalars['Boolean']>;
  importPayrollOrders?: Maybe<Scalars['Boolean']>;
  inviteFamilyFriendUser: InviteFamilyFriendUserResponse;
  loginLogout?: Maybe<Scalars['Boolean']>;
  loginRemoveActiveSession?: Maybe<Scalars['Boolean']>;
  makeTransfer?: Maybe<FlexiPointTransfer>;
  /** @deprecated These are for IDv2=>IDv4 migrations to make role mapping work. Use 'addUserToTeam' with access level */
  makeUserBasic?: Maybe<Scalars['Boolean']>;
  /** @deprecated These are for IDv2=>IDv4 migrations to make role mapping work. Use 'addGlobalAdminRole' */
  makeUserGlobalAdmin?: Maybe<Scalars['Boolean']>;
  merchantAddBaseOfferAndInitialLocation?: Maybe<Scalars['Boolean']>;
  merchantAddEmployeeToMerchant?: Maybe<Scalars['Boolean']>;
  merchantAddLocation?: Maybe<Scalars['Boolean']>;
  merchantConfirmMerchantPaymentMethod?: Maybe<Scalars['Boolean']>;
  merchantCreateMerchant?: Maybe<Merchant>;
  merchantDeleteLocation?: Maybe<Scalars['Boolean']>;
  merchantForgotPassword?: Maybe<Scalars['Boolean']>;
  merchantGenerateEmployeeOnboardingLink?: Maybe<MerchantEmployeeOnboardingLink>;
  merchantGhostUser?: Maybe<MerchantLogin>;
  merchantLogin?: Maybe<MerchantLogin>;
  merchantMarkMerchantPaymentDetailsEntered?: Maybe<Scalars['Boolean']>;
  merchantRemoveEmployeeFromMerchant?: Maybe<Scalars['Boolean']>;
  merchantResetPassword?: Maybe<MerchantLogin>;
  merchantSetupMerchantPaymentMethod?: Maybe<MerchantPaymentMethod>;
  merchantTriggerMerchantMigrationToBilling?: Maybe<Scalars['Boolean']>;
  merchantUpdateLocationDayOffers?: Maybe<Scalars['Boolean']>;
  merchantUpdateMerchant?: Maybe<Scalars['Boolean']>;
  merchantUpdateMerchantBillingDetails?: Maybe<Scalars['Boolean']>;
  mfaDeleteUser?: Maybe<Scalars['Boolean']>;
  mfaSetup?: Maybe<Mfa>;
  mfaTotpDeleteUser?: Maybe<Scalars['Boolean']>;
  mfaTotpSetup?: Maybe<MfaTotpSetup>;
  mfaTotpValidate?: Maybe<MfaValidate>;
  mfaValidate?: Maybe<MfaValidate>;
  moderateComment?: Maybe<RecognitionFeedComment>;
  moderatePollVote?: Maybe<PollVote>;
  moderateRecognition?: Maybe<Recognition>;
  modifyBulkReward?: Maybe<BulkRewardResponse>;
  organisationalApproval?: Maybe<Scalars['Boolean']>;
  organisationalApprovalCancel?: Maybe<Scalars['Boolean']>;
  passwordSet?: Maybe<Scalars['Boolean']>;
  passwordSetFromForgot?: Maybe<Scalars['Boolean']>;
  passwordSetFromLoginChallenge?: Maybe<Scalars['Boolean']>;
  paymentPayByCard?: Maybe<Payment>;
  paymentPayByWallet?: Maybe<Payment>;
  paymentPayByZip?: Maybe<Payment>;
  perksSagaComplete?: Maybe<DealSaga>;
  perksSagaOrder?: Maybe<DealSaga>;
  perksSagaPay?: Maybe<DealSaga>;
  perksSagaStart?: Maybe<DealSaga>;
  perksSagaUpdate?: Maybe<DealSaga>;
  processFidelTransaction?: Maybe<Scalars['Boolean']>;
  publishPoll?: Maybe<Poll>;
  pushUser?: Maybe<User>;
  /**
   * Transfer points between wallets, at this time the wallet will be completely
   * emptied of all funds and all budgets will be removed
   */
  reclaimWalletPoints: ReclaimWalletPointsResponse;
  redeemCustomReward?: Maybe<CustomRewardTransaction>;
  refundOrder?: Maybe<Scalars['Boolean']>;
  registerUser?: Maybe<Scalars['Boolean']>;
  removeBasketItem?: Maybe<RemoveBasketItemPayload>;
  removeCard?: Maybe<Scalars['Boolean']>;
  removeFavouriteMedia?: Maybe<WellnessProfile>;
  removeFeatureFlags?: Maybe<Scalars['Boolean']>;
  removeGlobalAdminRole?: Maybe<Scalars['Boolean']>;
  removeRoleFromUser?: Maybe<Scalars['Boolean']>;
  removeUserFromTeam?: Maybe<Scalars['Boolean']>;
  removeUserOnboardingStep?: Maybe<UserOnboarding>;
  requestPayment?: Maybe<Payment>;
  requestPoints?: Maybe<PointsRequest>;
  resendRenewalContract?: Maybe<Scalars['Boolean']>;
  resolveIncidentByDealId?: Maybe<Incident>;
  rewardEmployees?: Maybe<FlexiPointsReward>;
  salesNotifyCTAScreenSeen?: Maybe<Scalars['Boolean']>;
  schedulerCancelEvent?: Maybe<Scalars['Boolean']>;
  schedulerCancelSystemEvent?: Maybe<Scalars['Boolean']>;
  schedulerCreateSystemEvent?: Maybe<SchedulerSystemEvent>;
  schedulerModifyEvent?: Maybe<SchedulerEvent>;
  schedulerModifySystemEvent?: Maybe<SchedulerSystemEvent>;
  sendCreditAsReward?: Maybe<Scalars['Boolean']>;
  sendCreditToUser?: Maybe<Scalars['Boolean']>;
  setMyBillingUnit?: Maybe<Scalars['Boolean']>;
  setSalaryBracket?: Maybe<SetSalaryBracketPayload>;
  setSalsacBusinessBenefitRankings?: Maybe<Scalars['Boolean']>;
  setWorkOSDsyncConfig?: Maybe<WorkOsDsyncConfig>;
  ssoAdminLogin?: Maybe<Login>;
  startChangeEmail: StartChangeEmailResponse;
  startCheckout?: Maybe<Checkout>;
  startSignUp?: Maybe<SignUp>;
  stockAttemptReprocess?: Maybe<StockReprocess>;
  tenantWalletCreateRefund?: Maybe<TenantWalletCreateRefund>;
  toggleAutoApproval: AutoApprovedUserBudget;
  toggleCheckoutRedemptionUsed?: Maybe<CheckoutRedemption>;
  toggleReaction?: Maybe<ToggleReactionResponse>;
  toggleRedemptionUsed?: Maybe<DealRedemption>;
  transferFromTenantToReward?: Maybe<Scalars['Boolean']>;
  updateBasket?: Maybe<Basket>;
  updateBasketItem?: Maybe<UpdateBasketItemPayload>;
  updateBasketItemsBrochureGroup?: Maybe<PayrollUpdateBasketItemsBrochureGroupPayload>;
  updateBillingMapping?: Maybe<BillingMapping>;
  updateBillingZuoraSoldToContact?: Maybe<Scalars['Boolean']>;
  updateBranding?: Maybe<Branding>;
  /** @deprecated use 'changeBudgetCategories' instead */
  updateBudgetCategories: Scalars['Boolean'];
  updateBusiness?: Maybe<Business>;
  updateBusinessSettings?: Maybe<Scalars['Boolean']>;
  updateBusinessSsoConfiguration?: Maybe<Scalars['Boolean']>;
  updateCheckoutProductConfig?: Maybe<CheckoutProductConfig>;
  updateComment?: Maybe<RecognitionFeedComment>;
  updateCompanyBenefit?: Maybe<Deal>;
  updateCompanyNewsTile?: Maybe<CompanyNewsTile>;
  updateCustomReward?: Maybe<CustomReward>;
  updateCustomRewardStatus?: Maybe<CustomReward>;
  updateDeal?: Maybe<Deal>;
  updateDealBrand?: Maybe<DealBrand>;
  updateDealPackage?: Maybe<DealsPackage>;
  updateDealPriceModifier?: Maybe<DealPriceModifier>;
  updateDealSettings?: Maybe<DealSettings>;
  updateEnquiry?: Maybe<Scalars['Boolean']>;
  updateExternalDeal?: Maybe<ExternalDeal>;
  updateExternalDeals?: Maybe<Array<Maybe<ExternalDeal>>>;
  updateFraudBlacklistedEmail?: Maybe<FraudBlacklistedEmail>;
  updateFraudThreshold?: Maybe<FraudThreshold>;
  updateGroupCelebration?: Maybe<GroupCelebration>;
  updateGroupCelebrationMessage?: Maybe<GroupCelebration>;
  /** @deprecated Not used anymore */
  updateHomePageLayout?: Maybe<LayoutWidgets>;
  updateHomepage: Homepage;
  updateInternalAdminUser?: Maybe<InternalUser>;
  updateMarketingBusinessProfile?: Maybe<MarketingBusinessProfile>;
  updateMarketingProfile?: Maybe<MarketingProfile>;
  updateNetBenefitEducationalPopupSeen?: Maybe<UpdateNetBenefitEducationalPopupSeenPayload>;
  updateOAuthSettings?: Maybe<Scalars['Boolean']>;
  updateOccasion?: Maybe<Occasion>;
  updatePayrollOrder?: Maybe<Scalars['Boolean']>;
  updatePerksHomepage: PerksHomepage;
  updatePermissionsProductSettingsBenefitsMarketplace?: Maybe<ProductSettings>;
  updatePermissionsProductSettingsCarBenefits?: Maybe<ProductSettings>;
  updatePermissionsProductSettingsGymMembership?: Maybe<ProductSettings>;
  updatePermissionsProductSettingsHealthCashPlan?: Maybe<ProductSettings>;
  updatePermissionsProductSettingsMedical?: Maybe<ProductSettings>;
  updatePermissionsProductSettingsPerks?: Maybe<ProductSettings>;
  updatePermissionsProductSettingsRecognition?: Maybe<ProductSettings>;
  updatePermissionsProductSettingsWallet?: Maybe<ProductSettings>;
  updatePermissionsProductSettingsWellness?: Maybe<ProductSettings>;
  updatePointsRequestStatus?: Maybe<PointsRequest>;
  updatePollVote?: Maybe<PollVote>;
  updatePollWithRewardId?: Maybe<Poll>;
  updateProduct?: Maybe<Product>;
  updateProductSettingsCycleToWork?: Maybe<ProductSettings>;
  updateProductSettingsEmployeeAssistanceProgramme?: Maybe<ProductSettings>;
  updateProductSettingsRewards?: Maybe<ProductSettings>;
  updateRecognition?: Maybe<Recognition>;
  updateRecognitionAutomation?: Maybe<RecognitionAutomation>;
  updateRecognitionAutomationStatus?: Maybe<RecognitionAutomation>;
  updateRecognitionWithReward?: Maybe<Recognition>;
  /** @deprecated Now using another recognition service. Use 'updateRecognitionWithReward' instead. */
  updateRecognitionWithRewardId?: Maybe<Recognition>;
  updateRegion?: Maybe<Region>;
  updateSalsacBenefitLimitation?: Maybe<SalsacBenefitLimitation>;
  updateSalsacBusinessBenefitLimitation?: Maybe<SalsacBusinessBenefitLimitation>;
  updateSalsacBusinessIneligibilityCriteria?: Maybe<Scalars['Boolean']>;
  updateSalsacBusinessIneligibilityRule?: Maybe<Scalars['Boolean']>;
  updateSalsacOrderEligibilityNotification?: Maybe<SalsacOrderEligibilityNotification>;
  updateSalsacUserBusinessDetail?: Maybe<SalsacUserBusinessDetail>;
  /** @deprecated Now using the normal update recognition flow. Use 'updateRecognition' instead. */
  updateScheduledRecognition?: Maybe<SchedulerEvent>;
  updateServiceFeesTiers?: Maybe<Scalars['Boolean']>;
  updateTag?: Maybe<Tag>;
  updateTeam?: Maybe<Team>;
  updateTenantOnboarding?: Maybe<TenantOnboarding>;
  updateTenantOnboardingStep?: Maybe<TenantOnboarding>;
  updateUser?: Maybe<User>;
  updateUserEmploymentDetails?: Maybe<Scalars['Boolean']>;
  updateUserMetadata?: Maybe<UserMetadata>;
  updateUserPhoneNumber?: Maybe<Scalars['Boolean']>;
  updateUsersByEmail?: Maybe<Array<Maybe<User>>>;
  uploadAutoApproveCsv: AutoApproveCsvValidationResult;
  upsertFidelTransaction?: Maybe<Scalars['Boolean']>;
  validateChangeEmail?: Maybe<Scalars['Boolean']>;
  waiveServiceFeesByTenant?: Maybe<Scalars['Boolean']>;
  wellnessClearCache?: Maybe<Scalars['Boolean']>;
  workOSLinkCode?: Maybe<WorkOsLinkCode>;
};


export type MutationAcceptRenewalQuoteArgs = {
  businessId: Scalars['ID'];
  etag: Scalars['String'];
  option: InputRenewalOption;
  productsAdded?: InputMaybe<Array<InputMaybe<InputRenewalProduct>>>;
  productsRemoved?: InputMaybe<Array<InputMaybe<InputRenewalProduct>>>;
  productsUpdated?: InputMaybe<Array<InputMaybe<InputRenewalProduct>>>;
  seats?: InputMaybe<Scalars['Int']>;
  signatureContact: InputRenewalContact;
};


export type MutationAcceptRenewalUpsellArgs = {
  platformBillingPeriod?: InputMaybe<BillingPeriod>;
  productsAdded?: InputMaybe<Array<InputMaybe<InputRenewalProduct>>>;
  productsRemoved?: InputMaybe<Array<InputMaybe<InputRenewalProduct>>>;
  productsUpdated?: InputMaybe<Array<InputMaybe<InputRenewalProduct>>>;
  seats?: InputMaybe<Scalars['Int']>;
  signatureContact?: InputMaybe<InputRenewalUpsellContact>;
};


export type MutationAcceptTermsAndConditionsArgs = {
  signupId: Scalars['ID'];
  version: Scalars['String'];
};


export type MutationActivateUserArgs = {
  userId: Scalars['ID'];
};


export type MutationAddBasketItemArgs = {
  input: AddBasketItemInput;
};


export type MutationAddBusinessToGroupArgs = {
  data: AddBusinessToGroupInput;
};


export type MutationAddCheckoutProductConfigArgs = {
  data: CheckoutProductConfigAddInput;
  dealId: Scalars['ID'];
};


export type MutationAddCompanyArgs = {
  company: CompanyDetailsInput;
  uuid: Scalars['ID'];
};


export type MutationAddFavouriteMediaArgs = {
  media: WellnessFavouriteMediaInput;
  userId: Scalars['ID'];
};


export type MutationAddFeatureFlagsArgs = {
  entityId: Scalars['ID'];
  entityType: FeatureFlagEntityType;
  flags: Array<Scalars['ID']>;
};


export type MutationAddGlobalAdminRoleArgs = {
  userId: Scalars['ID'];
};


export type MutationAddIndividualArgs = {
  individual: AddIndividualInput;
  uuid: Scalars['ID'];
};


export type MutationAddPayrollOrderCommentArgs = {
  comment: Scalars['String'];
  order_id: Scalars['ID'];
};


export type MutationAddReactionArgs = {
  reaction: RecognitionFeedReactionInput;
};


export type MutationAddRoleToUserArgs = {
  roleId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAddUserToTeamArgs = {
  assignment?: InputMaybe<TeamAssignment>;
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAdsConvertClickArgs = {
  data?: InputMaybe<AdsConverClickInput>;
};


export type MutationAdyenAdditionalDetailsArgs = {
  data?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['ID'];
  paymentOrderId: Scalars['ID'];
};


export type MutationAdyenProcessPaymentArgs = {
  data?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['ID'];
  paymentOrderId: Scalars['ID'];
};


export type MutationArchiveCheckoutRedemptionArgs = {
  redemptionId: Scalars['ID'];
};


export type MutationArchiveCompanyBenefitArgs = {
  id: Scalars['ID'];
};


export type MutationArchiveCompanyValueArgs = {
  companyValue: CompanyValueInput;
  tenantId: Scalars['String'];
};


export type MutationArchiveDealRedemptionArgs = {
  ifMatch: Scalars['String'];
  redemptionId: Scalars['String'];
};


export type MutationArchiveRecognitionArgs = {
  recognitionId: Scalars['String'];
};


export type MutationAssignCreditArgs = {
  amount: Scalars['Int'];
  budget?: InputMaybe<BudgetCategoryRequest>;
  destinationUserIds: Array<Scalars['ID']>;
  message: Scalars['String'];
  sourceId: Scalars['ID'];
};


export type MutationAssignFfRewardPointsArgs = {
  input: AssignFfRewardPointsInput;
};


export type MutationBenefitsCreateEnquiryArgs = {
  data: BenefitEnquiryInput;
};


export type MutationBillingFindOrCreateUnitForRegionIdArgs = {
  businessId: Scalars['ID'];
  regionId: Scalars['ID'];
};


export type MutationBillingUnitsUpdateArgs = {
  businessId: Scalars['ID'];
};


export type MutationBotUnlinkBusinessArgs = {
  businessId: Scalars['ID'];
  type: BotLinkType;
};


export type MutationBotUnlinkUserArgs = {
  type: BotLinkType;
  userId: Scalars['ID'];
};


export type MutationBotUseStateArgs = {
  state: Scalars['String'];
};


export type MutationBulkChangeEmailArgs = {
  businessId: Scalars['ID'];
  changes?: InputMaybe<Array<InputMaybe<EmailChange>>>;
};


export type MutationCancelRenewalQuoteArgs = {
  businessId: Scalars['ID'];
  etag: Scalars['String'];
  reason?: InputMaybe<CancellationReason>;
  reasonText?: InputMaybe<Scalars['String']>;
};


export type MutationChangeBudgetCategoriesArgs = {
  input: UpdateBudgetCategoriesInput;
};


export type MutationChangeBusinessSubdomainArgs = {
  data: UpdateBusinessSubdomainInput;
};


export type MutationClearBasketArgs = {
  userId: Scalars['ID'];
};


export type MutationClearFidelTransactionArgs = {
  uuid: Scalars['String'];
};


export type MutationClearNotificationCountArgs = {
  channel: NotificationChannel;
  kind: NotificationKind;
};


export type MutationClearProductSettingsRewardsArgs = {
  businessId: Scalars['ID'];
  teamId: Scalars['ID'];
};


export type MutationCommsResendArgs = {
  messageId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationCompleteCheckoutArgs = {
  checkoutId: Scalars['ID'];
};


export type MutationCompleteMediaRentalArgs = {
  mediaId: Scalars['ID'];
};


export type MutationCompleteTopUpArgs = {
  topupId: Scalars['ID'];
};


export type MutationCompleteUserOnboardingStepArgs = {
  stepId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationConfirmBulkRewardArgs = {
  message: Scalars['String'];
  uuid: Scalars['ID'];
};


export type MutationConfirmRewardPaymentOrderArgs = {
  orderId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationConfirmSignUpPaymentArgs = {
  signUpPayment: SignUpPaymentInput;
  signupId: Scalars['ID'];
};


export type MutationCreateAnnualLeavePurchaseOrderArgs = {
  input: AnnualLeavePurchaseOrderInput;
};


export type MutationCreateBillingMappingArgs = {
  data?: InputMaybe<BillingMappingInput>;
};


export type MutationCreateBulkBudgetAssignmentArgs = {
  input: CreateBulkBudgetAssignmentInput;
};


export type MutationCreateBulkRewardArgs = {
  amount: Scalars['Int'];
  budget?: InputMaybe<BudgetCategoryRequest>;
  businessId: Scalars['String'];
  currency: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  emails: Array<Scalars['String']>;
  occasionId?: InputMaybe<Scalars['ID']>;
  sourceId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationCreateBusinessArgs = {
  data: CreateBusinessInput;
};


export type MutationCreateBusinessGroupArgs = {
  data: CreateBusinessGroupInput;
};


export type MutationCreateBusinessOnboardingArgs = {
  businessId: Scalars['String'];
};


export type MutationCreateCommentArgs = {
  comment: RecognitionFeedCommentInput;
};


export type MutationCreateCompanyBenefitArgs = {
  details?: InputMaybe<CompanyBenefitInput>;
};


export type MutationCreateCompanyNewsRowArgs = {
  tenantId: Scalars['String'];
  tiles: Array<CompanyNewsTileInput>;
};


export type MutationCreateCompanyValueArgs = {
  companyValue: CompanyValueInput;
  tenantId: Scalars['String'];
};


export type MutationCreateConfirmIdentifierArgs = {
  identifier: Scalars['String'];
};


export type MutationCreateCustomRewardArgs = {
  input: CustomRewardInput;
};


export type MutationCreateCustomerFileHandlerArgs = {
  mimeType: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreateCycleToWorkQuoteArgs = {
  input: CreateCycleToWorkQuoteInput;
};


export type MutationCreateDealArgs = {
  deal?: InputMaybe<CreateDealInput>;
};


export type MutationCreateDealBrandArgs = {
  params?: InputMaybe<CreateDealBrandInput>;
};


export type MutationCreateDealPackageArgs = {
  data?: InputMaybe<DealPackageInput>;
};


export type MutationCreateDealPriceModifierArgs = {
  data: CreateDealPriceModifierInput;
};


export type MutationCreateFraudBlacklistedEmailArgs = {
  data: CreateFraudBlacklistedEmailInput;
};


export type MutationCreateFraudThresholdArgs = {
  params: CreateFraudThresholdInput;
};


export type MutationCreateGroupCelebrationArgs = {
  scheduledGroupCelebration: CreateGroupCelebrationInput;
};


export type MutationCreateGroupCelebrationMessageArgs = {
  groupCelebrationID: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationCreateGymOrderArgs = {
  input: CreateGymOrderInput;
};


export type MutationCreateHomepageArgs = {
  data: HomepageInput;
};


export type MutationCreateIngestionJobArgs = {
  args?: InputMaybe<CreateIngestionJobInput>;
};


export type MutationCreateInternalAdminUserArgs = {
  data: NewInternalUserInput;
};


export type MutationCreateMagicLoginArgs = {
  identifier: Scalars['String'];
};


export type MutationCreateMediaRentalArgs = {
  mediaId: Scalars['ID'];
};


export type MutationCreateOccasionArgs = {
  occasion: OccasionInput;
  tenantId: Scalars['String'];
};


export type MutationCreatePaymentContextArgs = {
  input: CreatePaymentContextInput;
};


export type MutationCreatePayrollGivingQuoteArgs = {
  input: CreatePayrollGivingOrderInput;
};


export type MutationCreatePerksHomepageArgs = {
  data: PerksHomepageInput;
};


export type MutationCreatePollArgs = {
  poll: PollInput;
};


export type MutationCreatePollVoteArgs = {
  vote: PollVoteInput;
};


export type MutationCreateProductArgs = {
  data: ProductInput;
};


export type MutationCreateQuestionnaireArgs = {
  input: CreateQuestionnaireInput;
};


export type MutationCreateRecognitionArgs = {
  recognition: RecognitionInput;
};


export type MutationCreateRecognitionAutomationArgs = {
  recognitionAutomation: RecognitionAutomationInput;
};


export type MutationCreateRegionArgs = {
  data?: InputMaybe<RegionInput>;
};


export type MutationCreateRegistrationCodeArgs = {
  businessId: Scalars['ID'];
  code: Scalars['String'];
  codeType: SelfRegistrationCodeType;
};


export type MutationCreateRewardArgs = {
  payload: CreateRewardArgs;
};


export type MutationCreateSalsacBenefitLimitationArgs = {
  input: SalsacBenefitLimitationInput;
};


export type MutationCreateSalsacBusinessBenefitLimitationArgs = {
  input: SalsacBusinessBenefitLimitationInput;
};


export type MutationCreateSalsacBusinessIneligibilityCriteriaArgs = {
  businessId: Scalars['ID'];
  criteria: SalsacIneligibilityCriteriaInput;
};


export type MutationCreateSalsacBusinessIneligibilityRuleArgs = {
  businessId: Scalars['ID'];
  ruleSet: SalsacIneligibilityRuleSetInput;
};


export type MutationCreateSalsacOrderEligibilityNotificationArgs = {
  input: SalsacOrderEligibilityNotificationInput;
};


export type MutationCreateSalsacUserBusinessDetailArgs = {
  input: SalsacUserBusinessDetailInput;
};


export type MutationCreateScheduledRecognitionArgs = {
  recognition: CreateScheduledRecognitionInput;
};


export type MutationCreateScoreArgs = {
  input: CreateScoreInput;
};


export type MutationCreateStockArgs = {
  stock: StockInput;
};


export type MutationCreateStockBulkUploadArgs = {
  stocks: Array<StockInput>;
};


export type MutationCreateStockJobArgs = {
  action: StockJobAction;
  newExpiry?: InputMaybe<Scalars['String']>;
  openArchived: Scalars['Boolean'];
  poNumber?: InputMaybe<Scalars['String']>;
  productUuid: Scalars['String'];
};


export type MutationCreateStoreOrderArgs = {
  input: CreateStoreOrderInput;
};


export type MutationCreateTagArgs = {
  data: TagInput;
};


export type MutationCreateTeamArgs = {
  data: TeamInput;
  tenantId: Scalars['String'];
};


export type MutationCreateTenantWalletTransfersArgs = {
  data: CreateTenantWalletTransfersInput;
};


export type MutationCreateTopUpArgs = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  poNumber?: InputMaybe<Scalars['String']>;
  targetCurrency?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type: Scalars['String'];
  walletOwnerUuid?: InputMaybe<Scalars['String']>;
  walletUuid: Scalars['String'];
};


export type MutationCreateTravelAndLeisureOrderArgs = {
  input: CreateTravelAndLeisureOrderInput;
};


export type MutationCreateUserArgs = {
  user: NewUserInput;
};


export type MutationCreateWorkOsOrganisationArgs = {
  businessId: Scalars['ID'];
};


export type MutationDeactivateUserArgs = {
  userId: Scalars['ID'];
};


export type MutationDealAddFavouriteArgs = {
  dealId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationDealBrandDedupArgs = {
  uuid: Scalars['ID'];
};


export type MutationDealRemoveFavouriteArgs = {
  dealId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationDeleteBulkRewardArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCheckoutProductConfigArgs = {
  dealId: Scalars['ID'];
};


export type MutationDeleteCommentArgs = {
  comment: RecognitionFeedCommentInput;
  commentId: Scalars['String'];
};


export type MutationDeleteCompanyNewsRowArgs = {
  tenantId: Scalars['String'];
  tiles: Array<CompanyNewsTileInput>;
};


export type MutationDeleteCustomerFileArgs = {
  uuid: Scalars['ID'];
};


export type MutationDeleteGroupCelebrationArgs = {
  uuid: Scalars['String'];
};


export type MutationDeletePollArgs = {
  pollId: Scalars['String'];
};


export type MutationDeleteReactionArgs = {
  uuid: Scalars['String'];
};


export type MutationDeleteRegistrationCodeArgs = {
  businessId: Scalars['ID'];
  code: Scalars['String'];
  codeType: SelfRegistrationCodeType;
};


export type MutationDeleteSsoUserArgs = {
  userId: Scalars['ID'];
};


export type MutationDeleteSavedCardArgs = {
  cardReference: Scalars['ID'];
  provider: PaymentProvider;
};


export type MutationDeleteScheduledRecognitionArgs = {
  uuid: Scalars['String'];
};


export type MutationDeleteServiceFeesTiersArgs = {
  uuid: Array<Scalars['String']>;
};


export type MutationDeleteTeamArgs = {
  teamId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationDeleteTiersByTenantArgs = {
  currency?: InputMaybe<Scalars['String']>;
  tenant: Scalars['ID'];
};


export type MutationDeleteUserPhoneNumberArgs = {
  userId: Scalars['ID'];
};


export type MutationEditCompanyValueArgs = {
  companyValue: CompanyValueInput;
  tenantId: Scalars['String'];
};


export type MutationGdprRemoveUsersArgs = {
  emails: Array<InputMaybe<Scalars['String']>>;
};


export type MutationGiftUserWalletCreditArgs = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  reason: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationIgnoreIndividualCheckArgs = {
  checkId: Scalars['String'];
  signupId: Scalars['ID'];
};


export type MutationImportPayrollOrdersArgs = {
  file: Scalars['Upload'];
};


export type MutationInviteFamilyFriendUserArgs = {
  user: InviteFamilyFriendUserInput;
};


export type MutationLoginRemoveActiveSessionArgs = {
  sessionId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationMakeTransferArgs = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  destinationIds: Array<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  sourceId: Scalars['String'];
  transferType: Scalars['String'];
};


export type MutationMakeUserBasicArgs = {
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationMakeUserGlobalAdminArgs = {
  userId: Scalars['ID'];
};


export type MutationMerchantAddBaseOfferAndInitialLocationArgs = {
  baseOfferPercent: Scalars['Float'];
  locationInput: MerchantLocationInput;
  merchantId: Scalars['String'];
};


export type MutationMerchantAddEmployeeToMerchantArgs = {
  employeeEmail: Scalars['String'];
  employeeFirstName: Scalars['String'];
  employeeLastName: Scalars['String'];
  employeePosition: Scalars['String'];
  merchantId: Scalars['String'];
};


export type MutationMerchantAddLocationArgs = {
  locationInput: MerchantLocationInput;
  merchantId: Scalars['String'];
};


export type MutationMerchantConfirmMerchantPaymentMethodArgs = {
  billableEntityId: Scalars['String'];
  confirmationToken: Scalars['String'];
};


export type MutationMerchantCreateMerchantArgs = {
  name: Scalars['String'];
  refundPeriod: Scalars['Int'];
};


export type MutationMerchantDeleteLocationArgs = {
  locationId: Scalars['String'];
};


export type MutationMerchantForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationMerchantGenerateEmployeeOnboardingLinkArgs = {
  employeeId: Scalars['String'];
};


export type MutationMerchantGhostUserArgs = {
  merchantId: Scalars['String'];
};


export type MutationMerchantLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationMerchantMarkMerchantPaymentDetailsEnteredArgs = {
  merchantId: Scalars['String'];
};


export type MutationMerchantRemoveEmployeeFromMerchantArgs = {
  employeeId: Scalars['String'];
  merchantId: Scalars['String'];
};


export type MutationMerchantResetPasswordArgs = {
  employeeId: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationMerchantSetupMerchantPaymentMethodArgs = {
  billableEntityId: Scalars['String'];
  paymentMethod: Scalars['String'];
  redirectUrl?: InputMaybe<Scalars['String']>;
};


export type MutationMerchantTriggerMerchantMigrationToBillingArgs = {
  merchantId: Scalars['String'];
};


export type MutationMerchantUpdateLocationDayOffersArgs = {
  dayOffersInput: Array<InputMaybe<MerchantDayOfferInput>>;
  locationId: Scalars['String'];
};


export type MutationMerchantUpdateMerchantArgs = {
  etag: Scalars['String'];
  input?: InputMaybe<MerchantUpdateMerchantInput>;
  merchantId: Scalars['String'];
};


export type MutationMerchantUpdateMerchantBillingDetailsArgs = {
  address1: Scalars['String'];
  city: Scalars['String'];
  companyHouseName?: InputMaybe<Scalars['String']>;
  merchantId: Scalars['String'];
  postcode: Scalars['String'];
};


export type MutationMfaDeleteUserArgs = {
  userId: Scalars['ID'];
};


export type MutationMfaSetupArgs = {
  country: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationMfaTotpDeleteUserArgs = {
  userId: Scalars['ID'];
};


export type MutationMfaTotpValidateArgs = {
  passcode: Scalars['String'];
};


export type MutationMfaValidateArgs = {
  code: Scalars['String'];
};


export type MutationModerateCommentArgs = {
  comment: RecognitionFeedCommentInput;
  commentId: Scalars['String'];
};


export type MutationModeratePollVoteArgs = {
  vote: PollVoteInput;
  voteId: Scalars['String'];
};


export type MutationModerateRecognitionArgs = {
  recognitionId: Scalars['String'];
};


export type MutationModifyBulkRewardArgs = {
  input: ModifyBulkRewardInput;
};


export type MutationOrganisationalApprovalArgs = {
  additional_comment?: InputMaybe<Scalars['String']>;
  comment_sent_to_employee?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
  rejection_reasons?: InputMaybe<Array<InputMaybe<PayrollOrderReason>>>;
  status: Scalars['String'];
};


export type MutationOrganisationalApprovalCancelArgs = {
  orderId: Scalars['ID'];
};


export type MutationPasswordSetArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationPasswordSetFromForgotArgs = {
  confirmation: Scalars['String'];
  newPassword: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationPasswordSetFromLoginChallengeArgs = {
  challenge: PasswordChallenge;
  newPassword: Scalars['String'];
};


export type MutationPaymentPayByCardArgs = {
  details: PaymentCardInput;
  paymentOrderId: Scalars['ID'];
};


export type MutationPaymentPayByWalletArgs = {
  details: PaymentWalletInput;
  paymentOrderId: Scalars['ID'];
};


export type MutationPaymentPayByZipArgs = {
  details?: InputMaybe<PaymentZipInput>;
  paymentOrderId: Scalars['ID'];
};


export type MutationPerksSagaCompleteArgs = {
  sagaId: Scalars['ID'];
};


export type MutationPerksSagaOrderArgs = {
  details: PerksSagaOrderInput;
  sagaId: Scalars['ID'];
};


export type MutationPerksSagaPayArgs = {
  details: PerksSagaPayInput;
  sagaId: Scalars['ID'];
};


export type MutationPerksSagaStartArgs = {
  details: PerksSagaStartInput;
};


export type MutationPerksSagaUpdateArgs = {
  details?: InputMaybe<PerksSagaUpdateInput>;
  sagaId: Scalars['ID'];
};


export type MutationProcessFidelTransactionArgs = {
  fidelTransactionUuid: Scalars['String'];
};


export type MutationPublishPollArgs = {
  pollId: Scalars['String'];
};


export type MutationPushUserArgs = {
  user: NewUserInput;
};


export type MutationReclaimWalletPointsArgs = {
  input: ReclaimWalletPointsInput;
};


export type MutationRedeemCustomRewardArgs = {
  uuid: Scalars['ID'];
};


export type MutationRefundOrderArgs = {
  details: RefundOrderInputDetails;
  orderId: Scalars['String'];
};


export type MutationRegisterUserArgs = {
  user: RegisterUserInput;
};


export type MutationRemoveBasketItemArgs = {
  input: RemoveBasketItemInput;
};


export type MutationRemoveCardArgs = {
  cardUuid: Scalars['String'];
};


export type MutationRemoveFavouriteMediaArgs = {
  media: WellnessFavouriteMediaInput;
  userId: Scalars['ID'];
};


export type MutationRemoveFeatureFlagsArgs = {
  entityId: Scalars['ID'];
  entityType: FeatureFlagEntityType;
  flags: Array<Scalars['ID']>;
};


export type MutationRemoveGlobalAdminRoleArgs = {
  userId: Scalars['ID'];
};


export type MutationRemoveRoleFromUserArgs = {
  roleId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemoveUserFromTeamArgs = {
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemoveUserOnboardingStepArgs = {
  stepId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationRequestPaymentArgs = {
  input: RequestPaymentInput;
};


export type MutationRequestPointsArgs = {
  input: RequestPointsInput;
};


export type MutationResendRenewalContractArgs = {
  businessId: Scalars['ID'];
  signatureContact?: InputMaybe<InputRenewalContact>;
};


export type MutationResolveIncidentByDealIdArgs = {
  dealId: Scalars['ID'];
};


export type MutationRewardEmployeesArgs = {
  amount: Scalars['Int'];
  budget?: InputMaybe<BudgetCategoryRequest>;
  destinationUserIds: Array<Scalars['ID']>;
  message: Scalars['String'];
  occasionId?: InputMaybe<Scalars['ID']>;
  schedule?: InputMaybe<FlexiRewardScheduleInput>;
  sourceId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSalesNotifyCtaScreenSeenArgs = {
  ctaScreen?: InputMaybe<BillingCtaScreen>;
};


export type MutationSchedulerCancelEventArgs = {
  uuid: Scalars['ID'];
};


export type MutationSchedulerCancelSystemEventArgs = {
  uuid: Scalars['ID'];
};


export type MutationSchedulerCreateSystemEventArgs = {
  args?: InputMaybe<SchedulerCreateSystemEvent>;
};


export type MutationSchedulerModifyEventArgs = {
  args?: InputMaybe<SchedulerModifyEvent>;
};


export type MutationSchedulerModifySystemEventArgs = {
  args?: InputMaybe<SchedulerModifySystemEvent>;
};


export type MutationSendCreditAsRewardArgs = {
  rewardOrderId: Scalars['String'];
  tenantId: Scalars['String'];
  userId: Scalars['String'];
  walletId: Scalars['String'];
};


export type MutationSendCreditToUserArgs = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  receiverId: Scalars['String'];
  senderId: Scalars['String'];
};


export type MutationSetMyBillingUnitArgs = {
  teamId: Scalars['ID'];
};


export type MutationSetSalaryBracketArgs = {
  input: SetSalaryBracketInput;
};


export type MutationSetSalsacBusinessBenefitRankingsArgs = {
  businessId: Scalars['ID'];
  rankings: Array<SalsacDeductionTypeRankingsInput>;
};


export type MutationSetWorkOsDsyncConfigArgs = {
  businessId: Scalars['ID'];
  launchAt: DateInput;
};


export type MutationSsoAdminLoginArgs = {
  authProvider?: InputMaybe<AuthProvider>;
  googleAccessToken: Scalars['String'];
};


export type MutationStartChangeEmailArgs = {
  oldEmail: Scalars['String'];
};


export type MutationStartCheckoutArgs = {
  userId: Scalars['ID'];
};


export type MutationStartSignUpArgs = {
  enquiry: EnquiryInput;
};


export type MutationStockAttemptReprocessArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationTenantWalletCreateRefundArgs = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  reason: Scalars['String'];
  senderId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationToggleAutoApprovalArgs = {
  input: ToggleAutoApprovalInput;
};


export type MutationToggleCheckoutRedemptionUsedArgs = {
  redemptionId: Scalars['ID'];
};


export type MutationToggleReactionArgs = {
  reaction: RecognitionFeedReactionInput;
};


export type MutationToggleRedemptionUsedArgs = {
  isUsed?: InputMaybe<Scalars['Boolean']>;
  uuid: Scalars['String'];
};


export type MutationTransferFromTenantToRewardArgs = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  recipientIds: Array<InputMaybe<Scalars['String']>>;
  tenantId: Scalars['String'];
  walletType: Scalars['String'];
};


export type MutationUpdateBasketArgs = {
  basket?: InputMaybe<BasketInput>;
  userId: Scalars['ID'];
};


export type MutationUpdateBasketItemArgs = {
  input: UpdateBasketItemInput;
};


export type MutationUpdateBasketItemsBrochureGroupArgs = {
  input: PayrollUpdateBasketItemsBrochureGroupInput;
};


export type MutationUpdateBillingMappingArgs = {
  data?: InputMaybe<BillingMappingUpdateInput>;
};


export type MutationUpdateBillingZuoraSoldToContactArgs = {
  data?: InputMaybe<ZuoraSoldToContactInput>;
};


export type MutationUpdateBrandingArgs = {
  data: UpdateBrandingInput;
};


export type MutationUpdateBudgetCategoriesArgs = {
  input: UpdateBudgetCategoriesInput;
};


export type MutationUpdateBusinessArgs = {
  data: UpdateBusinessInput;
  ifMatch?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBusinessSettingsArgs = {
  businessId: Scalars['ID'];
  industry?: InputMaybe<Scalars['String']>;
  showUntil?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBusinessSsoConfigurationArgs = {
  configuration: SsoConfigurationInput;
};


export type MutationUpdateCheckoutProductConfigArgs = {
  data: CheckoutProductConfigUpdateInput;
  dealId: Scalars['ID'];
};


export type MutationUpdateCommentArgs = {
  comment: RecognitionFeedCommentInput;
  commentId: Scalars['String'];
};


export type MutationUpdateCompanyBenefitArgs = {
  details?: InputMaybe<CompanyBenefitUpdateInput>;
  id: Scalars['ID'];
};


export type MutationUpdateCompanyNewsTileArgs = {
  notify?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['String'];
  tile: CompanyNewsTileInput;
};


export type MutationUpdateCustomRewardArgs = {
  input: UpdateCustomRewardInput;
};


export type MutationUpdateCustomRewardStatusArgs = {
  status: CustomRewardStatus;
  uuid: Scalars['ID'];
};


export type MutationUpdateDealArgs = {
  deal?: InputMaybe<UpdateDealInput>;
};


export type MutationUpdateDealBrandArgs = {
  params?: InputMaybe<UpdateDealBrandInput>;
};


export type MutationUpdateDealPackageArgs = {
  data?: InputMaybe<UpdateDealPackageInput>;
};


export type MutationUpdateDealPriceModifierArgs = {
  data: UpdateDealPriceModifierInput;
};


export type MutationUpdateDealSettingsArgs = {
  settings: DealSettingsInput;
  tenantId: Scalars['ID'];
};


export type MutationUpdateEnquiryArgs = {
  enquiry: EnquiryInput;
  uuid: Scalars['ID'];
};


export type MutationUpdateExternalDealArgs = {
  deal?: InputMaybe<ExternalDealInput>;
};


export type MutationUpdateExternalDealsArgs = {
  deals: Array<InputMaybe<ExternalDealInput>>;
};


export type MutationUpdateFraudBlacklistedEmailArgs = {
  data: UpdateFraudBlacklistedEmailInput;
};


export type MutationUpdateFraudThresholdArgs = {
  params: UpdateFraudThresholdInput;
};


export type MutationUpdateGroupCelebrationArgs = {
  collaboratorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groupCelebrationID?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<UpdateGroupCelebrationInput>;
  scheduledAt?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  walletTransferId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateGroupCelebrationMessageArgs = {
  groupCelebrationID: Scalars['ID'];
  message: Scalars['String'];
  messageId: Scalars['ID'];
};


export type MutationUpdateHomePageLayoutArgs = {
  layout: LayoutWidgetsInput;
  tenantId: Scalars['String'];
};


export type MutationUpdateHomepageArgs = {
  data: HomepageUpdateInput;
};


export type MutationUpdateInternalAdminUserArgs = {
  data: UpdateInternalUserInput;
};


export type MutationUpdateMarketingBusinessProfileArgs = {
  settings: MarketingBusinessProfileSettingsInput;
};


export type MutationUpdateMarketingProfileArgs = {
  data: UpdateMarketingProfileInput;
};


export type MutationUpdateNetBenefitEducationalPopupSeenArgs = {
  input: UpdateNetBenefitEducationalPopupSeenInput;
};


export type MutationUpdateOAuthSettingsArgs = {
  businessId: Scalars['String'];
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider: OAuthProvider;
};


export type MutationUpdateOccasionArgs = {
  occasion: OccasionInput;
  occasionId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationUpdatePayrollOrderArgs = {
  apply_updates_to_employee_profile?: InputMaybe<Scalars['Boolean']>;
  basic_details_check_complete?: InputMaybe<Scalars['Boolean']>;
  employee_number?: InputMaybe<Scalars['String']>;
  national_minimum_wage_check_complete?: InputMaybe<Scalars['Boolean']>;
  ni_number?: InputMaybe<Scalars['String']>;
  order_details_check_complete?: InputMaybe<Scalars['Boolean']>;
  order_id: Scalars['String'];
};


export type MutationUpdatePerksHomepageArgs = {
  data: PerksHomepageUpdateInput;
};


export type MutationUpdatePermissionsProductSettingsBenefitsMarketplaceArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsBenefitsMarketplace;
  teamId: Scalars['ID'];
};


export type MutationUpdatePermissionsProductSettingsCarBenefitsArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsCarBenefits;
  teamId: Scalars['ID'];
};


export type MutationUpdatePermissionsProductSettingsGymMembershipArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsGymMembership;
  teamId: Scalars['ID'];
};


export type MutationUpdatePermissionsProductSettingsHealthCashPlanArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsHealthCashPlan;
  teamId: Scalars['ID'];
};


export type MutationUpdatePermissionsProductSettingsMedicalArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsMedical;
  teamId: Scalars['ID'];
};


export type MutationUpdatePermissionsProductSettingsPerksArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsPerks;
  teamId: Scalars['ID'];
};


export type MutationUpdatePermissionsProductSettingsRecognitionArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsRecognition;
  teamId: Scalars['ID'];
};


export type MutationUpdatePermissionsProductSettingsWalletArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsWallet;
  teamId: Scalars['ID'];
};


export type MutationUpdatePermissionsProductSettingsWellnessArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsWellness;
  teamId: Scalars['ID'];
};


export type MutationUpdatePointsRequestStatusArgs = {
  input: UpdatePointsRequestStatusInput;
};


export type MutationUpdatePollVoteArgs = {
  vote: PollVoteInput;
  voteId: Scalars['String'];
};


export type MutationUpdatePollWithRewardIdArgs = {
  orderId: Scalars['String'];
  pollId: Scalars['String'];
};


export type MutationUpdateProductArgs = {
  data: ProductUpdateInput;
};


export type MutationUpdateProductSettingsCycleToWorkArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsCycleToWork;
  teamId: Scalars['ID'];
};


export type MutationUpdateProductSettingsEmployeeAssistanceProgrammeArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsEmployeeAssistanceProgramme;
  teamId: Scalars['ID'];
};


export type MutationUpdateProductSettingsRewardsArgs = {
  businessId: Scalars['ID'];
  data: UpdateProductSettingsRewards;
  teamId: Scalars['ID'];
};


export type MutationUpdateRecognitionArgs = {
  message?: InputMaybe<Scalars['String']>;
  recognition?: InputMaybe<RecognitionInput>;
  recognitionId: Scalars['String'];
};


export type MutationUpdateRecognitionAutomationArgs = {
  recognitionAutomation: RecognitionAutomationInput;
  uuid: Scalars['ID'];
};


export type MutationUpdateRecognitionAutomationStatusArgs = {
  status: RecognitionAutomationStatus;
  uuid: Scalars['ID'];
};


export type MutationUpdateRecognitionWithRewardArgs = {
  recognitionId: Scalars['String'];
  walletTransferId: Scalars['String'];
};


export type MutationUpdateRecognitionWithRewardIdArgs = {
  orderId: Scalars['String'];
  recognitionId: Scalars['String'];
};


export type MutationUpdateRegionArgs = {
  data?: InputMaybe<RegionUpdateInput>;
};


export type MutationUpdateSalsacBenefitLimitationArgs = {
  input: SalsacBenefitLimitationInput;
};


export type MutationUpdateSalsacBusinessBenefitLimitationArgs = {
  input: SalsacBusinessBenefitLimitationInput;
};


export type MutationUpdateSalsacBusinessIneligibilityCriteriaArgs = {
  businessId: Scalars['ID'];
  criteria: SalsacIneligibilityCriteriaInput;
};


export type MutationUpdateSalsacBusinessIneligibilityRuleArgs = {
  businessId: Scalars['ID'];
  ruleSet: SalsacIneligibilityRuleSetInput;
};


export type MutationUpdateSalsacOrderEligibilityNotificationArgs = {
  input: SalsacOrderEligibilityNotificationInput;
};


export type MutationUpdateSalsacUserBusinessDetailArgs = {
  input: SalsacUserBusinessDetailInput;
};


export type MutationUpdateScheduledRecognitionArgs = {
  recognition: UpdateScheduledRecognitionInput;
};


export type MutationUpdateServiceFeesTiersArgs = {
  tiers: Array<TiersInput>;
};


export type MutationUpdateTagArgs = {
  data: TagUpdateInput;
};


export type MutationUpdateTeamArgs = {
  data: TeamUpdateInput;
  tenantId: Scalars['String'];
};


export type MutationUpdateTenantOnboardingArgs = {
  tenantId: Scalars['String'];
  variables: UpdateTenantOnboardingInput;
};


export type MutationUpdateTenantOnboardingStepArgs = {
  stepId: Scalars['String'];
  tenantId: Scalars['String'];
  variables: UpdateTenantOnboardingStepInput;
};


export type MutationUpdateUserArgs = {
  user: UserInput;
};


export type MutationUpdateUserEmploymentDetailsArgs = {
  input: UpdateUserEmploymentDetailsInput;
};


export type MutationUpdateUserMetadataArgs = {
  userMetadata: UserMetadataInput;
};


export type MutationUpdateUserPhoneNumberArgs = {
  data?: InputMaybe<UpdateUserPhoneNoInput>;
};


export type MutationUpdateUsersByEmailArgs = {
  tenantId: Scalars['String'];
  users: Array<InputMaybe<UpdateUserByEmailInput>>;
};


export type MutationUploadAutoApproveCsvArgs = {
  input: UploadAutoApproveCsvInput;
};


export type MutationUpsertFidelTransactionArgs = {
  fidelTransactionUuid: Scalars['String'];
};


export type MutationValidateChangeEmailArgs = {
  emailInput: ValidateChangeEmailInput;
};


export type MutationWaiveServiceFeesByTenantArgs = {
  businessId: Scalars['ID'];
  waive: Scalars['Boolean'];
};


export type MutationWorkOsLinkCodeArgs = {
  businessId: Scalars['ID'];
};

export type NewInternalUserInput = {
  email: Scalars['String'];
  featureFlags: Array<InternalFeatureFlags>;
  firstName: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  lastName: Scalars['String'];
};

export type NewUserInput = {
  businessId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<UserDateOfBirthInput>;
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employmentDetails?: InputMaybe<UserEmploymentDetailsInput>;
  externalEmployeeId?: InputMaybe<Scalars['ID']>;
  externalStartDate?: InputMaybe<Scalars['String']>;
  externalUserId?: InputMaybe<Scalars['ID']>;
  external_id?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  marketingEmailsAllowed?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  profile_img?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['ID']>;
  role?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<UserSource>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenant?: InputMaybe<Scalars['String']>;
};

export type NextTopup = {
  __typename?: 'NextTopup';
  amount: Scalars['Float'];
  date: Scalars['String'];
};

export const NotificationChannel = {
  CelebrationFeed: 'CELEBRATION_FEED',
  CelebrationOpenPolls: 'CELEBRATION_OPEN_POLLS',
  ChannelUnknown: 'CHANNEL_UNKNOWN',
  CultureHubPublishCards: 'CULTURE_HUB_PUBLISH_CARDS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type NotificationChannel = typeof NotificationChannel[keyof typeof NotificationChannel];
export const NotificationKind = {
  Badge: 'BADGE',
  KindUnknown: 'KIND_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type NotificationKind = typeof NotificationKind[keyof typeof NotificationKind];
export const OAuthProvider = {
  GoogleOAuth: 'GoogleOAuth',
  MicrosoftOAuth: 'MicrosoftOAuth',
  Unknown: 'Unknown'
} as const;

export type OAuthProvider = typeof OAuthProvider[keyof typeof OAuthProvider];
export type Occasion = {
  __typename?: 'Occasion';
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  desc?: Maybe<Scalars['String']>;
  icon?: Maybe<OccasionIcon>;
  image?: Maybe<OccasionIcon>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<OccasionStatus>;
  tag?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type OccasionIcon = {
  __typename?: 'OccasionIcon';
  alt?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
};

export type OccasionIconInput = {
  alt?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
};

export type OccasionInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  default?: InputMaybe<Scalars['Boolean']>;
  desc?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<OccasionIconInput>;
  name?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Paginated List for entity Occasion. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type OccasionList = {
  __typename?: 'OccasionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Occasion>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const OccasionStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Closed: 'CLOSED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type OccasionStatus = typeof OccasionStatus[keyof typeof OccasionStatus];
export type Onboarding = {
  __typename?: 'Onboarding';
  completedSteps?: Maybe<Array<Maybe<Scalars['String']>>>;
  flow?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  steps?: Maybe<Array<Maybe<Scalars['String']>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type OnboardingReport = {
  __typename?: 'OnboardingReport';
  reports?: Maybe<Array<Maybe<OnboardingReportStep>>>;
};

export type OnboardingReportStep = {
  __typename?: 'OnboardingReportStep';
  complete?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  step?: Maybe<Scalars['String']>;
};

export const OnboardingStep = {
  AdminTopup: 'ADMIN_TOPUP',
  AssignTeamManager: 'ASSIGN_TEAM_MANAGER',
  CreateCompanyBenefit: 'CREATE_COMPANY_BENEFIT',
  CreateCompanyCelebration: 'CREATE_COMPANY_CELEBRATION',
  CreateCompanyValue: 'CREATE_COMPANY_VALUE',
  CreateCultureHubTile: 'CREATE_CULTURE_HUB_TILE',
  CreateRegion: 'CREATE_REGION',
  CreateTeam: 'CREATE_TEAM',
  CustomiseLogoOrColour: 'CUSTOMISE_LOGO_OR_COLOUR',
  CustomiseWelcomeMessage: 'CUSTOMISE_WELCOME_MESSAGE',
  DirectorySyncEnabled: 'DIRECTORY_SYNC_ENABLED',
  InviteAdmin: 'INVITE_ADMIN',
  InvitePeople: 'INVITE_PEOPLE',
  MicrosoftTeamsEnabled: 'MICROSOFT_TEAMS_ENABLED',
  SsoEnabled: 'SSO_ENABLED',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type OnboardingStep = typeof OnboardingStep[keyof typeof OnboardingStep];
export type OnboardingUserEmailReturn = {
  __typename?: 'OnboardingUserEmailReturn';
  message?: Maybe<Scalars['String']>;
};

export type OnboardingUserProgress = {
  __typename?: 'OnboardingUserProgress';
  metadata?: Maybe<Metadata>;
  step?: Maybe<Scalars['String']>;
};

export type OnboardingUserUrl = {
  __typename?: 'OnboardingUserURL';
  onboardingUrl?: Maybe<Scalars['String']>;
};

export type OrganisationLimitationDetails = {
  __typename?: 'OrganisationLimitationDetails';
  allowedOrders?: Maybe<Scalars['String']>;
  appliedLimit?: Maybe<Scalars['String']>;
  availableAmountPerFrequency?: Maybe<Scalars['String']>;
  currentActiveOrderValue?: Maybe<Scalars['Float']>;
  currentActiveOrderValueWithReducingBalance?: Maybe<Scalars['Float']>;
  currentActiveOrderValueWithoutReducingBalance?: Maybe<Scalars['Float']>;
  currentOrders?: Maybe<Scalars['String']>;
  currentOrdersCountForSchemeType?: Maybe<Scalars['String']>;
  currentOrdersCountOverall?: Maybe<Scalars['String']>;
  nextOrderDate?: Maybe<Scalars['String']>;
  nextOrderDateWithReducingBalanceForSchemeType?: Maybe<Scalars['String']>;
  nextOrderDateWithReducingBalanceOverall?: Maybe<Scalars['String']>;
  nextOrderDateWithoutReducingBalanceForSchemeType?: Maybe<Array<Maybe<Scalars['String']>>>;
  nextOrderDateWithoutReducingBalanceOverall?: Maybe<Array<Maybe<Scalars['String']>>>;
  percentageLimit?: Maybe<Scalars['String']>;
  reducingBalance?: Maybe<Scalars['Boolean']>;
  spendCap?: Maybe<Scalars['String']>;
  valueLimit?: Maybe<Scalars['String']>;
};

export type OrganisationalSummary = {
  __typename?: 'OrganisationalSummary';
  availableBenchmarks?: Maybe<Array<Maybe<OrganisationalSummaryBenchmark>>>;
  celebrations?: Maybe<OrganisationalSummaryCelebrations>;
  flexi?: Maybe<OrganisationalSummaryFlexiPerks>;
  main?: Maybe<OrganisationalSummaryMain>;
  perks?: Maybe<OrganisationalSummaryPerks>;
  wellness?: Maybe<OrganisationalSummaryWellness>;
};

export type OrganisationalSummaryBenchmark = {
  __typename?: 'OrganisationalSummaryBenchmark';
  companySize?: Maybe<OrganisationalSummaryCompanySize>;
  industry?: Maybe<Scalars['String']>;
};

export const OrganisationalSummaryCategory = {
  Celebrations: 'CELEBRATIONS',
  FlexiPerks: 'FLEXI_PERKS',
  Main: 'MAIN',
  Perks: 'PERKS',
  Unrecognized: 'UNRECOGNIZED',
  Wellness: 'WELLNESS'
} as const;

export type OrganisationalSummaryCategory = typeof OrganisationalSummaryCategory[keyof typeof OrganisationalSummaryCategory];
export type OrganisationalSummaryCelebrations = {
  __typename?: 'OrganisationalSummaryCelebrations';
  engagementRate?: Maybe<Value>;
  polls?: Maybe<Value>;
  recognitions?: Maybe<Value>;
  rewardPointsGiven?: Maybe<Value>;
  rewardPointsPurchased?: Maybe<Value>;
  trends?: Maybe<Array<Maybe<OrganisationalSummaryCelebrationsTrend>>>;
  usersEngaged?: Maybe<Value>;
};

export type OrganisationalSummaryCelebrationsTrend = {
  __typename?: 'OrganisationalSummaryCelebrationsTrend';
  date?: Maybe<OrganisationalSummaryTrendDate>;
  industryBenchmark?: Maybe<OrganisationalSummaryIndustryBenchmark>;
  numberOfActivatedUsers?: Maybe<Value>;
  polls?: Maybe<Value>;
  recognitions?: Maybe<Value>;
  rewardPointsGiven?: Maybe<Value>;
  rewardPointsPurchased?: Maybe<Value>;
  usersEngaged?: Maybe<Value>;
  usersGivenRecognition?: Maybe<Value>;
  usersReceivedRecognition?: Maybe<Value>;
};

export type OrganisationalSummaryCompanySize = {
  __typename?: 'OrganisationalSummaryCompanySize';
  lower?: Maybe<Value>;
  upper?: Maybe<Value>;
};

export type OrganisationalSummaryCompanySizeInput = {
  lower?: InputMaybe<Scalars['Int']>;
  upper?: InputMaybe<Scalars['Int']>;
};

export const OrganisationalSummaryDuration = {
  SummaryLast_6Months: 'SUMMARY_LAST_6_MONTHS',
  SummaryLast_12Months: 'SUMMARY_LAST_12_MONTHS',
  SummaryLast_30Days: 'SUMMARY_LAST_30_DAYS',
  SummaryLast_90Days: 'SUMMARY_LAST_90_DAYS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type OrganisationalSummaryDuration = typeof OrganisationalSummaryDuration[keyof typeof OrganisationalSummaryDuration];
export type OrganisationalSummaryEstimatedSavings = {
  __typename?: 'OrganisationalSummaryEstimatedSavings';
  discountVouchersAud?: Maybe<Scalars['Float']>;
  discountVouchersGbp?: Maybe<Scalars['Float']>;
};

export type OrganisationalSummaryFlexiPerks = {
  __typename?: 'OrganisationalSummaryFlexiPerks';
  burned?: Maybe<Value>;
  earned?: Maybe<Value>;
  engagementRate?: Maybe<Value>;
  redemptions?: Maybe<Value>;
  savingsAUD?: Maybe<Value>;
  savingsGBP?: Maybe<Value>;
  trends?: Maybe<Array<Maybe<OrganisationalSummaryFlexiTrend>>>;
  usersRedeemed?: Maybe<Value>;
};

export type OrganisationalSummaryFlexiTrend = {
  __typename?: 'OrganisationalSummaryFlexiTrend';
  burned?: Maybe<Value>;
  date?: Maybe<OrganisationalSummaryTrendDate>;
  earned?: Maybe<Value>;
  industryBenchmark?: Maybe<OrganisationalSummaryIndustryBenchmark>;
  numberOfActivatedUsers?: Maybe<Value>;
  pointsEarnedBack?: Maybe<Value>;
  redemptions?: Maybe<Value>;
  savingsAUD?: Maybe<Value>;
  savingsGBP?: Maybe<Value>;
  usersEarnedBack?: Maybe<Value>;
  usersRedeemed?: Maybe<Value>;
};

export type OrganisationalSummaryIndustryBenchmark = {
  __typename?: 'OrganisationalSummaryIndustryBenchmark';
  benchmark?: Maybe<OrganisationalSummaryBenchmark>;
  engagementRate?: Maybe<Value>;
};

export type OrganisationalSummaryMain = {
  __typename?: 'OrganisationalSummaryMain';
  acceptedSpendGBP?: Maybe<Value>;
  engagementRate?: Maybe<Value>;
  estimatedSavingsAUD?: Maybe<Value>;
  estimatedSavingsGBP?: Maybe<Value>;
  fixedSavingsAUD?: Maybe<Value>;
  fixedSavingsGBP?: Maybe<Value>;
  loginRate?: Maybe<Value>;
  numberOfEngagedUsers?: Maybe<Value>;
  numberOfEngagements?: Maybe<Value>;
  savingsAUD?: Maybe<Value>;
  savingsGBP?: Maybe<Value>;
  savingsPercentage?: Maybe<Value>;
  trends?: Maybe<Array<Maybe<OrganisationalSummaryMainTrend>>>;
};

export type OrganisationalSummaryMainTrend = {
  __typename?: 'OrganisationalSummaryMainTrend';
  date?: Maybe<OrganisationalSummaryTrendDate>;
  industryBenchmark?: Maybe<OrganisationalSummaryIndustryBenchmark>;
  numberOfActivatedUsers?: Maybe<Value>;
  numberOfEngagedUsers?: Maybe<Value>;
  numberOfEngagements?: Maybe<Value>;
  numberOfUsersLoggedIn?: Maybe<Value>;
  savings?: Maybe<OrganisationalSummaryTrendRateSavings>;
  savingsAUD?: Maybe<Value>;
  savingsGBP?: Maybe<Value>;
  savingsPercentage?: Maybe<Value>;
};

export type OrganisationalSummaryPerks = {
  __typename?: 'OrganisationalSummaryPerks';
  digitalVoucherSavingsAud?: Maybe<Value>;
  digitalVoucherSavingsGbp?: Maybe<Value>;
  discountVoucherEstimatedSavingsAud?: Maybe<Value>;
  discountVoucherEstimatedSavingsGbp?: Maybe<Value>;
  engagementRate?: Maybe<Value>;
  estimatedSavingsAUD?: Maybe<Value>;
  estimatedSavingsGBP?: Maybe<Value>;
  fixedSavingsAUD?: Maybe<Value>;
  fixedSavingsGBP?: Maybe<Value>;
  flexiPointsBurned?: Maybe<Value>;
  redemptions?: Maybe<Value>;
  savingsAUD?: Maybe<Value>;
  savingsGBP?: Maybe<Value>;
  savingsPercentage?: Maybe<Value>;
  trends?: Maybe<Array<Maybe<OrganisationalSummaryPerksTrend>>>;
  usersRedeemed?: Maybe<Value>;
};

export type OrganisationalSummaryPerksTrend = {
  __typename?: 'OrganisationalSummaryPerksTrend';
  date?: Maybe<OrganisationalSummaryTrendDate>;
  flexiPointsBurned?: Maybe<Value>;
  industryBenchmark?: Maybe<OrganisationalSummaryIndustryBenchmark>;
  numberOfActivatedUsers?: Maybe<Value>;
  redemptions?: Maybe<Value>;
  savingsAUD?: Maybe<Value>;
  savingsGBP?: Maybe<Value>;
  savingsPercentage?: Maybe<Value>;
  usersRedeemed?: Maybe<Value>;
};

export type OrganisationalSummaryTrendDate = {
  __typename?: 'OrganisationalSummaryTrendDate';
  date?: Maybe<Value>;
  month?: Maybe<Value>;
  quarter?: Maybe<Value>;
  year?: Maybe<Value>;
};

export const OrganisationalSummaryTrendDuration = {
  SummaryTrendMonthly: 'SUMMARY_TREND_MONTHLY',
  SummaryTrendQuarterly: 'SUMMARY_TREND_QUARTERLY',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type OrganisationalSummaryTrendDuration = typeof OrganisationalSummaryTrendDuration[keyof typeof OrganisationalSummaryTrendDuration];
export type OrganisationalSummaryTrendRateSavings = {
  __typename?: 'OrganisationalSummaryTrendRateSavings';
  digitalVouchersAud?: Maybe<Scalars['Float']>;
  digitalVouchersGbp?: Maybe<Scalars['Float']>;
  estimated?: Maybe<OrganisationalSummaryEstimatedSavings>;
  flexiPointsAud?: Maybe<Scalars['Float']>;
  flexiPointsGbp?: Maybe<Scalars['Float']>;
  rewardPointsAud?: Maybe<Scalars['Float']>;
  rewardPointsGbp?: Maybe<Scalars['Float']>;
};

export type OrganisationalSummaryWellness = {
  __typename?: 'OrganisationalSummaryWellness';
  engagementRate?: Maybe<Value>;
  trends?: Maybe<Array<Maybe<OrganisationalSummaryWellnessTrend>>>;
  usersEngaged?: Maybe<Value>;
  views?: Maybe<Value>;
  webinarRegistrations?: Maybe<Value>;
};

export type OrganisationalSummaryWellnessTrend = {
  __typename?: 'OrganisationalSummaryWellnessTrend';
  date?: Maybe<OrganisationalSummaryTrendDate>;
  industryBenchmark?: Maybe<OrganisationalSummaryIndustryBenchmark>;
  numberOfActivatedUsers?: Maybe<Value>;
  usersEngaged?: Maybe<Value>;
  views?: Maybe<Value>;
  webinarRegistrations?: Maybe<Value>;
};

export type PrpAlgoliaCategory = {
  __typename?: 'PRPAlgoliaCategory';
  categoryId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  departmentId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PrpAlgoliaFacets = {
  __typename?: 'PRPAlgoliaFacets';
  categories?: Maybe<Array<Maybe<PrpAlgoliaCategory>>>;
};

export type PrpAlgoliaFilters = {
  __typename?: 'PRPAlgoliaFilters';
  facetFilters?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>;
  filters?: Maybe<Scalars['String']>;
};

export type PrpAlgoliaHit = {
  __typename?: 'PRPAlgoliaHit';
  id?: Maybe<Scalars['ID']>;
  imageCdnUrl?: Maybe<Scalars['String']>;
  onlineProductName?: Maybe<Scalars['String']>;
};

export type PrpAlgoliaSuggestions = {
  __typename?: 'PRPAlgoliaSuggestions';
  facets?: Maybe<PrpAlgoliaFacets>;
  hits?: Maybe<Array<Maybe<PrpAlgoliaHit>>>;
};

export type PaginationInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type Partner = {
  __typename?: 'Partner';
  dynamicBenefitJourney?: Maybe<Scalars['Boolean']>;
  lockUserToDestinationBenefit?: Maybe<Scalars['Boolean']>;
  platformType?: Maybe<Scalars['String']>;
  signOutLabel?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type PasswordChallenge = {
  challengeName: Scalars['String'];
  session: Scalars['String'];
  userId: Scalars['String'];
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  currency?: Maybe<PaymentCurrencyType>;
  details?: Maybe<PaymentDetails>;
  orderId?: Maybe<Scalars['String']>;
  provider?: Maybe<PaymentProvider>;
  revisionId?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentStatus>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedById?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type PaymentCardInput = {
  amount?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<PaymentCurrencyType>;
  details?: InputMaybe<PaymentCardInputDetails>;
  enableSaveCardOption?: InputMaybe<Scalars['Boolean']>;
  provider?: InputMaybe<PaymentProvider>;
};

export type PaymentCardInputDetails = {
  channel?: InputMaybe<Scalars['String']>;
  resURL?: InputMaybe<Scalars['String']>;
  shopperEmail?: InputMaybe<Scalars['String']>;
  shopperLocale?: InputMaybe<Scalars['String']>;
};

export const PaymentChannel = {
  Web: 'Web'
} as const;

export type PaymentChannel = typeof PaymentChannel[keyof typeof PaymentChannel];
export type PaymentConfigProvider = {
  __typename?: 'PaymentConfigProvider';
  name: Scalars['String'];
  pubKey: Scalars['String'];
};

export type PaymentConfigs = {
  __typename?: 'PaymentConfigs';
  paymentMethods?: Maybe<Array<PaymentMethodConfigs>>;
  provider: PaymentConfigProvider;
};

export type PaymentContext = {
  __typename?: 'PaymentContext';
  orderId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

export const PaymentContextSource = {
  Paypal: 'PAYPAL',
  UnknownType: 'UNKNOWN_TYPE',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PaymentContextSource = typeof PaymentContextSource[keyof typeof PaymentContextSource];
export const PaymentCountryCode = {
  Au: 'AU',
  Fr: 'FR',
  Gb: 'GB',
  Global: 'GLOBAL',
  Ie: 'IE'
} as const;

export type PaymentCountryCode = typeof PaymentCountryCode[keyof typeof PaymentCountryCode];
export const PaymentCurrencyType = {
  /** United Arab Emirates Dirham */
  Aed: 'AED',
  /** Afghan Afghani */
  Afn: 'AFN',
  /** Albanian Lek */
  All: 'ALL',
  /** Armenian Dram */
  Amd: 'AMD',
  /** Argentine Peso */
  Ars: 'ARS',
  /** Australian Dollar */
  Aud: 'AUD',
  /** Azerbaijani Manat */
  Azn: 'AZN',
  /** Bosnia-Herzegovina Convertible Marka */
  Bam: 'BAM',
  /** Bangladeshi Taka */
  Bdt: 'BDT',
  /** Bulgarian lev */
  Bgn: 'BGN',
  /** Bahraini Dinar */
  Bhd: 'BHD',
  /** Burundian Franc */
  Bif: 'BIF',
  /** BlendPoints of Rp and Fp, only exists client side */
  Blend: 'BLEND',
  /** Brunei Dollar */
  Bnd: 'BND',
  /** Bolivian Boliviano */
  Bob: 'BOB',
  /** Brazilian Real */
  Brl: 'BRL',
  /** Botswanan Pula */
  Bwp: 'BWP',
  /** Belarusian Ruble */
  Byn: 'BYN',
  /** Belize Dollar */
  Bzd: 'BZD',
  /** Canadian Dollar */
  Cad: 'CAD',
  /** Congolese Franc */
  Cdf: 'CDF',
  /** Swiss Franc */
  Chf: 'CHF',
  /** Chilean Peso */
  Clp: 'CLP',
  /** Chinese Yuan */
  Cny: 'CNY',
  /** Colombian Peso */
  Cop: 'COP',
  /** Costa Rican Colon */
  Crc: 'CRC',
  /** Cape Verdean Escudo */
  Cve: 'CVE',
  /** Czech Koruna */
  Czk: 'CZK',
  /** Djiboutian Franc */
  Djf: 'DJF',
  /** Danish Krone */
  Dkk: 'DKK',
  /** Dominican Peso */
  Dop: 'DOP',
  /** Algerian dinar */
  Dzd: 'DZD',
  /** Estonian Kroon */
  Eek: 'EEK',
  /** Egyptian Pound */
  Egp: 'EGP',
  /** Reward Points as used for celebrations and rewards, a replacement of the old 'RP' code */
  Ep: 'EP',
  /** Eritrean Nakfa */
  Ern: 'ERN',
  /** Ethiopian Birr */
  Etb: 'ETB',
  /** Euro */
  Eur: 'EUR',
  /** Pound Sterling */
  Gbp: 'GBP',
  /** Georgian Lari */
  Gel: 'GEL',
  /** Ghanaian Cedi */
  Ghs: 'GHS',
  /** Guinean Franc */
  Gnf: 'GNF',
  /** Guatemalan Quetzal */
  Gtq: 'GTQ',
  /** Hong Kong Dollar */
  Hkd: 'HKD',
  /** Honduran Lempira */
  Hnl: 'HNL',
  /** Croatian Kuna */
  Hrk: 'HRK',
  /** Hungarian Forint */
  Huf: 'HUF',
  /** Indonesian Rupiah */
  Idr: 'IDR',
  /** Israeli New Sheqel */
  Ils: 'ILS',
  /** Indian Rupee */
  Inr: 'INR',
  /** Iraqi Dinar */
  Iqd: 'IQD',
  /** Iranian Rial */
  Irr: 'IRR',
  /** Icelandic krona */
  Isk: 'ISK',
  /** Jamaican Dollar */
  Jmd: 'JMD',
  /** Jordanian Dinar */
  Jod: 'JOD',
  /** Japanese Yen */
  Jpy: 'JPY',
  /** Kenyan Shilling */
  Kes: 'KES',
  /** Cambodian Riel */
  Khr: 'KHR',
  /** Comorian Franc */
  Kmf: 'KMF',
  /** South Korean Won */
  Krw: 'KRW',
  /** Kuwaiti Dinar */
  Kwd: 'KWD',
  /** Kazakhstani Tenge */
  Kzt: 'KZT',
  /** Lebanese Pound */
  Lbp: 'LBP',
  /** Sri Lankan Rupee */
  Lkr: 'LKR',
  /** Lithuanian Litas */
  Ltl: 'LTL',
  /** Latvian Lats */
  Lvl: 'LVL',
  /** Libyan Dinar */
  Lyd: 'LYD',
  /** Moroccan Dirham */
  Mad: 'MAD',
  /** Moldovan Leu */
  Mdl: 'MDL',
  /** Malagasy Ariary */
  Mga: 'MGA',
  /** Macedonian Denar */
  Mkd: 'MKD',
  /** Myanma Kyat */
  Mmk: 'MMK',
  /** Macanese Pataca */
  Mop: 'MOP',
  /** Merchant points, used to normalise different stock prices across deal providers */
  Mp: 'MP',
  /** Mauritian Rupee */
  Mur: 'MUR',
  /** Maldivian Rufiyaa */
  Mvr: 'MVR',
  /** Mexican Peso */
  Mxn: 'MXN',
  /** Malaysian Ringgit */
  Myr: 'MYR',
  /** Mozambican Metical */
  Mzn: 'MZN',
  /** Namibian Dollar */
  Nad: 'NAD',
  /** Nigerian Naira */
  Ngn: 'NGN',
  /** Nicaraguan Cordoba */
  Nio: 'NIO',
  /** Norwegian Krone */
  Nok: 'NOK',
  /** Nepalese Rupee */
  Npr: 'NPR',
  /** New Zealand Dollar */
  Nzd: 'NZD',
  /** Omani Rial */
  Omr: 'OMR',
  /** Panamanian balboa */
  Pab: 'PAB',
  /** Peruvian Nuevo Sol */
  Pen: 'PEN',
  /** Philippine Peso */
  Php: 'PHP',
  /** Pakistani Rupee */
  Pkr: 'PKR',
  /** Zloty */
  Pln: 'PLN',
  /** Paraguayan Guarani */
  Pyg: 'PYG',
  /** Qatari Riyal */
  Qar: 'QAR',
  /** Romanian Leu */
  Ron: 'RON',
  /** The original Reward Point currency code before the great migration of 2024 */
  Rp: 'RP',
  /** Serbian Dinar */
  Rsd: 'RSD',
  /** Russian ruble */
  Rub: 'RUB',
  /** Rwandan Franc */
  Rwf: 'RWF',
  /** Saudi Riyal */
  Sar: 'SAR',
  /** Sudanese Pound */
  Sdg: 'SDG',
  /** Swedish Krona */
  Sek: 'SEK',
  /** Singapore dollar */
  Sgd: 'SGD',
  /** Somali Shilling */
  Sos: 'SOS',
  /** Syrian Pound */
  Syp: 'SYP',
  /** Thai baht */
  Thb: 'THB',
  /** Tunisian Dinar */
  Tnd: 'TND',
  /** Tongan Paʻanga */
  Top: 'TOP',
  /** Turkish Lira */
  Try: 'TRY',
  /** FlexiPoint tokens, originally referred to as treat tokens. Used for Perks */
  Tt: 'TT',
  /** Trinidad and Tobago Dollar */
  Ttd: 'TTD',
  /** New Taiwan dollar */
  Twd: 'TWD',
  /** Tanzanian Shilling */
  Tzs: 'TZS',
  /** Ukrainian Hryvnia */
  Uah: 'UAH',
  /** Ugandan Shilling */
  Ugx: 'UGX',
  /** US Dollar */
  Usd: 'USD',
  /** Uruguayan peso */
  Uyu: 'UYU',
  /** Uzbekistan Som */
  Uzs: 'UZS',
  /** Venezuelan Bolívar */
  Vef: 'VEF',
  /** Vietnamese Dong */
  Vnd: 'VND',
  /** Central African Franc */
  Xaf: 'XAF',
  /** East Caribbean dollar */
  Xcd: 'XCD',
  /** West African Franc */
  Xof: 'XOF',
  /** Yemeni Rial */
  Yer: 'YER',
  /** South African Rand */
  Zar: 'ZAR',
  /** Zambian Kwacha */
  Zmk: 'ZMK',
  /** Zimbabwean Dollar */
  Zwl: 'ZWL'
} as const;

export type PaymentCurrencyType = typeof PaymentCurrencyType[keyof typeof PaymentCurrencyType];
export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  authResult?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  clientKey?: Maybe<Scalars['String']>;
  merchantAccount?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<PaymentMethods>;
  pspReference?: Maybe<Scalars['String']>;
  pubKey?: Maybe<Scalars['String']>;
  shopperEmail?: Maybe<Scalars['String']>;
  shopperLocale?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PaymentLink = {
  __typename?: 'PaymentLink';
  key: Scalars['String'];
  pageId: Scalars['String'];
  signature: Scalars['String'];
  tenantId: Scalars['String'];
  token: Scalars['String'];
  uri: Scalars['String'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brands?: Maybe<Array<Maybe<Scalars['String']>>>;
  details?: Maybe<Array<Maybe<InputDetail>>>;
  group?: Maybe<DetailGroup>;
  name?: Maybe<Scalars['String']>;
  paymentMethodData?: Maybe<Scalars['String']>;
  supportsRecurring?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type PaymentMethodConfigs = {
  __typename?: 'PaymentMethodConfigs';
  circuits?: Maybe<Array<Maybe<Scalars['String']>>>;
  extId?: Maybe<Scalars['String']>;
  kind: PaymentMethodKind;
  returnUrl?: Maybe<Scalars['String']>;
  savedCards?: Maybe<Array<Maybe<PaymentSavedCard>>>;
};

export const PaymentMethodKind = {
  ApplePay: 'ApplePay',
  Card: 'Card',
  GooglePay: 'GooglePay',
  PayPal: 'PayPal'
} as const;

export type PaymentMethodKind = typeof PaymentMethodKind[keyof typeof PaymentMethodKind];
export const PaymentMethodType = {
  Applepay: 'applepay',
  /** bancontact */
  Bcmc: 'bcmc',
  Googlepay: 'googlepay',
  Ideal: 'ideal',
  Paypal: 'paypal'
} as const;

export type PaymentMethodType = typeof PaymentMethodType[keyof typeof PaymentMethodType];
export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  groups?: Maybe<Array<Maybe<PaymentMethodsGroup>>>;
  oneClickPaymentMethods?: Maybe<Array<Maybe<RecurringDetail>>>;
  paymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  storedPaymentMethods?: Maybe<Array<Maybe<StoredPaymentMethod>>>;
};

export type PaymentMethodsGroup = {
  __typename?: 'PaymentMethodsGroup';
  groupType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PaymentOrder = {
  __typename?: 'PaymentOrder';
  amount?: Maybe<Scalars['Int']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  currency?: Maybe<PaymentCurrencyType>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  revisionId?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentOrderStatus>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedById?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

/**
 * Paginated List for entity PaymentOrder. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type PaymentOrderList = {
  __typename?: 'PaymentOrderList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<PaymentOrder>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const PaymentOrderStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  PartRefunded: 'PART_REFUNDED',
  Pending: 'PENDING',
  Refunded: 'REFUNDED'
} as const;

export type PaymentOrderStatus = typeof PaymentOrderStatus[keyof typeof PaymentOrderStatus];
export const PaymentProvider = {
  Adyen: 'ADYEN',
  AdyenClassic: 'ADYEN_CLASSIC',
  CheckoutCom: 'CHECKOUT_COM',
  ProviderUnknown: 'PROVIDER_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED',
  Wallet: 'WALLET',
  Zip: 'ZIP'
} as const;

export type PaymentProvider = typeof PaymentProvider[keyof typeof PaymentProvider];
export type PaymentSavedCard = {
  __typename?: 'PaymentSavedCard';
  expiry?: Maybe<PaymentSavedCardExpiry>;
  holder?: Maybe<PaymentSavedCardHolder>;
  number?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['ID']>;
  variant?: Maybe<Scalars['String']>;
};

export type PaymentSavedCardExpiry = {
  __typename?: 'PaymentSavedCardExpiry';
  month?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type PaymentSavedCardHolder = {
  __typename?: 'PaymentSavedCardHolder';
  name?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity PaymentSavedCard. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type PaymentSavedCardList = {
  __typename?: 'PaymentSavedCardList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<PaymentSavedCard>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const PaymentStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  PartRefunded: 'PART_REFUNDED',
  Pending: 'PENDING',
  Refunded: 'REFUNDED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];
export type PaymentType = {
  __typename?: 'PaymentType';
  cardNumber?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  helpText?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PaymentWalletInput = {
  amount?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<PaymentCurrencyType>;
  details?: InputMaybe<PaymentWalletInputDetails>;
  /** extra optional details only applied in cases of multi-currency payments */
  multiCurrencyDetails?: InputMaybe<MultiCurrencyDetailsInput>;
  provider?: InputMaybe<PaymentProvider>;
};

export type PaymentWalletInputDetails = {
  reference?: InputMaybe<PaymentWalletReference>;
  sourceOwnerId?: InputMaybe<Scalars['ID']>;
  sourceWalletId?: InputMaybe<Scalars['ID']>;
  walletType?: InputMaybe<Scalars['String']>;
};

export type PaymentWalletReference = {
  dealHeader?: InputMaybe<Scalars['String']>;
  dealThumbnailImage?: InputMaybe<Scalars['String']>;
  isWellnessRental?: InputMaybe<Scalars['Boolean']>;
  orderTotal?: InputMaybe<PaymentWalletReferenceOrderTotal>;
  order_id?: InputMaybe<Scalars['String']>;
  redemptionUuid?: InputMaybe<Scalars['String']>;
  rewards_wallet_id?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type PaymentWalletReferenceOrderTotal = {
  currency?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export const PaymentWalletType = {
  Personal: 'personal',
  Rewards: 'rewards'
} as const;

export type PaymentWalletType = typeof PaymentWalletType[keyof typeof PaymentWalletType];
export type PaymentZipInput = {
  amount: Scalars['Int'];
  currency: PaymentCurrencyType;
  details?: InputMaybe<PaymentZipInputDetails>;
  provider: PaymentProvider;
};

export type PaymentZipInputDetails = {
  resURL: Scalars['String'];
};

export type PayrollAuditLog = {
  __typename?: 'PayrollAuditLog';
  changed_fields?: Maybe<Array<Maybe<PayrollAuditLogFields>>>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
};

export type PayrollAuditLogFields = {
  __typename?: 'PayrollAuditLogFields';
  field_name?: Maybe<Scalars['String']>;
  new_value?: Maybe<Scalars['String']>;
  previous_value?: Maybe<Scalars['String']>;
};

export type PayrollAuditLogs = {
  __typename?: 'PayrollAuditLogs';
  audit_logs?: Maybe<Array<Maybe<PayrollAuditLog>>>;
};

export type PayrollGivingOrder = {
  __typename?: 'PayrollGivingOrder';
  errors?: Maybe<Array<PayrollPayOrderError>>;
  order?: Maybe<PayrollPayOrder>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PayrollOrder = {
  __typename?: 'PayrollOrder';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  amount_per_pay_period?: Maybe<Scalars['String']>;
  approval_status?: Maybe<Scalars['String']>;
  basicNetCostPerPeriod?: Maybe<Scalars['String']>;
  basic_details_check_complete?: Maybe<Scalars['Boolean']>;
  benefit_name?: Maybe<Scalars['String']>;
  benefit_type?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<Maybe<PayrollOrderComment>>>;
  county?: Maybe<Scalars['String']>;
  current_existing_internal_reductions?: Maybe<Scalars['String']>;
  date_of_birth?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  effective_date?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employee_id?: Maybe<Scalars['String']>;
  firstPayrollDeduction?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  higherNetCostPerPeriod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  job_grade?: Maybe<Scalars['String']>;
  job_location?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  line_manager_email?: Maybe<Scalars['String']>;
  line_manager_name?: Maybe<Scalars['String']>;
  mobile_number?: Maybe<Scalars['String']>;
  national_minimum_wage?: Maybe<Scalars['Float']>;
  national_minimum_wage_check_complete?: Maybe<Scalars['Boolean']>;
  net?: Maybe<Scalars['Boolean']>;
  ni_number?: Maybe<Scalars['String']>;
  orderStatusMessage?: Maybe<Scalars['String']>;
  order_details_check_complete?: Maybe<Scalars['Boolean']>;
  order_management_order_status?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['Int']>;
  order_status?: Maybe<Scalars['String']>;
  other_orders?: Maybe<Array<Maybe<PayrollOrder>>>;
  partner_user_identifier?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<PayrollPayOrderProduct>>>;
  quoteType?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  telephone_number?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalBasicNetCost?: Maybe<Scalars['String']>;
  totalHigherNetCost?: Maybe<Scalars['String']>;
  total_amount_to_recover?: Maybe<Scalars['String']>;
  total_end_of_agreement_inc_vat?: Maybe<Scalars['String']>;
  total_existing_active_orders_value?: Maybe<Scalars['String']>;
};

export type PayrollOrderComment = {
  __typename?: 'PayrollOrderComment';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerUser?: Maybe<User>;
  partner_user_id?: Maybe<Scalars['String']>;
};

export type PayrollOrderDocument = {
  __typename?: 'PayrollOrderDocument';
  hire_agreement?: Maybe<Scalars['String']>;
  line_manager_approval?: Maybe<Scalars['Boolean']>;
};

export type PayrollOrderDocumentList = {
  __typename?: 'PayrollOrderDocumentList';
  hire_agreement?: Maybe<Scalars['String']>;
  line_manager_approval?: Maybe<Scalars['String']>;
  salarySacrificeAgreement?: Maybe<Scalars['String']>;
};

export type PayrollOrderDocuments = {
  __typename?: 'PayrollOrderDocuments';
  documents?: Maybe<PayrollOrderDocumentList>;
};

export type PayrollOrderFilterFrequency = {
  __typename?: 'PayrollOrderFilterFrequency';
  frequency?: Maybe<Scalars['String']>;
  periods?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PayrollOrderFilters = {
  __typename?: 'PayrollOrderFilters';
  employee_numbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  ni_numbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  organisation_approval?: Maybe<Array<Maybe<Scalars['String']>>>;
  payroll_periods_by_frequency?: Maybe<Array<Maybe<PayrollOrderFilterFrequency>>>;
  status?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PayrollOrderReason = {
  additional_information?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type PayrollPayBanner = {
  __typename?: 'PayrollPayBanner';
  desktopImageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PayrollPayBasket = {
  __typename?: 'PayrollPayBasket';
  employeeOrganisation?: Maybe<PayrollPayBasketEmployeeOrganisation>;
};

export type PayrollPayBasketData = {
  __typename?: 'PayrollPayBasketData';
  /** @deprecated Use limitationMessage instead. This field will be removed in a future release. */
  activeOrderDetails?: Maybe<ActiveOrderDetails>;
  basketItems: Array<PayrollPayBasketItem>;
  brochureGroupId?: Maybe<Scalars['ID']>;
  count?: Maybe<Scalars['Int']>;
  disposalFee?: Maybe<Scalars['Float']>;
  endOfAgreementFee?: Maybe<Scalars['Float']>;
  headroomValue?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** @deprecated Use limitationMessage instead. This field will be removed in a future release. */
  limitExceeded?: Maybe<LimitExceededDetails>;
  limitationMessage?: Maybe<LimitationMessage>;
  monthlyPrice?: Maybe<Scalars['Float']>;
  term?: Maybe<Scalars['Int']>;
  totalMonthlyGrossAmount?: Maybe<Scalars['Float']>;
  totalRrp?: Maybe<Scalars['Float']>;
  totalSavings?: Maybe<Scalars['Float']>;
};

export type PayrollPayBasketEmployeeOrganisation = {
  __typename?: 'PayrollPayBasketEmployeeOrganisation';
  id: Scalars['ID'];
  scheme?: Maybe<PayrollPayBasketScheme>;
};

export type PayrollPayBasketFeaturedCategory = {
  __typename?: 'PayrollPayBasketFeaturedCategory';
  imageUrl?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type PayrollPayBasketItem = {
  __typename?: 'PayrollPayBasketItem';
  brand?: Maybe<Scalars['String']>;
  brochureGroupId: Scalars['ID'];
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  outOfStock?: Maybe<Scalars['Boolean']>;
  previousPrice?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  productId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  releaseDate?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  storeName?: Maybe<Scalars['String']>;
  supplierName?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['Int']>;
  totalAmount?: Maybe<Scalars['Float']>;
  variant?: Maybe<Scalars['String']>;
};

export type PayrollPayBasketScheme = {
  __typename?: 'PayrollPayBasketScheme';
  basket: PayrollPayBasketData;
  brochureGroups?: Maybe<Array<PayrollPayBrochureGroup>>;
  featuredCategories?: Maybe<Array<PayrollPayBasketFeaturedCategory>>;
  id: Scalars['ID'];
};

export type PayrollPayBasketTotals = {
  __typename?: 'PayrollPayBasketTotals';
  count?: Maybe<Scalars['Int']>;
  disposalFee?: Maybe<Scalars['Float']>;
  endOfAgreementFee?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  monthlyPrice?: Maybe<Scalars['Float']>;
  term?: Maybe<Scalars['Int']>;
  totalMonthlyGrossAmount?: Maybe<Scalars['Float']>;
  totalRrp?: Maybe<Scalars['Float']>;
  totalSavings?: Maybe<Scalars['Float']>;
};

export type PayrollPayBenefit = {
  __typename?: 'PayrollPayBenefit';
  endDate?: Maybe<Scalars['String']>;
  faqUrl?: Maybe<Scalars['String']>;
  limitPercentage?: Maybe<Scalars['Int']>;
  limitValue?: Maybe<Scalars['Int']>;
  quoteType?: Maybe<Scalars['String']>;
  relativeUrl?: Maybe<Scalars['String']>;
  ssoCompanyName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  termsNCondsUrl?: Maybe<Scalars['String']>;
};

export type PayrollPayBenefits = {
  __typename?: 'PayrollPayBenefits';
  benefits?: Maybe<Array<Maybe<PayrollPayBenefit>>>;
};

export type PayrollPayBikeShop = {
  __typename?: 'PayrollPayBikeShop';
  employeeOrganisation?: Maybe<BikeShopData>;
};

export type PayrollPayBreadcrumb = {
  __typename?: 'PayrollPayBreadcrumb';
  label: Scalars['String'];
  link: Scalars['String'];
};

export type PayrollPayBrochureGroup = {
  __typename?: 'PayrollPayBrochureGroup';
  id: Scalars['ID'];
  term: Scalars['String'];
};

export type PayrollPayCheckoutCheckbox = {
  __typename?: 'PayrollPayCheckoutCheckbox';
  content?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
};

export type PayrollPayCheckoutData = {
  __typename?: 'PayrollPayCheckoutData';
  currentUser?: Maybe<PayrollPayCurrentUser>;
  employeeOrganisation?: Maybe<PayrollPayCheckoutEmployeeOrganisation>;
};


export type PayrollPayCheckoutDataEmployeeOrganisationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PayrollPayCheckoutEmployee = {
  __typename?: 'PayrollPayCheckoutEmployee';
  employeeNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type PayrollPayCheckoutEmployeeOrganisation = {
  __typename?: 'PayrollPayCheckoutEmployeeOrganisation';
  employee?: Maybe<PayrollPayCheckoutEmployee>;
  id: Scalars['ID'];
  scheme?: Maybe<PayrollPayCheckoutScheme>;
};


export type PayrollPayCheckoutEmployeeOrganisationSchemeArgs = {
  schemeTypeRelativeUrl: Scalars['ID'];
};

export type PayrollPayCheckoutNetSchemeCheckbox = {
  __typename?: 'PayrollPayCheckoutNetSchemeCheckbox';
  description?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PayrollPayCheckoutScheme = {
  __typename?: 'PayrollPayCheckoutScheme';
  basket?: Maybe<PayrollPayBasketData>;
  checkboxes?: Maybe<Array<PayrollPayCheckoutCheckbox>>;
  checkboxesForNetScheme?: Maybe<Array<PayrollPayCheckoutNetSchemeCheckbox>>;
  id: Scalars['ID'];
  quoteLimit?: Maybe<Scalars['Float']>;
  showDateOfBirth?: Maybe<Scalars['Boolean']>;
  storeName?: Maybe<Scalars['String']>;
};

export type PayrollPayCurrentUser = {
  __typename?: 'PayrollPayCurrentUser';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homePhone?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  niNumber?: Maybe<Scalars['String']>;
  placeOfWork?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
};

export type PayrollPayCustomFooterLink = {
  __typename?: 'PayrollPayCustomFooterLink';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PayrollPayDepartment = {
  __typename?: 'PayrollPayDepartment';
  breadcrumbs: Array<PayrollPayBreadcrumb>;
  categories: Array<StoreDepartmentCategory>;
  id: Scalars['ID'];
  landingRoundel?: Maybe<StoreDepartmentRoundel>;
  leftColour?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rightColour?: Maybe<Scalars['String']>;
  roundel?: Maybe<PayrollPayRoundel>;
};

export type PayrollPayDepartmentCategories = {
  __typename?: 'PayrollPayDepartmentCategories';
  count: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  subcategories: Array<PayrollPayDepartmentSubCategories>;
};

export type PayrollPayDepartmentCategoriesData = {
  __typename?: 'PayrollPayDepartmentCategoriesData';
  id: Scalars['ID'];
  scheme?: Maybe<StoreDepartmentScheme>;
};

export type PayrollPayDepartmentSubCategories = {
  __typename?: 'PayrollPayDepartmentSubCategories';
  count: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PayrollPayFeaturedCategory = {
  __typename?: 'PayrollPayFeaturedCategory';
  categoryId?: Maybe<Scalars['ID']>;
  departmentId?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type PayrollPayFrequency = {
  __typename?: 'PayrollPayFrequency';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PayrollPayLanguage = {
  __typename?: 'PayrollPayLanguage';
  code?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PayrollPayLayoutEmployeeOrganisationData = {
  __typename?: 'PayrollPayLayoutEmployeeOrganisationData';
  changePortalLink?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PayrollPayOrder = {
  __typename?: 'PayrollPayOrder';
  id: Scalars['ID'];
};

export type PayrollPayOrderError = {
  __typename?: 'PayrollPayOrderError';
  fieldName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type PayrollPayOrderProduct = {
  __typename?: 'PayrollPayOrderProduct';
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemImage?: Maybe<Scalars['String']>;
  item_description?: Maybe<Scalars['String']>;
  item_name?: Maybe<Scalars['String']>;
  item_no?: Maybe<Scalars['String']>;
  item_qty?: Maybe<Scalars['Int']>;
  item_value?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type PayrollPayOrderSchemeType = {
  __typename?: 'PayrollPayOrderSchemeType';
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type PayrollPayOrders = {
  __typename?: 'PayrollPayOrders';
  orders?: Maybe<Array<Maybe<PayrollOrder>>>;
  scheme_types_by_count?: Maybe<Array<Maybe<PayrollPayOrderSchemeType>>>;
};

export type PayrollPayProduct = {
  __typename?: 'PayrollPayProduct';
  brand?: Maybe<Scalars['String']>;
  brochureGroupId: Scalars['ID'];
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price: Scalars['Float'];
  productId: Scalars['ID'];
  productImages: Array<Scalars['String']>;
  productTagImage?: Maybe<Scalars['String']>;
  productTagName?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  supplierName?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type PayrollPayProductBreadcrumb = {
  __typename?: 'PayrollPayProductBreadcrumb';
  forceLink?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  link: Scalars['String'];
};

export type PayrollPayProductDetail = {
  __typename?: 'PayrollPayProductDetail';
  employeeOrganisation?: Maybe<ProductDetailData>;
};

export type PayrollPayProductRecommendation = {
  __typename?: 'PayrollPayProductRecommendation';
  brand?: Maybe<Scalars['String']>;
  brochureGroupId?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['ID']>;
  productTagImage?: Maybe<Scalars['String']>;
  productTagName?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  supplierName?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type PayrollPayProductsPageDepartment = {
  __typename?: 'PayrollPayProductsPageDepartment';
  categories: Array<PayrollPayDepartmentCategories>;
  count: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PayrollPayRoundel = {
  __typename?: 'PayrollPayRoundel';
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type PayrollPayStore = {
  __typename?: 'PayrollPayStore';
  departments?: Maybe<Array<PayrollPayDepartment>>;
  localBikeShopEnabled?: Maybe<Scalars['Boolean']>;
};

export type PayrollPayStoreFilters = {
  __typename?: 'PayrollPayStoreFilters';
  brands: Array<Scalars['String']>;
  promotions: Array<StorePromotionsFilterItem>;
  trendings: Array<StorePromotionsFilterItem>;
};

export type PayrollPayStoreOrder = {
  __typename?: 'PayrollPayStoreOrder';
  errors?: Maybe<Array<PayrollPayOrderError>>;
  order?: Maybe<PayrollPayOrder>;
  postUrl?: Maybe<Scalars['String']>;
  products?: Maybe<Array<PayrollPayOrderProduct>>;
  revenue?: Maybe<Scalars['Float']>;
  ssoLink?: Maybe<Scalars['String']>;
  storeName?: Maybe<Scalars['String']>;
  supplier?: Maybe<Scalars['String']>;
};

export type PayrollPayStoreProducts = {
  __typename?: 'PayrollPayStoreProducts';
  employeeOrganisation?: Maybe<PayrollPayStoreProductsData>;
};

export type PayrollPayStoreProductsData = {
  __typename?: 'PayrollPayStoreProductsData';
  algoliaQueryId?: Maybe<Scalars['String']>;
  breadcrumbs: Array<PayrollPayBreadcrumb>;
  departments: Array<PayrollPayProductsPageDepartment>;
  filters?: Maybe<PayrollPayStoreFilters>;
  id: Scalars['ID'];
  products: Array<PayrollPayProduct>;
  scheme?: Maybe<PayrollPayStoreProductsScheme>;
  totalEntries?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PayrollPayStoreProductsScheme = {
  __typename?: 'PayrollPayStoreProductsScheme';
  benefitName: Scalars['String'];
  brochureGroups?: Maybe<Array<PayrollPayBrochureGroup>>;
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Float']>;
  store?: Maybe<PayrollPayStoreProductsData>;
  storeName: Scalars['String'];
};

export type PayrollPaySupportLink = {
  __typename?: 'PayrollPaySupportLink';
  content?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PayrollProduct = {
  __typename?: 'PayrollProduct';
  availableSizes: Array<Maybe<Scalars['String']>>;
  brand?: Maybe<Scalars['String']>;
  breadcrumbs?: Maybe<Array<PayrollPayProductBreadcrumb>>;
  brochureGroupId?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  maximumQuantity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  preBackOrderProductMessage?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['ID']>;
  productImages: Array<Scalars['String']>;
  productTagImage?: Maybe<Scalars['String']>;
  productTagName?: Maybe<Scalars['String']>;
  reachedMaximumQuantity?: Maybe<Scalars['Boolean']>;
  recommendations?: Maybe<Array<PayrollPayProductRecommendation>>;
  recommendationsSimilarProducts?: Maybe<Array<PayrollPayProductRecommendation>>;
  recommendedRetailPrice?: Maybe<Scalars['Float']>;
  releaseDate?: Maybe<Scalars['String']>;
  savings?: Maybe<Scalars['Float']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  supplierDesktopBanner?: Maybe<Scalars['String']>;
  supplierMobileBanner?: Maybe<Scalars['String']>;
  supplierName?: Maybe<Scalars['String']>;
  techSpecs?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type PayrollUpdateBasketItemsBrochureGroupInput = {
  basketId: Scalars['ID'];
  brochureGroupId: Scalars['ID'];
};

export type PayrollUpdateBasketItemsBrochureGroupPayload = {
  __typename?: 'PayrollUpdateBasketItemsBrochureGroupPayload';
  updateBasketItemsBrochureGroup?: Maybe<BasketItemPayload>;
};

export type PendingDeal = {
  __typename?: 'PendingDeal';
  catalogId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  dateUnix?: Maybe<Scalars['Int']>;
  entryStatus?: Maybe<PendingDealEntryStatus>;
  errorData?: Maybe<Scalars['String']>;
  externalIdentifier?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  provider?: Maybe<PendingDealProvider>;
  status?: Maybe<PendingDealStatus>;
  uuid: Scalars['ID'];
};

export const PendingDealEntryStatus = {
  EntryStatusDelete: 'ENTRY_STATUS_DELETE',
  EntryStatusNew: 'ENTRY_STATUS_NEW',
  EntryStatusUpdate: 'ENTRY_STATUS_UPDATE',
  UknownEntryStatus: 'UKNOWN_ENTRY_STATUS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PendingDealEntryStatus = typeof PendingDealEntryStatus[keyof typeof PendingDealEntryStatus];
/**
 * Paginated List for entity PendingDeal. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type PendingDealList = {
  __typename?: 'PendingDealList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<PendingDeal>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const PendingDealProvider = {
  Csv: 'CSV',
  Ebd: 'EBD',
  Helix: 'HELIX',
  Lmd: 'LMD',
  Meritgc: 'MERITGC',
  PrezzeeAu: 'PREZZEE_AU',
  PrezzeeNz: 'PREZZEE_NZ',
  PrezzeeUk: 'PREZZEE_UK',
  ProviderUnknown: 'PROVIDER_UNKNOWN',
  Tillo: 'TILLO',
  Unrecognized: 'UNRECOGNIZED',
  Wegift: 'WEGIFT',
  Xoxoday: 'XOXODAY'
} as const;

export type PendingDealProvider = typeof PendingDealProvider[keyof typeof PendingDealProvider];
export const PendingDealStatus = {
  Created: 'CREATED',
  Failed: 'FAILED',
  Processed: 'PROCESSED',
  ReadyForProcessing: 'READY_FOR_PROCESSING'
} as const;

export type PendingDealStatus = typeof PendingDealStatus[keyof typeof PendingDealStatus];
export type PeopleTransaction = {
  __typename?: 'PeopleTransaction';
  creditRewarded?: Maybe<Scalars['Int']>;
  creditSpent?: Maybe<Scalars['Int']>;
  giftCardValueRewarded?: Maybe<Scalars['Int']>;
  perksGoSavings?: Maybe<Scalars['Int']>;
  remainingBalance?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};

/**
 * Paginated List for entity PeopleTransaction. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type PeopleTransactionList = {
  __typename?: 'PeopleTransactionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<PeopleTransaction>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type PerkRedemptionsReport = {
  __typename?: 'PerkRedemptionsReport';
  brandName?: Maybe<Scalars['String']>;
  dealId?: Maybe<Scalars['ID']>;
  estimatedSavingsAUD?: Maybe<Scalars['Float']>;
  estimatedSavingsGBP?: Maybe<Scalars['Float']>;
  header?: Maybe<Scalars['String']>;
  internalIdentifier?: Maybe<Scalars['String']>;
  redemptions?: Maybe<Scalars['Int']>;
  savingsAUD?: Maybe<Scalars['Float']>;
  savingsGBP?: Maybe<Scalars['Float']>;
  savingsPercentage?: Maybe<Scalars['Float']>;
  totalSavings?: Maybe<PerkRedemptionsReportTotalSavings>;
  type?: Maybe<Scalars['String']>;
  uniqueUsers?: Maybe<Scalars['Int']>;
  urlSlug?: Maybe<Scalars['String']>;
  /** @deprecated dealId */
  uuid?: Maybe<Scalars['ID']>;
};

export type PerkRedemptionsReportTotalSavings = {
  __typename?: 'PerkRedemptionsReportTotalSavings';
  currency?: Maybe<PaymentCurrencyType>;
  value?: Maybe<Scalars['Float']>;
};

export type PerksGo = {
  __typename?: 'PerksGO';
  dealHeader?: Maybe<Scalars['String']>;
  dealMerchantUuids?: Maybe<Array<Maybe<Scalars['String']>>>;
  dealTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  dealUrlSlug?: Maybe<Scalars['String']>;
  dealUuid?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isPerksGoRetailDeal?: Maybe<Scalars['Boolean']>;
  lastFour?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  savingPercent?: Maybe<Scalars['Int']>;
  status?: Maybe<ScheduledTransferStatus>;
  title?: Maybe<Scalars['String']>;
  transactionAmount?: Maybe<Scalars['Float']>;
  transactionDate?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PerksGoCashbackStatementItemTransfer = {
  __typename?: 'PerksGOCashbackStatementItemTransfer';
  dealHeader?: Maybe<Scalars['String']>;
  dealMerchantUuids?: Maybe<Array<Maybe<Scalars['String']>>>;
  dealTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  dealUrlSlug?: Maybe<Scalars['String']>;
  dealUuid?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isPerksGoRetailDeal?: Maybe<Scalars['Boolean']>;
  lastFour?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  savingPercent?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  transactionAmount?: Maybe<Scalars['Float']>;
  transactionDate?: Maybe<Scalars['String']>;
};

export type PerksGoMetrics = {
  __typename?: 'PerksGoMetrics';
  /** @deprecated No longer used. */
  perksgo?: Maybe<Array<Maybe<PerksGoMetricsByPerksGoPerk>>>;
};

export type PerksGoMetricsByPerksGoPerk = {
  __typename?: 'PerksGoMetricsByPerksGoPerk';
  /** @deprecated No longer used. */
  logo_url?: Maybe<Scalars['String']>;
  /** @deprecated No longer used. */
  name?: Maybe<Scalars['String']>;
  /** @deprecated No longer used. */
  savings?: Maybe<Scalars['Float']>;
  /** @deprecated No longer used. */
  transaction_count?: Maybe<Scalars['Int']>;
};

export type PerksHomePageLanesInput = {
  bodyText?: InputMaybe<Scalars['String']>;
  fallbackQuery?: InputMaybe<PerksHomepageLaneQueryInput>;
  headerText?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  linkedEntityUrl?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<PerksHomepageLaneQueryInput>;
  type?: InputMaybe<PerksHomepageLaneType>;
};

export type PerksHomepage = {
  __typename?: 'PerksHomepage';
  banner?: Maybe<Deal>;
  bannerTagId?: Maybe<Scalars['ID']>;
  birthdayBanner?: Maybe<Deal>;
  birthdayTagId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  lanes: Array<PerksHomepageLane>;
  metadata?: Maybe<Metadata>;
  name: Scalars['String'];
  state?: Maybe<PerksHomepageActiveState>;
  topCategoriesId?: Maybe<Scalars['ID']>;
  uuid: Scalars['ID'];
};

export const PerksHomepageActiveState = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;

export type PerksHomepageActiveState = typeof PerksHomepageActiveState[keyof typeof PerksHomepageActiveState];
export type PerksHomepageInput = {
  bannerTagId?: InputMaybe<Scalars['ID']>;
  birthdayTagId?: InputMaybe<Scalars['ID']>;
  description: Scalars['String'];
  lanes?: InputMaybe<Array<InputMaybe<PerksHomePageLanesInput>>>;
  name: Scalars['String'];
  state?: InputMaybe<PerksHomepageActiveState>;
  topCategoriesId?: InputMaybe<Scalars['ID']>;
};

export type PerksHomepageLane = {
  __typename?: 'PerksHomepageLane';
  bodyText?: Maybe<Scalars['String']>;
  data?: Maybe<DealList>;
  fallbackQuery?: Maybe<PerksHomepageLaneQuery>;
  headerText?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  linkedEntityUrl?: Maybe<Scalars['String']>;
  query?: Maybe<PerksHomepageLaneQuery>;
  type?: Maybe<PerksHomepageLaneType>;
};

export type PerksHomepageLaneQuery = {
  __typename?: 'PerksHomepageLaneQuery';
  distinct?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer used. */
  geo?: Maybe<Scalars['Boolean']>;
  hideEB?: Maybe<Scalars['Boolean']>;
  hidePerksGo?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  /** @deprecated No longer used. */
  ruleContexts?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Scalars['String']>>;
  tag?: Maybe<DealsTag>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  ttOnly?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type PerksHomepageLaneQueryInput = {
  distinct?: InputMaybe<Scalars['Boolean']>;
  geo?: InputMaybe<Scalars['Boolean']>;
  hideEB?: InputMaybe<Scalars['Boolean']>;
  hidePerksGo?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
  ttOnly?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export const PerksHomepageLaneType = {
  Company: 'COMPANY',
  Earn: 'EARN',
  HomepageLaneTypeUnknown: 'HomepageLaneType_UNKNOWN',
  NearMe: 'NEAR_ME',
  New: 'NEW',
  Other: 'OTHER',
  Spend: 'SPEND',
  Tag: 'TAG',
  Trending: 'TRENDING'
} as const;

export type PerksHomepageLaneType = typeof PerksHomepageLaneType[keyof typeof PerksHomepageLaneType];
/**
 * Paginated List for entity PerksHomepage. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type PerksHomepageList = {
  __typename?: 'PerksHomepageList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<PerksHomepage>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type PerksHomepageUpdateInput = {
  bannerTagId?: InputMaybe<Scalars['ID']>;
  birthdayTagId?: InputMaybe<Scalars['ID']>;
  description: Scalars['String'];
  lanes?: InputMaybe<Array<InputMaybe<PerksHomePageLanesInput>>>;
  name: Scalars['String'];
  state?: InputMaybe<PerksHomepageActiveState>;
  topCategoriesId?: InputMaybe<Scalars['ID']>;
  uuid: Scalars['ID'];
};

export type PerksMetrics = {
  __typename?: 'PerksMetrics';
  tenant?: Maybe<PerksMetricsByTenant>;
};

export type PerksMetricsByTenant = {
  __typename?: 'PerksMetricsByTenant';
  currency?: Maybe<Scalars['String']>;
  estimated_perks_savings?: Maybe<Scalars['Float']>;
  last_updated_date?: Maybe<Scalars['String']>;
  linked_cards_count?: Maybe<Scalars['Int']>;
  package?: Maybe<Scalars['String']>;
  perks?: Maybe<Array<Maybe<PerksMetricsByTenantByPerk>>>;
  perksgo_count?: Maybe<Scalars['Int']>;
  perksgo_savings_total?: Maybe<Scalars['Float']>;
  redemption_count?: Maybe<Scalars['Int']>;
  redemptions_12_weeks?: Maybe<Array<Maybe<Scalars['Int']>>>;
  team_count?: Maybe<Scalars['Int']>;
  total_savings?: Maybe<Scalars['Float']>;
};

export type PerksMetricsByTenantByPerk = {
  __typename?: 'PerksMetricsByTenantByPerk';
  estimated_perks_savings?: Maybe<Scalars['Float']>;
  header?: Maybe<Scalars['String']>;
  logo_url?: Maybe<Scalars['String']>;
  redemption_count?: Maybe<Scalars['Int']>;
};

export type PerksSagaOrderInput = {
  isCashback?: InputMaybe<Scalars['Boolean']>;
  products: Array<PerksSagaOrderInputProduct>;
  weGiftDealId?: InputMaybe<Scalars['ID']>;
};

export type PerksSagaOrderInputProduct = {
  openValue?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Int']>;
  uuid: Scalars['ID'];
};

export type PerksSagaPayInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type PerksSagaStartInput = {
  dealId: Scalars['ID'];
  isCompanyBenefit?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type PerksSagaUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type PerksSettingsInput = {
  monthlyTTAllowance?: InputMaybe<Scalars['Int']>;
  packageAddonIds?: InputMaybe<Array<Scalars['ID']>>;
  packageId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
  tier?: InputMaybe<ProductSettingsPerksTiers>;
  ttAllowance?: InputMaybe<Scalars['Int']>;
  ttTopupInterval?: InputMaybe<ProductSettingTopupInterval>;
  ttTopupIntervalCount?: InputMaybe<Scalars['Int']>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  countryCode?: Maybe<Scalars['String']>;
  e164PhoneNo?: Maybe<Scalars['String']>;
  intlPhoneNo: Scalars['String'];
  userId: Scalars['ID'];
};

export const Platform = {
  Android: 'ANDROID',
  Ios: 'IOS',
  Web: 'WEB'
} as const;

export type Platform = typeof Platform[keyof typeof Platform];
export type PlatformMetrics = {
  __typename?: 'PlatformMetrics';
  tenant?: Maybe<PlatformMetricsByTenant>;
};

export type PlatformMetricsByTenant = {
  __typename?: 'PlatformMetricsByTenant';
  assigned_licenses?: Maybe<Scalars['Int']>;
  deactivated_users?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  last_updated_date?: Maybe<Scalars['String']>;
  logged_in_rate?: Maybe<Scalars['Float']>;
  logged_in_users?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  team_count?: Maybe<Scalars['Int']>;
  teams?: Maybe<Array<Maybe<PlatformMetricsByTenantByTeam>>>;
  total_savings?: Maybe<Scalars['Float']>;
};

export type PlatformMetricsByTenantByTeam = {
  __typename?: 'PlatformMetricsByTenantByTeam';
  admins?: Maybe<Array<Maybe<Scalars['String']>>>;
  assigned_licences?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  logged_in_rate?: Maybe<Scalars['Float']>;
  logged_in_users?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  team?: Maybe<Team>;
};

export type PoNumberCount = {
  __typename?: 'PoNumberCount';
  count?: Maybe<Scalars['Int']>;
  poNumber?: Maybe<Scalars['String']>;
  usage?: Maybe<StockUsage>;
};

export type PointsRequest = {
  __typename?: 'PointsRequest';
  amount: Scalars['Int'];
  approver: User;
  budget: Budget;
  currency: Scalars['String'];
  reason: Scalars['String'];
  requester: User;
  responseMessage?: Maybe<Scalars['String']>;
  status: PointsRequestStatus;
  utcDateSubmitted?: Maybe<Scalars['Int']>;
  utcDateUpdated?: Maybe<Scalars['Int']>;
  uuid: Scalars['ID'];
};

export const PointsRequestFilterType = {
  TypeApprover: 'TYPE_APPROVER',
  TypeRequester: 'TYPE_REQUESTER',
  TypeUnknown: 'TYPE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PointsRequestFilterType = typeof PointsRequestFilterType[keyof typeof PointsRequestFilterType];
export const PointsRequestStatus = {
  StatusApproved: 'STATUS_APPROVED',
  StatusAutoApproved: 'STATUS_AUTO_APPROVED',
  StatusCancelled: 'STATUS_CANCELLED',
  StatusDeclined: 'STATUS_DECLINED',
  StatusPending: 'STATUS_PENDING',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PointsRequestStatus = typeof PointsRequestStatus[keyof typeof PointsRequestStatus];
/**
 * Paginated List for entity PointsRequest. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type PointsRequestsList = {
  __typename?: 'PointsRequestsList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<PointsRequest>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type Poll = {
  __typename?: 'Poll';
  active?: Maybe<Scalars['Boolean']>;
  allowAnonymousVoting?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  authorId?: Maybe<Scalars['String']>;
  businessId?: Maybe<Scalars['String']>;
  comments?: Maybe<RecognitionFeedCommentList>;
  companyValueIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyValues?: Maybe<CompanyValueList>;
  /** @deprecated Use 'metadata.createdAt' now. */
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  /** @deprecated Use 'authorId' now. */
  createdById?: Maybe<Scalars['String']>;
  criteria?: Maybe<Scalars['String']>;
  /** @deprecated Use 'criteria' now. */
  desc?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['String']>;
  moderated?: Maybe<Scalars['Boolean']>;
  occasion?: Maybe<Occasion>;
  private?: Maybe<Scalars['Boolean']>;
  publishType?: Maybe<PollPublishType>;
  reactions?: Maybe<RecognitionFeedReactionList>;
  resultVisibility?: Maybe<PollResultsVisibility>;
  reward?: Maybe<Reward>;
  rewardOrder?: Maybe<RewardOrder>;
  status?: Maybe<PollStatus>;
  teamIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  teams?: Maybe<TeamList>;
  /** @deprecated Use 'businessId' now. */
  tenantId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalVotes?: Maybe<Scalars['Int']>;
  trophy?: Maybe<Trophy>;
  /** @deprecated Use 'metadata.updatedAt' now. */
  updatedAt?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  votes?: Maybe<PollVoteList>;
  winnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  winners?: Maybe<PollWinnerList>;
};


export type PollCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type PollVotesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type PollWinnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type PollInput = {
  allowAnonymousVoting?: InputMaybe<Scalars['Boolean']>;
  companyValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  desc: Scalars['String'];
  endsAt: Scalars['String'];
  publishType?: InputMaybe<PollPublishType>;
  resultVisibility?: InputMaybe<PollResultsVisibility>;
  reward?: InputMaybe<RewardInput>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  trophy: TrophyInput;
};

/**
 * Paginated List for entity Poll. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type PollList = {
  __typename?: 'PollList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Poll>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const PollPublishType = {
  PublishTypeAutomatic: 'PUBLISH_TYPE_AUTOMATIC',
  PublishTypeManual: 'PUBLISH_TYPE_MANUAL',
  PublishTypeScheduled: 'PUBLISH_TYPE_SCHEDULED',
  PublishTypeUnknown: 'PUBLISH_TYPE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PollPublishType = typeof PollPublishType[keyof typeof PollPublishType];
export type PollReport = {
  __typename?: 'PollReport';
  polls: Array<CelebrationsReportPoll>;
  winners: Array<CelebrationsReportPollWinner>;
};

export const PollResultsVisibility = {
  ResultVisibilityAdminsAndManagers: 'RESULT_VISIBILITY_ADMINS_AND_MANAGERS',
  ResultVisibilityAdminsOnly: 'RESULT_VISIBILITY_ADMINS_ONLY',
  ResultVisibilityEveryone: 'RESULT_VISIBILITY_EVERYONE',
  ResultVisibilityUnknown: 'RESULT_VISIBILITY_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PollResultsVisibility = typeof PollResultsVisibility[keyof typeof PollResultsVisibility];
export const PollStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Closed: 'CLOSED',
  ClosedUnpublished: 'CLOSED_UNPUBLISHED',
  Scheduled: 'SCHEDULED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PollStatus = typeof PollStatus[keyof typeof PollStatus];
export type PollVote = {
  __typename?: 'PollVote';
  archived?: Maybe<Scalars['Boolean']>;
  authorId?: Maybe<Scalars['String']>;
  /** @deprecated Use 'metadata.createdAt' now. */
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  /** @deprecated Use 'authorId' now. */
  createdById?: Maybe<Scalars['String']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  moderated?: Maybe<Scalars['Boolean']>;
  receiverId?: Maybe<Scalars['String']>;
  /** @deprecated Use 'metadata.updatedAt' now. */
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  /** @deprecated Use 'receiverId' now. */
  userId?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type PollVoteInput = {
  isAnonymous?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  pollId: Scalars['String'];
  userId: Scalars['String'];
};

/**
 * Paginated List for entity PollVote. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type PollVoteList = {
  __typename?: 'PollVoteList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<PollVote>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type PollWinner = {
  __typename?: 'PollWinner';
  id?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<User>;
};

/**
 * Paginated List for entity PollWinner. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type PollWinnerList = {
  __typename?: 'PollWinnerList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<PollWinner>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type PowerbiReportDetails = {
  __typename?: 'PowerbiReportDetails';
  embedToken?: Maybe<Scalars['String']>;
  embedUrl?: Maybe<Scalars['String']>;
  reportId?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
};

export const PowerbiReportType = {
  Approvals: 'Approvals',
  Benefits: 'Benefits',
  CategoryBrands: 'CategoryBrands',
  OnlineGp: 'OnlineGP'
} as const;

export type PowerbiReportType = typeof PowerbiReportType[keyof typeof PowerbiReportType];
export const PriceModifierDealKind = {
  DealKindPerk: 'DEAL_KIND_PERK',
  DealKindReward: 'DEAL_KIND_REWARD',
  DealKindUnknown: 'DEAL_KIND_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PriceModifierDealKind = typeof PriceModifierDealKind[keyof typeof PriceModifierDealKind];
export const PriceModifierDealStatus = {
  StatusDisabled: 'STATUS_DISABLED',
  StatusEnabled: 'STATUS_ENABLED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type PriceModifierDealStatus = typeof PriceModifierDealStatus[keyof typeof PriceModifierDealStatus];
export type ProcessedPaymentAdditionalData = {
  __typename?: 'ProcessedPaymentAdditionalData';
  recurringProcessingModel?: Maybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  acqDiscount?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['String']>;
  data?: Maybe<ProductData>;
  date?: Maybe<Scalars['String']>;
  dateUnix?: Maybe<Scalars['Int']>;
  externalIdentifier?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provider?: Maybe<ProductProvider>;
  recomRetailPrice?: Maybe<Scalars['Int']>;
  salePrice?: Maybe<ProductSalePrice>;
  savings?: Maybe<Scalars['Float']>;
  supplier?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  limits?: Maybe<ProductConfigLimits>;
  products: Array<Maybe<Product>>;
};

export type ProductConfigLimits = {
  __typename?: 'ProductConfigLimits';
  forOpenValue?: Maybe<ProductConfigLimitsForOpenValue>;
  inWindow?: Maybe<ProductConfigLimitsInWindow>;
  overTime?: Maybe<ProductConfigLimitsOverTime>;
  perRedemption?: Maybe<ProductConfigLimitsPerRedemption>;
};

export type ProductConfigLimitsForOpenValue = {
  __typename?: 'ProductConfigLimitsForOpenValue';
  maxValue?: Maybe<Scalars['Float']>;
  minValue?: Maybe<Scalars['Float']>;
  stepValue?: Maybe<Scalars['Float']>;
};

export type ProductConfigLimitsInWindow = {
  __typename?: 'ProductConfigLimitsInWindow';
  dateWindow?: Maybe<ProductConfigLimitsInWindowDate>;
  eventWindow?: Maybe<ProductConfigLimitsInWindowEvent>;
};

export type ProductConfigLimitsInWindowDate = {
  __typename?: 'ProductConfigLimitsInWindowDate';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type ProductConfigLimitsInWindowEvent = {
  __typename?: 'ProductConfigLimitsInWindowEvent';
  daysAfter?: Maybe<Scalars['Int']>;
  daysBefore?: Maybe<Scalars['Int']>;
  type?: Maybe<RedemptionEvents>;
};

export type ProductConfigLimitsOverTime = {
  __typename?: 'ProductConfigLimitsOverTime';
  maxPrice?: Maybe<ProductConfigLimitsOverTimeMaxPrice>;
  numberOfItems?: Maybe<ProductConfigLimitsOverTimeNumberOfItems>;
};

export type ProductConfigLimitsOverTimeMaxPrice = {
  __typename?: 'ProductConfigLimitsOverTimeMaxPrice';
  price?: Maybe<ProductConfigLimitsOverTimeMaxPricePrice>;
  timePeriod?: Maybe<Scalars['Int']>;
};

export type ProductConfigLimitsOverTimeMaxPricePrice = {
  __typename?: 'ProductConfigLimitsOverTimeMaxPricePrice';
  currency?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type ProductConfigLimitsOverTimeNumberOfItems = {
  __typename?: 'ProductConfigLimitsOverTimeNumberOfItems';
  number?: Maybe<Scalars['Int']>;
  timePeriod?: Maybe<Scalars['Int']>;
};

export type ProductConfigLimitsPerRedemption = {
  __typename?: 'ProductConfigLimitsPerRedemption';
  maxPriceBeforeDiscounts?: Maybe<Scalars['Float']>;
  minPriceBeforeDiscounts?: Maybe<Scalars['Float']>;
  numberOfItems?: Maybe<Scalars['Int']>;
  numberOfProducts?: Maybe<Scalars['Int']>;
};

export type ProductData = {
  __typename?: 'ProductData';
  cinemaMetadata?: Maybe<ProductDataCinemaMetadata>;
  externalMetadata?: Maybe<ProductDataExternalMetadata>;
};

export type ProductDataCinemaMetadata = {
  __typename?: 'ProductDataCinemaMetadata';
  enabled?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProductDataCinemaMetadataInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductDataExternalMetadata = {
  __typename?: 'ProductDataExternalMetadata';
  advertiserId?: Maybe<Scalars['String']>;
  apiCode?: Maybe<Scalars['String']>;
  denomination?: Maybe<Scalars['Int']>;
  nativeID?: Maybe<Scalars['ID']>;
  openValue?: Maybe<Scalars['Boolean']>;
  reservable?: Maybe<Scalars['Boolean']>;
};

export type ProductDataExternalMetadataInput = {
  advertiserId?: InputMaybe<Scalars['String']>;
  apiCode?: InputMaybe<Scalars['String']>;
  denomination?: InputMaybe<Scalars['Int']>;
  nativeID?: InputMaybe<Scalars['ID']>;
  openValue?: InputMaybe<Scalars['Boolean']>;
  reservable?: InputMaybe<Scalars['Boolean']>;
};

export type ProductDataInput = {
  cinemaMetadata?: InputMaybe<ProductDataCinemaMetadataInput>;
  externalMetadata?: InputMaybe<ProductDataExternalMetadataInput>;
};

export type ProductDetailData = {
  __typename?: 'ProductDetailData';
  id: Scalars['ID'];
  scheme?: Maybe<ProductDetailSheme>;
};

export type ProductDetailSheme = {
  __typename?: 'ProductDetailSheme';
  brochureGroups?: Maybe<Array<PayrollPayBrochureGroup>>;
  id: Scalars['ID'];
  isNewNet?: Maybe<Scalars['Boolean']>;
  isNhs?: Maybe<Scalars['Boolean']>;
  product?: Maybe<PayrollProduct>;
  storeName?: Maybe<Scalars['String']>;
};

export type ProductInput = {
  acqDiscount?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<ProductDataInput>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<ProductProvider>;
  recomRetailPrice?: InputMaybe<Scalars['Int']>;
  savings?: InputMaybe<Scalars['Float']>;
  supplier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  vat?: InputMaybe<Scalars['Float']>;
};

/**
 * Paginated List for entity Product. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type ProductList = {
  __typename?: 'ProductList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Product>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type ProductPermissions = {
  __typename?: 'ProductPermissions';
  admin?: Maybe<ProductPermissionsAdmin>;
  benefits?: Maybe<ProductPermissionsBenefits>;
  businessId: Scalars['ID'];
  ghost?: Maybe<ProductPermissionsGhost>;
  /** @deprecated Insights is no longer a product */
  insights?: Maybe<ProductPermissionsInsights>;
  internal?: Maybe<ProductPermissionsInternal>;
  localBenefits?: Maybe<ProductPermissionsLocalBenefits>;
  medical?: Maybe<ProductPermissionsMedical>;
  /** @deprecated Merchant is no longer a product */
  merchant?: Maybe<ProductPermissionsMerchant>;
  perks?: Maybe<ProductPermissionsPerks>;
  platform?: Maybe<ProductPermissionsPlatform>;
  recognition?: Maybe<ProductPermissionsRecognition>;
  uuid: Scalars['ID'];
  wallet?: Maybe<ProductPermissionsWallet>;
  wellnessHub?: Maybe<ProductPermissionsWellnessHub>;
};

export type ProductPermissionsAdmin = {
  __typename?: 'ProductPermissionsAdmin';
  benefitMarketplace?: Maybe<Scalars['Boolean']>;
  billingUnit?: Maybe<Scalars['Boolean']>;
  customPermissions?: Maybe<Scalars['Boolean']>;
  dealVisibility?: Maybe<Scalars['Boolean']>;
  directorySync?: Maybe<Scalars['Boolean']>;
  domainBasedSelfRegistration?: Maybe<Scalars['Boolean']>;
  oldSelfServeRegistration?: Maybe<Scalars['Boolean']>;
  people?: Maybe<Scalars['Boolean']>;
  reporting?: Maybe<Scalars['Boolean']>;
  /** @deprecated All businesses now have access, no longer needed. */
  reportingAdminDashboard?: Maybe<Scalars['Boolean']>;
  reportingBeta?: Maybe<Scalars['Boolean']>;
  selfSignUp?: Maybe<Scalars['Boolean']>;
  singleSignOn?: Maybe<Scalars['Boolean']>;
  sso?: Maybe<Scalars['Boolean']>;
  teams?: Maybe<Scalars['Boolean']>;
  tenant?: Maybe<Scalars['Boolean']>;
  /** @deprecated All businesses now have access, no longer needed. */
  workOSFullAccess?: Maybe<Scalars['Boolean']>;
};

/** Benefits acronyms: CycleToWork, Home&Electronics, AnnualLeavePurchase, ... */
export type ProductPermissionsBenefits = {
  __typename?: 'ProductPermissionsBenefits';
  alp?: Maybe<Scalars['Boolean']>;
  bl?: Maybe<Scalars['Boolean']>;
  cs?: Maybe<Scalars['Boolean']>;
  ctw?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use 'bl' instead. Field renamed from Eligibility and Limitations to Benefit Limitations. */
  eal?: Maybe<Scalars['Boolean']>;
  eap?: Maybe<Scalars['Boolean']>;
  el?: Maybe<Scalars['Boolean']>;
  gm?: Maybe<Scalars['Boolean']>;
  hasOrderManagementAccess?: Maybe<Scalars['Boolean']>;
  hcp?: Maybe<Scalars['Boolean']>;
  he?: Maybe<Scalars['Boolean']>;
  ibs?: Maybe<Scalars['Boolean']>;
  nbs?: Maybe<Scalars['Boolean']>;
  pa?: Maybe<Scalars['Boolean']>;
  pg?: Maybe<Scalars['Boolean']>;
  sf?: Maybe<Scalars['Boolean']>;
  tal?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsFlexiRewards = {
  __typename?: 'ProductPermissionsFlexiRewards';
  budget?: Maybe<ProductPermissionsWalletBudget>;
  /**
   * Feature Toggle:
   * Indicates a tenant admin can create and manage team budgets
   */
  canAdvancedBudgeting?: Maybe<Scalars['Boolean']>;
  canRewardEmployees?: Maybe<Scalars['Boolean']>;
  canTopUpRewardPoints?: Maybe<Scalars['Boolean']>;
  canViewFullReports?: Maybe<Scalars['Boolean']>;
  hasAutoApprovals?: Maybe<Scalars['Boolean']>;
  merchandiseHidden?: Maybe<Scalars['Boolean']>;
  view?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsGhost = {
  __typename?: 'ProductPermissionsGhost';
  ghostId?: Maybe<Scalars['ID']>;
  isGhost: Scalars['Boolean'];
};

export type ProductPermissionsInsights = {
  __typename?: 'ProductPermissionsInsights';
  /** @deprecated Insights is no longer a product */
  admin?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  bookmarkComments?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  changeOverTime?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  chatroom?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  customSurvey?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  heatmap?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  questionOverrides?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  reports?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  schedules?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  schedulesReporting?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  survey?: Maybe<Scalars['Boolean']>;
  /** @deprecated Insights is no longer a product */
  wizard?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsInternal = {
  __typename?: 'ProductPermissionsInternal';
  features?: Maybe<ProductPermissionsInternalFeature>;
  finance?: Maybe<ProductPermissionsInternalFinance>;
};

export type ProductPermissionsInternalFeature = {
  __typename?: 'ProductPermissionsInternalFeature';
  canGdprUsers?: Maybe<Scalars['Boolean']>;
  canManageInternalUsers?: Maybe<Scalars['Boolean']>;
  deactivateUsers?: Maybe<Scalars['Boolean']>;
  favouriting?: Maybe<Scalars['Boolean']>;
  hasDealDiscount?: Maybe<Scalars['Boolean']>;
  isEngineer?: Maybe<Scalars['Boolean']>;
  resendWelcomeEmails?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsInternalFinance = {
  __typename?: 'ProductPermissionsInternalFinance';
  create?: Maybe<Scalars['Boolean']>;
  createFraudThresholds?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
  removeLinkedCards?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsLocalBenefits = {
  __typename?: 'ProductPermissionsLocalBenefits';
  enabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if there are any local benefits available for the business. */
  hasLocalBenefits?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsMedical = {
  __typename?: 'ProductPermissionsMedical';
  medical?: Maybe<Scalars['Boolean']>;
  onlineGP?: Maybe<Scalars['Boolean']>;
  reports?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsMerchant = {
  __typename?: 'ProductPermissionsMerchant';
  canViewMerchantDetails?: Maybe<Scalars['Boolean']>;
  canViewMerchantLocations?: Maybe<Scalars['Boolean']>;
  employees?: Maybe<ProductPermissionsMerchantEmployees>;
  locations?: Maybe<ProductPermissionsMerchantLocaitons>;
  merchants?: Maybe<ProductPermissionsMerchantMerchants>;
};

export type ProductPermissionsMerchantEmployees = {
  __typename?: 'ProductPermissionsMerchantEmployees';
  canGenerateOnboardingLink?: Maybe<Scalars['Boolean']>;
  canGhost?: Maybe<Scalars['Boolean']>;
  detach?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsMerchantLocaitons = {
  __typename?: 'ProductPermissionsMerchantLocaitons';
  create?: Maybe<Scalars['Boolean']>;
  createOffers?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsMerchantMerchants = {
  __typename?: 'ProductPermissionsMerchantMerchants';
  create?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
  readAll?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsPerks = {
  __typename?: 'ProductPermissionsPerks';
  /** @deprecated no longer used */
  exclusive?: Maybe<Scalars['Boolean']>;
  favourites?: Maybe<Scalars['Boolean']>;
  perksGo?: Maybe<Scalars['Boolean']>;
  redemptions?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsPlatform = {
  __typename?: 'ProductPermissionsPlatform';
  companyValues?: Maybe<Scalars['Boolean']>;
  contentCards?: Maybe<Scalars['Boolean']>;
  cultureHub?: Maybe<ProductPermissionsPlatformCultureHub>;
  cultureHubFileUploadHidden?: Maybe<Scalars['Boolean']>;
  customRewards?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use cultureHubFileUploadHidden instead */
  enableFileUploadTab?: Maybe<Scalars['Boolean']>;
  /** @deprecated no longer used */
  fidel?: Maybe<Scalars['Boolean']>;
  /** @deprecated no longer used */
  geoLocation?: Maybe<Scalars['Boolean']>;
  hasCultureHub?: Maybe<Scalars['Boolean']>;
  hideCashback?: Maybe<Scalars['Boolean']>;
  homepageLanesHidden?: Maybe<Scalars['Boolean']>;
  homepageTiles?: Maybe<ProductPermissionsPlatformHomepageTiles>;
  payments?: Maybe<ProductPermissionsPlatformPayments>;
  userSavings?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsPlatformCultureHub = {
  __typename?: 'ProductPermissionsPlatformCultureHub';
  /** @deprecated cultureHub enabled for all. Remove when deprecated 26/08/21 */
  read?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsPlatformHomepageTiles = {
  __typename?: 'ProductPermissionsPlatformHomepageTiles';
  read?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsPlatformPayments = {
  __typename?: 'ProductPermissionsPlatformPayments';
  zip?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsRecognition = {
  __typename?: 'ProductPermissionsRecognition';
  attachReward?: Maybe<Scalars['Boolean']>;
  comments?: Maybe<ProductPermissionsRecognitionComments>;
  createPoll?: Maybe<Scalars['Boolean']>;
  poll?: Maybe<ProductPermissionsRecognitionPoll>;
  recognition?: Maybe<ProductPermissionsRecognitionRecognition>;
  rewards?: Maybe<ProductPermissionsRecognitionRewards>;
  share?: Maybe<Scalars['Boolean']>;
  viewReward?: Maybe<Scalars['Boolean']>;
  viewRewardDetails?: Maybe<Scalars['Boolean']>;
  votes?: Maybe<ProductPermissionsRecognitionVotes>;
};

export type ProductPermissionsRecognitionComments = {
  __typename?: 'ProductPermissionsRecognitionComments';
  delete?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsRecognitionPoll = {
  __typename?: 'ProductPermissionsRecognitionPoll';
  create?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsRecognitionRecognition = {
  __typename?: 'ProductPermissionsRecognitionRecognition';
  create?: Maybe<Scalars['Boolean']>;
  everyone?: Maybe<Scalars['Boolean']>;
  sendToEveryone?: Maybe<Scalars['Boolean']>;
  sendToTeams?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsRecognitionRewards = {
  __typename?: 'ProductPermissionsRecognitionRewards';
  create?: Maybe<Scalars['Boolean']>;
  viewLimited?: Maybe<Scalars['Boolean']>;
  viewOff?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsRecognitionVotes = {
  __typename?: 'ProductPermissionsRecognitionVotes';
  update?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsWallet = {
  __typename?: 'ProductPermissionsWallet';
  canApprovePointsRequest?: Maybe<Scalars['Boolean']>;
  canPurchasePoints?: Maybe<Scalars['Boolean']>;
  canRequestPoints?: Maybe<Scalars['Boolean']>;
  flexiRewards?: Maybe<ProductPermissionsFlexiRewards>;
  /**
   * Feature Toggle:
   * Indicates a user is eligible to use points blend, but not necessarily that
   * they have points blend - that is determined by other values based on their
   * wallets and products
   */
  pointsBlendEligible?: Maybe<Scalars['Boolean']>;
  rewardWallet?: Maybe<Scalars['Boolean']>;
  tenantWallet?: Maybe<Scalars['Boolean']>;
  treatTokens?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsWalletBudget = {
  __typename?: 'ProductPermissionsWalletBudget';
  manageCategory?: Maybe<Scalars['Boolean']>;
  manageFunds?: Maybe<ProductPermissionsWalletBudgetManageFunds>;
};

export type ProductPermissionsWalletBudgetManageFunds = {
  __typename?: 'ProductPermissionsWalletBudgetManageFunds';
  betweenAny?: Maybe<Scalars['Boolean']>;
  /**
   * This indicates a user can move funds from the unassigned category to any other category. The intention
   * at the time of writing this is to limit the scope of budget manipulation for managers, in order to prevent
   * them using budget from category X into category Y (under the assumption it was assigned to them by their admin)
   */
  fromUnassigned?: Maybe<Scalars['Boolean']>;
};

export type ProductPermissionsWellnessHub = {
  __typename?: 'ProductPermissionsWellnessHub';
  /** Access to Employee Assistance Programme (EAP) benefit */
  eap?: Maybe<Scalars['Boolean']>;
  /** Access to the EAP contact number if available */
  eapContactNumber?: Maybe<Scalars['String']>;
  /** The tier level for EAP if enabled (Basic, Standard, or Enhanced) */
  eapTier?: Maybe<EapTier>;
  /** @deprecated Use 'visible' to indicate access to wellness, or 'wellbeing' for wellness articles content */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Access to the Online GP platform */
  onlineGP?: Maybe<Scalars['Boolean']>;
  /** User has access to any wellbeing offerings => Library, OnlineGP or EAP */
  visible?: Maybe<Scalars['Boolean']>;
  /** Access to articles and video content => Wellness Library */
  wellbeing?: Maybe<Scalars['Boolean']>;
  /** Access to  Wellness Assessment */
  wellnessAssessment?: Maybe<Scalars['Boolean']>;
};

export const ProductProvider = {
  Amazon: 'AMAZON',
  Awin: 'AWIN',
  Digitalglue: 'DIGITALGLUE',
  DigitalglueNz: 'DIGITALGLUE_NZ',
  Ebd: 'EBD',
  Helix: 'HELIX',
  Impact: 'IMPACT',
  Lmd: 'LMD',
  Meritgc: 'MERITGC',
  Partnerize: 'PARTNERIZE',
  PrezzeeAu: 'PREZZEE_AU',
  PrezzeeNz: 'PREZZEE_NZ',
  PrezzeeUk: 'PREZZEE_UK',
  ProductProviderNone: 'PRODUCT_PROVIDER_NONE',
  ProductProviderUnknown: 'PRODUCT_PROVIDER_UNKNOWN',
  Stock: 'STOCK',
  Stocklinks: 'STOCKLINKS',
  Tillo: 'TILLO',
  Uber: 'UBER',
  Unrecognized: 'UNRECOGNIZED',
  VivupEap: 'VIVUP_EAP',
  Wegift: 'WEGIFT',
  Xoxoday: 'XOXODAY'
} as const;

export type ProductProvider = typeof ProductProvider[keyof typeof ProductProvider];
export type ProductSalePrice = {
  __typename?: 'ProductSalePrice';
  clippingPercentage?: Maybe<Scalars['Int']>;
  currency?: Maybe<PaymentCurrencyType>;
  discount?: Maybe<Scalars['Float']>;
  originalCurrency?: Maybe<PaymentCurrencyType>;
  originalCurrencyToRPExchangeRate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type ProductSalePriceInput = {
  currency?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<Scalars['Float']>;
};

export const ProductSettingTopupInterval = {
  Day: 'Day',
  IntervalUnspecified: 'IntervalUnspecified',
  Month: 'Month',
  Unrecognized: 'UNRECOGNIZED',
  Week: 'Week'
} as const;

export type ProductSettingTopupInterval = typeof ProductSettingTopupInterval[keyof typeof ProductSettingTopupInterval];
export type ProductSettings = {
  __typename?: 'ProductSettings';
  benefitsMarketplaceSettings?: Maybe<ProductSettingsBenefitsMarketplace>;
  businessId?: Maybe<Scalars['ID']>;
  carBenefitsSettings?: Maybe<ProductSettingsCarBenefits>;
  cycleToWorkSettings?: Maybe<ProductSettingsCycleToWork>;
  eapContact?: Maybe<ProductSettingsEmployeeAssistanceProgrammeContact>;
  eapSettings?: Maybe<ProductSettingsEmployeeAssistanceProgramme>;
  gymMembershipSettings?: Maybe<ProductSettingsGymMembership>;
  healthCashPlanSettings?: Maybe<ProductSettingsHealthCashPlan>;
  medicalSettings?: Maybe<ProductSettingsMedical>;
  perksSettings?: Maybe<ProductSettingsPerks>;
  recognitionSettings?: Maybe<ProductSettingsRecognition>;
  rewardSettings?: Maybe<ProductSettingsReward>;
  teamId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
  walletSettings?: Maybe<ProductSettingsWallet>;
  wellnessSettings?: Maybe<ProductSettingsWellness>;
};

export type ProductSettingsBenefitsMarketplace = {
  __typename?: 'ProductSettingsBenefitsMarketplace';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type ProductSettingsCarBenefits = {
  __typename?: 'ProductSettingsCarBenefits';
  hasCPC?: Maybe<Scalars['Boolean']>;
  provider?: Maybe<ProductSettingsCarBenefitsProviders>;
};

export const ProductSettingsCarBenefitsProviders = {
  ProviderLoveElectric: 'PROVIDER_LOVE_ELECTRIC',
  ProviderTusker: 'PROVIDER_TUSKER',
  ProviderUnknown: 'PROVIDER_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ProductSettingsCarBenefitsProviders = typeof ProductSettingsCarBenefitsProviders[keyof typeof ProductSettingsCarBenefitsProviders];
export type ProductSettingsCycleToWork = {
  __typename?: 'ProductSettingsCycleToWork';
  tier: ProductSettingsCycleToWorkTiers;
};

export const ProductSettingsCycleToWorkTiers = {
  CycleToWorkTierEnhanced: 'CYCLE_TO_WORK_TIER_ENHANCED',
  CycleToWorkTierStandard: 'CYCLE_TO_WORK_TIER_STANDARD',
  CycleToWorkTierUnknown: 'CYCLE_TO_WORK_TIER_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ProductSettingsCycleToWorkTiers = typeof ProductSettingsCycleToWorkTiers[keyof typeof ProductSettingsCycleToWorkTiers];
export type ProductSettingsEmployeeAssistanceProgramme = {
  __typename?: 'ProductSettingsEmployeeAssistanceProgramme';
  tier: ProductSettingsEmployeeAssistanceProgrammeTiers;
};

export type ProductSettingsEmployeeAssistanceProgrammeContact = {
  __typename?: 'ProductSettingsEmployeeAssistanceProgrammeContact';
  phoneNumber: Scalars['String'];
};

export const ProductSettingsEmployeeAssistanceProgrammeTiers = {
  EmployeeAssistanceProgrammeTierBasic: 'EMPLOYEE_ASSISTANCE_PROGRAMME_TIER_BASIC',
  EmployeeAssistanceProgrammeTierEnhanced: 'EMPLOYEE_ASSISTANCE_PROGRAMME_TIER_ENHANCED',
  EmployeeAssistanceProgrammeTierStandard: 'EMPLOYEE_ASSISTANCE_PROGRAMME_TIER_STANDARD',
  EmployeeAssistanceProgrammeTierUnknown: 'EMPLOYEE_ASSISTANCE_PROGRAMME_TIER_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ProductSettingsEmployeeAssistanceProgrammeTiers = typeof ProductSettingsEmployeeAssistanceProgrammeTiers[keyof typeof ProductSettingsEmployeeAssistanceProgrammeTiers];
export type ProductSettingsGymMembership = {
  __typename?: 'ProductSettingsGymMembership';
  companyId?: Maybe<Scalars['ID']>;
};

export type ProductSettingsHealthCashPlan = {
  __typename?: 'ProductSettingsHealthCashPlan';
  externalId?: Maybe<Scalars['ID']>;
  metadata?: Maybe<Metadata>;
  type?: Maybe<ProductSettingsHealthCashPlanTiers>;
};

export const ProductSettingsHealthCashPlanTiers = {
  HealthCashPlanCompanyFunded: 'HEALTH_CASH_PLAN_COMPANY_FUNDED',
  HealthCashPlanUnknown: 'HEALTH_CASH_PLAN_UNKNOWN',
  HealthCashPlanVoluntary: 'HEALTH_CASH_PLAN_VOLUNTARY',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ProductSettingsHealthCashPlanTiers = typeof ProductSettingsHealthCashPlanTiers[keyof typeof ProductSettingsHealthCashPlanTiers];
export type ProductSettingsInput = {
  benefitsMarketplaceSettings?: InputMaybe<UpdateProductSettingsBenefitsMarketplace>;
  businessId?: InputMaybe<Scalars['ID']>;
  carBenefitsSettings?: InputMaybe<UpdateProductSettingsCarBenefits>;
  cycleToWorkSettings?: InputMaybe<UpdateProductSettingsCycleToWork>;
  eapContact?: InputMaybe<UpdateProductSettingsEmployeeAssistanceProgrammeContact>;
  eapSettings?: InputMaybe<UpdateProductSettingsEmployeeAssistanceProgramme>;
  medicalSettings?: InputMaybe<UpdateProductSettingsMedical>;
  perksSettings?: InputMaybe<UpdateProductSettingsPerks>;
  recognitionSettings?: InputMaybe<UpdateProductSettingsRecognition>;
  rewardSettings?: InputMaybe<UpdateProductSettingsRewards>;
  teamId?: InputMaybe<Scalars['ID']>;
  walletSettings?: InputMaybe<UpdateProductSettingsWallet>;
  wellnessSettings?: InputMaybe<UpdateProductSettingsWellness>;
};

export type ProductSettingsMedical = {
  __typename?: 'ProductSettingsMedical';
  meatadata?: Maybe<Metadata>;
  tier?: Maybe<ProductSettingsMedicalTiers>;
};

export const ProductSettingsMedicalTiers = {
  TierOne: 'TierOne',
  TierThree: 'TierThree',
  TierTwo: 'TierTwo'
} as const;

export type ProductSettingsMedicalTiers = typeof ProductSettingsMedicalTiers[keyof typeof ProductSettingsMedicalTiers];
export type ProductSettingsPerks = {
  __typename?: 'ProductSettingsPerks';
  blacklistedPerks: Array<Scalars['ID']>;
  blacklistedTags: Array<Scalars['ID']>;
  /** @deprecated No longer used anywhere */
  maxTTAllowance?: Maybe<Scalars['Int']>;
  meatadata?: Maybe<Metadata>;
  /** @deprecated Please use ttAllowance */
  monthlyTTAllowance?: Maybe<Scalars['Int']>;
  package?: Maybe<Tag>;
  packageAddonIds: Array<Scalars['ID']>;
  packageAddons: Array<Tag>;
  packageId?: Maybe<Scalars['ID']>;
  regionId?: Maybe<Scalars['ID']>;
  tier?: Maybe<ProductSettingsPerksTiers>;
  /**
   * topupAmount is the amount of points given in a given topup. This happens every `topupInterval x topupIntervalCount`
   * examples:
   * 100 Points every month:
   * - `topupAmount=100`
   * - `topupIntervalCount=1`
   * - `topupInterval=Month`
   *
   * 200 Points every 10 weeks:
   * - `topupAmount=100`
   * - `topupIntervalCount=10`
   * - `topupInterval=Week`
   */
  ttAllowance: Scalars['Int'];
  /** topupInterval is the unit of time used to specify the time between top-ups, see `topupAmount` for details on how these fields relate */
  ttTopupInterval: ProductSettingTopupInterval;
  /** topupIntervalCount is the number of `topupInterval`s between top-ups, see `topupAmount` for details on how these fields relate */
  ttTopupIntervalCount: Scalars['Int'];
  whitelistedPerks: Array<Scalars['ID']>;
  whitelistedTags: Array<Scalars['ID']>;
};

export const ProductSettingsPerksTiers = {
  PerksTierComplete: 'PERKS_TIER_COMPLETE',
  PerksTierCore: 'PERKS_TIER_CORE',
  PerksTierUnknown: 'PERKS_TIER_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ProductSettingsPerksTiers = typeof ProductSettingsPerksTiers[keyof typeof ProductSettingsPerksTiers];
export type ProductSettingsRecognition = {
  __typename?: 'ProductSettingsRecognition';
  attachReward?: Maybe<ProductSettingsRecognitionValuesByRank>;
  createPoll?: Maybe<ProductSettingsRecognitionValuesByRank>;
  meatadata?: Maybe<Metadata>;
  rewardPackageId?: Maybe<Scalars['ID']>;
  sendToEveryone?: Maybe<ProductSettingsRecognitionValuesByRank>;
  sendToTeams?: Maybe<ProductSettingsRecognitionValuesByRank>;
  sharing?: Maybe<ProductSettingsRecognitionValuesByRank>;
  viewReward?: Maybe<ProductSettingsRecognitionValuesByVisibility>;
};

export const ProductSettingsRecognitionValuesByRank = {
  Everyone: 'Everyone',
  Off: 'Off',
  TeamLeaderAndManager: 'TeamLeaderAndManager',
  TeamLeaderOnly: 'TeamLeaderOnly'
} as const;

export type ProductSettingsRecognitionValuesByRank = typeof ProductSettingsRecognitionValuesByRank[keyof typeof ProductSettingsRecognitionValuesByRank];
export const ProductSettingsRecognitionValuesByVisibility = {
  Hidden: 'Hidden',
  Limited: 'Limited',
  Visible: 'Visible'
} as const;

export type ProductSettingsRecognitionValuesByVisibility = typeof ProductSettingsRecognitionValuesByVisibility[keyof typeof ProductSettingsRecognitionValuesByVisibility];
export type ProductSettingsReward = {
  __typename?: 'ProductSettingsReward';
  /** Settings for a specific business, distinguishes between defaults and set */
  business?: Maybe<ProductSettingsRewardBusiness>;
};

export type ProductSettingsRewardBusiness = ProductSettingsRewardDefault | ProductSettingsRewardSet;

/** Default settings with global rules */
export type ProductSettingsRewardDefault = {
  __typename?: 'ProductSettingsRewardDefault';
  /** null means unlimited */
  defaultMax?: Maybe<Scalars['Float']>;
  defaultMin: Scalars['Float'];
};

/** Settings for a specific business applied by a business admin */
export type ProductSettingsRewardSet = {
  __typename?: 'ProductSettingsRewardSet';
  setMax: Scalars['Float'];
  setMin: Scalars['Float'];
};

export type ProductSettingsWallet = {
  __typename?: 'ProductSettingsWallet';
  canApprovePointsRequest?: Maybe<ProductSettingsRecognitionValuesByRank>;
  canPurchasePoints?: Maybe<ProductSettingsRecognitionValuesByRank>;
  canRequestPoints?: Maybe<ProductSettingsRecognitionValuesByRank>;
  meatadata?: Maybe<Metadata>;
};

export type ProductSettingsWellness = {
  __typename?: 'ProductSettingsWellness';
  assessment?: Maybe<Scalars['Boolean']>;
  blacklistedCategories: Array<ProductSettingsWellnessCategory>;
};

export type ProductSettingsWellnessCategory = {
  __typename?: 'ProductSettingsWellnessCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProductSettingsWellnessCategoryInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export const ProductStockStatus = {
  Archived: 'ARCHIVED',
  Assigned: 'ASSIGNED',
  Closed: 'CLOSED',
  Complete: 'COMPLETE',
  Created: 'CREATED',
  Failed: 'FAILED',
  ItemStatusUnknown: 'ITEM_STATUS_UNKNOWN',
  Open: 'OPEN',
  Processing: 'PROCESSING',
  Reserved: 'RESERVED',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ProductStockStatus = typeof ProductStockStatus[keyof typeof ProductStockStatus];
export type ProductUpdateInput = {
  acqDiscount?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<ProductDataInput>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<ProductProvider>;
  recomRetailPrice?: InputMaybe<Scalars['Int']>;
  savings?: InputMaybe<Scalars['Float']>;
  supplier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type PromotionStatus = {
  __typename?: 'PromotionStatus';
  enabled: Scalars['Boolean'];
  expiresAt?: Maybe<Scalars['String']>;
};

export const PromotionType = {
  FlexiPointsConversionStatusMid: 'FlexiPointsConversionStatusMid',
  FlexiPointsConversionStatusPost: 'FlexiPointsConversionStatusPost',
  FlexiPointsConversionStatusPre: 'FlexiPointsConversionStatusPre',
  FlexiRewardTopupChristmas23Campaign: 'FlexiRewardTopupChristmas23Campaign',
  RewardChristmasMerchandise: 'RewardChristmasMerchandise'
} as const;

export type PromotionType = typeof PromotionType[keyof typeof PromotionType];
export type ProviderSettings = {
  __typename?: 'ProviderSettings';
  androidSettings?: Maybe<AndroidPaymentSettings>;
  iosSettings?: Maybe<IosPaymentSettings>;
};

export type PublicBusiness = {
  __typename?: 'PublicBusiness';
  businessId: Scalars['ID'];
  businessName: Scalars['String'];
};

export type PushConfig = {
  __typename?: 'PushConfig';
  /** @deprecated No longer used, legacy SFMC implementation. */
  status?: Maybe<Scalars['String']>;
  /** @deprecated No longer used, legacy SFMC implementation. */
  updatedAt?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  accountGroupCelebrations?: Maybe<GroupCelebrationList>;
  accountRecognitions?: Maybe<AccountRecognitionList>;
  accountRecognitionsFeed?: Maybe<RecognitionFeedList>;
  /** @deprecated Use 'scheduledRecognitions' instead. */
  accountScheduledRecognitions?: Maybe<SchedulerEventList>;
  accountTrophies?: Maybe<AccountTrophyList>;
  accountVotes?: Maybe<AccountVoteList>;
  adsClick?: Maybe<AdsClick>;
  adsOffers?: Maybe<AdsOfferList>;
  /** Namespace for all advancedBudgets queries */
  advancedBudgets: AdvancedBudgetsQueries;
  allRegions?: Maybe<RegionList>;
  /** @deprecated We use intercom now for NPS */
  askNicelyEmailHash: Scalars['String'];
  auditForInitiatingUser?: Maybe<AuditLogEntryList>;
  auditForResource?: Maybe<AuditLogEntryList>;
  basketForUser?: Maybe<Basket>;
  /** @deprecated Use organisationalSummary for benchamrk instead */
  benchmarkReports?: Maybe<BenchmarkReports>;
  benefitsContent?: Maybe<BenefitContent>;
  benefitsListBenefits?: Maybe<BenefitList>;
  bikeShopData?: Maybe<PayrollPayBikeShop>;
  billingMapping?: Maybe<BillingMapping>;
  billingMappings?: Maybe<BillingMappingList>;
  billingMappingsForTeam?: Maybe<Array<Maybe<BillingMapping>>>;
  billingProductsForTeam?: Maybe<BillingProductsForTeam>;
  billingUnitForRegionId?: Maybe<TeamRegionMap>;
  billingUnits?: Maybe<Array<TeamRegionMap>>;
  billingZuoraCurrentPlan?: Maybe<ZuoraCurrentPlan>;
  billingZuoraInvoice?: Maybe<ZuoraInvoice>;
  billingZuoraInvoices?: Maybe<ZuoraInvoices>;
  billingZuoraManagedFeatureFlags: Array<Scalars['ID']>;
  billingZuoraProductOptions?: Maybe<ZuoraProductOptions>;
  billingZuoraProductsForBusiness: Array<ZuoraProduct>;
  billingZuoraSeatsCount?: Maybe<ZuoraSeatsCount>;
  billingZuoraSoldToContact?: Maybe<ZuoraSoldToContact>;
  blackListedCategoriesForBrands: Array<Scalars['ID']>;
  botLinkedBusiness?: Maybe<BotLinkedBusiness>;
  botLinkedUser?: Maybe<BotLinkedUser>;
  branding?: Maybe<Branding>;
  brandingBySubdomain?: Maybe<Branding>;
  bulkRewardFailedEmails?: Maybe<Array<Maybe<BulkRewardFailedEmails>>>;
  bulkRewardStatus?: Maybe<BulkRewardStatusResponse>;
  bulkRewardTransferOutcome?: Maybe<BulkRewardTransferOutcome>;
  bulkUploadUrl?: Maybe<GetUploadUrlResponse>;
  business?: Maybe<Business>;
  businessBySubdomain?: Maybe<UnauthedBusiness>;
  businessGroup?: Maybe<BusinessGroup>;
  businessGroups?: Maybe<BusinessGroupList>;
  businessMetadata?: Maybe<BusinessMetadata>;
  businessRedemptionReport?: Maybe<BusinessRedemptionReportResponse>;
  businessRestrictions?: Maybe<BusinessRestrictions>;
  businessSettings?: Maybe<BusinessSettings>;
  businessSsoConfiguration?: Maybe<SsoConfigurationResponse>;
  businessStory?: Maybe<BusinessStory>;
  businessSubdomainHistory?: Maybe<Array<Maybe<BusinessSubdomainChange>>>;
  businessWalletTransfersCSV?: Maybe<BusinessWalletTransfersCsv>;
  businesses?: Maybe<BusinessList>;
  businessesPublic?: Maybe<Array<Maybe<PublicBusiness>>>;
  canRedeemBasket?: Maybe<Scalars['Boolean']>;
  cashbackProducts?: Maybe<Array<Maybe<CashbackProduct>>>;
  cashbackTransactionsList?: Maybe<CashbackTransactionsListResponse>;
  cashbackTransactionsTotalAmount?: Maybe<CashbackTransactionTotalAmount>;
  celebrationTag?: Maybe<CelebrationTag>;
  celebrationTags?: Maybe<Array<Maybe<CelebrationTag>>>;
  celebrationsReport?: Maybe<CelebrationsReport>;
  checkout?: Maybe<Checkout>;
  checkoutData?: Maybe<PayrollPayCheckoutData>;
  checkoutProductConfig?: Maybe<CheckoutProductConfig>;
  checkoutRedemption?: Maybe<CheckoutRedemption>;
  checkoutRedemptions?: Maybe<CheckoutRedemptionList>;
  checkoutTotals?: Maybe<BasketTotalWithBreakDown>;
  checkouts?: Maybe<CheckoutList>;
  closedPolls?: Maybe<PollList>;
  /** @deprecated We use cashbackProducts instead */
  commissionGroups?: Maybe<Array<Maybe<CommissionGroup>>>;
  commsListByStatus?: Maybe<CommsMessageList>;
  commsListForUser?: Maybe<CommsMessageList>;
  commsMessage?: Maybe<CommsMessage>;
  companyNews?: Maybe<Array<Maybe<CompanyNewsTile>>>;
  companyValues?: Maybe<CompanyValueList>;
  completePayment?: Maybe<Payment>;
  confirmIdentifier?: Maybe<Scalars['Boolean']>;
  countAvailableCustomRewards?: Maybe<Scalars['Int']>;
  currencyExchange: CurrencyExchange;
  currentUser?: Maybe<VivupCurrentUser>;
  customReward?: Maybe<CustomReward>;
  customRewards?: Maybe<Array<Maybe<CustomReward>>>;
  customRewardsTransactions?: Maybe<CustomRewardTransactionsList>;
  customerFile?: Maybe<CustomerFileResponse>;
  deal?: Maybe<Deal>;
  dealAddonById?: Maybe<Tag>;
  dealAddons?: Maybe<TagList>;
  dealBrand?: Maybe<DealBrand>;
  dealBrandBySlug?: Maybe<DealBrand>;
  dealBrands?: Maybe<DealBrandList>;
  dealBrandsByIds?: Maybe<DealBrandSearchResponse>;
  dealBySlug?: Maybe<Deal>;
  dealCategoriesForCurrentPackage?: Maybe<DealCategoryList>;
  dealFavourites: Array<Maybe<Deal>>;
  dealLocationFilterTags?: Maybe<Array<Maybe<DealLocationFilterTags>>>;
  /** @deprecated Perks go is no more */
  dealLocations?: Maybe<DealLocationList>;
  dealMerchandiseRegionList: Array<Scalars['String']>;
  dealPackage?: Maybe<DealsPackage>;
  dealPackageById?: Maybe<DealsPackage>;
  dealPackages?: Maybe<DealsPackageList>;
  /** @deprecated Perks go is no more */
  dealPerksGoFilter?: Maybe<Tag>;
  /** @deprecated Perks go is no more */
  dealPerksGoFilterTags?: Maybe<Array<Maybe<Tag>>>;
  dealPriceModifiers?: Maybe<DealPriceModifiersList>;
  dealSettings?: Maybe<DealSettings>;
  dealStockCount?: Maybe<DealStockCounts>;
  dealStockCountByUrlSlug?: Maybe<DealStockCounts>;
  dealTagsForCurrentPackage?: Maybe<TagList>;
  deals?: Maybe<DealList>;
  dealsBrands?: Maybe<Array<Maybe<DealBrandSearchResponse>>>;
  dealsInternal?: Maybe<DealList>;
  dealsPriceModifiers?: Maybe<Array<Maybe<DealPriceModifier>>>;
  departmentData?: Maybe<CategoriesEmployeeOrganisation>;
  exportPayrollOrders?: Maybe<Scalars['Boolean']>;
  externalDeal?: Maybe<ExternalDeal>;
  externalDealCounts?: Maybe<ExternalDealCounts>;
  externalDeals?: Maybe<ExternalDealList>;
  fidelUserTransactions?: Maybe<FidelTransactionList>;
  flexiPointsExpiryList?: Maybe<FlexiPointsExpiry>;
  fraudBlacklistedEmail?: Maybe<FraudBlacklistedEmail>;
  fraudBlacklistedEmails?: Maybe<FraudBlacklistedEmailsList>;
  fraudThreshold?: Maybe<FraudThreshold>;
  fraudThresholds?: Maybe<FraudThresholdList>;
  generateAssertion?: Maybe<Assertion>;
  generateIntercomToken?: Maybe<Scalars['String']>;
  generateVivupToken?: Maybe<Scalars['String']>;
  /** @deprecated Perks go is no more */
  geoDeals?: Maybe<SlimDealList>;
  getAnnualLeavePurchaseConfig?: Maybe<StoreHomeEmployeeOrganisation>;
  getAuthURL?: Maybe<GetAuthUrlResponse>;
  getAutoApproveCsv: Array<AutoApproveCsvTemplateRow>;
  getAutoApprovedUserBudget?: Maybe<AutoApprovedUserBudget>;
  /** @deprecated Replaced by getFeaturedLane */
  getCarousel?: Maybe<Array<Maybe<WellnessCarousel>>>;
  /** Returns EAP phone numbers keyed by region code. */
  getEAPPhoneNumbers?: Maybe<EapPhoneNumbers>;
  /** This is the featured lane that will be displayed on the homepage. */
  getFeaturedLane?: Maybe<WellnessLane>;
  getLanes?: Maybe<Array<Maybe<WellnessLane>>>;
  getOAuthSettings?: Maybe<GetOAuthSettingsResponse>;
  getOnboardingUrl?: Maybe<OnboardingUserUrl>;
  getPaymentLink?: Maybe<PaymentLink>;
  getPeopleWalletTransactions?: Maybe<PeopleTransactionList>;
  getQuote?: Maybe<SignUpQuote>;
  getQuotePageData?: Maybe<GetQuotePageData>;
  getRegistrationCode?: Maybe<SelfRegistrationCodeResponse>;
  getRelatedWellnessMediaList?: Maybe<Array<Maybe<WellnessMedia>>>;
  getRewardWalletReport?: Maybe<RewardWalletReportList>;
  getRewardWalletTotals?: Maybe<RewardWalletTotalList>;
  getSignUp?: Maybe<SignUp>;
  /** @deprecated Use 'tenantOnboarding' query. */
  getTenantOnboarding?: Maybe<TenantOnboarding>;
  /** @deprecated Use 'tenantOnboardingList' query. */
  getTenantOnboardingList?: Maybe<TenantOnboardingList>;
  getTermsAndConditions?: Maybe<TermsAndConditionsResponse>;
  getTopUp?: Maybe<Topup>;
  getTopUps?: Maybe<TopupList>;
  getTransferOutcome?: Maybe<FlexiPointTransfer>;
  getUserByEmail?: Maybe<User>;
  getUserEmploymentDetails?: Maybe<UserEmploymentDetails>;
  getUserPhoneNumber?: Maybe<PhoneNumber>;
  getVimeoVideoSource?: Maybe<Scalars['String']>;
  getWalletBalanceAtTime?: Maybe<WalletBalanceAtTime>;
  getWalletBalancesFromTime?: Maybe<WalletBalanceFromTime>;
  getWellnessCategoryById?: Maybe<WellnessMediaCategory>;
  getWellnessCategoryTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  getWellnessMediaById?: Maybe<WellnessMedia>;
  getWellnessMediaCategories?: Maybe<Array<Maybe<WellnessMediaCategory>>>;
  getWellnessMediaCategoriesForAdmin: Array<WellnessMediaCategory>;
  getWellnessProfile?: Maybe<WellnessProfile>;
  globalLogin?: Maybe<Scalars['Boolean']>;
  globalTenant?: Maybe<GlobalTenant>;
  groupCelebration?: Maybe<GroupCelebration>;
  helixOrderHistory?: Maybe<HelixOrderList>;
  helixOrderLatest?: Maybe<HelixOrder>;
  holidayQuoteValue?: Maybe<GetHolidayQuoteValues>;
  homePageRewardsLanes?: Maybe<Array<Maybe<RewardsLane>>>;
  homepage?: Maybe<Homepage>;
  /** @deprecated UI now supports multiple banners */
  homepageBanner?: Maybe<Deal>;
  homepageBanners?: Maybe<Array<Maybe<Deal>>>;
  /** @deprecated No longer required */
  homepageBirthdayBanner?: Maybe<Deal>;
  /** @deprecated Use new 'homepageDealCategoryTags' query */
  homepageDealCategories?: Maybe<DealCategoryList>;
  homepageDealCategoryTags?: Maybe<TagList>;
  homepageLanes?: Maybe<HomepageLaneList>;
  homepages?: Maybe<HomepageList>;
  incidents?: Maybe<IncidentsList>;
  ingestionJob?: Maybe<IngestionJob>;
  ingestionJobs?: Maybe<IngestionJobList>;
  inspirations?: Maybe<InspirationList>;
  internalAdminUser?: Maybe<InternalUser>;
  internalAdminUsers?: Maybe<InternalUserList>;
  isAuthed?: Maybe<Scalars['Boolean']>;
  isCheckoutDotComEnabled?: Maybe<Scalars['Boolean']>;
  latestScore?: Maybe<Score>;
  layoutData?: Maybe<StoreLayoutResponse>;
  /** @deprecated Not used anymore */
  layoutWidgets?: Maybe<LayoutWidgets>;
  linkedCards?: Maybe<CardList>;
  listAllTransactions?: Maybe<Array<Maybe<CustomRewardTransaction>>>;
  listAutoApprovedUserBudgets?: Maybe<AutoApprovedUserBudgetList>;
  listCompanies?: Maybe<Array<Maybe<CompanyDetails>>>;
  listPayrollBenefits?: Maybe<PayrollPayBenefits>;
  listPayrollOrders?: Maybe<PayrollPayOrders>;
  listPointsRequests?: Maybe<PointsRequestsList>;
  listRegistrationCodes?: Maybe<ListSelfRegistrationCodesResponse>;
  listRoles?: Maybe<ListRolesResponse>;
  listScheduledRewards: Array<ListScheduledRewards>;
  listUserPayrollOrders?: Maybe<PayrollPayOrders>;
  lockedProductRecommendations?: Maybe<LockedProductRecommendations>;
  login?: Maybe<Login>;
  loginActiveSessions?: Maybe<Array<Maybe<LoginActiveSession>>>;
  loginGhost?: Maybe<LoginGhost>;
  loginGhostTokenForBusiness?: Maybe<Scalars['String']>;
  loginPasswordless?: Maybe<LoginPasswordless>;
  loginRefresh?: Maybe<LoginRefresh>;
  magicLogin?: Maybe<MagicLoginResponse>;
  marketingBusinessProfile?: Maybe<MarketingBusinessProfile>;
  marketingProfile?: Maybe<MarketingProfile>;
  marketingProfileSettings?: Maybe<MarketingProfileSettings>;
  me?: Maybe<User>;
  merchant?: Maybe<Merchant>;
  merchantBaseOffer?: Maybe<MerchantBaseOffer>;
  merchantEmployee?: Maybe<MerchantEmployee>;
  merchantEmployees?: Maybe<MerchantEmployeeList>;
  merchantGetEmployeeByEmail?: Maybe<MerchantEmployee>;
  merchantGetMerchantsForEmail?: Maybe<Array<Maybe<Merchant>>>;
  merchantLocation?: Maybe<MerchantLocation>;
  merchantLocations?: Maybe<MerchantLocationList>;
  merchantTransactions?: Maybe<MerchantTransactionList>;
  merchants?: Maybe<MerchantList>;
  merchantsByLocationUuid?: Maybe<MerchantList>;
  metaBusinessCreations?: Maybe<Array<Maybe<BusinessCreationMetadata>>>;
  mfaGetUser?: Maybe<MfaSetup>;
  mfaHasFlag?: Maybe<Scalars['Boolean']>;
  mfaHasFlagShortTerm?: Maybe<Scalars['Boolean']>;
  mfaRequest?: Maybe<Mfa>;
  mfaTotpGetUser?: Maybe<MfaTotpUser>;
  /** @deprecated Use mutation instead */
  mfaValidate?: Maybe<MfaValidate>;
  minSupportedAppVersion?: Maybe<Scalars['String']>;
  minSupportedExpoVersion: Array<ExpoVersionMapping>;
  myBasket?: Maybe<Basket>;
  myBusiness?: Maybe<Business>;
  myCustomRewardsTransactions?: Maybe<CustomRewardTransactionsList>;
  notificationCount?: Maybe<Scalars['Int']>;
  /** @deprecated use celebrationTags */
  occasions?: Maybe<OccasionList>;
  onboardingReport?: Maybe<OnboardingReport>;
  onboardingReportByStep?: Maybe<OnboardingReportStep>;
  orderAuditLogs?: Maybe<PayrollAuditLogs>;
  orderDocuments?: Maybe<PayrollOrderDocuments>;
  orderFilters?: Maybe<PayrollOrderFilters>;
  orderPdfData?: Maybe<StoreHomeEmployeeOrganisation>;
  organisationalSummary?: Maybe<OrganisationalSummary>;
  overview?: Maybe<ReportingOverview>;
  passwordRequestForgot?: Maybe<Scalars['Boolean']>;
  paymentConfigs?: Maybe<PaymentConfigs>;
  paymentMethods: Array<PaymentMethod>;
  paymentOrder?: Maybe<PaymentOrder>;
  /** @deprecated Moved to dealIngestion */
  pendingDeals?: Maybe<PendingDealList>;
  /** @deprecated No longer used. */
  perksGoMetrics: PerksGoMetrics;
  perksGoPromotionalDeals?: Maybe<DealList>;
  perksHomepage?: Maybe<PerksHomepage>;
  /** @deprecated Use new 'perksHomepage' query */
  perksHomepageById?: Maybe<PerksHomepage>;
  perksHomepages?: Maybe<PerksHomepageList>;
  perksMetrics: PerksMetrics;
  perksSaga?: Maybe<DealSaga>;
  perksSearchPromotedTags?: Maybe<Array<Maybe<TagPromotion>>>;
  permissionsProductSettingsForTeam?: Maybe<ProductSettings>;
  platformMetrics: PlatformMetrics;
  poll?: Maybe<Poll>;
  polls?: Maybe<PollList>;
  /** @deprecated Use 'popularRewards' query without locale param (27/2/2020). */
  popularRewards?: Maybe<Array<Maybe<RewardsLane>>>;
  powerbiReport?: Maybe<PowerbiReportDetails>;
  preferredUserFraudThreshold?: Maybe<FraudThreshold>;
  product?: Maybe<Product>;
  productDetail?: Maybe<PayrollPayProductDetail>;
  productPermissions?: Maybe<ProductPermissions>;
  productStockCheckByPoNumber?: Maybe<Array<Maybe<PoNumberCount>>>;
  productSuppliers?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<ProductList>;
  productsSearch?: Maybe<ProductList>;
  promotionStatus?: Maybe<PromotionStatus>;
  providerSettings?: Maybe<ProviderSettings>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaires: Array<Questionnaire>;
  recognition?: Maybe<Recognition>;
  recognitionAutomation?: Maybe<RecognitionAutomation>;
  recognitionAutomations?: Maybe<Array<Maybe<RecognitionAutomation>>>;
  recognitionFeed?: Maybe<RecognitionFeedList>;
  recognitionMessageTemplates: Array<Maybe<RecognitionMessageTemplate>>;
  redemption?: Maybe<DealRedemption>;
  redemptionLimitsForDeal: Array<CheckoutRedemptionUserLimits>;
  redemptionLimitsForUser: Array<CheckoutRedemptionUserLimits>;
  redemptions?: Maybe<DealRedemptionList>;
  region?: Maybe<Region>;
  regions?: Maybe<RegionList>;
  reportingBusinessOverview?: Maybe<ReportingBusinessOverview>;
  resendWelcomeEmail?: Maybe<OnboardingUserEmailReturn>;
  resendWelcomeEmails?: Maybe<Scalars['Boolean']>;
  resumeSession?: Maybe<ResumeLogin>;
  reward?: Maybe<RewardCatalogueReward>;
  rewardCatalogueReward?: Maybe<RewardCatalogueReward>;
  rewardCatalogueRewards?: Maybe<RewardCatalogueRewardList>;
  rewardCategoriesForCurrentPackage?: Maybe<DealCategoryList>;
  rewardOrder?: Maybe<RewardOrder>;
  rewardOrders?: Maybe<RewardOrderList>;
  rewardPackage?: Maybe<RewardPackage>;
  rewardPackageById?: Maybe<RewardPackage>;
  rewardPackages?: Maybe<RewardPackageList>;
  rewardRedemptions?: Maybe<RewardRedemptionList>;
  rewardStatementItems?: Maybe<StatementItemList>;
  rewardWallets?: Maybe<RewardWalletList>;
  rewardsReportUrl?: Maybe<RewardsReportUrl>;
  rewardsReportingUrl?: Maybe<RewardsReportingUrl>;
  salaryBrackets: Array<SalaryBracket>;
  salesPreviewRenewalQuote?: Maybe<RenewalQuote>;
  salesRenewalCancellation?: Maybe<RenewalCancellation>;
  salesRenewalQuote?: Maybe<RenewalQuote>;
  salesRenewalQuoteStatus?: Maybe<RenewalQuoteOutcome>;
  salsacBenefitLimitation?: Maybe<SalsacBenefitLimitation>;
  salsacBenefitLimitations?: Maybe<Array<Maybe<SalsacBenefitLimitation>>>;
  salsacBusinessBenefitLimitation?: Maybe<SalsacBusinessBenefitLimitation>;
  salsacBusinessBenefitRankings: Array<SalsacDeductionTypeRankings>;
  salsacBusinessIneligibilityCriteria?: Maybe<SalsacIneligibilityCriteria>;
  salsacBusinessIneligibilityRule?: Maybe<SalsacIneligibilityRuleSet>;
  salsacBusinessIneligibilityRules: Array<SalsacIneligibilityRuleSet>;
  salsacCheckEligibility?: Maybe<SalsacCheckEligibilityResponse>;
  salsacJobGradeUsageCount?: Maybe<SalsacJobGradeUsageCount>;
  salsacMissingCriterionDataCount?: Maybe<SalsacMissingCriterionDataCount>;
  salsacMultiCheckEligibility: Array<SalsacDeductionTypeMap>;
  salsacOrderEligibilityNotification?: Maybe<SalsacOrderEligibilityNotification>;
  salsacUserBusinessDetail?: Maybe<SalsacUserBusinessDetail>;
  savedCards?: Maybe<PaymentSavedCardList>;
  savingsCalculatorData?: Maybe<SavingCalculatorData>;
  savingsCalculatorDealBrandList?: Maybe<Array<SavingsCalculatorDealBrand>>;
  scheduledEvent?: Maybe<SchedulerEvent>;
  scheduledEvents?: Maybe<SchedulerEventList>;
  /** @deprecated Use 'recognition' instead. */
  scheduledRecognition?: Maybe<SchedulerEvent>;
  scheduledRecognitions?: Maybe<AccountRecognitionList>;
  scheduledSystemEvent?: Maybe<SchedulerSystemEvent>;
  scheduledSystemEvents?: Maybe<SchedulerSystemEventList>;
  scheduledTransfers?: Maybe<ScheduledTransferList>;
  schemeDeductionTypes?: Maybe<SchemeDeductionTypes>;
  /** @deprecated Use topupServiceFeesTiers instead */
  serviceFeesTiers: Array<TiersResponse>;
  /** @deprecated Use topupServiceFeesTiers instead */
  serviceFeesTiersByTenant: Array<TiersResponse>;
  /** @deprecated Use ssoLoginV2 */
  ssoLogin?: Maybe<Login>;
  ssoLoginV2?: Maybe<Login>;
  statementItems?: Maybe<StatementItemList>;
  stock?: Maybe<Stock>;
  stockJobList?: Maybe<StockJobList>;
  storeBasketData?: Maybe<PayrollPayBasket>;
  storeHomeBannersData?: Maybe<StoreHomeEmployeeOrganisation>;
  storeHomeDepartmentsData?: Maybe<StoreHomeEmployeeOrganisation>;
  storeHomeFeaturedCategoriesData?: Maybe<StoreHomeEmployeeOrganisation>;
  storeHomePopularBikesData?: Maybe<StoreHomeEmployeeOrganisation>;
  storeHomeSchemeData?: Maybe<StoreHomeEmployeeOrganisation>;
  storeProductsData?: Maybe<PayrollPayStoreProducts>;
  tag?: Maybe<Tag>;
  tags?: Maybe<TagList>;
  team?: Maybe<Team>;
  teamPerksMetrics: TeamPerksMetrics;
  teamReports?: Maybe<TeamReports>;
  teams?: Maybe<TeamList>;
  teamsPaginated?: Maybe<TeamsPaginatedResponse>;
  /** @deprecated Tenants are now businesses, use 'business' query. */
  tenant?: Maybe<Tenant>;
  tenantAudit?: Maybe<TenantAuditList>;
  /** @deprecated Use 'businessMetadata' now. */
  tenantMetadata?: Maybe<TenantMetadata>;
  tenantOnboarding?: Maybe<TenantOnboarding>;
  tenantOnboardingList?: Maybe<TenantOnboardingList>;
  tenantWallet?: Maybe<TenantWallet>;
  tenantWalletList?: Maybe<WalletList>;
  tenantWalletTransactions?: Maybe<TenantTransactionList>;
  topupCurrencyCode?: Maybe<Scalars['String']>;
  topupServiceFeesTiers: TopupServiceFeeTiers;
  topupTaxForBusiness: Tax;
  trophies?: Maybe<TrophyList>;
  unAuthedBusiness?: Maybe<UnauthedBusiness>;
  unAuthedUser?: Maybe<UnauthedUser>;
  /** @deprecated No longer a thing */
  upsell?: Maybe<Upsell>;
  usageReports?: Maybe<UsageReports>;
  user?: Maybe<User>;
  userAudit?: Maybe<Array<Maybe<UserAudit>>>;
  userDealsSagas?: Maybe<DealSagaList>;
  userMetadata?: Maybe<UserMetadata>;
  userOnboarding?: Maybe<UserOnboarding>;
  userPaymentOrders?: Maybe<PaymentOrderList>;
  userPlatformData?: Maybe<UserPlatformData>;
  userPublic?: Maybe<UserPublic>;
  userRedemptionReport?: Maybe<UserRedemptionReportResponse>;
  userSavings?: Maybe<UserSavingsResponse>;
  userTeamAssignments: Array<UserTeamAssignment>;
  userWalletList?: Maybe<WalletList>;
  usersForBusiness?: Maybe<UserList>;
  usersForInternal?: Maybe<UserList>;
  validateBulkBudgetAssignment?: Maybe<ValidateBulkBudgetAssignmentResponse>;
  viewPayrollOrder?: Maybe<PayrollOrder>;
  viewPayrollOrderHistory?: Maybe<PayrollOrder>;
  wallet?: Maybe<Wallet>;
  /** @deprecated Use serviceFeesTiers instead */
  walletTopupServiceCharge?: Maybe<WalletTopupServiceCharge>;
  weeklyBudget?: Maybe<WeeklyBudget>;
  wellnessMediaList?: Maybe<WellnessMediaList>;
  wellnessMediaRentals?: Maybe<MediaRentalList>;
  wellnessSearch: WellnessMediaList;
  workOSDsyncConfig?: Maybe<WorkOsDsyncConfig>;
  workOSLinksFromCode?: Maybe<WorkOsPortalLinks>;
  workOSOrganisation?: Maybe<WorkOsOrganisation>;
  workOSPortalLinks?: Maybe<WorkOsPortalLinks>;
  workOSUser?: Maybe<WorkOsUser>;
  workSSOLogin?: Maybe<Login>;
};


export type QueryAccountGroupCelebrationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryAccountRecognitionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryAccountRecognitionsFeedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryAccountScheduledRecognitionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryAccountTrophiesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryAccountVotesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryAdsClickArgs = {
  offerId: Scalars['ID'];
};


export type QueryAdsOffersArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  dealId?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<AdsOfferKind>;
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<AdsOfferStatus>;
};


export type QueryAuditForInitiatingUserArgs = {
  filterByEvent?: InputMaybe<Array<AuditEventType>>;
  searchAfter?: InputMaybe<Scalars['String']>;
  userUuid: Scalars['ID'];
};


export type QueryAuditForResourceArgs = {
  filterByEvent?: InputMaybe<Array<AuditEventType>>;
  resourceId: Scalars['ID'];
  resourceType: AuditResourceType;
  searchAfter?: InputMaybe<Scalars['String']>;
};


export type QueryBasketForUserArgs = {
  userId: Scalars['ID'];
};


export type QueryBenefitsContentArgs = {
  benefit: BenefitContentType;
};


export type QueryBenefitsListBenefitsArgs = {
  businessId?: InputMaybe<Scalars['ID']>;
};


export type QueryBikeShopDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryBillingMappingArgs = {
  id: Scalars['ID'];
};


export type QueryBillingMappingsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<BillingRegion>;
  regionId?: InputMaybe<Scalars['ID']>;
  zuoraProductId?: InputMaybe<Scalars['ID']>;
};


export type QueryBillingMappingsForTeamArgs = {
  teamId: Scalars['ID'];
};


export type QueryBillingProductsForTeamArgs = {
  teamId: Scalars['ID'];
};


export type QueryBillingUnitForRegionIdArgs = {
  businessId: Scalars['ID'];
  regionId: Scalars['ID'];
};


export type QueryBillingUnitsArgs = {
  businessId: Scalars['ID'];
};


export type QueryBillingZuoraCurrentPlanArgs = {
  businessId: Scalars['ID'];
};


export type QueryBillingZuoraInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type QueryBillingZuoraInvoicesArgs = {
  businessId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryBillingZuoraProductOptionsArgs = {
  businessId: Scalars['ID'];
};


export type QueryBillingZuoraProductsForBusinessArgs = {
  businessId: Scalars['ID'];
};


export type QueryBillingZuoraSeatsCountArgs = {
  businessId: Scalars['ID'];
};


export type QueryBillingZuoraSoldToContactArgs = {
  businessId: Scalars['ID'];
};


export type QueryBotLinkedBusinessArgs = {
  businessId: Scalars['ID'];
  type: BotLinkType;
};


export type QueryBotLinkedUserArgs = {
  type: BotLinkType;
  userId: Scalars['ID'];
};


export type QueryBrandingArgs = {
  businessId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryBrandingBySubdomainArgs = {
  subdomain: Scalars['String'];
};


export type QueryBulkRewardFailedEmailsArgs = {
  uuid: Scalars['ID'];
};


export type QueryBulkRewardStatusArgs = {
  uuid: Scalars['ID'];
};


export type QueryBulkRewardTransferOutcomeArgs = {
  uuid: Scalars['ID'];
};


export type QueryBulkUploadUrlArgs = {
  attributes?: InputMaybe<UploadAttributesInput>;
  businessId: Scalars['ID'];
  uploadType: UploadTypeUrl;
  userId: Scalars['ID'];
};


export type QueryBusinessArgs = {
  businessId: Scalars['ID'];
};


export type QueryBusinessBySubdomainArgs = {
  subdomain: Scalars['String'];
};


export type QueryBusinessGroupArgs = {
  id: Scalars['ID'];
};


export type QueryBusinessGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  noPagination?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBusinessMetadataArgs = {
  businessId: Scalars['ID'];
};


export type QueryBusinessRedemptionReportArgs = {
  businessId: Scalars['ID'];
  duration?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<DateInput>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  types?: InputMaybe<Array<InputMaybe<BusinessRedemptionReportRedemptionType>>>;
};


export type QueryBusinessRestrictionsArgs = {
  businessId: Scalars['ID'];
};


export type QueryBusinessSettingsArgs = {
  businessId: Scalars['ID'];
};


export type QueryBusinessSsoConfigurationArgs = {
  businessId: Scalars['String'];
};


export type QueryBusinessStoryArgs = {
  businessId: Scalars['ID'];
};


export type QueryBusinessSubdomainHistoryArgs = {
  businessId: Scalars['ID'];
};


export type QueryBusinessWalletTransfersCsvArgs = {
  includeHeaderRow?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryBusinessesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
};


export type QueryBusinessesPublicArgs = {
  q?: InputMaybe<Scalars['String']>;
};


export type QueryCanRedeemBasketArgs = {
  userId: Scalars['ID'];
};


export type QueryCashbackProductsArgs = {
  id: Scalars['ID'];
  provider?: InputMaybe<ProductProvider>;
};


export type QueryCashbackTransactionsListArgs = {
  filters?: InputMaybe<CashbackTransactionListFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  searchAfter?: InputMaybe<Scalars['String']>;
};


export type QueryCashbackTransactionsTotalAmountArgs = {
  currency: Scalars['String'];
  status: CashbackTransactionStatus;
  userId: Scalars['ID'];
};


export type QueryCelebrationTagArgs = {
  id: Scalars['String'];
};


export type QueryCelebrationTagsArgs = {
  kind: CelebrationTagKind;
};


export type QueryCelebrationsReportArgs = {
  businessId: Scalars['ID'];
  category?: InputMaybe<CelebrationsReportCategory>;
  duration?: InputMaybe<CelebrationsReportDuration>;
  limit?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<DateInput>;
  regionIds?: InputMaybe<Array<Scalars['ID']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCheckoutArgs = {
  uuid: Scalars['ID'];
};


export type QueryCheckoutDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryCheckoutProductConfigArgs = {
  dealId: Scalars['ID'];
};


export type QueryCheckoutRedemptionArgs = {
  uuid: Scalars['ID'];
};


export type QueryCheckoutRedemptionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['ID']>;
  isUsed?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CheckoutRedemptionType>;
  types?: InputMaybe<Array<CheckoutRedemptionType>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryCheckoutTotalsArgs = {
  isRewards?: InputMaybe<Scalars['Boolean']>;
  items: Array<BasketInputItem>;
  paymentDetails?: InputMaybe<BasketPaymentDetailsInput>;
};


export type QueryCheckoutsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryClosedPollsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCommissionGroupsArgs = {
  id: Scalars['ID'];
};


export type QueryCommsListByStatusArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  status: CommsMessageStatus;
};


export type QueryCommsListForUserArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type QueryCommsMessageArgs = {
  id: Scalars['ID'];
};


export type QueryCompanyNewsArgs = {
  tenantId: Scalars['String'];
};


export type QueryCompanyValuesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
};


export type QueryCompletePaymentArgs = {
  paymentOrderId: Scalars['String'];
};


export type QueryConfirmIdentifierArgs = {
  data?: InputMaybe<ConfirmIdentifierInput>;
};


export type QueryCurrencyExchangeArgs = {
  currency: Scalars['String'];
};


export type QueryCustomRewardArgs = {
  uuid: Scalars['ID'];
};


export type QueryCustomRewardsArgs = {
  filters?: InputMaybe<CustomRewardsFilter>;
};


export type QueryCustomRewardsTransactionsArgs = {
  filters?: InputMaybe<ListCustomRewardsTransactionsFilter>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCustomerFileArgs = {
  uuid: Scalars['ID'];
};


export type QueryDealArgs = {
  useWhitelist?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};


export type QueryDealAddonByIdArgs = {
  id: Scalars['ID'];
};


export type QueryDealBrandArgs = {
  uuid: Scalars['ID'];
};


export type QueryDealBrandBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryDealBrandsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListDealBrandFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryDealBrandsByIdsArgs = {
  resolveToParent?: InputMaybe<Scalars['Boolean']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDealBySlugArgs = {
  isRewards?: InputMaybe<Scalars['Boolean']>;
  urlSlug?: InputMaybe<Scalars['String']>;
};


export type QueryDealFavouritesArgs = {
  userId: Scalars['ID'];
};


export type QueryDealLocationsArgs = {
  boundingBox?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
};


export type QueryDealPackageByIdArgs = {
  id: Scalars['ID'];
};


export type QueryDealPerksGoFilterArgs = {
  id: Scalars['ID'];
};


export type QueryDealPriceModifiersArgs = {
  businessId: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryDealSettingsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryDealStockCountArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type QueryDealStockCountByUrlSlugArgs = {
  urlSlug: Scalars['String'];
};


export type QueryDealsArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  brandTagIds?: InputMaybe<Array<Scalars['String']>>;
  customDealType?: InputMaybe<Scalars['String']>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  geo?: InputMaybe<Scalars['Boolean']>;
  hideEB?: InputMaybe<Scalars['Boolean']>;
  hidePerksGo?: InputMaybe<Scalars['Boolean']>;
  ignoreBlacklist?: InputMaybe<Scalars['Boolean']>;
  ignorePackage?: InputMaybe<Scalars['Boolean']>;
  insideBoundingBox?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isRewards?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  locale?: InputMaybe<Scalars['String']>;
  locationTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxTTPrice?: InputMaybe<Scalars['Float']>;
  noTt?: InputMaybe<Scalars['Boolean']>;
  notTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  provider?: InputMaybe<PendingDealProvider>;
  q?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  regions?: InputMaybe<Array<Scalars['ID']>>;
  reviewState?: InputMaybe<DealReviewState>;
  ruleContexts?: InputMaybe<Scalars['String']>;
  slim?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<DealListSort>;
  status?: InputMaybe<DealStatus>;
  statuses?: InputMaybe<Array<DealStatus>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ttOnly?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<DealsListType>;
  types?: InputMaybe<Array<InputMaybe<DealType>>>;
  urlSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useWhitelist?: InputMaybe<Scalars['Boolean']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDealsBrandsArgs = {
  brandTagIds?: InputMaybe<Array<Scalars['String']>>;
  customDealType?: InputMaybe<Scalars['String']>;
  excludeBrandId?: InputMaybe<Scalars['String']>;
  ignoreBlacklist?: InputMaybe<Scalars['Boolean']>;
  ignorePackage?: InputMaybe<Scalars['Boolean']>;
  isRewards?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  notTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  provider?: InputMaybe<PendingDealProvider>;
  q?: InputMaybe<Scalars['String']>;
  regions?: InputMaybe<Array<Scalars['ID']>>;
  reviewState?: InputMaybe<DealReviewState>;
  sort?: InputMaybe<DealListSort>;
  statuses?: InputMaybe<Array<DealStatus>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ttOnly?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<InputMaybe<DealType>>>;
  urlSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDealsInternalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  provider?: InputMaybe<Scalars['String']>;
  q?: InputMaybe<Scalars['String']>;
  regions?: InputMaybe<Array<Scalars['ID']>>;
  reviewState?: InputMaybe<DealReviewState>;
  statuses?: InputMaybe<Array<DealStatus>>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
  ttOnly?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<DealsListType>;
  uuids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryDealsPriceModifiersArgs = {
  dealIds: Array<Scalars['String']>;
  dealKind: PriceModifierDealKind;
  status: PriceModifierDealStatus;
  tier?: InputMaybe<ProductSettingsPerksTiers>;
};


export type QueryDepartmentDataArgs = {
  departmentId: Scalars['ID'];
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryExportPayrollOrdersArgs = {
  benefit_type?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employee_number?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  ni_number?: InputMaybe<Scalars['String']>;
  order_number?: InputMaybe<Scalars['Int']>;
  order_status?: InputMaybe<Scalars['String']>;
  organisation_approval?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  partner_user_identifier?: InputMaybe<Scalars['String']>;
  pay_frequency?: InputMaybe<Scalars['String']>;
  payroll_period?: InputMaybe<Scalars['String']>;
  show_employee_cancelled_orders?: InputMaybe<Scalars['Boolean']>;
};


export type QueryExternalDealArgs = {
  apiCode: Scalars['String'];
  nativeId: Scalars['String'];
};


export type QueryExternalDealCountsArgs = {
  apiCode: Scalars['String'];
};


export type QueryExternalDealsArgs = {
  apiCode: Scalars['String'];
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
};


export type QueryFidelUserTransactionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};


export type QueryFlexiPointsExpiryListArgs = {
  beforeDate: Scalars['String'];
  currency: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  fromDate: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  walletId: Scalars['ID'];
};


export type QueryFraudBlacklistedEmailArgs = {
  fraudBlacklistedEmail: Scalars['String'];
};


export type QueryFraudBlacklistedEmailsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryFraudThresholdArgs = {
  fraudThresholdId: Scalars['String'];
};


export type QueryGenerateAssertionArgs = {
  metadata?: InputMaybe<GenerateAssertionMetadata>;
  provider?: InputMaybe<GenerateAssertionProvider>;
};


export type QueryGenerateIntercomTokenArgs = {
  channel: ThirdPartyTokenChannel;
};


export type QueryGenerateVivupTokenArgs = {
  channel: ThirdPartyTokenChannel;
};


export type QueryGeoDealsArgs = {
  geo?: InputMaybe<Scalars['Int']>;
  insideBoundingBox?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  slim?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAnnualLeavePurchaseConfigArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryGetAuthUrlArgs = {
  businessId?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<GetAuthUrlRequestClientType>;
  connectionId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AuthUrlState>;
  useSP?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAutoApprovedUserBudgetArgs = {
  input: GetAutoApprovedUserBudgetInput;
};


export type QueryGetOAuthSettingsArgs = {
  businessId: Scalars['String'];
};


export type QueryGetOnboardingUrlArgs = {
  userId: Scalars['String'];
};


export type QueryGetPaymentLinkArgs = {
  method: SignUpPaymentMethodType;
  signupId: Scalars['ID'];
};


export type QueryGetPeopleWalletTransactionsArgs = {
  currency?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxDate?: InputMaybe<Scalars['String']>;
  minDate?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGetQuoteArgs = {
  uuid: Scalars['ID'];
};


export type QueryGetQuotePageDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryGetRegistrationCodeArgs = {
  businessId: Scalars['ID'];
  code: Scalars['String'];
  codeType: SelfRegistrationCodeType;
};


export type QueryGetRelatedWellnessMediaListArgs = {
  mediaId: Scalars['ID'];
};


export type QueryGetRewardWalletReportArgs = {
  currency?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxDate?: InputMaybe<Scalars['String']>;
  minDate?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderDesc?: InputMaybe<Scalars['Boolean']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  walletTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGetRewardWalletTotalsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  maxDate?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  minDate?: InputMaybe<Scalars['String']>;
  minValue?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDesc?: InputMaybe<Scalars['Boolean']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  walletTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGetSignUpArgs = {
  uuid: Scalars['ID'];
};


export type QueryGetTenantOnboardingArgs = {
  tenantId: Scalars['String'];
};


export type QueryGetTenantOnboardingListArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  launchManagerId?: InputMaybe<Scalars['ID']>;
  onboardingFinished?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetTermsAndConditionsArgs = {
  signupId: Scalars['ID'];
};


export type QueryGetTopUpArgs = {
  topupId: Scalars['String'];
};


export type QueryGetTopUpsArgs = {
  businessId?: InputMaybe<Scalars['ID']>;
  scrollId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};


export type QueryGetTransferOutcomeArgs = {
  transferId: Scalars['ID'];
};


export type QueryGetUserByEmailArgs = {
  email: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryGetUserEmploymentDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryGetUserPhoneNumberArgs = {
  userId: Scalars['ID'];
};


export type QueryGetVimeoVideoSourceArgs = {
  videoId?: InputMaybe<Scalars['String']>;
};


export type QueryGetWalletBalanceAtTimeArgs = {
  currency: Scalars['String'];
  maxValue?: InputMaybe<Scalars['Int']>;
  minValue?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
  walletType?: InputMaybe<Scalars['String']>;
};


export type QueryGetWalletBalancesFromTimeArgs = {
  currency: Scalars['String'];
  dateType: Scalars['String'];
  dateValue: Scalars['Int'];
  maxDate?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['String']>;
  minValue?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  walletId?: InputMaybe<Scalars['String']>;
  walletType?: InputMaybe<Scalars['String']>;
};


export type QueryGetWellnessCategoryByIdArgs = {
  categoryId: Scalars['ID'];
};


export type QueryGetWellnessCategoryTagsArgs = {
  categoryId: Scalars['ID'];
};


export type QueryGetWellnessMediaByIdArgs = {
  mediaId: Scalars['ID'];
};


export type QueryGetWellnessProfileArgs = {
  userId: Scalars['ID'];
};


export type QueryGlobalLoginArgs = {
  email: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
};


export type QueryGlobalTenantArgs = {
  subdomain: Scalars['String'];
};


export type QueryGroupCelebrationArgs = {
  id: Scalars['String'];
};


export type QueryHelixOrderHistoryArgs = {
  redemptionId: Scalars['ID'];
};


export type QueryHelixOrderLatestArgs = {
  redemptionId: Scalars['ID'];
};


export type QueryHolidayQuoteValueArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  quotePrice: Scalars['String'];
  schemeType: Scalars['ID'];
};


export type QueryHomePageRewardsLanesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type QueryHomepageArgs = {
  id: Scalars['ID'];
};


export type QueryHomepageLanesArgs = {
  kind?: InputMaybe<HomepageKind>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  radius?: InputMaybe<Scalars['Int']>;
};


export type QueryHomepagesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  kind?: InputMaybe<HomepageKind>;
  limit?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<HomepageState>;
};


export type QueryIncidentsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ListIncidentsFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryIngestionJobArgs = {
  uuid: Scalars['ID'];
};


export type QueryIngestionJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  provider?: InputMaybe<PendingDealProvider>;
  searchAfter?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IngestionJobStatus>;
};


export type QueryInspirationsArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
  useTranslations?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInternalAdminUserArgs = {
  email: Scalars['String'];
};


export type QueryInternalAdminUsersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
};


export type QueryLatestScoreArgs = {
  questionnaireId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryLayoutDataArgs = {
  deductionType?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryLayoutWidgetsArgs = {
  tenantId: Scalars['String'];
};


export type QueryLinkedCardsArgs = {
  userId: Scalars['ID'];
};


export type QueryListAutoApprovedUserBudgetsArgs = {
  input: ListAutoApprovedUserBudgetsInput;
};


export type QueryListCompaniesArgs = {
  filter: ListCompaniesFilterInput;
  uuid: Scalars['ID'];
};


export type QueryListPayrollBenefitsArgs = {
  vivupOrgId?: InputMaybe<Scalars['ID']>;
};


export type QueryListPayrollOrdersArgs = {
  benefit_type?: InputMaybe<Scalars['String']>;
  employee_number?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  ni_number?: InputMaybe<Scalars['String']>;
  order_number?: InputMaybe<Scalars['String']>;
  order_status?: InputMaybe<Scalars['String']>;
  orders_date_from?: InputMaybe<Scalars['String']>;
  orders_date_to?: InputMaybe<Scalars['String']>;
  organisation_approval?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  partner_user_identifier?: InputMaybe<Scalars['String']>;
  pay_frequency?: InputMaybe<Scalars['String']>;
  payroll_period?: InputMaybe<Scalars['String']>;
  show_employee_cancelled_orders?: InputMaybe<Scalars['Boolean']>;
};


export type QueryListPointsRequestsArgs = {
  input: ListPointsRequestsInput;
};


export type QueryListRegistrationCodesArgs = {
  businessId: Scalars['ID'];
  codeType: SelfRegistrationCodeType;
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
};


export type QueryListScheduledRewardsArgs = {
  input: ListScheduledRewardsInput;
};


export type QueryListUserPayrollOrdersArgs = {
  benefit_type?: InputMaybe<Scalars['String']>;
  order_status?: InputMaybe<Scalars['String']>;
  orders_date_from?: InputMaybe<Scalars['String']>;
  orders_date_to?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  show_employee_cancelled_orders?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLockedProductRecommendationsArgs = {
  brochureGroupId: Scalars['ID'];
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
  spendCap?: InputMaybe<Scalars['Float']>;
};


export type QueryLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryLoginActiveSessionsArgs = {
  userId: Scalars['String'];
};


export type QueryLoginGhostTokenForBusinessArgs = {
  businessId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryLoginPasswordlessArgs = {
  expiresIn?: InputMaybe<Scalars['Int']>;
  secret: Scalars['String'];
  tenantId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryLoginRefreshArgs = {
  expiredToken: Scalars['String'];
  refreshToken?: InputMaybe<Scalars['String']>;
};


export type QueryMagicLoginArgs = {
  businessId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  identifier: Scalars['String'];
  uuid: Scalars['ID'];
};


export type QueryMarketingBusinessProfileArgs = {
  businessId: Scalars['ID'];
};


export type QueryMarketingProfileArgs = {
  data: GetMarketingProfileInput;
};


export type QueryMarketingProfileSettingsArgs = {
  userId: Scalars['ID'];
};


export type QueryMerchantArgs = {
  id: Scalars['String'];
};


export type QueryMerchantBaseOfferArgs = {
  merchantId: Scalars['String'];
};


export type QueryMerchantEmployeeArgs = {
  employeeId: Scalars['String'];
};


export type QueryMerchantEmployeesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  merchantId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryMerchantGetEmployeeByEmailArgs = {
  email: Scalars['String'];
};


export type QueryMerchantGetMerchantsForEmailArgs = {
  email: Scalars['String'];
};


export type QueryMerchantLocationArgs = {
  locationId: Scalars['String'];
};


export type QueryMerchantLocationsArgs = {
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  merchantId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryMerchantTransactionsArgs = {
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  merchantId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryMerchantsArgs = {
  employeeId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryMerchantsByLocationUuidArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  uuids: Scalars['String'];
};


export type QueryMetaBusinessCreationsArgs = {
  internalUserId: Scalars['ID'];
};


export type QueryMfaGetUserArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryMfaTotpGetUserArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryMfaValidateArgs = {
  code: Scalars['String'];
};


export type QueryMyCustomRewardsTransactionsArgs = {
  filters?: InputMaybe<ListMyCustomRewardsTransactionsFilter>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNotificationCountArgs = {
  channel: NotificationChannel;
  kind: NotificationKind;
};


export type QueryOccasionsArgs = {
  tenantId: Scalars['String'];
};


export type QueryOnboardingReportArgs = {
  businessId: Scalars['ID'];
};


export type QueryOnboardingReportByStepArgs = {
  businessId: Scalars['ID'];
  step: OnboardingStep;
};


export type QueryOrderAuditLogsArgs = {
  order_id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderDocumentsArgs = {
  order_id: Scalars['ID'];
};


export type QueryOrderPdfDataArgs = {
  brochureGroupId: Scalars['ID'];
  organisationId?: InputMaybe<Scalars['ID']>;
  pdfType: Scalars['String'];
  schemeType: Scalars['ID'];
};


export type QueryOrganisationalSummaryArgs = {
  businessId: Scalars['ID'];
  category?: InputMaybe<OrganisationalSummaryCategory>;
  companySize?: InputMaybe<OrganisationalSummaryCompanySizeInput>;
  duration?: InputMaybe<OrganisationalSummaryDuration>;
  industry?: InputMaybe<Scalars['String']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  trendRateDuration?: InputMaybe<OrganisationalSummaryTrendDuration>;
  trendRateEndsDate?: InputMaybe<Scalars['String']>;
};


export type QueryOverviewArgs = {
  businessId: Scalars['ID'];
};


export type QueryPasswordRequestForgotArgs = {
  businessId: Scalars['ID'];
  email: Scalars['String'];
};


export type QueryPaymentConfigsArgs = {
  platform?: InputMaybe<Platform>;
};


export type QueryPaymentMethodsArgs = {
  amount: Scalars['Int'];
  channel?: InputMaybe<PaymentChannel>;
  countryCode?: InputMaybe<Scalars['String']>;
  currency: PaymentCurrencyType;
  locale?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentOrderArgs = {
  id: Scalars['ID'];
};


export type QueryPendingDealsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  externalIdentifier?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  provider?: InputMaybe<PendingDealProvider>;
  searchAfter?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PendingDealStatus>;
};


export type QueryPerksGoMetricsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryPerksGoPromotionalDealsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DealListSort>;
};


export type QueryPerksHomepageByIdArgs = {
  id: Scalars['ID'];
};


export type QueryPerksHomepagesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<PerksHomepageActiveState>;
};


export type QueryPerksMetricsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryPerksSagaArgs = {
  uuid?: InputMaybe<Scalars['String']>;
};


export type QueryPermissionsProductSettingsForTeamArgs = {
  businessId: Scalars['ID'];
  teamId: Scalars['ID'];
};


export type QueryPlatformMetricsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryPollArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPollsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPopularRewardsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type QueryPowerbiReportArgs = {
  businessId: Scalars['String'];
  type: PowerbiReportType;
};


export type QueryPreferredUserFraudThresholdArgs = {
  tenantId: Scalars['String'];
  thresholdType: FraudThresholdType;
  userId: Scalars['String'];
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductDetailArgs = {
  brochureGroupId: Scalars['ID'];
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryProductStockCheckByPoNumberArgs = {
  productId: Scalars['String'];
  status: ProductStockStatus;
};


export type QueryProductSuppliersArgs = {
  search: Scalars['String'];
};


export type QueryProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  supplier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryProductsSearchArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  supplier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryPromotionStatusArgs = {
  type: PromotionType;
};


export type QueryProviderSettingsArgs = {
  platform?: InputMaybe<Platform>;
};


export type QueryQuestionnaireArgs = {
  questionnaireId: Scalars['ID'];
};


export type QueryQuestionnairesArgs = {
  type?: InputMaybe<QuestionnaireKind>;
};


export type QueryRecognitionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryRecognitionAutomationArgs = {
  uuid: Scalars['ID'];
};


export type QueryRecognitionAutomationsArgs = {
  businessId?: InputMaybe<Scalars['ID']>;
  occasionId?: InputMaybe<Scalars['ID']>;
};


export type QueryRecognitionFeedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  view?: InputMaybe<Scalars['String']>;
};


export type QueryRedemptionArgs = {
  uuid?: InputMaybe<Scalars['String']>;
};


export type QueryRedemptionLimitsForDealArgs = {
  dealId: Scalars['ID'];
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  userId: Scalars['ID'];
};


export type QueryRedemptionLimitsForUserArgs = {
  products: Array<CheckoutRedemptionUserLimitsProductsInput>;
  userId: Scalars['ID'];
};


export type QueryRedemptionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  isUsed?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryRegionArgs = {
  id: Scalars['ID'];
};


export type QueryRegionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<RegionActiveState>;
};


export type QueryReportingBusinessOverviewArgs = {
  businessId: Scalars['ID'];
  duration?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
};


export type QueryResendWelcomeEmailArgs = {
  userId: Scalars['String'];
};


export type QueryResendWelcomeEmailsArgs = {
  businessId: Scalars['ID'];
  ignoreUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryResumeSessionArgs = {
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryRewardArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryRewardCatalogueRewardArgs = {
  rewardId?: InputMaybe<Scalars['String']>;
};


export type QueryRewardCatalogueRewardsArgs = {
  isCreditOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  rewardsForMyPackage?: InputMaybe<Scalars['Boolean']>;
  rewardsForUserId?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRewardOrderArgs = {
  orderId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryRewardOrdersArgs = {
  author?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryRewardPackageByIdArgs = {
  id: Scalars['ID'];
};


export type QueryRewardRedemptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryRewardStatementItemsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId: Scalars['String'];
  walletId: Scalars['String'];
};


export type QueryRewardWalletsArgs = {
  currency: Scalars['String'];
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryRewardsReportUrlArgs = {
  businessId: Scalars['ID'];
  reportType: ReportType;
};


export type QueryRewardsReportingUrlArgs = {
  businessId: Scalars['ID'];
  reportType: ReportType;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerySalesPreviewRenewalQuoteArgs = {
  businessId: Scalars['ID'];
  etag: Scalars['String'];
  option?: InputMaybe<InputRenewalOption>;
  productsAdded?: InputMaybe<Array<InputMaybe<InputRenewalProduct>>>;
  productsRemoved?: InputMaybe<Array<InputMaybe<InputRenewalProduct>>>;
  productsUpdated?: InputMaybe<Array<InputMaybe<InputRenewalProduct>>>;
  seats?: InputMaybe<Scalars['Int']>;
  signatureContact?: InputMaybe<InputRenewalContact>;
};


export type QuerySalesRenewalCancellationArgs = {
  businessId: Scalars['ID'];
};


export type QuerySalesRenewalQuoteArgs = {
  businessId: Scalars['ID'];
};


export type QuerySalesRenewalQuoteStatusArgs = {
  businessId: Scalars['ID'];
};


export type QuerySalsacBenefitLimitationArgs = {
  benefitId?: InputMaybe<Scalars['ID']>;
  businessId: Scalars['ID'];
  deductionType?: InputMaybe<SalsacDeduction>;
  schemeTypeId?: InputMaybe<Scalars['ID']>;
};


export type QuerySalsacBenefitLimitationsArgs = {
  businessId: Scalars['ID'];
};


export type QuerySalsacBusinessBenefitLimitationArgs = {
  businessId: Scalars['ID'];
};


export type QuerySalsacBusinessBenefitRankingsArgs = {
  benefitIds: Array<Scalars['ID']>;
  businessId: Scalars['ID'];
};


export type QuerySalsacBusinessIneligibilityCriteriaArgs = {
  businessId: Scalars['ID'];
};


export type QuerySalsacBusinessIneligibilityRuleArgs = {
  businessId: Scalars['ID'];
  uuid: Scalars['ID'];
};


export type QuerySalsacBusinessIneligibilityRulesArgs = {
  businessId: Scalars['ID'];
};


export type QuerySalsacCheckEligibilityArgs = {
  businessId: Scalars['ID'];
  checkCondition: SalsacBenefitDeductionTypesInput;
  userId: Scalars['ID'];
};


export type QuerySalsacJobGradeUsageCountArgs = {
  businessId: Scalars['ID'];
  jobGrade: Scalars['String'];
};


export type QuerySalsacMissingCriterionDataCountArgs = {
  businessId: Scalars['ID'];
};


export type QuerySalsacMultiCheckEligibilityArgs = {
  businessId: Scalars['ID'];
  checkConditions: Array<SalsacBenefitDeductionTypesInput>;
  userId: Scalars['ID'];
};


export type QuerySalsacOrderEligibilityNotificationArgs = {
  businessId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QuerySalsacUserBusinessDetailArgs = {
  businessId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QuerySavedCardsArgs = {
  provider: PaymentProvider;
};


export type QuerySavingsCalculatorDataArgs = {
  brochureGroupId: Scalars['ID'];
  costOfQuote: Scalars['String'];
  employeeSalary: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryScheduledEventArgs = {
  uuid: Scalars['ID'];
};


export type QueryScheduledEventsArgs = {
  businessId?: InputMaybe<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['ID']>;
  eventName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  status: SchedulerEventStatus;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryScheduledRecognitionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryScheduledRecognitionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryScheduledSystemEventArgs = {
  uuid: Scalars['ID'];
};


export type QueryScheduledSystemEventsArgs = {
  cursor?: InputMaybe<Scalars['ID']>;
  entityId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<SchedulerEntityType>;
  eventName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  status: SchedulerEventStatus;
};


export type QueryScheduledTransfersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  scheduledTransferStatus?: InputMaybe<Array<InputMaybe<ScheduledTransferStatus>>>;
  walletId: Scalars['String'];
  walletOwnerId: Scalars['String'];
};


export type QuerySchemeDeductionTypesArgs = {
  schemeTypeId: Scalars['ID'];
};


export type QueryServiceFeesTiersArgs = {
  currency?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['ID']>;
};


export type QueryServiceFeesTiersByTenantArgs = {
  currency?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};


export type QuerySsoLoginArgs = {
  accessToken: Scalars['String'];
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryStatementItemsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  knownTypes?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
  walletId: Scalars['String'];
  walletOwnerId?: InputMaybe<Scalars['String']>;
};


export type QueryStockArgs = {
  stockId: Scalars['String'];
};


export type QueryStockJobListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  poNumber?: InputMaybe<Scalars['String']>;
  productUuid?: InputMaybe<Scalars['String']>;
};


export type QueryStoreBasketDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryStoreHomeBannersDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryStoreHomeDepartmentsDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryStoreHomeFeaturedCategoriesDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryStoreHomePopularBikesDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryStoreHomeSchemeDataArgs = {
  locale?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  schemeType: Scalars['ID'];
};


export type QueryStoreProductsDataArgs = {
  filters?: InputMaybe<FilterArgument>;
  locale?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  organisationId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  productsPerPage?: InputMaybe<Scalars['Int']>;
  schemeType: Scalars['ID'];
};


export type QueryTagArgs = {
  id: Scalars['ID'];
};


export type QueryTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  kind?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTeamArgs = {
  id: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryTeamPerksMetricsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryTeamReportsArgs = {
  businessId: Scalars['ID'];
  duration?: InputMaybe<TeamReportDuration>;
  teamDate?: InputMaybe<TeamDateInput>;
  teamState?: InputMaybe<TeamState>;
  teamStates?: InputMaybe<Array<InputMaybe<ReportingTeamState>>>;
};


export type QueryTeamsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<TeamState>;
  tenantId: Scalars['String'];
};


export type QueryTeamsPaginatedArgs = {
  businessId: Scalars['ID'];
  featureFlags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasBranding?: InputMaybe<Scalars['Boolean']>;
  hasManager?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchAfter?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TeamState>;
  teamName?: InputMaybe<Scalars['String']>;
};


export type QueryTenantArgs = {
  tenantId: Scalars['String'];
};


export type QueryTenantAuditArgs = {
  action?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
};


export type QueryTenantMetadataArgs = {
  tenantId: Scalars['String'];
};


export type QueryTenantOnboardingArgs = {
  tenantId: Scalars['String'];
};


export type QueryTenantOnboardingListArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  launchManagerId?: InputMaybe<Scalars['ID']>;
  onboardingFinished?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTenantWalletArgs = {
  currency: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryTenantWalletListArgs = {
  tenantId: Scalars['String'];
};


export type QueryTenantWalletTransactionsArgs = {
  amount?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxDate?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['Int']>;
  minDate?: InputMaybe<Scalars['String']>;
  minValue?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
  walletTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTopupCurrencyCodeArgs = {
  businessId?: InputMaybe<Scalars['ID']>;
};


export type QueryTopupServiceFeesTiersArgs = {
  currency?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['ID']>;
};


export type QueryTopupTaxForBusinessArgs = {
  businessId?: InputMaybe<Scalars['ID']>;
};


export type QueryUnAuthedBusinessArgs = {
  businessId: Scalars['ID'];
};


export type QueryUnAuthedUserArgs = {
  id: Scalars['ID'];
};


export type QueryUpsellArgs = {
  businessId: Scalars['ID'];
};


export type QueryUsageReportsArgs = {
  businessId: Scalars['ID'];
  interval?: InputMaybe<Scalars['String']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserAuditArgs = {
  action?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};


export type QueryUserDealsSagasArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  next?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type QueryUserMetadataArgs = {
  userId: Scalars['String'];
};


export type QueryUserOnboardingArgs = {
  userId: Scalars['ID'];
};


export type QueryUserPaymentOrdersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type QueryUserPublicArgs = {
  businessId: Scalars['String'];
  email: Scalars['String'];
};


export type QueryUserRedemptionReportArgs = {
  duration?: InputMaybe<RedemptionReportDuration>;
  limit?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<RedemptionReportDateMessageInput>;
};


export type QueryUserSavingsArgs = {
  duration?: InputMaybe<RedemptionReportDuration>;
  limit?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<RedemptionReportDateMessageInput>;
};


export type QueryUserTeamAssignmentsArgs = {
  id: Scalars['ID'];
};


export type QueryUserWalletListArgs = {
  userId: Scalars['String'];
};


export type QueryUsersForBusinessArgs = {
  activated?: InputMaybe<Scalars['Boolean']>;
  adminsOnly?: InputMaybe<Scalars['Boolean']>;
  businessId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  excludeRemovedUsers?: InputMaybe<Scalars['Boolean']>;
  friendsFamilyOnly?: InputMaybe<Scalars['Boolean']>;
  hasDateOfBirth?: InputMaybe<Scalars['Boolean']>;
  hasEmploymentStartDate?: InputMaybe<Scalars['Boolean']>;
  invitedBy?: InputMaybe<Scalars['ID']>;
  lastNameCharacter?: InputMaybe<Scalars['String']>;
  leadersOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  managersAndLeadersOnly?: InputMaybe<Scalars['Boolean']>;
  managersOnly?: InputMaybe<Scalars['Boolean']>;
  nonOnboarded?: InputMaybe<Scalars['Boolean']>;
  notInRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  searchString?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['ID']>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  totalOnly?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryUsersForInternalArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  lastNameCharacter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryValidateBulkBudgetAssignmentArgs = {
  input: ValidateBulkBudgetAssignmentInput;
};


export type QueryViewPayrollOrderArgs = {
  order_number: Scalars['ID'];
};


export type QueryViewPayrollOrderHistoryArgs = {
  order_number: Scalars['ID'];
};


export type QueryWalletArgs = {
  currency: Scalars['String'];
  entityId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<WalletEntityType>;
  userId: Scalars['String'];
};


export type QueryWellnessMediaListArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryWellnessMediaRentalsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  expiryStatus: ListMediaRentalsExpiryStatus;
  limit?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryWellnessSearchArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryWorkOsDsyncConfigArgs = {
  businessId: Scalars['ID'];
};


export type QueryWorkOsLinksFromCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type QueryWorkOsOrganisationArgs = {
  businessId: Scalars['ID'];
};


export type QueryWorkOsPortalLinksArgs = {
  businessId: Scalars['ID'];
};


export type QueryWorkOsUserArgs = {
  userId: Scalars['ID'];
};


export type QueryWorkSsoLoginArgs = {
  businessId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  connectionId?: InputMaybe<Scalars['String']>;
};

export type Question = {
  __typename?: 'Question';
  answers: Array<Answer>;
  instructions?: Maybe<Scalars['String']>;
  prompt: Scalars['String'];
  uuid: Scalars['ID'];
};

export type QuestionInput = {
  answers: Array<AnswerInput>;
  instructions?: InputMaybe<Scalars['String']>;
  prompt: Scalars['String'];
  uuid: Scalars['String'];
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  /** The kind of assessment this questionnaire belongs to */
  assessmentType?: Maybe<AssessmentKind>;
  calculationId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  name: Scalars['String'];
  questions?: Maybe<Array<Question>>;
  status: QuestionnaireStatus;
  type: QuestionnaireKind;
  uuid: Scalars['ID'];
};

export const QuestionnaireKind = {
  QuestionnaireTypeAssessment: 'QUESTIONNAIRE_TYPE_ASSESSMENT',
  QuestionnaireTypeSurvey: 'QUESTIONNAIRE_TYPE_SURVEY',
  QuestionnaireTypeUnknown: 'QUESTIONNAIRE_TYPE_UNKNOWN'
} as const;

export type QuestionnaireKind = typeof QuestionnaireKind[keyof typeof QuestionnaireKind];
export const QuestionnaireStatus = {
  QuestionnaireStatusActive: 'QUESTIONNAIRE_STATUS_ACTIVE',
  QuestionnaireStatusComingSoon: 'QUESTIONNAIRE_STATUS_COMING_SOON',
  QuestionnaireStatusInactive: 'QUESTIONNAIRE_STATUS_INACTIVE',
  QuestionnaireStatusUnknown: 'QUESTIONNAIRE_STATUS_UNKNOWN'
} as const;

export type QuestionnaireStatus = typeof QuestionnaireStatus[keyof typeof QuestionnaireStatus];
export type QuoteSavings = {
  __typename?: 'QuoteSavings';
  actualReduction?: Maybe<Scalars['String']>;
  disposalFeeExVat?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  monthlyGrossSalaryReduction?: Maybe<Scalars['String']>;
  quotePrice?: Maybe<Scalars['String']>;
  roundingCharges?: Maybe<Scalars['String']>;
  totalPayment?: Maybe<Scalars['String']>;
};

export type ReactionInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type ReclaimWalletPointsInput = {
  wallets: Array<WalletTransferPair>;
};

export type ReclaimWalletPointsResponse = {
  __typename?: 'ReclaimWalletPointsResponse';
  updatedWallets: Array<Wallet>;
};

export type Recognition = {
  __typename?: 'Recognition';
  active?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  authorId?: Maybe<Scalars['String']>;
  budget?: Maybe<BudgetCategory>;
  businessId?: Maybe<Scalars['String']>;
  comments?: Maybe<RecognitionFeedCommentList>;
  companyValues?: Maybe<CompanyValueList>;
  /** @deprecated Use 'metadata.createdAt' now. */
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  /** @deprecated Use 'authorId' now. */
  createdById?: Maybe<Scalars['String']>;
  customReward?: Maybe<CustomReward>;
  customRewardId?: Maybe<Scalars['String']>;
  expectReward?: Maybe<Scalars['Boolean']>;
  isEveryone?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  moderated?: Maybe<Scalars['Boolean']>;
  occasion?: Maybe<Occasion>;
  originalTimezone?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
  reactions?: Maybe<RecognitionFeedReactionList>;
  receiverIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  receivers?: Maybe<UserList>;
  reward?: Maybe<Reward>;
  rewardAmount?: Maybe<Scalars['Int']>;
  rewardOrder?: Maybe<RewardOrder>;
  scheduledAt?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<RecognitionStatus>;
  teamIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  teams?: Maybe<TeamList>;
  /** @deprecated Use 'businessId' now. */
  tenantId?: Maybe<Scalars['String']>;
  trophy?: Maybe<Trophy>;
  uuid?: Maybe<Scalars['String']>;
  /** @deprecated Use 'walletTransferIds' now. */
  walletTransferId?: Maybe<Scalars['String']>;
  walletTransferIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RecognitionCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type RecognitionReceiversArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type RecognitionAutomation = {
  __typename?: 'RecognitionAutomation';
  authorId?: Maybe<Scalars['String']>;
  /** @deprecated Get automation type from reward rules configuration instead. */
  automationType?: Maybe<RecognitionAutomationType>;
  budget?: Maybe<RecognitionAutomationBudget>;
  businessId?: Maybe<Scalars['String']>;
  companyCelebration?: Maybe<Occasion>;
  companyCelebrationId?: Maybe<Scalars['String']>;
  companyValueIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyValues?: Maybe<CompanyValueList>;
  consent?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<User>;
  /** @deprecated Use message in each reward rule instead. */
  message?: Maybe<Scalars['String']>;
  metadata?: Maybe<RecognitionAutomationMetadata>;
  occasion?: Maybe<CelebrationTag>;
  occasionId?: Maybe<Scalars['String']>;
  region?: Maybe<Team>;
  regionId?: Maybe<Scalars['String']>;
  rewardRules?: Maybe<Array<Maybe<RecognitionAutomationRule>>>;
  /** @deprecated Get rule type from reward rules configuration instead. */
  ruleType?: Maybe<RecognitionAutomationRuleType>;
  senderName?: Maybe<Scalars['String']>;
  source?: Maybe<RecognitionAutomationSource>;
  status?: Maybe<RecognitionAutomationStatus>;
  uuid?: Maybe<Scalars['String']>;
  walletId?: Maybe<Scalars['String']>;
  walletUser?: Maybe<User>;
};

export type RecognitionAutomationBudget = {
  __typename?: 'RecognitionAutomationBudget';
  categoryId?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  useUnassigned?: Maybe<Scalars['Boolean']>;
};

export type RecognitionAutomationInput = {
  budget?: InputMaybe<BudgetCategoryRequest>;
  companyCelebrationId?: InputMaybe<Scalars['String']>;
  companyValueIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  consent?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  occasionId: Scalars['String'];
  recognitionAutomationStatus: RecognitionAutomationStatus;
  recognitionAutomationType?: InputMaybe<RecognitionAutomationType>;
  regionId: Scalars['String'];
  rewardRules?: InputMaybe<Array<InputMaybe<RecognitionAutomationRuleInput>>>;
  ruleType?: InputMaybe<RecognitionAutomationRuleType>;
  senderName?: InputMaybe<Scalars['String']>;
  walletId?: InputMaybe<Scalars['String']>;
};

export type RecognitionAutomationMetadata = {
  __typename?: 'RecognitionAutomationMetadata';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
};

export type RecognitionAutomationRule = {
  __typename?: 'RecognitionAutomationRule';
  amount?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type RecognitionAutomationRuleInput = {
  amount?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export const RecognitionAutomationRuleType = {
  Custom: 'CUSTOM',
  SettingsUnknown: 'SETTINGS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED',
  Yearly: 'YEARLY'
} as const;

export type RecognitionAutomationRuleType = typeof RecognitionAutomationRuleType[keyof typeof RecognitionAutomationRuleType];
export const RecognitionAutomationSource = {
  Perkbox: 'PERKBOX',
  SourceUnknown: 'SOURCE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type RecognitionAutomationSource = typeof RecognitionAutomationSource[keyof typeof RecognitionAutomationSource];
export const RecognitionAutomationStatus = {
  Active: 'ACTIVE',
  Deactivated: 'DEACTIVATED',
  Draft: 'DRAFT',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type RecognitionAutomationStatus = typeof RecognitionAutomationStatus[keyof typeof RecognitionAutomationStatus];
export const RecognitionAutomationType = {
  RecognitionOnly: 'RECOGNITION_ONLY',
  Reward: 'REWARD',
  TypeUnknown: 'TYPE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type RecognitionAutomationType = typeof RecognitionAutomationType[keyof typeof RecognitionAutomationType];
export type RecognitionFeed = {
  __typename?: 'RecognitionFeed';
  entityType?: Maybe<Scalars['String']>;
  groupCelebration?: Maybe<GroupCelebration>;
  id?: Maybe<Scalars['String']>;
  poll?: Maybe<Poll>;
  recognition?: Maybe<Recognition>;
  /** @deprecated Use 'entityType' now. */
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type RecognitionFeedComment = {
  __typename?: 'RecognitionFeedComment';
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  moderated?: Maybe<Scalars['Boolean']>;
  reactions?: Maybe<RecognitionFeedReactionList>;
  updatedAt?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type RecognitionFeedCommentInput = {
  id: Scalars['String'];
  message: Scalars['String'];
  type: Scalars['String'];
};

/**
 * Paginated List for entity RecognitionFeedComment. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RecognitionFeedCommentList = {
  __typename?: 'RecognitionFeedCommentList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RecognitionFeedComment>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

/**
 * Paginated List for entity RecognitionFeed. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RecognitionFeedList = {
  __typename?: 'RecognitionFeedList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RecognitionFeed>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RecognitionFeedReaction = {
  __typename?: 'RecognitionFeedReaction';
  authorId?: Maybe<Scalars['String']>;
  /** @deprecated Use 'metadata.createdAt' now. */
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  /** @deprecated Use 'authorId' now. */
  createdById?: Maybe<Scalars['String']>;
  emoji?: Maybe<Emoji>;
  parentId?: Maybe<Scalars['String']>;
  /** @deprecated Use 'emoji' now. */
  reaction?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type RecognitionFeedReactionInput = {
  parentId: Scalars['String'];
  reaction: ReactionInput;
  type: FeedEntityType;
};

/**
 * Paginated List for entity RecognitionFeedReaction. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RecognitionFeedReactionList = {
  __typename?: 'RecognitionFeedReactionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RecognitionFeedReaction>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RecognitionInput = {
  budget?: InputMaybe<BudgetCategoryRequest>;
  companyValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customRewardId?: InputMaybe<Scalars['String']>;
  expectReward?: InputMaybe<Scalars['Boolean']>;
  isEveryone?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  occasionId?: InputMaybe<Scalars['String']>;
  originalTimezone?: InputMaybe<Scalars['String']>;
  reward?: InputMaybe<RewardInput>;
  rewardAmount?: InputMaybe<Scalars['Int']>;
  scheduledAt?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  walletTransferId?: InputMaybe<Scalars['String']>;
};

export type RecognitionMessageTemplate = {
  __typename?: 'RecognitionMessageTemplate';
  icon: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  text: Scalars['String'];
};

export type RecognitionReport = {
  __typename?: 'RecognitionReport';
  teams: Array<CelebrationsReportTeam>;
  users: Array<CelebrationsReportUser>;
};

export const RecognitionSource = {
  MicrosoftTeams: 'MICROSOFT_TEAMS',
  Perkbox: 'PERKBOX',
  SchedulerApp: 'SCHEDULER_APP',
  SourceUnknown: 'SOURCE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type RecognitionSource = typeof RecognitionSource[keyof typeof RecognitionSource];
export const RecognitionStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Publishing: 'PUBLISHING',
  PublishFailure: 'PUBLISH_FAILURE',
  Scheduled: 'SCHEDULED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type RecognitionStatus = typeof RecognitionStatus[keyof typeof RecognitionStatus];
export const RecognitionVisibility = {
  Everyone: 'EVERYONE',
  Private: 'PRIVATE',
  Teams: 'TEAMS',
  Unrecognized: 'UNRECOGNIZED',
  VisibilityUnknown: 'VISIBILITY_UNKNOWN'
} as const;

export type RecognitionVisibility = typeof RecognitionVisibility[keyof typeof RecognitionVisibility];
export type RecurringDetail = {
  __typename?: 'RecurringDetail';
  brands?: Maybe<Array<Maybe<Scalars['String']>>>;
  details?: Maybe<Array<Maybe<InputDetail>>>;
  group?: Maybe<DetailGroup>;
  name?: Maybe<Scalars['String']>;
  paymentMethodData?: Maybe<Scalars['String']>;
  recurringDetailReference?: Maybe<Scalars['String']>;
  storedDetails?: Maybe<StoredPaymentDetails>;
  supportsRecurring?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export const RedemptionEvents = {
  UsersDateOfBirth: 'USERS_DATE_OF_BIRTH'
} as const;

export type RedemptionEvents = typeof RedemptionEvents[keyof typeof RedemptionEvents];
export type RedemptionReportDateMessage = {
  __typename?: 'RedemptionReportDateMessage';
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type RedemptionReportDateMessageInput = {
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export const RedemptionReportDuration = {
  AllTime: 'ALL_TIME',
  CustomDate: 'CUSTOM_DATE',
  Last_7Days: 'LAST_7_DAYS',
  Last_12Months: 'LAST_12_MONTHS',
  Last_30Days: 'LAST_30_DAYS',
  Monthly: 'MONTHLY',
  Quarterly: 'QUARTERLY',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type RedemptionReportDuration = typeof RedemptionReportDuration[keyof typeof RedemptionReportDuration];
export const RedemptionStatus = {
  Complete: 'COMPLETE',
  Started: 'STARTED'
} as const;

export type RedemptionStatus = typeof RedemptionStatus[keyof typeof RedemptionStatus];
export type RefundOrderInputDetails = {
  devalued?: InputMaybe<Scalars['Boolean']>;
  refundReason?: InputMaybe<Scalars['String']>;
};

export const RefundReasonType = {
  CancelledPhysicalCard: 'CANCELLED_PHYSICAL_CARD',
  DiscountNotApplied: 'DISCOUNT_NOT_APPLIED',
  DuplicatePaymentSecondVoucherDevalued: 'DUPLICATE_PAYMENT_SECOND_VOUCHER_DEVALUED',
  DuplicatePaymentSecondVoucherSpareSheet: 'DUPLICATE_PAYMENT_SECOND_VOUCHER_SPARE_SHEET',
  DuplicatePaymentSingleVoucher: 'DUPLICATE_PAYMENT_SINGLE_VOUCHER',
  InvalidVoucherLink: 'INVALID_VOUCHER_LINK',
  MistakenRedemption: 'MISTAKEN_REDEMPTION',
  NoPhysicalCard: 'NO_PHYSICAL_CARD',
  NoTopup: 'NO_TOPUP',
  NoVoucherBalance: 'NO_VOUCHER_BALANCE',
  TransactionError: 'TRANSACTION_ERROR',
  TAndCUnclear: 'T_AND_C_UNCLEAR',
  Unrecognized: 'UNRECOGNIZED',
  VoucherDeliveredLate: 'VOUCHER_DELIVERED_LATE',
  VoucherGenerateFailed: 'VOUCHER_GENERATE_FAILED',
  VoucherNotAccepted: 'VOUCHER_NOT_ACCEPTED'
} as const;

export type RefundReasonType = typeof RefundReasonType[keyof typeof RefundReasonType];
export type RefundToTenantWalletTransfer = {
  __typename?: 'RefundToTenantWalletTransfer';
  sender?: Maybe<User>;
  senderUserId?: Maybe<Scalars['String']>;
};

export type Region = {
  __typename?: 'Region';
  description?: Maybe<Scalars['String']>;
  homepageCategoryId?: Maybe<Scalars['ID']>;
  homepageId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  metadata?: Maybe<Metadata>;
  name: Scalars['String'];
  paymentCountryCode?: Maybe<PaymentCountryCode>;
  platformHomepageId?: Maybe<Scalars['ID']>;
  state?: Maybe<RegionActiveState>;
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
};

export const RegionActiveState = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;

export type RegionActiveState = typeof RegionActiveState[keyof typeof RegionActiveState];
export type RegionInput = {
  description: Scalars['String'];
  homepageCategoryId?: InputMaybe<Scalars['ID']>;
  homepageId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  paymentCountryCode: PaymentCountryCode;
  platformHomepageId?: InputMaybe<Scalars['ID']>;
  state: RegionActiveState;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
};

/**
 * Paginated List for entity Region. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RegionList = {
  __typename?: 'RegionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Region>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RegionUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  homepageCategoryId?: InputMaybe<Scalars['ID']>;
  homepageId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  paymentCountryCode?: InputMaybe<PaymentCountryCode>;
  platformHomepageId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<RegionActiveState>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
};

export type RegisterUserInput = {
  businessId: Scalars['ID'];
  captchaToken: Scalars['String'];
  code: Scalars['String'];
  codeType: SelfRegistrationCodeType;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type RemoveBasketItemInput = {
  basketItemId: Scalars['ID'];
};

export type RemoveBasketItemPayload = {
  __typename?: 'RemoveBasketItemPayload';
  removeBasketItem?: Maybe<BasketItemPayload>;
};

export type RenewalCancellation = {
  __typename?: 'RenewalCancellation';
  isManual?: Maybe<Scalars['Boolean']>;
  submittedAt?: Maybe<Date>;
  submittedBy?: Maybe<User>;
  submittedById?: Maybe<Scalars['ID']>;
};

export type RenewalContact = {
  __typename?: 'RenewalContact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
};

export const RenewalError = {
  ContractSendingFailed: 'CONTRACT_SENDING_FAILED',
  Failed: 'FAILED',
  FailedGettingContact: 'FAILED_GETTING_CONTACT',
  None: 'NONE',
  ObtainingQuoteFailed: 'OBTAINING_QUOTE_FAILED',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type RenewalError = typeof RenewalError[keyof typeof RenewalError];
export type RenewalOption = {
  __typename?: 'RenewalOption';
  annualCost?: Maybe<Scalars['Float']>;
  annualSaving?: Maybe<Scalars['Int']>;
  costPerSeatMonth?: Maybe<Scalars['Float']>;
  costPerSeatMonth4Dp?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Float']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  termLength?: Maybe<Scalars['Float']>;
};

export type RenewalProduct = {
  __typename?: 'RenewalProduct';
  costPerSeatMonth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  recurringChargeId?: Maybe<Scalars['String']>;
  seats?: Maybe<Scalars['Int']>;
  usageChargeId?: Maybe<Scalars['String']>;
};

export type RenewalQuote = {
  __typename?: 'RenewalQuote';
  acceptedAt?: Maybe<Date>;
  acceptedBy?: Maybe<User>;
  acceptedById?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Date>;
  currency?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorType?: Maybe<RenewalError>;
  etag?: Maybe<Scalars['String']>;
  isManual?: Maybe<Scalars['Boolean']>;
  novateToSmehci?: Maybe<Scalars['Boolean']>;
  options: Array<RenewalOption>;
  products?: Maybe<Array<Maybe<RenewalProduct>>>;
  seats?: Maybe<Scalars['Float']>;
  sentForSignature?: Maybe<Date>;
  signatureContact?: Maybe<RenewalContact>;
  signedAt?: Maybe<Date>;
  status?: Maybe<RenewalQuoteStatus>;
  statusMessage?: Maybe<Scalars['String']>;
  winbackOption?: Maybe<RenewalOption>;
};

export type RenewalQuoteOutcome = {
  __typename?: 'RenewalQuoteOutcome';
  errorMessage?: Maybe<Scalars['String']>;
  errorType?: Maybe<RenewalError>;
  evergreenBackstopDate?: Maybe<Date>;
  isEvergreen?: Maybe<Scalars['Boolean']>;
  isFromCache?: Maybe<Scalars['Boolean']>;
  isManual?: Maybe<Scalars['Boolean']>;
  sentForSignature?: Maybe<Date>;
  status?: Maybe<RenewalQuoteStatus>;
};

export const RenewalQuoteStatus = {
  Autorenewed: 'AUTORENEWED',
  Available: 'AVAILABLE',
  CancellationCreated: 'CANCELLATION_CREATED',
  Completed: 'COMPLETED',
  NotFound: 'NOT_FOUND',
  NoSelfServiceRenewal: 'NO_SELF_SERVICE_RENEWAL',
  SentForSignature: 'SENT_FOR_SIGNATURE',
  SignedInProgress: 'SIGNED_IN_PROGRESS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type RenewalQuoteStatus = typeof RenewalQuoteStatus[keyof typeof RenewalQuoteStatus];
export const RentalPeriodUnit = {
  Days: 'DAYS',
  DurationTypeUnknown: 'DURATION_TYPE_UNKNOWN',
  Hours: 'HOURS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type RentalPeriodUnit = typeof RentalPeriodUnit[keyof typeof RentalPeriodUnit];
export const ReportType = {
  FlexipointsTransactions: 'FLEXIPOINTS_TRANSACTIONS',
  ManagerWallet: 'MANAGER_WALLET',
  PeopleWallet: 'PEOPLE_WALLET',
  PointsBalance: 'POINTS_BALANCE',
  PointsTransactions: 'POINTS_TRANSACTIONS',
  RewardsWallet: 'REWARDS_WALLET',
  RewardTransactions: 'REWARD_TRANSACTIONS',
  TenantWallet: 'TENANT_WALLET',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ReportType = typeof ReportType[keyof typeof ReportType];
export type ReportingBusinessOverview = {
  __typename?: 'ReportingBusinessOverview';
  benefits?: Maybe<ReportingCompanyBenefits>;
  costOfLiving?: Maybe<ReportingCostOfLiving>;
  overview?: Maybe<ReportingOverview>;
  perks?: Maybe<ReportingHighestSavingPerks>;
  recognition?: Maybe<ReportingRecognition>;
  showMaximiseUsage?: Maybe<Scalars['Boolean']>;
  valuesAndCelebrations?: Maybe<ReportingValuesAndCelebrations>;
  wellness?: Maybe<ReportingWellness>;
};

export type ReportingCompanyBenefit = {
  __typename?: 'ReportingCompanyBenefit';
  companyBenefit?: Maybe<Deal>;
  redemptions?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type ReportingCompanyBenefits = {
  __typename?: 'ReportingCompanyBenefits';
  benefits?: Maybe<Array<Maybe<ReportingCompanyBenefit>>>;
  redemptions?: Maybe<Scalars['Int']>;
};

export type ReportingCostOfLiving = {
  __typename?: 'ReportingCostOfLiving';
  digitalVouchersAud?: Maybe<Scalars['Float']>;
  digitalVouchersGbp?: Maybe<Scalars['Float']>;
  discountVouchers?: Maybe<Scalars['Float']>;
  discountVouchersAud?: Maybe<Scalars['Float']>;
  discountVouchersGbp?: Maybe<Scalars['Float']>;
  flexiPointsAud?: Maybe<Scalars['Float']>;
  flexiPointsGbp?: Maybe<Scalars['Float']>;
  perksAud?: Maybe<Scalars['Float']>;
  perksGbp?: Maybe<Scalars['Float']>;
  rewardPointsAud?: Maybe<Scalars['Float']>;
  rewardPointsGbp?: Maybe<Scalars['Float']>;
};

export type ReportingHighestSavingPerk = {
  __typename?: 'ReportingHighestSavingPerk';
  deal?: Maybe<Deal>;
  estimatedSavingsAUD?: Maybe<Scalars['Float']>;
  estimatedSavingsGBP?: Maybe<Scalars['Float']>;
  savingsAUD?: Maybe<Scalars['Float']>;
  savingsGBP?: Maybe<Scalars['Float']>;
  savingsPercentage?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type ReportingHighestSavingPerks = {
  __typename?: 'ReportingHighestSavingPerks';
  flexi?: Maybe<Array<Maybe<ReportingHighestSavingPerk>>>;
  perks?: Maybe<Array<Maybe<ReportingHighestSavingPerk>>>;
};

export type ReportingOverview = {
  __typename?: 'ReportingOverview';
  activated?: Maybe<Scalars['Float']>;
  activatedUsers?: Maybe<Scalars['Float']>;
  regions?: Maybe<Scalars['Float']>;
  teams?: Maybe<Scalars['Float']>;
  unspentFlexiPointsAud?: Maybe<Scalars['Float']>;
  unspentFlexiPointsGbp?: Maybe<Scalars['Float']>;
  users?: Maybe<Scalars['Float']>;
};

export type ReportingRecognition = {
  __typename?: 'ReportingRecognition';
  topGivingUser?: Maybe<ReportingRecognitionUser>;
  topReceivedUser?: Maybe<ReportingRecognitionUser>;
  totalRecognitions?: Maybe<Scalars['Int']>;
};

export type ReportingRecognitionUser = {
  __typename?: 'ReportingRecognitionUser';
  total?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export const ReportingTeamState = {
  BillingUnit: 'BILLING_UNIT',
  Generic: 'GENERIC',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ReportingTeamState = typeof ReportingTeamState[keyof typeof ReportingTeamState];
export type ReportingValuesAndCelebrations = {
  __typename?: 'ReportingValuesAndCelebrations';
  topCelebration?: Maybe<Celebration>;
  topValues?: Maybe<Array<Maybe<CompanyValue>>>;
  totalCelebrations?: Maybe<Scalars['Int']>;
  totalValues?: Maybe<Scalars['Int']>;
};

export type ReportingWellness = {
  __typename?: 'ReportingWellness';
  categories: Array<ReportingWellnessCategory>;
  categoriesWatched?: Maybe<Scalars['Int']>;
};

export type ReportingWellnessCategory = {
  __typename?: 'ReportingWellnessCategory';
  category?: Maybe<WellnessMediaCategory>;
  uuid: Scalars['ID'];
};

export type RequestPaymentDetails = {
  billingAddress?: InputMaybe<RequestPaymentDetailsBillingAddress>;
  cardId?: InputMaybe<Scalars['ID']>;
  cvv?: InputMaybe<Scalars['String']>;
  deviceSessionId?: InputMaybe<Scalars['ID']>;
  paymentContextId?: InputMaybe<Scalars['ID']>;
  rememberCard?: InputMaybe<Scalars['Boolean']>;
  resURL?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['ID']>;
};

export type RequestPaymentDetailsBillingAddress = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type RequestPaymentInput = {
  amount: Scalars['Int'];
  currency: PaymentCurrencyType;
  details: RequestPaymentDetails;
  paymentOrderId: Scalars['ID'];
};

export type RequestPointsInput = {
  amount: Scalars['Int'];
  approver: Scalars['ID'];
  budgetCategory: Scalars['ID'];
  reason: Scalars['String'];
};

export type ResumeLogin = {
  __typename?: 'ResumeLogin';
  business?: Maybe<Business>;
  productPermissions?: Maybe<ProductPermissions>;
  session?: Maybe<Session>;
  user?: Maybe<User>;
  userOnboarding?: Maybe<UserOnboarding>;
};

export type Reward = {
  __typename?: 'Reward';
  address?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  barcode?: Maybe<Scalars['String']>;
  barcodeUrl?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  companyValues?: Maybe<CompanyValueList>;
  created_at?: Maybe<Scalars['String']>;
  custom?: Maybe<Scalars['Boolean']>;
  desc?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  employee_id?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  howToRedeem?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
  legacy?: Maybe<Scalars['Boolean']>;
  packageRewardId?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentType>;
  recipient?: Maybe<User>;
  recipients?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  webImage?: Maybe<Scalars['String']>;
};

export type RewardAndPaymentOrders = {
  __typename?: 'RewardAndPaymentOrders';
  paymentOrder?: Maybe<PaymentOrder>;
  rewardOrder?: Maybe<RewardOrder>;
};

export type RewardBasket = {
  custom?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  recipientUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  recognitionTeamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rewardId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};

export type RewardCatalogueProduct = {
  __typename?: 'RewardCatalogueProduct';
  currency?: Maybe<Scalars['String']>;
  /** @deprecated Use 'product.name'. */
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']>;
  rewardCatalogueProductId?: Maybe<Scalars['String']>;
  /** @deprecated Use 'product.supplier'. */
  supplier?: Maybe<Scalars['String']>;
  /** @deprecated Use 'product.type'. */
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity RewardCatalogueProduct. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardCatalogueProductList = {
  __typename?: 'RewardCatalogueProductList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RewardCatalogueProduct>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardCatalogueReward = {
  __typename?: 'RewardCatalogueReward';
  archived?: Maybe<Scalars['Boolean']>;
  bannerImage?: Maybe<Scalars['String']>;
  cardImage?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  deliveryInfo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  importantInfo?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalIdentifier?: Maybe<Scalars['String']>;
  isCredit?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  locale?: Maybe<Scalars['String']>;
  products?: Maybe<RewardCatalogueProductList>;
  redemptionInstructions?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  termsAndConditions?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  urlSlug?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity RewardCatalogueReward. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardCatalogueRewardList = {
  __typename?: 'RewardCatalogueRewardList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RewardCatalogueReward>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardInput = {
  alt: Scalars['String'];
  desc: Scalars['String'];
  href: Scalars['String'];
  isCustom?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Paginated List for entity Reward. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardList = {
  __typename?: 'RewardList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Reward>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardOrder = {
  __typename?: 'RewardOrder';
  archived?: Maybe<Scalars['Boolean']>;
  companyValues?: Maybe<Array<Maybe<Scalars['String']>>>;
  costPerUnit?: Maybe<RewardOrderCost>;
  costTotal?: Maybe<RewardOrderCost>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  created_at?: Maybe<Scalars['String']>;
  custom?: Maybe<Scalars['String']>;
  everyone?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  occasionId?: Maybe<Scalars['String']>;
  paymentOrder?: Maybe<PaymentOrder>;
  paymentOrderId?: Maybe<Scalars['String']>;
  poll?: Maybe<Poll>;
  product?: Maybe<RewardCatalogueProduct>;
  productId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  recipientIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  recipients?: Maybe<UserList>;
  recognition?: Maybe<Recognition>;
  reward?: Maybe<RewardCatalogueReward>;
  rewardId?: Maybe<Scalars['String']>;
  rewards?: Maybe<Array<Maybe<Reward>>>;
  sender?: Maybe<User>;
  sender_email?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  teamIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  teams?: Maybe<TeamList>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['String']>;
};

export type RewardOrderCost = {
  __typename?: 'RewardOrderCost';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity RewardOrder. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardOrderList = {
  __typename?: 'RewardOrderList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RewardOrder>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardPackage = {
  __typename?: 'RewardPackage';
  locale: Scalars['String'];
  name: Scalars['String'];
  paymentCountryCode: Scalars['String'];
  region: Scalars['String'];
  rewardCategory: Tag;
  rewardCategoryId: Scalars['ID'];
  uuid: Scalars['ID'];
};

/**
 * Paginated List for entity RewardPackage. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardPackageList = {
  __typename?: 'RewardPackageList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RewardPackage>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardPaymentOrder = {
  __typename?: 'RewardPaymentOrder';
  paymentOrder?: Maybe<PaymentOrder>;
  paymentOrderId?: Maybe<Scalars['String']>;
};

export type RewardRedemption = {
  __typename?: 'RewardRedemption';
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  custom?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  recipient?: Maybe<User>;
  recipientUserId?: Maybe<Scalars['String']>;
  rewardOrder?: Maybe<RewardOrder>;
  status?: Maybe<Scalars['String']>;
  stock?: Maybe<RewardStock>;
  stockId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity RewardRedemption. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardRedemptionList = {
  __typename?: 'RewardRedemptionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RewardRedemption>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardStock = {
  __typename?: 'RewardStock';
  code?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type RewardWallet = {
  __typename?: 'RewardWallet';
  availableBalance?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  ownerUuid?: Maybe<Scalars['String']>;
  scheduledInBalance?: Maybe<Scalars['Float']>;
  scheduledOutBalance?: Maybe<Scalars['Float']>;
  tenantUuid?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  walletOwners?: Maybe<Array<Maybe<Scalars['String']>>>;
  walletUuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity RewardWallet. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardWalletList = {
  __typename?: 'RewardWalletList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RewardWallet>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardWalletReport = {
  __typename?: 'RewardWalletReport';
  given?: Maybe<Scalars['Int']>;
  spent?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  value?: Maybe<Scalars['Float']>;
  walletTypeId?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity RewardWalletReport. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardWalletReportList = {
  __typename?: 'RewardWalletReportList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RewardWalletReport>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardWalletTotal = {
  __typename?: 'RewardWalletTotal';
  currency?: Maybe<Scalars['String']>;
  given?: Maybe<Scalars['Float']>;
  spent?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  walletTypeId?: Maybe<Scalars['String']>;
};


export type RewardWalletTotalGivenArgs = {
  maxDate?: InputMaybe<Scalars['String']>;
  minDate?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  walletTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RewardWalletTotalSpentArgs = {
  maxDate?: InputMaybe<Scalars['String']>;
  minDate?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  walletTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Paginated List for entity RewardWalletTotal. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardWalletTotalList = {
  __typename?: 'RewardWalletTotalList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RewardWalletTotal>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

/**
 * Paginated List for entity AdvancedBudget. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use offset based pagination
 */
export type RewardWalletWithBudgets = {
  __typename?: 'RewardWalletWithBudgets';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<AdvancedBudget>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardsLane = {
  __typename?: 'RewardsLane';
  rewards?: Maybe<Array<Maybe<RewardCatalogueReward>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  type?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity RewardsLane. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type RewardsLaneList = {
  __typename?: 'RewardsLaneList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<RewardsLane>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type RewardsReportUrl = {
  __typename?: 'RewardsReportUrl';
  reportFileUrl?: Maybe<Scalars['String']>;
};

export type RewardsReportingUrl = {
  __typename?: 'RewardsReportingUrl';
  reportFileUrl?: Maybe<Scalars['String']>;
};

export type Rockstar = {
  __typename?: 'Rockstar';
  engagementRate?: Maybe<Scalars['Float']>;
  totalSavingsAud?: Maybe<Scalars['Float']>;
  totalSavingsGbp?: Maybe<Scalars['Float']>;
};

export type Role = {
  __typename?: 'Role';
  businessId?: Maybe<Scalars['String']>;
  featureFlags?: Maybe<Array<Maybe<Scalars['String']>>>;
  metadata?: Maybe<Array<Maybe<Metadata>>>;
  roleName?: Maybe<Scalars['String']>;
  roleType?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type SalaryBracket = {
  __typename?: 'SalaryBracket';
  description: Scalars['String'];
  id: Scalars['ID'];
  rate?: Maybe<Scalars['String']>;
};

export type SalsacBenefitDeduction = {
  __typename?: 'SalsacBenefitDeduction';
  benefitId: Scalars['ID'];
  deductionType: Scalars['String'];
};

export type SalsacBenefitDeductionTypeInput = {
  benefitId: Scalars['ID'];
  deductionType: Scalars['String'];
};

export type SalsacBenefitDeductionTypesInput = {
  benefitId: Scalars['ID'];
  deductionTypes: Array<Scalars['String']>;
};

export type SalsacBenefitLimitation = {
  __typename?: 'SalsacBenefitLimitation';
  benefitCountLimit?: Maybe<Scalars['Int']>;
  benefitId?: Maybe<Scalars['ID']>;
  benefitPercentageLimit?: Maybe<Scalars['Float']>;
  benefitValueLimit?: Maybe<Scalars['Float']>;
  businessId: Scalars['ID'];
  deductionType?: Maybe<SalsacDeduction>;
  disabled?: Maybe<Scalars['Boolean']>;
  higherLower?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Metadata>;
  minimumOrderLimit?: Maybe<Scalars['Float']>;
  nmwCheckDisabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use benefitId instead */
  schemeTypeId?: Maybe<Scalars['ID']>;
};

export type SalsacBenefitLimitationInput = {
  benefitCountLimit?: InputMaybe<Scalars['Int']>;
  benefitId?: InputMaybe<Scalars['ID']>;
  benefitPercentageLimit?: InputMaybe<Scalars['Float']>;
  benefitValueLimit?: InputMaybe<Scalars['Float']>;
  businessId: Scalars['ID'];
  deductionType?: InputMaybe<SalsacDeduction>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  higherLower?: InputMaybe<Scalars['Int']>;
  minimumOrderLimit?: InputMaybe<Scalars['Float']>;
  nmwCheckDisabled?: InputMaybe<Scalars['Boolean']>;
  schemeTypeId?: InputMaybe<Scalars['ID']>;
};

export type SalsacBusinessBenefitLimitation = {
  __typename?: 'SalsacBusinessBenefitLimitation';
  activeOrderCountLimit?: Maybe<Scalars['Int']>;
  businessId: Scalars['ID'];
  higherLower?: Maybe<Scalars['Int']>;
  limitCtw?: Maybe<Scalars['Boolean']>;
  limitationType: SalsacLimitation;
  metadata?: Maybe<Metadata>;
  minimumOrderLimit?: Maybe<Scalars['Float']>;
  percentageLimit?: Maybe<Scalars['Float']>;
  reducingBalance?: Maybe<Scalars['Boolean']>;
  valueLimit?: Maybe<Scalars['Float']>;
};

export type SalsacBusinessBenefitLimitationInput = {
  activeOrderCountLimit?: InputMaybe<Scalars['Int']>;
  businessId: Scalars['ID'];
  higherLower?: InputMaybe<Scalars['Int']>;
  limitCtw?: InputMaybe<Scalars['Boolean']>;
  limitationType: SalsacLimitation;
  minimumOrderLimit?: InputMaybe<Scalars['Float']>;
  percentageLimit?: InputMaybe<Scalars['Float']>;
  reducingBalance?: InputMaybe<Scalars['Boolean']>;
  valueLimit?: InputMaybe<Scalars['Float']>;
};

export type SalsacCheckEligibilityResponse = {
  __typename?: 'SalsacCheckEligibilityResponse';
  deductionType?: Maybe<Scalars['String']>;
};

export const SalsacDeduction = {
  DeductionTypeNetPay: 'DEDUCTION_TYPE_NET_PAY',
  DeductionTypeSalarySacrifice: 'DEDUCTION_TYPE_SALARY_SACRIFICE'
} as const;

export type SalsacDeduction = typeof SalsacDeduction[keyof typeof SalsacDeduction];
export type SalsacDeductionTypeMap = {
  __typename?: 'SalsacDeductionTypeMap';
  benefitId: Scalars['ID'];
  deductionType: Scalars['String'];
};

export type SalsacDeductionTypeRankings = {
  __typename?: 'SalsacDeductionTypeRankings';
  benefitId: Scalars['ID'];
  rankings: Array<SalsacRankingMap>;
};

export type SalsacDeductionTypeRankingsInput = {
  benefitId: Scalars['ID'];
  rankings: Array<SalsacRankingInput>;
};

export type SalsacIneligibilityCriteria = {
  __typename?: 'SalsacIneligibilityCriteria';
  jobGrades: Array<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  probation: Scalars['Boolean'];
};

export type SalsacIneligibilityCriteriaInput = {
  jobGrades: Array<Scalars['String']>;
  probation: Scalars['Boolean'];
};

export type SalsacIneligibilityRule = {
  __typename?: 'SalsacIneligibilityRule';
  disabled: Scalars['Boolean'];
  jobGrades: Array<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  probation: Scalars['Boolean'];
  uuid: Scalars['ID'];
};

export type SalsacIneligibilityRuleInput = {
  disabled: Scalars['Boolean'];
  jobGrades: Array<Scalars['String']>;
  probation: Scalars['Boolean'];
  uuid?: InputMaybe<Scalars['ID']>;
};

export type SalsacIneligibilityRuleSet = {
  __typename?: 'SalsacIneligibilityRuleSet';
  benefitDeductionTypes: Array<SalsacBenefitDeduction>;
  rule: SalsacIneligibilityRule;
};

export type SalsacIneligibilityRuleSetInput = {
  benefitDeductionTypes: Array<SalsacBenefitDeductionTypeInput>;
  rule: SalsacIneligibilityRuleInput;
};

export type SalsacJobGradeUsageCount = {
  __typename?: 'SalsacJobGradeUsageCount';
  rulesCount: Scalars['Int'];
  usersCount: Scalars['Int'];
};

export const SalsacLimitation = {
  LimitationTypeBenefitLimitsOnly: 'LIMITATION_TYPE_BENEFIT_LIMITS_ONLY',
  LimitationTypeCombinedOrderLimit: 'LIMITATION_TYPE_COMBINED_ORDER_LIMIT',
  LimitationTypeUnknown: 'LIMITATION_TYPE_UNKNOWN'
} as const;

export type SalsacLimitation = typeof SalsacLimitation[keyof typeof SalsacLimitation];
export type SalsacMissingCriterionDataCount = {
  __typename?: 'SalsacMissingCriterionDataCount';
  jobGradesCount: Scalars['Int'];
  probationCount: Scalars['Int'];
};

export type SalsacOrderEligibilityNotification = {
  __typename?: 'SalsacOrderEligibilityNotification';
  businessId: Scalars['ID'];
  metadata?: Maybe<Metadata>;
  notificationDeliveryDate?: Maybe<Scalars['String']>;
  notificationSentAt?: Maybe<Scalars['String']>;
  notificationType: Scalars['String'];
  pushNotificationSentAt?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type SalsacOrderEligibilityNotificationInput = {
  businessId: Scalars['ID'];
  notificationDeliveryDate?: InputMaybe<Scalars['String']>;
  notificationSentAt?: InputMaybe<Scalars['String']>;
  notificationType: Scalars['String'];
  pushNotificationSentAt?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type SalsacRankingInput = {
  deductionType: Scalars['String'];
  ranking: Scalars['Int'];
};

export type SalsacRankingMap = {
  __typename?: 'SalsacRankingMap';
  deductionType: Scalars['String'];
  ranking: Scalars['Int'];
};

export type SalsacUserBusinessDetail = {
  __typename?: 'SalsacUserBusinessDetail';
  annualGrossSalary?: Maybe<Scalars['Float']>;
  businessId: Scalars['ID'];
  existingSalarySacrificeExternal?: Maybe<Scalars['Float']>;
  hoursAddedByEmployer?: Maybe<Scalars['Boolean']>;
  hoursPerWeek?: Maybe<Scalars['Float']>;
  jobGrade?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  probationEndDate?: Maybe<Scalars['String']>;
  salaryAddedByEmployer?: Maybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type SalsacUserBusinessDetailInput = {
  annualGrossSalary?: InputMaybe<Scalars['Float']>;
  businessId: Scalars['ID'];
  existingSalarySacrificeExternal?: InputMaybe<Scalars['Float']>;
  hoursAddedByEmployer?: InputMaybe<Scalars['Boolean']>;
  hoursPerWeek?: InputMaybe<Scalars['Float']>;
  jobGrade?: InputMaybe<Scalars['String']>;
  probationEndDate?: InputMaybe<Scalars['String']>;
  salaryAddedByEmployer?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type SavedCard = {
  __typename?: 'SavedCard';
  create_date?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['Int']>;
  expiryYear?: Maybe<Scalars['Int']>;
  holderName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity SavedCard. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type SavedCardList = {
  __typename?: 'SavedCardList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<SavedCard>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type SavingCalculatorData = {
  __typename?: 'SavingCalculatorData';
  employeeOrganisation?: Maybe<SavingsCalculatorEmployeeOrganization>;
};

export type SavingsCalculator = {
  __typename?: 'SavingsCalculator';
  calculatedResult?: Maybe<SavingsCalculatorResult>;
};

export type SavingsCalculatorDealBrand = {
  __typename?: 'SavingsCalculatorDealBrand';
  dealSlug?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  img: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type SavingsCalculatorEmployeeOrganization = {
  __typename?: 'SavingsCalculatorEmployeeOrganization';
  id?: Maybe<Scalars['ID']>;
  scheme?: Maybe<SavingsCalculatorScheme>;
};

export type SavingsCalculatorResult = {
  __typename?: 'SavingsCalculatorResult';
  costOfQuote?: Maybe<Scalars['String']>;
  endOfAgreementFee?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  monthlyCostToYou?: Maybe<Scalars['String']>;
  roundingCharges?: Maybe<Scalars['String']>;
  salarySacrifice?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['String']>;
};

export type SavingsCalculatorScheme = {
  __typename?: 'SavingsCalculatorScheme';
  savingsCalculator?: Maybe<SavingsCalculator>;
};

export const ScheduledRecognitionSource = {
  MicrosoftTeams: 'MICROSOFT_TEAMS',
  Perkbox: 'PERKBOX',
  SchedulerApp: 'SCHEDULER_APP',
  SourceUnknown: 'SOURCE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ScheduledRecognitionSource = typeof ScheduledRecognitionSource[keyof typeof ScheduledRecognitionSource];
/**
 * A Scheduler timestamp, expected to be used when a service is returning partial data from the Scheduler.
 * The intention is to then parse this on the frontend with a time parsing library such as moment-timezone, e.g
 * ```
 *   const {when, originalTimezone} = data.scheduledFor
 *   const timestamp = momentTZ.tz(when, originalTimezone).toISOString()
 * ```
 */
export type ScheduledTime = {
  __typename?: 'ScheduledTime';
  originalTimezone: Scalars['String'];
  when: Scalars['String'];
};

export type ScheduledTransfer = {
  __typename?: 'ScheduledTransfer';
  amount?: Maybe<Scalars['Float']>;
  captureAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  destinationWallet?: Maybe<Scalars['String']>;
  perksGO?: Maybe<PerksGo>;
  sourceWallet?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity ScheduledTransfer. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type ScheduledTransferList = {
  __typename?: 'ScheduledTransferList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<ScheduledTransfer>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const ScheduledTransferStatus = {
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  Failing: 'FAILING',
  NotActivated: 'NOT_ACTIVATED',
  Pending: 'PENDING'
} as const;

export type ScheduledTransferStatus = typeof ScheduledTransferStatus[keyof typeof ScheduledTransferStatus];
export type SchedulerCreateSystemEvent = {
  entityId: Scalars['ID'];
  entityType?: InputMaybe<SchedulerEntityType>;
  originalTimezone?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<SchedulerCreateSystemEventPayload>;
  repeat?: InputMaybe<SchedulerEventRepeating>;
  when?: InputMaybe<Scalars['String']>;
};

export type SchedulerCreateSystemEventPayload = {
  boostedDiscountChange?: InputMaybe<SchedulerEventBoostedDiscountChange>;
  dealStatusChange?: InputMaybe<SchedulerEventDealStatusChange>;
  tagChange?: InputMaybe<SchedulerEventTagChange>;
};

export const SchedulerEntityType = {
  DealAction: 'DEAL_ACTION',
  EntityTypeUnknown: 'ENTITY_TYPE_UNKNOWN',
  GroupRecognition: 'GROUP_RECOGNITION',
  RecognitionPoll: 'RECOGNITION_POLL',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SchedulerEntityType = typeof SchedulerEntityType[keyof typeof SchedulerEntityType];
/** A Scheduler event, as returned from the Scheduler */
export type SchedulerEvent = {
  __typename?: 'SchedulerEvent';
  businessId: Scalars['ID'];
  createdBy?: Maybe<User>;
  eventData: Scalars['String'];
  eventName: Scalars['String'];
  metadata?: Maybe<Metadata>;
  originalTimezone?: Maybe<Scalars['String']>;
  payload?: Maybe<SchedulerEventPayload>;
  publishedAt: Array<Scalars['String']>;
  remindedAt: Array<Scalars['String']>;
  reminder?: Maybe<SchedulerReminder>;
  reminderTtl?: Maybe<Scalars['Int']>;
  repeat: SchedulerEventRepeating;
  status: SchedulerEventStatus;
  ttl: Scalars['Int'];
  userId: Scalars['ID'];
  uuid: Scalars['ID'];
  when: Scalars['String'];
};

export type SchedulerEventBoostedDiscountChange = {
  discount?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<SchedulerEventDealBoostedDiscountChangeStatus>;
};

export const SchedulerEventDealBoostedDiscountChangeStatus = {
  StatusOff: 'STATUS_OFF',
  StatusOn: 'STATUS_ON',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SchedulerEventDealBoostedDiscountChangeStatus = typeof SchedulerEventDealBoostedDiscountChangeStatus[keyof typeof SchedulerEventDealBoostedDiscountChangeStatus];
export type SchedulerEventDealStatusChange = {
  status?: InputMaybe<SchedulerEventDealStatusChangeStatus>;
};

export const SchedulerEventDealStatusChangeStatus = {
  StatusOff: 'STATUS_OFF',
  StatusOn: 'STATUS_ON',
  StatusUnavailable: 'STATUS_UNAVAILABLE',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SchedulerEventDealStatusChangeStatus = typeof SchedulerEventDealStatusChangeStatus[keyof typeof SchedulerEventDealStatusChangeStatus];
export const SchedulerEventDealTagChangeStatus = {
  StatusOff: 'STATUS_OFF',
  StatusOn: 'STATUS_ON',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SchedulerEventDealTagChangeStatus = typeof SchedulerEventDealTagChangeStatus[keyof typeof SchedulerEventDealTagChangeStatus];
/**
 * Paginated List for entity SchedulerEvent. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type SchedulerEventList = {
  __typename?: 'SchedulerEventList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<SchedulerEvent>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type SchedulerEventPayload = {
  __typename?: 'SchedulerEventPayload';
  publishRecognition?: Maybe<SchedulerEventPublishRecognition>;
};

export type SchedulerEventPublishRecognition = {
  __typename?: 'SchedulerEventPublishRecognition';
  budget?: Maybe<BudgetCategory>;
  companyValueIds?: Maybe<Array<Scalars['ID']>>;
  companyValues?: Maybe<Array<Maybe<CompanyValue>>>;
  customRewardId?: Maybe<Scalars['String']>;
  isEveryone?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  occasion?: Maybe<Occasion>;
  occasionId?: Maybe<Scalars['ID']>;
  receiverIds?: Maybe<Array<Scalars['ID']>>;
  receivers: Array<User>;
  recognitionId?: Maybe<Scalars['ID']>;
  rewardAmount?: Maybe<Scalars['Int']>;
  source?: Maybe<ScheduledRecognitionSource>;
  visibility?: Maybe<SchedulerEventPublishRecognitionVisibility>;
};

export const SchedulerEventPublishRecognitionVisibility = {
  Everyone: 'EVERYONE',
  Private: 'PRIVATE',
  Teams: 'TEAMS',
  Unrecognized: 'UNRECOGNIZED',
  VisibilityUnknown: 'VISIBILITY_UNKNOWN'
} as const;

export type SchedulerEventPublishRecognitionVisibility = typeof SchedulerEventPublishRecognitionVisibility[keyof typeof SchedulerEventPublishRecognitionVisibility];
export const SchedulerEventRepeating = {
  BiWeekly: 'BI_WEEKLY',
  Daily: 'DAILY',
  Monthly: 'MONTHLY',
  None: 'NONE',
  RepeatingUnknown: 'REPEATING_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED',
  Weekly: 'WEEKLY',
  Yearly: 'YEARLY'
} as const;

export type SchedulerEventRepeating = typeof SchedulerEventRepeating[keyof typeof SchedulerEventRepeating];
export const SchedulerEventStatus = {
  Active: 'ACTIVE',
  Canceled: 'CANCELED',
  Failed: 'FAILED',
  Published: 'PUBLISHED',
  StatusUnknown: 'STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SchedulerEventStatus = typeof SchedulerEventStatus[keyof typeof SchedulerEventStatus];
export type SchedulerEventTagChange = {
  status?: InputMaybe<SchedulerEventDealTagChangeStatus>;
  tagId?: InputMaybe<Scalars['ID']>;
};

export type SchedulerModifyEvent = {
  repeat?: InputMaybe<SchedulerEventRepeating>;
  uuid: Scalars['ID'];
  when?: InputMaybe<Scalars['String']>;
};

export type SchedulerModifySystemEvent = {
  repeat?: InputMaybe<SchedulerEventRepeating>;
  uuid: Scalars['ID'];
  when?: InputMaybe<Scalars['String']>;
};

export type SchedulerReminder = {
  __typename?: 'SchedulerReminder';
  amount?: Maybe<Scalars['Int']>;
  unit?: Maybe<SchedulerReminderUnit>;
};

export const SchedulerReminderUnit = {
  Day: 'DAY',
  Hour: 'HOUR',
  Minute: 'MINUTE',
  Month: 'MONTH',
  UnitUnknown: 'UNIT_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SchedulerReminderUnit = typeof SchedulerReminderUnit[keyof typeof SchedulerReminderUnit];
export type SchedulerSystemEvent = {
  __typename?: 'SchedulerSystemEvent';
  entityId: Scalars['ID'];
  entityType: Scalars['ID'];
  eventData: Scalars['String'];
  eventName: Scalars['String'];
  metadata?: Maybe<Metadata>;
  publishedAt: Array<Scalars['String']>;
  remindedAt: Array<Scalars['String']>;
  reminder?: Maybe<SchedulerReminder>;
  reminderTtl?: Maybe<Scalars['Int']>;
  repeat: SchedulerEventRepeating;
  status: SchedulerEventStatus;
  ttl: Scalars['Int'];
  uuid: Scalars['ID'];
  when: Scalars['String'];
};

/**
 * Paginated List for entity SchedulerSystemEvent. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type SchedulerSystemEventList = {
  __typename?: 'SchedulerSystemEventList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<SchedulerSystemEvent>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type SchemeDeductionTypes = {
  __typename?: 'SchemeDeductionTypes';
  deductionTypes: Array<Scalars['String']>;
};

export type Score = {
  __typename?: 'Score';
  calculatedScore: Scalars['Int'];
  completedAt: Scalars['String'];
  metadata?: Maybe<Metadata>;
  questionnaireId: Scalars['ID'];
  secretId: Scalars['String'];
  tenantId: Scalars['String'];
  uuid: Scalars['ID'];
};

export const ScoreStrategy = {
  ScoreStrategyTypeBurnout: 'SCORE_STRATEGY_TYPE_BURNOUT',
  ScoreStrategyTypeUnknown: 'SCORE_STRATEGY_TYPE_UNKNOWN',
  ScoreStrategyTypeWellbeing: 'SCORE_STRATEGY_TYPE_WELLBEING'
} as const;

export type ScoreStrategy = typeof ScoreStrategy[keyof typeof ScoreStrategy];
export type SelfRegistrationAttributesInput = {
  codeType: SelfRegistrationCodeType;
};

export type SelfRegistrationCode = {
  __typename?: 'SelfRegistrationCode';
  businessId: Scalars['ID'];
  code?: Maybe<Scalars['String']>;
  codeType: SelfRegistrationCodeType;
  metadata?: Maybe<Metadata>;
  registeredUser?: Maybe<User>;
  status?: Maybe<SelfRegistrationStatus>;
  uuid: Scalars['ID'];
};

export type SelfRegistrationCodeResponse = {
  __typename?: 'SelfRegistrationCodeResponse';
  code?: Maybe<SelfRegistrationCode>;
};

export const SelfRegistrationCodeType = {
  CodeTypeAssignmentId: 'CODE_TYPE_ASSIGNMENT_ID',
  CodeTypeEmployeeId: 'CODE_TYPE_EMPLOYEE_ID',
  CodeTypeMembershipId: 'CODE_TYPE_MEMBERSHIP_ID',
  CodeTypePayrollNumber: 'CODE_TYPE_PAYROLL_NUMBER',
  CodeTypeUnknown: 'CODE_TYPE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SelfRegistrationCodeType = typeof SelfRegistrationCodeType[keyof typeof SelfRegistrationCodeType];
export const SelfRegistrationStatus = {
  RegistrationStatusNotRegistered: 'REGISTRATION_STATUS_NOT_REGISTERED',
  RegistrationStatusRegistered: 'REGISTRATION_STATUS_REGISTERED',
  RegistrationStatusUnknown: 'REGISTRATION_STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SelfRegistrationStatus = typeof SelfRegistrationStatus[keyof typeof SelfRegistrationStatus];
export type SendCreditAsRewardTransfer = {
  __typename?: 'SendCreditAsRewardTransfer';
  order_id?: Maybe<Scalars['String']>;
  recipientUserId?: Maybe<Scalars['String']>;
  recipient_user_id?: Maybe<Scalars['String']>;
  rewardOrder?: Maybe<RewardOrder>;
  rewardOrderId?: Maybe<Scalars['String']>;
  rewards_wallet_id?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
};

export type SendCreditTransfer = {
  __typename?: 'SendCreditTransfer';
  recipient?: Maybe<User>;
  sender?: Maybe<User>;
};

export type ServiceFeeCharge = {
  __typename?: 'ServiceFeeCharge';
  appliedFee?: Maybe<Scalars['Float']>;
  baseFee?: Maybe<Scalars['Float']>;
};

export type Session = {
  __typename?: 'Session';
  businessId: Scalars['ID'];
  featureFlagSource: Array<SessionFeatureFlagSource>;
  featureFlags: Array<Scalars['String']>;
  lastMFATime?: Maybe<Scalars['String']>;
  sessionType: SessionType;
  teamAssignments: Array<SessionTeamAssignment>;
  userId: Scalars['ID'];
  uuid: Scalars['ID'];
};

export type SessionFeatureFlagSource = {
  __typename?: 'SessionFeatureFlagSource';
  featureFlag: Scalars['String'];
  resourceId: Scalars['ID'];
};

export type SessionTeamAssignment = {
  __typename?: 'SessionTeamAssignment';
  role: Scalars['String'];
  teamId: Scalars['ID'];
};

export const SessionType = {
  GhostSession: 'GhostSession',
  IAdminSession: 'IAdminSession',
  ServiceToService: 'ServiceToService',
  Unrecognized: 'UNRECOGNIZED',
  UserSession: 'UserSession'
} as const;

export type SessionType = typeof SessionType[keyof typeof SessionType];
export type SetSalaryBracketInput = {
  payrollFrequency: Scalars['String'];
  salaryBracketId: Scalars['ID'];
};

export type SetSalaryBracketPayload = {
  __typename?: 'SetSalaryBracketPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  salaryBracketId?: Maybe<Scalars['ID']>;
};

export type SignUp = {
  __typename?: 'SignUp';
  companyCheck?: Maybe<CompanyCheck>;
  enquiry: Enquiry;
  expiry: Scalars['Int'];
  individualChecks: Array<Maybe<IndividualCheck>>;
  stage: SignUpStage;
  status: SignUpStatus;
  uuid: Scalars['String'];
};

export const SignUpBillingPeriod = {
  BillingPeriodMonthly: 'BILLING_PERIOD_MONTHLY',
  BillingPeriodQuarterly: 'BILLING_PERIOD_QUARTERLY',
  BillingPeriodUnknown: 'BILLING_PERIOD_UNKNOWN'
} as const;

export type SignUpBillingPeriod = typeof SignUpBillingPeriod[keyof typeof SignUpBillingPeriod];
export type SignUpOutcome = {
  __typename?: 'SignUpOutcome';
  alerts: Array<Maybe<SignUpOutcomeAlert>>;
  indicator: SignUpOutcomeIndicator;
  score: Scalars['Int'];
};

export type SignUpOutcomeAlert = {
  __typename?: 'SignUpOutcomeAlert';
  message: Scalars['String'];
  severity: Scalars['String'];
};

export const SignUpOutcomeIndicator = {
  CheckIndicatorAmber: 'CHECK_INDICATOR_AMBER',
  CheckIndicatorGreen: 'CHECK_INDICATOR_GREEN',
  CheckIndicatorRed: 'CHECK_INDICATOR_RED',
  CheckIndicatorUnknown: 'CHECK_INDICATOR_UNKNOWN',
  CheckIndicatorWaiting: 'CHECK_INDICATOR_WAITING',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SignUpOutcomeIndicator = typeof SignUpOutcomeIndicator[keyof typeof SignUpOutcomeIndicator];
export type SignUpPaymentInput = {
  paymentMethod: SignUpPaymentMethodType;
  paymentMethodId: Scalars['String'];
  signature: Scalars['String'];
};

export const SignUpPaymentMethodType = {
  PaymentMethodCreditCard: 'PAYMENT_METHOD_CREDIT_CARD',
  PaymentMethodDirectDebit: 'PAYMENT_METHOD_DIRECT_DEBIT'
} as const;

export type SignUpPaymentMethodType = typeof SignUpPaymentMethodType[keyof typeof SignUpPaymentMethodType];
export const SignUpProvisioningPeriod = {
  ProvisioningPeriodMonthly: 'PROVISIONING_PERIOD_MONTHLY',
  ProvisioningPeriodQuarterly: 'PROVISIONING_PERIOD_QUARTERLY',
  ProvisioningPeriodUnknown: 'PROVISIONING_PERIOD_UNKNOWN'
} as const;

export type SignUpProvisioningPeriod = typeof SignUpProvisioningPeriod[keyof typeof SignUpProvisioningPeriod];
export type SignUpQuote = {
  __typename?: 'SignUpQuote';
  currency: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  options: Array<Maybe<SignUpQuoteOption>>;
};

export type SignUpQuoteOption = {
  __typename?: 'SignUpQuoteOption';
  billingPeriod: SignUpBillingPeriod;
  lengthOfContractInMonths: Scalars['Int'];
  pointsPerYear: Scalars['Int'];
  pricePerMonth: Scalars['Int'];
  provisioningPeriod: SignUpProvisioningPeriod;
  quoteId?: Maybe<Scalars['String']>;
};

export const SignUpStage = {
  SignUpStageCompany: 'SIGN_UP_STAGE_COMPANY',
  SignUpStageComplete: 'SIGN_UP_STAGE_COMPLETE',
  SignUpStageDetailsAndPackage: 'SIGN_UP_STAGE_DETAILS_AND_PACKAGE',
  SignUpStageIndividual: 'SIGN_UP_STAGE_INDIVIDUAL',
  SignUpStagePayment: 'SIGN_UP_STAGE_PAYMENT',
  SignUpStageTerms: 'SIGN_UP_STAGE_TERMS',
  SignUpStageUnknown: 'SIGN_UP_STAGE_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SignUpStage = typeof SignUpStage[keyof typeof SignUpStage];
export const SignUpStatus = {
  SignUpAccepted: 'SIGN_UP_ACCEPTED',
  SignUpArchived: 'SIGN_UP_ARCHIVED',
  SignUpError: 'SIGN_UP_ERROR',
  SignUpFailed: 'SIGN_UP_FAILED',
  SignUpManualInterventionRequired: 'SIGN_UP_MANUAL_INTERVENTION_REQUIRED',
  SignUpRejected: 'SIGN_UP_REJECTED',
  SignUpStatusDraft: 'SIGN_UP_STATUS_DRAFT',
  SignUpStatusOpen: 'SIGN_UP_STATUS_OPEN',
  SignUpStatusPending: 'SIGN_UP_STATUS_PENDING',
  SignUpStatusUnknown: 'SIGN_UP_STATUS_UNKNOWN',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type SignUpStatus = typeof SignUpStatus[keyof typeof SignUpStatus];
export type SlimDeal = {
  __typename?: 'SlimDeal';
  header?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  location?: Maybe<DealLocation>;
  savings?: Maybe<UserSaving>;
  thumbnailImage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  urlSlug?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity SlimDeal. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type SlimDealList = {
  __typename?: 'SlimDealList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<SlimDeal>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type SpendStatementItemTransfer = {
  __typename?: 'SpendStatementItemTransfer';
  dealHeader?: Maybe<Scalars['String']>;
  dealThumbnailImage?: Maybe<Scalars['String']>;
  orderTotal?: Maybe<SpendStatementItemTransferOrderTotal>;
  redemptionUuid?: Maybe<Scalars['String']>;
};

export type SpendStatementItemTransferOrderTotal = {
  __typename?: 'SpendStatementItemTransferOrderTotal';
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export type StartChangeEmailResponse = {
  __typename?: 'StartChangeEmailResponse';
  digits?: Maybe<Scalars['Int']>;
  expireAt?: Maybe<Date>;
  resendAt?: Maybe<Date>;
  uuid: Scalars['ID'];
};

export type StatementItem = {
  __typename?: 'StatementItem';
  availableBalance: Scalars['Float'];
  /** Text content for the given statement item */
  content?: Maybe<StatementItemContent>;
  transactionId?: Maybe<Scalars['ID']>;
  transactionType?: Maybe<TransactionType>;
  transfer?: Maybe<StatementItemTransfer>;
  uuid: Scalars['String'];
};

export type StatementItemContent = {
  __typename?: 'StatementItemContent';
  details?: Maybe<StatementItemInfo>;
  /** The image href to display for the statement item, special values "PERKBOX" and "BRAND" will display the appropriate company logo */
  image?: Maybe<Scalars['String']>;
  status: StatementItemStatusEnum;
  subTitle?: Maybe<StatementItemInfo>;
  title: StatementItemInfo;
  /**
   * The display type of the statement item, used to map the payload to a specific component
   * At this time there is only one, and this is intended to be used intead of StatementItem.transfer.type.
   * By keeping both, the UI can still debug the original transfer type from downstream.
   */
  type: Scalars['String'];
};

/**
 * Backend driven statment item info, this can then be consumed and rendered to produce
 * many different statement items without client code updates
 */
export type StatementItemInfo = {
  __typename?: 'StatementItemInfo';
  /** A list of keys from StatementItemInfo.values that should be converted to currency before passing into text */
  currencyKeys?: Maybe<Array<Scalars['String']>>;
  /** A list of keys from StatementItemInfo.values that should be converted to numbers before passing into text */
  numberKeys?: Maybe<Array<Scalars['String']>>;
  /** A CMS content key or plain text string */
  text: Scalars['String'];
  /**
   * A tuple of variables to be interpreted as part of the text string.
   * This means clients don't need to know all combinations of CMS keys and potential variables.
   * The intention is for this to be converted to an object in the client with something like `Object.fromEntries`
   */
  values?: Maybe<Array<Array<Scalars['String']>>>;
};

export type StatementItemLink = {
  __typename?: 'StatementItemLink';
  key: Scalars['String'];
  to: Scalars['String'];
};

/**
 * Paginated List for entity StatementItem. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type StatementItemList = {
  __typename?: 'StatementItemList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<StatementItem>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const StatementItemStatusEnum = {
  Cancelled: 'CANCELLED',
  Cleared: 'CLEARED',
  Expired: 'EXPIRED',
  Failed: 'FAILED',
  Pending: 'PENDING',
  RefundSpent: 'REFUND_SPENT',
  Reward: 'REWARD',
  RewardWalletCleared: 'REWARD_WALLET_CLEARED',
  RewardWalletSpent: 'REWARD_WALLET_SPENT',
  ScheduledSpend: 'SCHEDULED_SPEND',
  ScheduledTopup: 'SCHEDULED_TOPUP',
  Spent: 'SPENT',
  SpentRefund: 'SPENT_REFUND'
} as const;

export type StatementItemStatusEnum = typeof StatementItemStatusEnum[keyof typeof StatementItemStatusEnum];
export type StatementItemTransfer = {
  __typename?: 'StatementItemTransfer';
  amount: Scalars['Float'];
  createdAt: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  destinationIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  destinationWallet: Scalars['ID'];
  destinationWalletOwnerUuid: Scalars['ID'];
  manualCredit?: Maybe<ManualCreditStatementItemTransfer>;
  message?: Maybe<Scalars['String']>;
  perksGOCashback?: Maybe<PerksGoCashbackStatementItemTransfer>;
  refundToTenantWallet?: Maybe<RefundToTenantWalletTransfer>;
  rewardedUsers?: Maybe<Array<User>>;
  sendCredit?: Maybe<SendCreditTransfer>;
  sendCreditAsReward?: Maybe<SendCreditAsRewardTransfer>;
  sourceUser?: Maybe<User>;
  sourceWallet: Scalars['ID'];
  sourceWalletOwnerUuid: Scalars['ID'];
  spend?: Maybe<SpendStatementItemTransfer>;
  tenantWalletTransactionByWalletId?: Maybe<TenantWalletTransactionByWalletId>;
  /** @deprecated Use 'transactionDate' in perksGOCashback instead */
  transactionDate?: Maybe<Scalars['String']>;
  transferToRewardWallet?: Maybe<TransferToRewardWalletTransfer>;
  type?: Maybe<Scalars['String']>;
  useCreditToBuyReward?: Maybe<UseCreditToBuyRewardTransfer>;
  uuid: Scalars['ID'];
  walletType?: Maybe<Scalars['String']>;
};


export type StatementItemTransferTenantWalletTransactionByWalletIdArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
};

export type Stock = {
  __typename?: 'Stock';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  details?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  provider?: Maybe<Scalars['String']>;
  status?: Maybe<ProductStockStatus>;
  type?: Maybe<StockType>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  usage?: Maybe<StockUsage>;
  uuid?: Maybe<Scalars['String']>;
};

export type StockInput = {
  code: Scalars['String'];
  currency?: InputMaybe<Scalars['String']>;
  expiry?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
  type: StockType;
  usage: Scalars['String'];
  vat?: InputMaybe<Scalars['Int']>;
};

export type StockJob = {
  __typename?: 'StockJob';
  action?: Maybe<StockJobAction>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  newExpiry?: Maybe<Scalars['String']>;
  oldExpiry?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  productUuid?: Maybe<Scalars['String']>;
  results?: Maybe<Scalars['Int']>;
  status?: Maybe<StockJobStatus>;
  uuid?: Maybe<Scalars['String']>;
};

export const StockJobAction = {
  DeleteItems: 'DELETE_ITEMS',
  UpdateExpiry: 'UPDATE_EXPIRY'
} as const;

export type StockJobAction = typeof StockJobAction[keyof typeof StockJobAction];
/**
 * Paginated List for entity StockJob. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type StockJobList = {
  __typename?: 'StockJobList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<StockJob>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const StockJobStatus = {
  Done: 'DONE',
  Failed: 'FAILED',
  InProgress: 'IN_PROGRESS'
} as const;

export type StockJobStatus = typeof StockJobStatus[keyof typeof StockJobStatus];
/**
 * Paginated List for entity Stock. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type StockList = {
  __typename?: 'StockList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Stock>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type StockReprocess = {
  __typename?: 'StockReprocess';
  ignored: Array<StockReprocessIgnored>;
  sent: Array<Scalars['ID']>;
};

export type StockReprocessIgnored = {
  __typename?: 'StockReprocessIgnored';
  reason?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export const StockType = {
  File: 'FILE',
  HelixOrder: 'HELIX_ORDER',
  ItemTypeUnknown: 'ITEM_TYPE_UNKNOWN',
  Pdf: 'PDF',
  Qrcode: 'QRCODE',
  Text: 'TEXT',
  Url: 'URL'
} as const;

export type StockType = typeof StockType[keyof typeof StockType];
export const StockUsage = {
  Multiple: 'MULTIPLE',
  Single: 'SINGLE'
} as const;

export type StockUsage = typeof StockUsage[keyof typeof StockUsage];
export type StoreDepartment = {
  __typename?: 'StoreDepartment';
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type StoreDepartmentCategory = {
  __typename?: 'StoreDepartmentCategory';
  id: Scalars['String'];
  name: Scalars['String'];
  roundel?: Maybe<StoreDepartmentRoundel>;
};

export type StoreDepartmentRoundel = {
  __typename?: 'StoreDepartmentRoundel';
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type StoreDepartmentScheme = {
  __typename?: 'StoreDepartmentScheme';
  department?: Maybe<PayrollPayDepartment>;
  id: Scalars['ID'];
};

export type StoreHomeEmployeeOrganisation = {
  __typename?: 'StoreHomeEmployeeOrganisation';
  employeeOrganisation?: Maybe<EmployeeOrganisationData>;
};

export type StoreLayoutCurrentUser = {
  __typename?: 'StoreLayoutCurrentUser';
  backendUser?: Maybe<Scalars['Boolean']>;
  employeeOrganisations?: Maybe<Array<PayrollPayLayoutEmployeeOrganisationData>>;
  id: Scalars['ID'];
  organisationLimitationDetails?: Maybe<OrganisationLimitationDetails>;
  payrollFrequency?: Maybe<Scalars['String']>;
  salaryBracket?: Maybe<SalaryBracket>;
};


export type StoreLayoutCurrentUserSalaryBracketArgs = {
  organisationId?: InputMaybe<Scalars['ID']>;
};

export type StoreLayoutEmployeeOrganisation = {
  __typename?: 'StoreLayoutEmployeeOrganisation';
  availableLanguages?: Maybe<Array<PayrollPayLanguage>>;
  condensedLogo?: Maybe<Scalars['String']>;
  customPrivacyNoticeUrl?: Maybe<Scalars['String']>;
  defaultLanguage?: Maybe<PayrollPayLanguage>;
  footerLinks?: Maybe<FooterLinks>;
  footerLogo?: Maybe<Scalars['String']>;
  grossPriceOnProductCardFeatureFlag?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isValidBenefitType?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netBenefitEducationalPopupSeen?: Maybe<Scalars['Boolean']>;
  nmw?: Maybe<Scalars['Float']>;
  organisationPayrollFrequencies?: Maybe<Array<PayrollPayFrequency>>;
  organisationPrivacyNotice?: Maybe<Scalars['String']>;
  partner?: Maybe<Partner>;
  scheme?: Maybe<LayoutScheme>;
};


export type StoreLayoutEmployeeOrganisationSchemeArgs = {
  deductionType?: InputMaybe<Scalars['String']>;
  schemeTypeRelativeUrl?: InputMaybe<Scalars['ID']>;
};

export type StoreLayoutResponse = {
  __typename?: 'StoreLayoutResponse';
  currentUser?: Maybe<StoreLayoutCurrentUser>;
  employeeOrganisation?: Maybe<StoreLayoutEmployeeOrganisation>;
};

export type StorePromotionsFilterItem = {
  __typename?: 'StorePromotionsFilterItem';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type StoreScheme = {
  __typename?: 'StoreScheme';
  banners: Array<PayrollPayBanner>;
  bikeDepartmentId?: Maybe<Scalars['ID']>;
  brochureGroups?: Maybe<Array<PayrollPayBrochureGroup>>;
  deductionTypes?: Maybe<Array<Scalars['String']>>;
  endDate?: Maybe<Scalars['String']>;
  featuredCategories?: Maybe<Array<PayrollPayFeaturedCategory>>;
  id: Scalars['ID'];
  orderPdf?: Maybe<Scalars['String']>;
  popularBikes?: Maybe<Array<PayrollPayProduct>>;
  popularProducts?: Maybe<Array<PayrollPayProduct>>;
  startDate?: Maybe<Scalars['String']>;
  store?: Maybe<PayrollPayStore>;
  variableConfigurations?: Maybe<VariableConfigurations>;
  windowEndDate?: Maybe<Scalars['String']>;
  windowStartDate?: Maybe<Scalars['String']>;
};

export type StoredPaymentDetails = {
  __typename?: 'StoredPaymentDetails';
  bank?: Maybe<StoredPaymentDetailsBank>;
  card?: Maybe<StoredPaymentDetailsCard>;
  emailAddress?: Maybe<Scalars['String']>;
};

export type StoredPaymentDetailsBank = {
  __typename?: 'StoredPaymentDetailsBank';
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankCity?: Maybe<Scalars['String']>;
  bankLocationId?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type StoredPaymentDetailsCard = {
  __typename?: 'StoredPaymentDetailsCard';
  cvc?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  holderName?: Maybe<Scalars['String']>;
  issueNumber?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  startMonth?: Maybe<Scalars['String']>;
  startYear?: Maybe<Scalars['String']>;
};

export type StoredPaymentMethod = {
  __typename?: 'StoredPaymentMethod';
  brand?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  holderName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shopperEmail?: Maybe<Scalars['String']>;
  supportedShopperInteractions?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

export type StoryCards = {
  __typename?: 'StoryCards';
  deal?: Maybe<StoryDealCard>;
  total?: Maybe<StoryRedemptions>;
};

export type StoryDealCard = {
  __typename?: 'StoryDealCard';
  dealId?: Maybe<Scalars['ID']>;
  redemptions?: Maybe<Scalars['Int']>;
  totalSavingsAud?: Maybe<Scalars['Float']>;
  totalSavingsGbp?: Maybe<Scalars['Float']>;
  type?: Maybe<StoryDealCardType>;
};

export const StoryDealCardType = {
  DealCardTypeAppleCrusader: 'DEAL_CARD_TYPE_APPLE_CRUSADER',
  DealCardTypeBakery: 'DEAL_CARD_TYPE_BAKERY',
  DealCardTypeCinemaConnoisseur: 'DEAL_CARD_TYPE_CINEMA_CONNOISSEUR',
  DealCardTypeCoffeeHooray: 'DEAL_CARD_TYPE_COFFEE_HOORAY',
  DealCardTypeFashionistas: 'DEAL_CARD_TYPE_FASHIONISTAS',
  DealCardTypeFeastMode: 'DEAL_CARD_TYPE_FEAST_MODE',
  DealCardTypeOnlineShoppingPerfection: 'DEAL_CARD_TYPE_ONLINE_SHOPPING_PERFECTION',
  DealCardTypeStreamingRoyalty: 'DEAL_CARD_TYPE_STREAMING_ROYALTY',
  DealCardTypeTechConnoisseur: 'DEAL_CARD_TYPE_TECH_CONNOISSEUR',
  DealCardTypeTechSaavy: 'DEAL_CARD_TYPE_TECH_SAAVY',
  DealCardTypeTrolleyTakeover: 'DEAL_CARD_TYPE_TROLLEY_TAKEOVER',
  DealCardTypeUnknown: 'DEAL_CARD_TYPE_UNKNOWN',
  DealCardTypeWanderlusters: 'DEAL_CARD_TYPE_WANDERLUSTERS',
  DealCardTypeWorkoutWarriors: 'DEAL_CARD_TYPE_WORKOUT_WARRIORS',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type StoryDealCardType = typeof StoryDealCardType[keyof typeof StoryDealCardType];
export type StoryEngagement = {
  __typename?: 'StoryEngagement';
  engagedUsers?: Maybe<Scalars['Int']>;
};

export type StoryHighlights = {
  __typename?: 'StoryHighlights';
  engagement?: Maybe<StoryEngagement>;
  savings?: Maybe<StorySavings>;
};

export type StoryPersona = {
  __typename?: 'StoryPersona';
  diva?: Maybe<DiscountDiva>;
  enthusiast?: Maybe<Scalars['Boolean']>;
  guru?: Maybe<EngagementGuru>;
  rockstar?: Maybe<Rockstar>;
  saver?: Maybe<TopSaver>;
};

export type StoryRedemptions = {
  __typename?: 'StoryRedemptions';
  redemptions?: Maybe<Scalars['Int']>;
  totalSavingsAud?: Maybe<Scalars['Float']>;
  totalSavingsGbp?: Maybe<Scalars['Float']>;
  uniqueDeals?: Maybe<Scalars['Int']>;
};

export type StorySavings = {
  __typename?: 'StorySavings';
  coffees?: Maybe<Scalars['Int']>;
  totalSavingsAud?: Maybe<Scalars['Float']>;
  totalSavingsGbp?: Maybe<Scalars['Float']>;
};

export type SubInputDetail = {
  __typename?: 'SubInputDetail';
  items?: Maybe<Array<Maybe<DetailItem>>>;
  key?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  children: Array<Tag>;
  childrenIds: Array<Scalars['ID']>;
  filterable?: Maybe<Scalars['Boolean']>;
  image?: Maybe<Scalars['String']>;
  kind: TagKind;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type TagInput = {
  childrenIds: Array<InputMaybe<Scalars['ID']>>;
  filterable: Scalars['Boolean'];
  image?: InputMaybe<Scalars['String']>;
  kind: TagKind;
  locale: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export const TagKind = {
  BudgetTag: 'BudgetTag',
  DealAddon: 'DealAddon',
  DealCategories: 'DealCategories',
  DealCategory: 'DealCategory',
  DealLegacyAddon: 'DealLegacyAddon',
  DealLegacyPackage: 'DealLegacyPackage',
  DealLocationFilter: 'DealLocationFilter',
  DealLocationFilters: 'DealLocationFilters',
  DealPackage: 'DealPackage',
  DealPerksGoFilter: 'DealPerksGoFilter',
  DealPerksGoFilters: 'DealPerksGoFilters',
  DealTag: 'DealTag',
  DealTopCategories: 'DealTopCategories',
  RewardCategories: 'RewardCategories',
  RewardCategory: 'RewardCategory',
  RewardPackage: 'RewardPackage'
} as const;

export type TagKind = typeof TagKind[keyof typeof TagKind];
/**
 * Paginated List for entity Tag. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type TagList = {
  __typename?: 'TagList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Tag>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type TagPromotion = {
  __typename?: 'TagPromotion';
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tagid?: Maybe<Scalars['String']>;
};

export type TagUpdateInput = {
  Etag?: InputMaybe<Scalars['String']>;
  childrenIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  filterable?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type Tax = {
  __typename?: 'Tax';
  name: Scalars['String'];
  rate: Scalars['Float'];
};

export type Team = {
  __typename?: 'Team';
  /** @deprecated No longer tracked. */
  Etag?: Maybe<Scalars['String']>;
  branding?: Maybe<Branding>;
  businessId?: Maybe<Scalars['String']>;
  featureFlags?: Maybe<Array<Maybe<Scalars['String']>>>;
  isRootTeam?: Maybe<Scalars['Boolean']>;
  managers?: Maybe<UserList>;
  meatadata?: Maybe<Metadata>;
  /** @deprecated This holds old team data, should not be used outside graph. */
  oldTeamData?: Maybe<Team>;
  /** @deprecated Was never populated. */
  owners?: Maybe<Array<Maybe<Scalars['String']>>>;
  parentId?: Maybe<Scalars['ID']>;
  /** @deprecated No longer tracked. */
  permissions?: Maybe<Scalars['String']>;
  /** @deprecated Use 'teamName' instead. */
  public_name?: Maybe<Scalars['String']>;
  /** @deprecated Use 'teamState' instead. */
  state?: Maybe<TeamState>;
  teamCategory?: Maybe<TeamCategory>;
  teamName?: Maybe<Scalars['String']>;
  teamState?: Maybe<TeamState>;
  tier?: Maybe<Scalars['Int']>;
  users?: Maybe<UserList>;
  uuid?: Maybe<Scalars['ID']>;
};


export type TeamManagersArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  totalOnly?: InputMaybe<Scalars['Boolean']>;
};


export type TeamUsersArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  totalOnly?: InputMaybe<Scalars['Boolean']>;
};

export const TeamAssignment = {
  Basic: 'Basic',
  Leader: 'Leader',
  Manager: 'Manager'
} as const;

export type TeamAssignment = typeof TeamAssignment[keyof typeof TeamAssignment];
export const TeamCategory = {
  Department: 'Department',
  Site: 'Site',
  Unknown: 'Unknown'
} as const;

export type TeamCategory = typeof TeamCategory[keyof typeof TeamCategory];
export type TeamDate = {
  __typename?: 'TeamDate';
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type TeamDateInput = {
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type TeamInput = {
  owners?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentId?: InputMaybe<Scalars['ID']>;
  permissions?: InputMaybe<Scalars['String']>;
  public_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TeamState>;
  teamCategory?: InputMaybe<TeamCategory>;
  teamName?: InputMaybe<Scalars['String']>;
  teamState?: InputMaybe<TeamState>;
  tier?: InputMaybe<Scalars['Int']>;
};

/**
 * Paginated List for entity Team. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type TeamList = {
  __typename?: 'TeamList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Team>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type TeamPerksMetrics = {
  __typename?: 'TeamPerksMetrics';
  teams?: Maybe<Array<Maybe<TeamPerksMetricsByTeam>>>;
};

export type TeamPerksMetricsByTeam = {
  __typename?: 'TeamPerksMetricsByTeam';
  admins?: Maybe<Array<Maybe<Scalars['String']>>>;
  estimated_perks_savings?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  perksgo_count?: Maybe<Scalars['Int']>;
  perksgo_saving_total?: Maybe<Scalars['Float']>;
  redemption_count?: Maybe<Scalars['Int']>;
  team?: Maybe<Team>;
};

export type TeamRegionMap = {
  __typename?: 'TeamRegionMap';
  /** @deprecated Use 'regionId' now. */
  region: BillingRegion;
  regionId: Scalars['ID'];
  team: Team;
  teamId: Scalars['ID'];
};

export type TeamReport = {
  __typename?: 'TeamReport';
  activationRate?: Maybe<Scalars['Float']>;
  /** @deprecated Use 'engaged' now. */
  active?: Maybe<Scalars['Float']>;
  activeUsers?: Maybe<Scalars['Int']>;
  cultureHubUsage?: Maybe<Scalars['Float']>;
  enabledUsers?: Maybe<Scalars['Int']>;
  engaged?: Maybe<Scalars['Float']>;
  managers?: Maybe<Scalars['Int']>;
  overall?: Maybe<Scalars['Float']>;
  perksUsage?: Maybe<Scalars['Float']>;
  recognitionUsage?: Maybe<Scalars['Float']>;
  redemptions?: Maybe<Scalars['Int']>;
  teamName?: Maybe<Scalars['String']>;
  teamState?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
  wellnessUsage?: Maybe<Scalars['Float']>;
};

export const TeamReportDuration = {
  Month: 'MONTH'
} as const;

export type TeamReportDuration = typeof TeamReportDuration[keyof typeof TeamReportDuration];
export type TeamReports = {
  __typename?: 'TeamReports';
  availableDates?: Maybe<Array<Maybe<TeamDate>>>;
  /** @deprecated Use 'availableDates' now. */
  availableGenericTeamDates?: Maybe<Array<Maybe<TeamDate>>>;
  reports?: Maybe<Array<Maybe<TeamReport>>>;
  until?: Maybe<Scalars['String']>;
};

export const TeamState = {
  All: 'All',
  BillingUnit: 'BillingUnit',
  BudgetHolders: 'BudgetHolders',
  Deactivated: 'Deactivated',
  Deleted: 'Deleted',
  Generic: 'Generic',
  Hidden: 'HIDDEN',
  Ok: 'OK',
  Protected: 'Protected',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type TeamState = typeof TeamState[keyof typeof TeamState];
export type TeamUpdateInput = {
  parentId?: InputMaybe<Scalars['ID']>;
  public_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<TeamState>;
  teamCategory?: InputMaybe<TeamCategory>;
  teamName?: InputMaybe<Scalars['String']>;
  teamState?: InputMaybe<TeamState>;
  uuid: Scalars['ID'];
};

export type TeamsPaginatedResponse = {
  __typename?: 'TeamsPaginatedResponse';
  searchAfter?: Maybe<Scalars['String']>;
  searchData?: Maybe<TeamsSearchData>;
  teams?: Maybe<Array<Maybe<Team>>>;
};

export type TeamsSearchData = {
  __typename?: 'TeamsSearchData';
  total?: Maybe<Scalars['Int']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  /** @deprecated Request a 'business' instead. */
  groupId?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'business' instead. */
  locale?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'business' instead. */
  public_name?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'business' instead. */
  rootTeamId: Scalars['ID'];
  /** @deprecated Request a 'business' instead. */
  salesforceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Request a 'business' instead. */
  settings?: Maybe<TenantSettings>;
  /** @deprecated Request a 'business' instead. */
  subdomain?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'business' instead. */
  uuid?: Maybe<Scalars['String']>;
};

export const TenantActivationStatus = {
  Activated: 'ACTIVATED',
  Deactivated: 'DEACTIVATED',
  Onhold: 'ONHOLD'
} as const;

export type TenantActivationStatus = typeof TenantActivationStatus[keyof typeof TenantActivationStatus];
export type TenantAudit = {
  __typename?: 'TenantAudit';
  action?: Maybe<TenantAuditAction>;
  executedByTenant?: Maybe<Scalars['String']>;
  executedByUser?: Maybe<Scalars['String']>;
  meta?: Maybe<TenantAuditMeta>;
  tenantUUID?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
};

export const TenantAuditAction = {
  Activated: 'ACTIVATED',
  BulkResendWelcomeEmail: 'BULK_RESEND_WELCOME_EMAIL',
  Deactivated: 'DEACTIVATED',
  Onhold: 'ONHOLD'
} as const;

export type TenantAuditAction = typeof TenantAuditAction[keyof typeof TenantAuditAction];
/**
 * Paginated List for entity TenantAudit. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type TenantAuditList = {
  __typename?: 'TenantAuditList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<TenantAudit>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type TenantAuditMeta = {
  __typename?: 'TenantAuditMeta';
  newStatus?: Maybe<Scalars['String']>;
  oldStatus?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity Tenant. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type TenantList = {
  __typename?: 'TenantList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Tenant>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type TenantMetadata = {
  __typename?: 'TenantMetadata';
  comments?: Maybe<Scalars['String']>;
  config?: Maybe<TenantMetadataConfig>;
  homepage?: Maybe<HomePage>;
  uuid?: Maybe<Scalars['ID']>;
};

export type TenantMetadataConfig = {
  __typename?: 'TenantMetadataConfig';
  alternativeAppDownloadImage?: Maybe<Scalars['String']>;
};

export type TenantOnboarding = {
  __typename?: 'TenantOnboarding';
  assignedSteps?: Maybe<Array<Maybe<TenantOnboardingStep>>>;
  business?: Maybe<Business>;
  businessId?: Maybe<Scalars['String']>;
  /** @deprecated Use 'metadata' instead */
  createdAt?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Metadata>;
  onboardingFinished?: Maybe<Scalars['Boolean']>;
  preOnboardingFinished?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use 'business' instead. */
  tenant?: Maybe<Tenant>;
  uuid?: Maybe<Scalars['ID']>;
};

/**
 * Paginated List for entity TenantOnboarding. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type TenantOnboardingList = {
  __typename?: 'TenantOnboardingList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<TenantOnboarding>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type TenantOnboardingStep = {
  __typename?: 'TenantOnboardingStep';
  metadata?: Maybe<Metadata>;
  selection?: Maybe<Scalars['Int']>;
  state?: Maybe<TenantOnboardingStepStates>;
  stepId?: Maybe<Scalars['String']>;
  /** @deprecated Use 'metadata' instead */
  updatedAt?: Maybe<Scalars['String']>;
  /** @deprecated Use 'metadata' instead */
  updatedBy?: Maybe<User>;
};

export const TenantOnboardingStepStates = {
  Done: 'DONE',
  Open: 'OPEN',
  Skipped: 'SKIPPED'
} as const;

export type TenantOnboardingStepStates = typeof TenantOnboardingStepStates[keyof typeof TenantOnboardingStepStates];
export type TenantSettings = {
  __typename?: 'TenantSettings';
  /** @deprecated Request a 'branding' instead. */
  color?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'branding' instead. */
  employeeName?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'branding' instead. */
  featureFlags?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'branding' instead. */
  hideNormalLogin?: Maybe<Scalars['Boolean']>;
  /** @deprecated Request a 'branding' instead. */
  imageLink?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'branding' instead. */
  showSSOOptions?: Maybe<Scalars['Boolean']>;
  /** @deprecated Request a 'branding' instead. */
  signUpOption?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'branding' instead. */
  ssoButtonText?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'branding' instead. */
  textColor?: Maybe<Scalars['String']>;
  /** @deprecated Request a 'branding' instead. */
  welcomeEmail?: Maybe<Scalars['String']>;
};

export type TenantTransaction = {
  __typename?: 'TenantTransaction';
  actionedByUser?: Maybe<User>;
  amount?: Maybe<AmountAndCurrency>;
  date?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  senderRecipientType?: Maybe<Scalars['String']>;
  senderRecipientUser?: Maybe<User>;
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity TenantTransaction. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type TenantTransactionList = {
  __typename?: 'TenantTransactionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<TenantTransaction>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type TenantWallet = {
  __typename?: 'TenantWallet';
  availableBalance?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  ownerUuid?: Maybe<Scalars['String']>;
  scheduledInBalance?: Maybe<Scalars['Float']>;
  scheduledOutBalance?: Maybe<Scalars['Float']>;
  tenantUuid?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  walletOwners?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TenantWalletCreateRefund = {
  __typename?: 'TenantWalletCreateRefund';
  uuid?: Maybe<Scalars['String']>;
};

export type TenantWalletTransactionByWalletId = {
  __typename?: 'TenantWalletTransactionByWalletId';
  actionedByUserId?: Maybe<Scalars['String']>;
  senderRecipientType?: Maybe<Scalars['String']>;
  senderRecipientUserId?: Maybe<Scalars['String']>;
};

export type TenantWalletTransfer = {
  __typename?: 'TenantWalletTransfer';
  amount?: Maybe<TenantWalletTransferAmount>;
  createdAt?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  receivers?: Maybe<TenantWalletTransferReceivers>;
  status?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  transferId?: Maybe<Scalars['String']>;
  transferRequestId?: Maybe<Scalars['String']>;
  transferRequestType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type TenantWalletTransferAmount = {
  __typename?: 'TenantWalletTransferAmount';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity TenantWalletTransfer. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type TenantWalletTransferList = {
  __typename?: 'TenantWalletTransferList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<TenantWalletTransfer>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type TenantWalletTransferReceivers = {
  __typename?: 'TenantWalletTransferReceivers';
  users?: Maybe<Array<Maybe<User>>>;
  walletType?: Maybe<Scalars['String']>;
};

export type TermsAndConditionsResponse = {
  __typename?: 'TermsAndConditionsResponse';
  content: Scalars['String'];
  version: Scalars['String'];
};

export const ThirdPartyTokenChannel = {
  ThirdPartyChannelAndroid: 'THIRD_PARTY_CHANNEL_ANDROID',
  ThirdPartyChannelIos: 'THIRD_PARTY_CHANNEL_IOS',
  ThirdPartyChannelUnknown: 'THIRD_PARTY_CHANNEL_UNKNOWN',
  ThirdPartyChannelWeb: 'THIRD_PARTY_CHANNEL_WEB',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ThirdPartyTokenChannel = typeof ThirdPartyTokenChannel[keyof typeof ThirdPartyTokenChannel];
export type TiersInput = {
  baseServiceFee: Scalars['Float'];
  currency: Scalars['String'];
  endValue: Scalars['Int'];
  startValue: Scalars['Int'];
  tenant: Scalars['String'];
  tierServiceFee: Scalars['Float'];
  uuid?: InputMaybe<Scalars['ID']>;
};

export type TiersResponse = {
  __typename?: 'TiersResponse';
  baseServiceFee: Scalars['Float'];
  baseServiceFeeRate?: Maybe<Scalars['Float']>;
  endValue: Scalars['Int'];
  startValue: Scalars['Int'];
  tenant?: Maybe<Scalars['String']>;
  tierServiceFee: Scalars['Float'];
  tierServiceFeeRate?: Maybe<Scalars['Float']>;
  uuid: Scalars['ID'];
};

export type ToggleAutoApprovalInput = {
  budgetCategoryId: Scalars['ID'];
  isAutoApprovalEnabled: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type ToggleReactionResponse = {
  __typename?: 'ToggleReactionResponse';
  comment?: Maybe<RecognitionFeedComment>;
  groupCelebration?: Maybe<GroupCelebration>;
  poll?: Maybe<Poll>;
  recognition?: Maybe<Recognition>;
};

export type TopSaver = {
  __typename?: 'TopSaver';
  totalSavingsAud?: Maybe<Scalars['Float']>;
  totalSavingsGbp?: Maybe<Scalars['Float']>;
};

export type Topup = {
  __typename?: 'Topup';
  amount?: Maybe<Scalars['Float']>;
  countryCode?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']>;
  flexiPointAmount?: Maybe<Scalars['Float']>;
  flexiPointCurrency?: Maybe<Scalars['String']>;
  metadata?: Maybe<TopupMetadata>;
  payment?: Maybe<TopupPayment>;
  paymentOrder?: Maybe<PaymentOrder>;
  serviceFee?: Maybe<ServiceFeeCharge>;
  taxes?: Maybe<Array<Tax>>;
  tenantId?: Maybe<Scalars['String']>;
  totalToPay?: Maybe<Scalars['Float']>;
  uuid?: Maybe<Scalars['String']>;
  walletOwnerUuid?: Maybe<Scalars['String']>;
  walletTransferCreatedAt?: Maybe<Scalars['String']>;
  walletTransferUuid?: Maybe<Scalars['String']>;
  walletType?: Maybe<Scalars['String']>;
  walletTypeUuid?: Maybe<Scalars['String']>;
  walletUuid?: Maybe<Scalars['String']>;
};

export type TopupList = {
  __typename?: 'TopupList';
  fromScrollId?: Maybe<Scalars['String']>;
  scrollId?: Maybe<Scalars['String']>;
  topUps?: Maybe<Array<Maybe<Topup>>>;
  total?: Maybe<Scalars['Float']>;
};

export type TopupMetadata = {
  __typename?: 'TopupMetadata';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type TopupPayment = {
  __typename?: 'TopupPayment';
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceUuid?: Maybe<Scalars['String']>;
  paymentOrderUuid?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TopupServiceFeeTiers = {
  __typename?: 'TopupServiceFeeTiers';
  globallyEnabled: Scalars['Boolean'];
  tiers: Array<TiersResponse>;
};

export type Transaction = {
  __typename?: 'Transaction';
  actionedBy?: Maybe<User>;
  amount?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  senderRecipient?: Maybe<User>;
  uuid?: Maybe<Scalars['String']>;
};

/**
 * Paginated List for entity Transaction. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type TransactionList = {
  __typename?: 'TransactionList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Transaction>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export const TransactionType = {
  Allocation: 'ALLOCATION',
  BudgetAdjustment: 'BUDGET_ADJUSTMENT',
  BulkReward: 'BULK_REWARD',
  Expiry: 'EXPIRY',
  Migration: 'MIGRATION',
  Topup: 'TOPUP',
  TransactionTypeUnknown: 'TRANSACTION_TYPE_UNKNOWN',
  Transfer: 'TRANSFER',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type TransactionType = typeof TransactionType[keyof typeof TransactionType];
/** Input for transferring budget between managers and budgets */
export type TransferAdvancedBudgetInput = {
  amount: Scalars['Int'];
  budgetFrom: Scalars['ID'];
  budgetTo: Scalars['ID'];
  managerFrom: Scalars['ID'];
  managerTo: Scalars['ID'];
  message: Scalars['String'];
};

/** Response from transferring advanced budgets */
export type TransferAdvancedBudgetsResponse = {
  __typename?: 'TransferAdvancedBudgetsResponse';
  success: Scalars['Boolean'];
};

export type TransferToRewardWalletTransfer = {
  __typename?: 'TransferToRewardWalletTransfer';
  recipient?: Maybe<User>;
  recipient_user_id?: Maybe<Scalars['String']>;
};

export type TravelLeisureOrder = {
  __typename?: 'TravelLeisureOrder';
  id: Scalars['ID'];
};

export type TravelLeisureOrderData = {
  __typename?: 'TravelLeisureOrderData';
  errors?: Maybe<Array<TravelLeisureOrderError>>;
  order?: Maybe<TravelLeisureOrder>;
};

export type TravelLeisureOrderError = {
  __typename?: 'TravelLeisureOrderError';
  fieldName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type TravelLeisureOrderPayload = {
  __typename?: 'TravelLeisureOrderPayload';
  createTravelAndLeisureOrder?: Maybe<TravelLeisureOrderData>;
};

export type Trophy = {
  __typename?: 'Trophy';
  alt?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type TrophyInput = {
  alt?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
};

/**
 * Paginated List for entity Trophy. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type TrophyList = {
  __typename?: 'TrophyList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<Trophy>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type UnauthedBusiness = {
  __typename?: 'UnauthedBusiness';
  branding?: Maybe<Branding>;
  businessName: Scalars['String'];
  /** @deprecated No longer a thing. */
  locale?: Maybe<Scalars['String']>;
  loginPageSsoButtonText?: Maybe<Scalars['String']>;
  /** @deprecated Use 'businessName' instead. */
  public_name?: Maybe<Scalars['String']>;
  selfRegistrations?: Maybe<Array<Maybe<BusinessSelfRegistrationType>>>;
  /** @deprecated Use 'Query.branding' instead. */
  settings?: Maybe<TenantSettings>;
  showPasswordLogin: Scalars['Boolean'];
  showSsoLogin: Scalars['Boolean'];
  /** @deprecated Use connectionId in WorkOSOrganisation instead. */
  ssoId?: Maybe<Scalars['ID']>;
  subdomain: Scalars['String'];
  uuid: Scalars['ID'];
};

export type UnauthedUser = {
  __typename?: 'UnauthedUser';
  businessId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type UpdateBasketItemInput = {
  basketItemId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type UpdateBasketItemPayload = {
  __typename?: 'UpdateBasketItemPayload';
  updateBasketItem?: Maybe<BasketItemPayload>;
};

export type UpdateBrandingInput = {
  businessId: Scalars['ID'];
  businessLogoUrl?: InputMaybe<Scalars['String']>;
  businessSquareLogoUrl?: InputMaybe<Scalars['String']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  primaryColour?: InputMaybe<Scalars['String']>;
  teamId: Scalars['ID'];
  textColour?: InputMaybe<Scalars['String']>;
  welcomeEmail?: InputMaybe<Scalars['String']>;
};

export type UpdateBudgetCategoriesInput = {
  /** The list of existing categories with any alterations, all categories must be provided, even if unchanged or they will be presumed as set to zero */
  categories: Array<UpdateBudgetCategory>;
  newCategories: Array<UpdateBudgetCategory>;
  userId: Scalars['String'];
};

export type UpdateBudgetCategory = {
  amount: Scalars['Int'];
  color: Scalars['String'];
  name: Scalars['String'];
  tagId: Scalars['String'];
  uuid: Scalars['ID'];
};

export type UpdateBusinessInput = {
  businessName?: InputMaybe<Scalars['String']>;
  directorySyncId?: InputMaybe<Scalars['ID']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  loginPageSsoButtonText?: InputMaybe<Scalars['String']>;
  selfRegistrations?: InputMaybe<Array<InputMaybe<BusinessSelfRegistrationType>>>;
  showPasswordLogin?: InputMaybe<Scalars['Boolean']>;
  showSsoLogin?: InputMaybe<Scalars['Boolean']>;
  ssoId?: InputMaybe<Scalars['ID']>;
  subdomain?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type UpdateBusinessSubdomainInput = {
  businessId: Scalars['ID'];
  newSubdomain: Scalars['String'];
};

export type UpdateCustomRewardInput = {
  locations: Array<Scalars['String']>;
  policy?: InputMaybe<Scalars['String']>;
  redemptionInstructions?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type UpdateDealBrandInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  bannerUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DealBrandStatus>;
  uuid: Scalars['ID'];
};

export type UpdateDealInput = {
  bannerImage?: InputMaybe<Scalars['String']>;
  cardImage?: InputMaybe<Scalars['String']>;
  contactInfo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  importantInfo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalIdentifier?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  redemptionInstructions?: InputMaybe<Scalars['String']>;
  savings?: InputMaybe<CompanyBenefitSavingsInput>;
  status?: InputMaybe<DealStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DealType>;
  urlSlug?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type UpdateDealPackageInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDealPriceModifierInput = {
  businessId?: InputMaybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealKind: PriceModifierDealKind;
  discount: Scalars['Float'];
  status: PriceModifierDealStatus;
  tier?: InputMaybe<ProductSettingsPerksTiers>;
  uuid: Scalars['String'];
};

export type UpdateFraudBlacklistedEmailInput = {
  email: Scalars['String'];
  state?: InputMaybe<FraudBlacklistedEmailState>;
};

export type UpdateFraudThresholdInput = {
  enabled: Scalars['Boolean'];
  fraudDurationHours: Scalars['Int'];
  fraudThresholdId: Scalars['String'];
  revisionId: Scalars['String'];
  tenantId?: InputMaybe<Scalars['String']>;
  threshold: Scalars['Int'];
  type: FraudThresholdType;
  userId?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupCelebrationInput = {
  budget?: InputMaybe<BudgetCategoryRequest>;
  collaboratorIds?: InputMaybe<Array<Scalars['ID']>>;
  customRewardId?: InputMaybe<Scalars['String']>;
  groupCelebrationID: Scalars['ID'];
  rewardAmount?: InputMaybe<Scalars['Int']>;
  scheduledAt?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  walletTransferId?: InputMaybe<Scalars['ID']>;
};

export type UpdateInternalUserInput = {
  email: Scalars['String'];
  featureFlags?: InputMaybe<Array<InputMaybe<InternalFeatureFlags>>>;
  fullName?: InputMaybe<Scalars['String']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMarketingProfileInput = {
  settings?: InputMaybe<MarketingProfileSettingsInput>;
  signature: Scalars['String'];
  uuid: Scalars['ID'];
};

export type UpdateNetBenefitEducationalPopupSeenInput = {
  netBenefitEducationalPopupSeen: Scalars['Boolean'];
};

export type UpdateNetBenefitEducationalPopupSeenPayload = {
  __typename?: 'UpdateNetBenefitEducationalPopupSeenPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type UpdatePointsRequestStatusInput = {
  responseMessage?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PointsRequestStatus>;
  uuid: Scalars['ID'];
};

export type UpdateProductSettingsBenefitsMarketplace = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProductSettingsCarBenefits = {
  hasCPC?: InputMaybe<Scalars['Boolean']>;
  provider?: InputMaybe<ProductSettingsCarBenefitsProviders>;
};

export type UpdateProductSettingsCycleToWork = {
  tier?: InputMaybe<ProductSettingsCycleToWorkTiers>;
};

export type UpdateProductSettingsEmployeeAssistanceProgramme = {
  tier?: InputMaybe<ProductSettingsEmployeeAssistanceProgrammeTiers>;
};

export type UpdateProductSettingsEmployeeAssistanceProgrammeContact = {
  phoneNumber: Scalars['String'];
};

export type UpdateProductSettingsGymMembership = {
  companyId: Scalars['ID'];
};

export type UpdateProductSettingsHealthCashPlan = {
  externalId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ProductSettingsHealthCashPlanTiers>;
};

export type UpdateProductSettingsMedical = {
  tier?: InputMaybe<ProductSettingsMedicalTiers>;
};

export type UpdateProductSettingsPerks = {
  blacklistedPerks?: InputMaybe<Array<Scalars['ID']>>;
  blacklistedTags?: InputMaybe<Array<Scalars['ID']>>;
  monthlyTTAllowance?: InputMaybe<Scalars['Int']>;
  packageAddonIds?: InputMaybe<Array<Scalars['ID']>>;
  packageId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
  tier?: InputMaybe<ProductSettingsPerksTiers>;
  ttAllowance?: InputMaybe<Scalars['Int']>;
  ttTopupInterval?: InputMaybe<ProductSettingTopupInterval>;
  ttTopupIntervalCount?: InputMaybe<Scalars['Int']>;
  whitelistedPerks?: InputMaybe<Array<Scalars['ID']>>;
  whitelistedTags?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateProductSettingsRecognition = {
  attachReward?: InputMaybe<ProductSettingsRecognitionValuesByRank>;
  createPoll?: InputMaybe<ProductSettingsRecognitionValuesByRank>;
  rewardPackageId?: InputMaybe<Scalars['ID']>;
  sendToEveryone?: InputMaybe<ProductSettingsRecognitionValuesByRank>;
  sendToTeams?: InputMaybe<ProductSettingsRecognitionValuesByRank>;
  sharing?: InputMaybe<ProductSettingsRecognitionValuesByRank>;
  viewReward?: InputMaybe<ProductSettingsRecognitionValuesByVisibility>;
};

export type UpdateProductSettingsRewards = {
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type UpdateProductSettingsWallet = {
  canApprovePointsRequest?: InputMaybe<ProductSettingsRecognitionValuesByRank>;
  canPurchasePoints?: InputMaybe<ProductSettingsRecognitionValuesByRank>;
  canRequestPoints?: InputMaybe<ProductSettingsRecognitionValuesByRank>;
};

export type UpdateProductSettingsWellness = {
  assessment?: InputMaybe<Scalars['Boolean']>;
  blacklistedCategories?: InputMaybe<Array<ProductSettingsWellnessCategoryInput>>;
  meatadata?: InputMaybe<MetadataInput>;
};

export type UpdateRewardArgs = {
  order_id: Scalars['String'];
  reward_id?: InputMaybe<Scalars['String']>;
};

export type UpdateScheduledRecognitionInput = {
  budget?: InputMaybe<BudgetCategoryRequest>;
  companyValueIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  customRewardId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  occasionId?: InputMaybe<Scalars['ID']>;
  originalTimezone?: InputMaybe<Scalars['String']>;
  receiverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rewardAmount?: InputMaybe<Scalars['Int']>;
  scheduledAt?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<ScheduledRecognitionSource>;
  uuid: Scalars['ID'];
  visibility?: InputMaybe<RecognitionVisibility>;
};

export type UpdateTenantOnboardingInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  onboardingFinished?: InputMaybe<Scalars['Boolean']>;
  preOnboardingFinished?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateTenantOnboardingStepInput = {
  selection: Scalars['Int'];
  state: TenantOnboardingStepStates;
};

export type UpdateUserByEmailInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  externalUserId?: InputMaybe<Scalars['ID']>;
  external_id?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneNubmer?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateUserEmploymentDetailsInput = {
  annual_gross_salary?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employee_number?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  hours_per_week?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: InputMaybe<Scalars['String']>;
  ni_number?: InputMaybe<Scalars['String']>;
  pay_frequency?: InputMaybe<Scalars['String']>;
  probation_end_date?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  termination_date?: InputMaybe<Scalars['String']>;
};

export type UpdateUserPhoneNoInput = {
  confirmationId: Scalars['ID'];
  countryCode: Scalars['String'];
  e164PhoneNo: Scalars['String'];
  identifier: Scalars['String'];
  intlPhoneNo: Scalars['String'];
  phoneCode: Scalars['String'];
  userId: Scalars['ID'];
};

export type UploadAttributesInput = {
  selfRegistration?: InputMaybe<SelfRegistrationAttributesInput>;
};

export type UploadAutoApproveCsvInput = {
  rows: Array<UploadAutoApproveCsvRowInput>;
};

export type UploadAutoApproveCsvRowInput = {
  budgetCategoryName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  userId: Scalars['String'];
};

export const UploadTypeUrl = {
  Unrecognized: 'UNRECOGNIZED',
  UploadTypeBulkUserCreate: 'UPLOAD_TYPE_BULK_USER_CREATE',
  UploadTypeSelfRegistrationCode: 'UPLOAD_TYPE_SELF_REGISTRATION_CODE',
  UploadTypeUnknown: 'UPLOAD_TYPE_UNKNOWN'
} as const;

export type UploadTypeUrl = typeof UploadTypeUrl[keyof typeof UploadTypeUrl];
export type Upsell = {
  __typename?: 'Upsell';
  /** @deprecated No longer a thing */
  region?: Maybe<UpsellRegion>;
};

export const UpsellRegion = {
  Aus: 'AUS',
  Fra: 'FRA',
  Gbr: 'GBR',
  Ire: 'IRE'
} as const;

export type UpsellRegion = typeof UpsellRegion[keyof typeof UpsellRegion];
export type UsageReport = {
  __typename?: 'UsageReport';
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  points?: Maybe<Array<Maybe<DatePoint>>>;
  topic?: Maybe<Scalars['String']>;
};

export type UsageReports = {
  __typename?: 'UsageReports';
  reports?: Maybe<Array<Maybe<UsageReport>>>;
};

export type UseCreditToBuyRewardTransfer = {
  __typename?: 'UseCreditToBuyRewardTransfer';
  rewardOrder?: Maybe<RewardOrder>;
  rewardOrderId?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  activatedAt?: Maybe<Scalars['String']>;
  billingUnitId?: Maybe<Scalars['ID']>;
  business?: Maybe<Business>;
  businessId?: Maybe<Scalars['ID']>;
  dateOfBirth?: Maybe<UserDateOfBirth>;
  directorySyncId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  employmentDetails?: Maybe<EmploymentDetails>;
  externalEmployeeId?: Maybe<Scalars['ID']>;
  externalStartDate?: Maybe<Scalars['String']>;
  externalUserId?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated Use 'firstName' instead. */
  firstname?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  invitedBy?: Maybe<User>;
  invitedUsers?: Maybe<Array<Maybe<InvitedUser>>>;
  isActivated?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isGlobalAdmin?: Maybe<Scalars['Boolean']>;
  isManagedExternally?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  /** @deprecated Use 'lastName' instead. */
  lastname?: Maybe<Scalars['String']>;
  locationDescription?: Maybe<Scalars['String']>;
  /** User's managed fields by external integretions, such as SSO or DSYNC */
  managedFields?: Maybe<UserManagedFields>;
  /** @deprecated Use marketing profile settings instead. */
  marketingEmailsAllowed?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Metadata>;
  notBeforeDate?: Maybe<Scalars['String']>;
  /** @deprecated This holds old user data, should not be used outside graph. */
  oldUserData?: Maybe<User>;
  phoneNumber?: Maybe<Scalars['String']>;
  primaryTeamId?: Maybe<Scalars['ID']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use 'profileImageUrl' instead. */
  profile_img?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['ID']>;
  /**
   * A user's reward wallet
   * Currently only support RewardPoints and only available for managers and admins
   */
  rewardWallet?: Maybe<Wallet>;
  /** @deprecated No longer tracked */
  role?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  source?: Maybe<UserSource>;
  ssoId?: Maybe<Scalars['ID']>;
  supervisorId?: Maybe<Scalars['ID']>;
  teamAssignments?: Maybe<Array<UserTeamAssignment>>;
  teamIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  teams?: Maybe<TeamList>;
  userPreferences?: Maybe<UserPreferences>;
  userType?: Maybe<UserType>;
  uuid?: Maybe<Scalars['ID']>;
  wallet?: Maybe<Wallet>;
};


export type UserWalletArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type UserAudit = {
  __typename?: 'UserAudit';
  action?: Maybe<UserAuditAction>;
  executedByTenant?: Maybe<Scalars['String']>;
  executedByUser?: Maybe<Scalars['String']>;
  meta?: Maybe<UserAuditMeta>;
  timestamp?: Maybe<Scalars['String']>;
  userUUID?: Maybe<Scalars['String']>;
};

export const UserAuditAction = {
  Activated: 'ACTIVATED',
  Deactivated: 'DEACTIVATED',
  EmailAddressChanged: 'EMAIL_ADDRESS_CHANGED',
  RoleChanged: 'ROLE_CHANGED'
} as const;

export type UserAuditAction = typeof UserAuditAction[keyof typeof UserAuditAction];
export type UserAuditMeta = {
  __typename?: 'UserAuditMeta';
  newEmail?: Maybe<Scalars['String']>;
  newRole?: Maybe<Scalars['String']>;
  oldEmail?: Maybe<Scalars['String']>;
  oldRole?: Maybe<Scalars['String']>;
};

export type UserDateOfBirth = {
  __typename?: 'UserDateOfBirth';
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type UserDateOfBirthInput = {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type UserEmploymentDetails = {
  __typename?: 'UserEmploymentDetails';
  annual_gross_salary?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employee_number?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  hours_per_week?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  ni_number?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<Scalars['String']>;
  probation_end_date?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  termination_date?: Maybe<Scalars['String']>;
};

export type UserEmploymentDetailsInput = {
  annual_gross_salary?: InputMaybe<Scalars['String']>;
  employee_number?: InputMaybe<Scalars['String']>;
  hours_per_week?: InputMaybe<Scalars['String']>;
  job_grade?: InputMaybe<Scalars['String']>;
  ni_number?: InputMaybe<Scalars['String']>;
  pay_frequency?: InputMaybe<Scalars['String']>;
  probation_end_date?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  termination_date?: InputMaybe<Scalars['String']>;
};

export const UserField = {
  Email: 'Email',
  ExternalStartDate: 'ExternalStartDate',
  ExternalUserId: 'ExternalUserId',
  FirstName: 'FirstName',
  LastName: 'LastName'
} as const;

export type UserField = typeof UserField[keyof typeof UserField];
export type UserInput = {
  Etag?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<UserDateOfBirthInput>;
  dob?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employmentDetails?: InputMaybe<UserEmploymentDetailsInput>;
  employmentStartDate?: InputMaybe<Scalars['String']>;
  externalEmployeeId?: InputMaybe<Scalars['ID']>;
  externalStartDate?: InputMaybe<Scalars['String']>;
  externalUserId?: InputMaybe<Scalars['ID']>;
  external_id?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  marketingEmailsAllowed?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  primaryTeamId?: InputMaybe<Scalars['ID']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  profile_img?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<UserSource>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenant?: InputMaybe<Scalars['String']>;
  userPreferences?: InputMaybe<UserPreferencesInput>;
  uuid: Scalars['ID'];
};

/**
 * Paginated List for entity User. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type UserList = {
  __typename?: 'UserList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<User>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type UserManagedField = {
  __typename?: 'UserManagedField';
  field?: Maybe<UserField>;
  manager?: Maybe<Scalars['String']>;
};

export type UserManagedFields = {
  __typename?: 'UserManagedFields';
  fields?: Maybe<Array<Maybe<UserManagedField>>>;
  managers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UserMetadata = {
  __typename?: 'UserMetadata';
  comments?: Maybe<Scalars['String']>;
  config?: Maybe<UserMetadataConfig>;
  /** @deprecated Supports saga fall back, will be removed. */
  sagaFallback?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type UserMetadataConfig = {
  __typename?: 'UserMetadataConfig';
  favouriteCategories?: Maybe<Array<Tag>>;
  favouriteCategoryIds?: Maybe<Array<Scalars['ID']>>;
  /** @deprecated No longer used, legacy SFMC implementation. */
  push?: Maybe<PushConfig>;
};

export type UserMetadataConfigInput = {
  favouriteCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserMetadataInput = {
  comments?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<UserMetadataConfigInput>;
  uuid: Scalars['ID'];
};

export type UserOnboarding = {
  __typename?: 'UserOnboarding';
  /** @deprecated Use 'userProgress' instead */
  completedSteps?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Discontinued */
  flow?: Maybe<Scalars['String']>;
  /** @deprecated Use 'uuid' instead */
  owner?: Maybe<Scalars['ID']>;
  /** @deprecated Discontinued */
  steps?: Maybe<Array<Maybe<Scalars['String']>>>;
  userProgress?: Maybe<Array<Maybe<OnboardingUserProgress>>>;
  uuid?: Maybe<Scalars['ID']>;
};

export type UserOrganisationDetail = {
  __typename?: 'UserOrganisationDetail';
  annualGrossSalary?: Maybe<Scalars['Float']>;
  existingSalarySacrificeExternal?: Maybe<Scalars['Float']>;
  existingSalarySacrificeInternal?: Maybe<Scalars['Float']>;
  hoursAddedByEmployer?: Maybe<Scalars['Boolean']>;
  hoursPerWeek?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  salaryAddedByEmployer?: Maybe<Scalars['Boolean']>;
};

export type UserPlatformData = {
  __typename?: 'UserPlatformData';
  accountRecognitionCount?: Maybe<Scalars['Int']>;
  celebrationCount?: Maybe<Scalars['Int']>;
  cultureHubCount?: Maybe<Scalars['Int']>;
  hasCultureHubTiles?: Maybe<Scalars['Boolean']>;
  userSavings?: Maybe<UserPlatformSavings>;
  /** @deprecated Use Query.wallet */
  walletFP?: Maybe<Wallet>;
  /** @deprecated Use Query.wallet */
  walletRP?: Maybe<Wallet>;
};

export type UserPlatformSavings = {
  __typename?: 'UserPlatformSavings';
  comparisonDate?: Maybe<Scalars['String']>;
  savings?: Maybe<UserRedemptionReportSavingsData>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  birthdayPreferences?: Maybe<BirthdayPreferences>;
};

export type UserPreferencesInput = {
  birthdayPreferences?: InputMaybe<BirthdayPreferences>;
};

export type UserPublic = {
  __typename?: 'UserPublic';
  userId: Scalars['ID'];
};

export type UserRedemptionReportResponse = {
  __typename?: 'UserRedemptionReportResponse';
  report?: Maybe<BusinessRedemptionReport>;
  savings?: Maybe<UserRedemptionReportSavings>;
};

export type UserRedemptionReportSavings = {
  __typename?: 'UserRedemptionReportSavings';
  estimated?: Maybe<UserRedemptionReportSavingsData>;
  fixed?: Maybe<UserRedemptionReportSavingsData>;
  total?: Maybe<UserRedemptionReportSavingsData>;
};

export type UserRedemptionReportSavingsData = {
  __typename?: 'UserRedemptionReportSavingsData';
  breakdown?: Maybe<Array<Maybe<UserRedemptionReportSavingsDataBreakdown>>>;
  currency?: Maybe<PaymentCurrencyType>;
  value?: Maybe<Scalars['Int']>;
};

export type UserRedemptionReportSavingsDataBreakdown = {
  __typename?: 'UserRedemptionReportSavingsDataBreakdown';
  currency?: Maybe<PaymentCurrencyType>;
  type?: Maybe<UserRedemptionReportSavingsDataBreakdownType>;
  value?: Maybe<Scalars['Int']>;
};

export const UserRedemptionReportSavingsDataBreakdownType = {
  DiscountCodes: 'DiscountCodes',
  FlexiPerks: 'FlexiPerks',
  FlexiRewards: 'FlexiRewards',
  GiftCards: 'GiftCards'
} as const;

export type UserRedemptionReportSavingsDataBreakdownType = typeof UserRedemptionReportSavingsDataBreakdownType[keyof typeof UserRedemptionReportSavingsDataBreakdownType];
export type UserSaving = {
  __typename?: 'UserSaving';
  boostedSavings?: Maybe<BoostedSavings>;
  userSavings?: Maybe<UserSavings>;
};

export type UserSavingInput = {
  userSavings?: InputMaybe<UserSavingsInput>;
};

export type UserSavings = {
  __typename?: 'UserSavings';
  header?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UserSavingsBrand = {
  __typename?: 'UserSavingsBrand';
  brandId?: Maybe<Scalars['ID']>;
  brandLogoUrl?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  brandSlug?: Maybe<Scalars['String']>;
  deals?: Maybe<Array<Maybe<PerkRedemptionsReport>>>;
  totalRedemptions?: Maybe<Scalars['Int']>;
  totalSavings?: Maybe<Scalars['Float']>;
};

export type UserSavingsCategories = {
  __typename?: 'UserSavingsCategories';
  category?: Maybe<Tag>;
  redemptions?: Maybe<Scalars['Int']>;
};

export type UserSavingsInput = {
  header?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UserSavingsResponse = {
  __typename?: 'UserSavingsResponse';
  brands?: Maybe<Array<Maybe<UserSavingsBrand>>>;
  categories?: Maybe<Array<Maybe<UserSavingsCategories>>>;
  comparisonDate?: Maybe<Scalars['String']>;
  /** @deprecated No longer used. */
  previousSavings?: Maybe<UserRedemptionReportSavings>;
  /** @deprecated Use brands instead. */
  report?: Maybe<BusinessRedemptionReport>;
  savings?: Maybe<UserRedemptionReportSavings>;
};

export const UserSource = {
  Legacy: 'LEGACY',
  Local: 'LOCAL',
  Pull: 'Pull',
  Push: 'Push',
  Saml: 'SAML',
  SelfCode: 'SELF_CODE',
  SelfEmail: 'SELF_EMAIL',
  SignUp: 'SignUp',
  Upload: 'Upload'
} as const;

export type UserSource = typeof UserSource[keyof typeof UserSource];
export type UserTeamAssignment = {
  __typename?: 'UserTeamAssignment';
  assignment?: Maybe<TeamAssignment>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  isBudgetHolder?: Maybe<Scalars['Boolean']>;
  teamId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export const UserType = {
  Employee: 'Employee',
  FriendsAndFamily: 'FriendsAndFamily',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type UserType = typeof UserType[keyof typeof UserType];
export type ValidateBulkBudgetAssignmentError = {
  __typename?: 'ValidateBulkBudgetAssignmentError';
  budget?: Maybe<Scalars['String']>;
  errorType: BulkBudgetAssignmentErrorType;
  userId: Scalars['ID'];
};

export type ValidateBulkBudgetAssignmentInput = {
  assignments: Array<BulkBudgetAssignmentAssignment>;
  sourceId: Scalars['ID'];
};

export type ValidateBulkBudgetAssignmentResponse = {
  __typename?: 'ValidateBulkBudgetAssignmentResponse';
  errors: Array<ValidateBulkBudgetAssignmentError>;
  valid: Scalars['Boolean'];
};

export type ValidateChangeEmailInput = {
  businessId: Scalars['ID'];
  code: Scalars['String'];
  newEmail: Scalars['String'];
  oldEmail: Scalars['String'];
  userId: Scalars['ID'];
  uuid: Scalars['ID'];
};

export type Value = {
  __typename?: 'Value';
  value?: Maybe<Scalars['Float']>;
};

export type ValuesAndCelebrationsReport = {
  __typename?: 'ValuesAndCelebrationsReport';
  celebrations: Array<Celebration>;
  companyValues: Array<CompanyValue>;
};

export type VariableConfigurations = {
  __typename?: 'VariableConfigurations';
  fixedTerm?: Maybe<AnnualLeaveConfig>;
  flexibleWorking?: Maybe<AnnualLeaveConfig>;
  fullTime?: Maybe<AnnualLeaveConfig>;
  partTime?: Maybe<AnnualLeaveConfig>;
  temporary?: Maybe<AnnualLeaveConfig>;
};

export type VerificationLink = {
  __typename?: 'VerificationLink';
  expires?: Maybe<Date>;
  url?: Maybe<Scalars['String']>;
};

export const VivupBenefitType = {
  BenefitTypeAffordableLoans: 'BENEFIT_TYPE_AFFORDABLE_LOANS',
  BenefitTypeAnnualLeavePurchase: 'BENEFIT_TYPE_ANNUAL_LEAVE_PURCHASE',
  BenefitTypeBikeShop: 'BENEFIT_TYPE_BIKE_SHOP',
  BenefitTypeCarScheme: 'BENEFIT_TYPE_CAR_SCHEME',
  BenefitTypeCycleToWork: 'BENEFIT_TYPE_CYCLE_TO_WORK',
  BenefitTypeFamilyCare: 'BENEFIT_TYPE_FAMILY_CARE',
  BenefitTypeFamilyPay: 'BENEFIT_TYPE_FAMILY_PAY',
  BenefitTypeGymMembership: 'BENEFIT_TYPE_GYM_MEMBERSHIP',
  BenefitTypeHolidayClubs: 'BENEFIT_TYPE_HOLIDAY_CLUBS',
  BenefitTypeHomeAndElectronics: 'BENEFIT_TYPE_HOME_AND_ELECTRONICS',
  BenefitTypePayrollGiving: 'BENEFIT_TYPE_PAYROLL_GIVING',
  BenefitTypeTravelAndLeisure: 'BENEFIT_TYPE_TRAVEL_AND_LEISURE',
  BenefitTypeUnknown: 'BENEFIT_TYPE_UNKNOWN',
  BenefitTypeVivupHighfive: 'BENEFIT_TYPE_VIVUP_HIGHFIVE',
  BenefitTypeWorkplaceNursery: 'BENEFIT_TYPE_WORKPLACE_NURSERY',
  BenefitTypeYourCareWellbeingPlatform: 'BENEFIT_TYPE_YOUR_CARE_WELLBEING_PLATFORM',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type VivupBenefitType = typeof VivupBenefitType[keyof typeof VivupBenefitType];
export type VivupCurrentUser = {
  __typename?: 'VivupCurrentUser';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  backendUser?: Maybe<Scalars['Boolean']>;
  confirmedAt?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeeOrganisations?: Maybe<Array<Maybe<VivupEmployeeOrganisation>>>;
  failedAttempts?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  homePhone?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isOrganisationSettingUser?: Maybe<Scalars['Boolean']>;
  isPlatformUserManagementUser?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastValidationNumber?: Maybe<Scalars['String']>;
  lastValidationNumberId?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  niNumber?: Maybe<Scalars['String']>;
  payrollFrequency?: Maybe<Scalars['String']>;
  pendingDeletionRequest?: Maybe<Scalars['Boolean']>;
  placeOfWork?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
  validValidationNumber?: Maybe<Scalars['Boolean']>;
};

export type VivupEmployeeOrganisation = {
  __typename?: 'VivupEmployeeOrganisation';
  changePortalLink?: Maybe<Scalars['String']>;
  employerPortalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mobileNumberState?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerClientId?: Maybe<Scalars['String']>;
  partnerSource?: Maybe<Scalars['String']>;
  privacyNoticeUrl?: Maybe<Scalars['String']>;
  requiresDomainValidation?: Maybe<Scalars['Boolean']>;
  salaryBracketState?: Maybe<Scalars['String']>;
  showLoggedOutBanner?: Maybe<Scalars['Boolean']>;
  validationNumberRequired?: Maybe<Scalars['Boolean']>;
  validationNumberType?: Maybe<Scalars['String']>;
};

export type VivupMetadata = {
  benefitType: VivupBenefitType;
};

export type VoucherCount = {
  __typename?: 'VoucherCount';
  available?: Maybe<Scalars['Int']>;
  etag?: Maybe<Scalars['String']>;
};

export type Wallet = {
  __typename?: 'Wallet';
  amount: Scalars['Int'];
  availableBalance: Scalars['Float'];
  availableBalanceInCents: Scalars['Int'];
  budgets?: Maybe<BudgetCategories>;
  creditRewarded?: Maybe<Scalars['Float']>;
  creditSpent?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  giftCardValueRewarded?: Maybe<Scalars['Float']>;
  isSystemWallet?: Maybe<Scalars['Boolean']>;
  nextTopup?: Maybe<NextTopup>;
  ownerUuid?: Maybe<Scalars['String']>;
  perksGOSavings?: Maybe<Scalars['Float']>;
  remainingBalance?: Maybe<Scalars['Float']>;
  scheduledInBalance?: Maybe<Scalars['Float']>;
  scheduledOutBalance?: Maybe<Scalars['Float']>;
  taxableAmount?: Maybe<Scalars['Float']>;
  uuid: Scalars['String'];
};

export type WalletBalanceAtTime = {
  __typename?: 'WalletBalanceAtTime';
  currency?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
  walletType?: Maybe<Scalars['String']>;
};

export type WalletBalanceForTime = {
  __typename?: 'WalletBalanceForTime';
  balance?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['String']>;
};

export type WalletBalanceFromTime = {
  __typename?: 'WalletBalanceFromTime';
  balances?: Maybe<Array<Maybe<WalletBalanceForTime>>>;
  currency?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export const WalletEntityType = {
  Reward: 'reward',
  User: 'user'
} as const;

export type WalletEntityType = typeof WalletEntityType[keyof typeof WalletEntityType];
/**
 * Paginated List for entity WalletListItem. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type WalletList = {
  __typename?: 'WalletList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<WalletListItem>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type WalletListItem = {
  __typename?: 'WalletListItem';
  availableBalance?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['String']>;
  walletId?: Maybe<Scalars['String']>;
};

/** Represents a wallet sum for a business user - total balance per wallet */
export type WalletSum = {
  __typename?: 'WalletSum';
  /** Total balance across all budgets in this wallet */
  sum: Scalars['Int'];
  /** The user who owns this wallet */
  user: WalletUser;
  /** The unique wallet identifier */
  walletId: Scalars['ID'];
};

/**
 * Paginated List for entity WalletSum. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use offset based pagination
 */
export type WalletSumsList = {
  __typename?: 'WalletSumsList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<WalletSum>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type WalletTopupServiceCharge = {
  __typename?: 'WalletTopupServiceCharge';
  base?: Maybe<Scalars['Float']>;
  forNextTransfer?: Maybe<Scalars['Float']>;
};

/** Total balance information for a user's reward wallet */
export type WalletTotals = {
  __typename?: 'WalletTotals';
  /** Total balance across all budgets in the user's wallet */
  totalBalance: Scalars['Int'];
  /** Unassigned balance in the user's wallet */
  unassignedBalance: Scalars['Int'];
};

/** Total balance information for all reward wallets in the business */
export type WalletTotalsSummary = {
  __typename?: 'WalletTotalsSummary';
  /** Total balance across every reward wallet in the business */
  totalBalance: Scalars['Int'];
};

export type WalletTransferPair = {
  currency: PaymentCurrencyType;
  from: Scalars['ID'];
  to: Scalars['ID'];
};

/** User information for wallet owners */
export type WalletUser = {
  __typename?: 'WalletUser';
  /** The user's full name */
  fullName: Scalars['String'];
  /** Whether the user is currently enabled */
  isEnabled: Scalars['Boolean'];
  /** The user's unique identifier */
  userId: Scalars['ID'];
};

export type WeeklyBudget = {
  __typename?: 'WeeklyBudget';
  budget: Array<CalculatorBudget>;
  currency: Scalars['String'];
};

export type WellnessCarousel = {
  __typename?: 'WellnessCarousel';
  backgroundImage?: Maybe<Scalars['String']>;
  ctaResource?: Maybe<Scalars['String']>;
  ctaText: Scalars['String'];
  ctaType?: Maybe<WellnessCarouselType>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  subtext: Scalars['String'];
  textColor: WellnessCarouselTextColor;
  title: Scalars['String'];
};

export const WellnessCarouselTextColor = {
  Black: 'black',
  White: 'white'
} as const;

export type WellnessCarouselTextColor = typeof WellnessCarouselTextColor[keyof typeof WellnessCarouselTextColor];
export const WellnessCarouselType = {
  Category: 'category',
  External: 'external',
  Media: 'media'
} as const;

export type WellnessCarouselType = typeof WellnessCarouselType[keyof typeof WellnessCarouselType];
export type WellnessFavouriteMedia = {
  __typename?: 'WellnessFavouriteMedia';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type WellnessFavouriteMediaInput = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type WellnessLane = {
  __typename?: 'WellnessLane';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mediaCardCount?: Maybe<Scalars['Int']>;
  mediaList?: Maybe<Array<Maybe<WellnessMedia>>>;
  title: Scalars['String'];
  /** @deprecated Use 'id' instead */
  uuid: Scalars['ID'];
};

export type WellnessLiveNotification = {
  __typename?: 'WellnessLiveNotification';
  expiresAt?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
};

export type WellnessLiveNotificationInput = {
  expiresAt?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['String']>;
};

export type WellnessMedia = {
  __typename?: 'WellnessMedia';
  allowedCountries: Array<Scalars['String']>;
  author: WellnessMediaAuthor;
  /** @deprecated Use 'author' instead */
  authorId?: Maybe<Scalars['ID']>;
  category: WellnessMediaCategory;
  /** @deprecated Use 'category' instead */
  categoryId?: Maybe<Scalars['ID']>;
  /** @deprecated Not used */
  courseMediaCount?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['String'];
  /** @deprecated Use 'thumbnail' instead */
  heroImage?: Maybe<Scalars['String']>;
  /** @deprecated Use 'homepageLaneIds' instead */
  homepageLaneId?: Maybe<Scalars['ID']>;
  /** @deprecated changed relationship to be Lane dominant */
  homepageLaneIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id: Scalars['ID'];
  /** @deprecated Use 'thumbnail' instead */
  image?: Maybe<Scalars['String']>;
  isEAPSpecificContent: Scalars['Boolean'];
  /** @deprecated Banners will come from the carousel collection type in strapi */
  isHeroBanner?: Maybe<Scalars['Boolean']>;
  liveVideoEndTime?: Maybe<Scalars['String']>;
  liveVideoStartTime?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  provider: WellnessMediaProvider;
  /** @deprecated Use 'provider' instead */
  providerId?: Maybe<Scalars['ID']>;
  rentalPeriod?: Maybe<Scalars['Int']>;
  rentalPeriodUnit?: Maybe<RentalPeriodUnit>;
  src?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  type: WellnessMediaType;
  /** @deprecated Use 'id' instead */
  uuid: Scalars['ID'];
};

export type WellnessMediaAuthor = {
  __typename?: 'WellnessMediaAuthor';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Use 'id' instead */
  uuid: Scalars['ID'];
};

export type WellnessMediaCategory = {
  __typename?: 'WellnessMediaCategory';
  count?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  mediaLabel: Scalars['String'];
  name: Scalars['String'];
  svgData?: Maybe<Scalars['String']>;
  /** @deprecated Use 'id' instead */
  uuid: Scalars['ID'];
};

/**
 * Paginated List for entity WellnessMedia. See https://www.apollographql.com/docs/react/pagination/core-api for details.
 * Use cursor or offset based pagination
 */
export type WellnessMediaList = {
  __typename?: 'WellnessMediaList';
  /** Number of items returned from this page, a.k.a pageSize (which may differ to limit if items where filtered in graph) */
  count?: Maybe<Scalars['Int']>;
  /**
   * Cursor key to start next pagination from.
   * Do not use with "offset". See https://www.apollographql.com/docs/react/pagination/cursor-based
   */
  cursor?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  /** Maximum results to return - this typically mirrors the $limit argument for usage in the client */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Latest offset of the returned page, i.e the index of the list to continue pagination from.
   * Do not use with "cursor" pagination. See https://www.apollographql.com/docs/react/pagination/offset-based for more.
   */
  offset?: Maybe<Scalars['Int']>;
  results: Array<WellnessMedia>;
  /** The total number of items available to be paginated through. Not all endpoints can expose this. */
  total?: Maybe<Scalars['Int']>;
};

export type WellnessMediaProvider = {
  __typename?: 'WellnessMediaProvider';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Use 'id' instead */
  uuid: Scalars['ID'];
};

export const WellnessMediaType = {
  Article: 'Article',
  AudioCourse: 'AudioCourse',
  LiveVideo: 'LiveVideo',
  SingleAudio: 'SingleAudio',
  SingleVideo: 'SingleVideo',
  VideoCourse: 'VideoCourse'
} as const;

export type WellnessMediaType = typeof WellnessMediaType[keyof typeof WellnessMediaType];
export type WellnessProfile = {
  __typename?: 'WellnessProfile';
  favouriteMedia?: Maybe<Array<WellnessFavouriteMedia>>;
  metadata?: Maybe<Metadata>;
  uuid?: Maybe<Scalars['ID']>;
};

export type WorkOsDsyncConfig = {
  __typename?: 'WorkOSDsyncConfig';
  directorySyncConfig?: Maybe<DirectorySyncConfig>;
};

export type WorkOsLinkCode = {
  __typename?: 'WorkOSLinkCode';
  code?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
};

export type WorkOsOrganisation = {
  __typename?: 'WorkOSOrganisation';
  connectionId?: Maybe<Scalars['ID']>;
  directoryId?: Maybe<Scalars['ID']>;
  organisationId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type WorkOsPortalLinks = {
  __typename?: 'WorkOSPortalLinks';
  directorySyncUrl?: Maybe<Scalars['String']>;
  ssoUrl?: Maybe<Scalars['String']>;
};

export type WorkOsUser = {
  __typename?: 'WorkOSUser';
  directorySyncId?: Maybe<Scalars['ID']>;
  ssoId?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type ZuoraContactDetails = {
  __typename?: 'ZuoraContactDetails';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  soldToIsBillTo?: Maybe<Scalars['Boolean']>;
  telephone?: Maybe<Scalars['String']>;
};

export type ZuoraCurrentPlan = {
  __typename?: 'ZuoraCurrentPlan';
  addOns: Array<ZuoraProduct>;
  cancelling?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['String']>;
  paused?: Maybe<Scalars['Boolean']>;
  renewalPending?: Maybe<Scalars['Boolean']>;
  seats?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['String']>;
  window?: Maybe<ZuoraCurrentPlanWindow>;
};

export const ZuoraCurrentPlanWindow = {
  Ongoing: 'Ongoing',
  RenewalWindow: 'RenewalWindow',
  RenewalWindowWithoutCancellation: 'RenewalWindowWithoutCancellation',
  Unrecognized: 'UNRECOGNIZED'
} as const;

export type ZuoraCurrentPlanWindow = typeof ZuoraCurrentPlanWindow[keyof typeof ZuoraCurrentPlanWindow];
export type ZuoraInvoice = {
  __typename?: 'ZuoraInvoice';
  body?: Maybe<Scalars['String']>;
};

export type ZuoraInvoices = {
  __typename?: 'ZuoraInvoices';
  invoices?: Maybe<Array<Maybe<Invoice>>>;
};

export type ZuoraProduct = {
  __typename?: 'ZuoraProduct';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type ZuoraProductDiscount = {
  __typename?: 'ZuoraProductDiscount';
  duration?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
  recurringChargeId?: Maybe<Scalars['String']>;
};

export type ZuoraProductOption = {
  __typename?: 'ZuoraProductOption';
  discount?: Maybe<ZuoraProductDiscount>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  pricePerSeatPerMonth?: Maybe<Scalars['Int']>;
  recurringChargeId?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
  uncounted?: Maybe<Scalars['Boolean']>;
  usageChargeId?: Maybe<Scalars['String']>;
};

export type ZuoraProductOptions = {
  __typename?: 'ZuoraProductOptions';
  currency?: Maybe<Scalars['String']>;
  newProducts?: Maybe<Array<Maybe<ZuoraProductOption>>>;
  platformBillingPeriod?: Maybe<BillingPeriod>;
  upgradeSequences?: Maybe<Array<Maybe<ZuoraUpgradeSequence>>>;
};

export type ZuoraSeatsCount = {
  __typename?: 'ZuoraSeatsCount';
  count?: Maybe<Scalars['Int']>;
};

export type ZuoraSoldToContact = {
  __typename?: 'ZuoraSoldToContact';
  contact?: Maybe<ZuoraContactDetails>;
  invalid?: Maybe<Scalars['Boolean']>;
  invalidReasons?: Maybe<Scalars['String']>;
};

export type ZuoraSoldToContactInput = {
  businessId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  soldToIsBillTo?: InputMaybe<Scalars['Boolean']>;
  telephone?: InputMaybe<Scalars['String']>;
};

export type ZuoraUpgradeSequence = {
  __typename?: 'ZuoraUpgradeSequence';
  name?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
  upgrades?: Maybe<Array<Maybe<ZuoraProductOption>>>;
};

export type SsoConfiguration = {
  __typename?: 'ssoConfiguration';
  businessId?: Maybe<Scalars['String']>;
  preventUserCreation?: Maybe<Scalars['Boolean']>;
};

export type SsoConfigurationInput = {
  businessId?: InputMaybe<Scalars['String']>;
  preventUserCreation?: InputMaybe<Scalars['Boolean']>;
};

export type SsoConfigurationResponse = {
  __typename?: 'ssoConfigurationResponse';
  configuration?: Maybe<SsoConfiguration>;
};

import "./global.ts"